webpackJsonp([21],{

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(486);

var _stringify2 = _interopRequireDefault(_stringify);

var _slicedToArray2 = __webpack_require__(1292);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Isomorphic CSS style loader for Webpack
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var prefix = 's';
var inserted = {};

// Base64 encoding and decoding - The "Unicode Problem"
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

/**
 * Remove style/link elements for specified node IDs
 * if they are no longer referenced by UI components.
 */
function removeCss(ids) {
  ids.forEach(function (id) {
    if (--inserted[id] <= 0) {
      var elem = document.getElementById(prefix + id);
      if (elem) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
}

/**
 * Example:
 *   // Insert CSS styles object generated by `css-loader` into DOM
 *   var removeCss = insertCss([[1, 'body { color: red; }']]);
 *
 *   // Remove it from the DOM
 *   removeCss();
 */
function insertCss(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$replace = _ref.replace,
      replace = _ref$replace === undefined ? false : _ref$replace,
      _ref$prepend = _ref.prepend,
      prepend = _ref$prepend === undefined ? false : _ref$prepend;

  var ids = [];
  for (var i = 0; i < styles.length; i++) {
    var _styles$i = (0, _slicedToArray3.default)(styles[i], 4),
        moduleId = _styles$i[0],
        css = _styles$i[1],
        media = _styles$i[2],
        sourceMap = _styles$i[3];

    var id = moduleId + '-' + i;

    ids.push(id);

    if (inserted[id]) {
      if (!replace) {
        inserted[id]++;
        continue;
      }
    }

    inserted[id] = 1;

    var elem = document.getElementById(prefix + id);
    var create = false;

    if (!elem) {
      create = true;

      elem = document.createElement('style');
      elem.setAttribute('type', 'text/css');
      elem.id = prefix + id;

      if (media) {
        elem.setAttribute('media', media);
      }
    }

    var cssText = css;
    if (sourceMap && typeof btoa === 'function') {
      // skip IE9 and below, see http://caniuse.com/atob-btoa
      cssText += '\n/*# sourceMappingURL=data:application/json;base64,' + b64EncodeUnicode((0, _stringify2.default)(sourceMap)) + '*/';
      cssText += '\n/*# sourceURL=' + sourceMap.file + '?' + id + '*/';
    }

    if ('textContent' in elem) {
      elem.textContent = cssText;
    } else {
      elem.styleSheet.cssText = cssText;
    }

    if (create) {
      if (prepend) {
        document.head.insertBefore(elem, document.head.childNodes[0]);
      } else {
        document.head.appendChild(elem);
      }
    }
  }

  return removeCss.bind(null, ids);
}

module.exports = insertCss;

/***/ }),

/***/ 1238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(316);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(311);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(313);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(314);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(315);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1289);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(1278);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var contextTypes = {
  insertCss: _propTypes2.default.func
}; /**
    * Isomorphic CSS style loader for Webpack
    *
    * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE.txt file in the root directory of this source tree.
    */

function withStyles() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  return function wrapWithStyles(ComposedComponent) {
    var WithStyles = function (_Component) {
      (0, _inherits3.default)(WithStyles, _Component);

      function WithStyles() {
        (0, _classCallCheck3.default)(this, WithStyles);
        return (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).apply(this, arguments));
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var _context;

          this.removeCss = (_context = this.context).insertCss.apply(_context, styles);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.removeCss) {
            setTimeout(this.removeCss, 0);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(ComposedComponent, this.props);
        }
      }]);
      return WithStyles;
    }(_react.Component);

    var displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';

    WithStyles.displayName = 'WithStyles(' + displayName + ')';
    WithStyles.contextTypes = contextTypes;
    WithStyles.ComposedComponent = ComposedComponent;

    return (0, _hoistNonReactStatics2.default)(WithStyles, ComposedComponent);
  };
}

exports.default = withStyles;

/***/ }),

/***/ 1239:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(87)) === 'object' && __webpack_require__(87)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 1241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_js__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_locale__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      var _this$props = _this.props,
          to = _this$props.to,
          locale = _this$props.locale;


      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (event.defaultPrevented === true) {
        return;
      }

      event.preventDefault();

      if (to) {
        __WEBPACK_IMPORTED_MODULE_3_history_js__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_4__helpers_locale__["h" /* toLocalized */](to, locale));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          to = _props.to,
          locale = _props.locale,
          children = _props.children,
          elementRef = _props.elementRef,
          shouldSetNoIndex = _props.shouldSetNoIndex,
          dispatch = _props.dispatch,
          props = _objectWithoutProperties(_props, ['to', 'locale', 'children', 'elementRef', 'shouldSetNoIndex', 'dispatch']);

      var title = typeof children === 'string' ? children : '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        _extends({
          title: title,
          href: __WEBPACK_IMPORTED_MODULE_4__helpers_locale__["h" /* toLocalized */](to, locale)
        }, props, {
          ref: elementRef,
          onClick: this.handleClick
        }),
        children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.defaultProps = {
  shouldSetNoIndex: false,
  onClick: null,
  children: '',
  elementRef: undefined,
  dispatch: undefined,
  to: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](function (_ref2) {
  var locale = _ref2.globals.locale;
  return { locale: locale };
})(Link));

/***/ }),

/***/ 1242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withTranslate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var withTranslate = function withTranslate(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */]((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.t = function (string) {
        var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

        if (!string) {
          return '';
        }

        return _this.props.intl.formatMessage({ id: string }, values);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { t: this.t }));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withTranslate(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2));
};

/***/ }),

/***/ 1243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__payment__ = __webpack_require__(308);
var _business, _advert;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var ADVERT_CLICK = 'clickAddAdButton_';
// const SERVICE = 'service';
var TARIFF_PLAN = 'tariffplan';
var SERVICE = 'service';
var TARIFF_PLAN_BUSINESS = 'tariffplan_business';
var SERVICE_BUSINESS = 'service_business';
var C2C_SLOT = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_SLOT,
    C2C_SINGLE = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_SINGLE,
    C2C_TURBO = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_TURBO,
    C2C_FAST = __WEBPACK_IMPORTED_MODULE_0__payment__["d" /* PACKAGES */].C2C_FAST;


var EVENTS = {
  MOBILE: {
    sendMessageToOwner: { event: 'sendlOwnerMessage_button' },
    registrationSuccess: { event: 'successRegistration' },
    adSent0: { event: 'clickAddAdButton_Free' },
    adSent1: { event: 'clickAddAdButton_109' },
    adSent2: { event: 'clickAddAdButton_199' },
    adSent3: { event: 'clickAddAdButton_299' },
    // Page types
    pageMain: { pageType: 'mainpage' },
    pageAdCard: { pageType: 'Ad_card' },
    pageDealer: { pageType: 'Dealer_Page' },
    pageSearch: { pageType: 'catalog' },
    pageAddAdvMainInfo: { pageType: 'Step 1' },
    pageAddAdvContactsPhoto: { pageType: 'Step 2' },
    pageAddAdvSellCar: { pageType: 'Step 3' },

    //
    pageDealers: { pageType: 'Dealers_Page' },
    pageProfile: { pageType: 'Profile_Page' },
    pageGeo: { pageType: 'Geo_Page' },
    pageFilters: { pageType: 'Filters_Page' },
    pageFavorites: { pageType: 'Favorites_Page' }
  },
  // Adverts
  AddCarNumberButton: { event: 'Add__NumberButton' },
  AddChooseBrand: { event: 'Add__ChooseBrand' },
  AddPhotoAdded: { event: 'Add__PhotoAdded' },
  AddPhotoDeleted: { event: 'Add__PhotoDeleted' },
  AddPhotoSort: { event: 'Add__PhotoSort' },
  AddSubmit: { event: 'Add__Submit' },
  AddSubmitFinal: { event: 'Add__SubmitFinall' },
  AddClearWarningMessageAndSubmit: { event: 'Add__SubmitAfterError' },
  AddSubmitForm: { event: 'Add__SubmitForm' },
  AddNextButtonCommon: { event: 'Add__NextButtonAll' },
  AddCommonPublishButton: { event: 'Add__PublishButtonAll' },
  // AddNextButton1: { event: 'Add__NextButton-1' },
  // AddNextButton2: { event: 'Add__NextButton-2' },
  // AddNextButton3: { event: 'Add__NextButton-3' },
  // AddNextButton4: { event: 'Add__NextButton-4' },

  AddCarBrandGroup: { event: 'AddCarBrandGroup' },
  freeAdSent: { event: 'freeAdSent' },
  turboAdvert: { event: ADVERT_CLICK + '333_Turbo' },
  fastAdvert: { event: ADVERT_CLICK + '198_Quick' },
  freeAll: { event: ADVERT_CLICK + '555_All' },
  freeUp: { event: ADVERT_CLICK + '105_Autopromotion' },
  freeVip: { event: ADVERT_CLICK + '225_VIP' },
  freeCol: { event: ADVERT_CLICK + '75_Colour' },
  freeTop: { event: ADVERT_CLICK + '150_TOP' },
  freeUpVipCol: { event: ADVERT_CLICK + '405_Auto+VIP+Colour' },
  freeUpVip: { event: ADVERT_CLICK + '330_Auto+VIP' },
  freeUpCol: { event: ADVERT_CLICK + '180_Auto+Colour' },
  freeUpTop: { event: ADVERT_CLICK + '150_Auto+Top' },
  freeUpTopCol: { event: ADVERT_CLICK + '225_Auto+Top+Colour' },
  freeVipVolTop: { event: ADVERT_CLICK + '450_VIP+Colour+Top' },
  freeVipCol: { event: ADVERT_CLICK + '300_Vip+Colour' },
  freeVipTop: { event: ADVERT_CLICK + '375_Vip+Top' },
  freeVipTopUp: { event: ADVERT_CLICK + '480_Vip+Top+Auto' },
  freeColTop: { event: ADVERT_CLICK + '225_Colour+Top' },
  //
  addToFavorites: { event: 'likeCar_button' },
  sellCarButtonClick: { event: 'sellCarr_Button' },
  seeReviews: { event: 'see_review_Button' },
  showPhoneClick: { event: 'showPhone_button' },
  sendTestDriveForm: { event: 'sendTestDrive_Form' },
  dealerSiteRedirect: { event: 'goDealerSite_Button' },
  showAllDealerAdverts: { event: 'showAllDealerCars_Button' },
  successLogin: { event: 'successRegistration' },
  callOwner: { event: 'callOwner_button' },
  searchButtonClick: { event: 'pressSearchButton' },
  paidAdSent: { event: 'paidAdSent' },
  advert: (_advert = {
    'balance-refill': { event: 'balance_refil' }
  }, _defineProperty(_advert, C2C_SLOT, { event: TARIFF_PLAN + '/4/' }), _defineProperty(_advert, 'sp-slot', { event: TARIFF_PLAN + '/25/' }), _defineProperty(_advert, C2C_SINGLE, { event: TARIFF_PLAN + '/31/' }), _defineProperty(_advert, 'update', { event: SERVICE + '/1/' }), _defineProperty(_advert, 'vip', { event: SERVICE + '/2/' }), _defineProperty(_advert, 'top', { event: SERVICE + '/4/' }), _defineProperty(_advert, 'color', { event: SERVICE + '/3/' }), _defineProperty(_advert, C2C_TURBO, { event: TARIFF_PLAN + '/6/' }), _defineProperty(_advert, C2C_FAST, { event: TARIFF_PLAN + '/5/' }), _defineProperty(_advert, 'b2c', { event: TARIFF_PLAN_BUSINESS + '/2/' }), _defineProperty(_advert, 'business', (_business = {}, _defineProperty(_business, C2C_SINGLE, { event: TARIFF_PLAN_BUSINESS + '/31/' }), _defineProperty(_business, 'b2c', { event: TARIFF_PLAN_BUSINESS + '/2/' }), _defineProperty(_business, 'update', { event: SERVICE_BUSINESS + '/1/' }), _defineProperty(_business, 'vip', { event: SERVICE_BUSINESS + '/2/' }), _defineProperty(_business, 'top', { event: SERVICE_BUSINESS + '/4/' }), _defineProperty(_business, 'color', { event: SERVICE_BUSINESS + '/3/' }), _defineProperty(_business, C2C_FAST, { event: TARIFF_PLAN_BUSINESS + '/5/' }), _defineProperty(_business, C2C_TURBO, { event: TARIFF_PLAN_BUSINESS + '/6/' }), _defineProperty(_business, 'spareparts-500', { event: TARIFF_PLAN_BUSINESS + '/7/' }), _defineProperty(_business, 'spareparts-1000', { event: TARIFF_PLAN_BUSINESS + '/8/' }), _defineProperty(_business, 'spareparts-2000', { event: TARIFF_PLAN_BUSINESS + '/9/' }), _defineProperty(_business, 'spareparts-3000', { event: TARIFF_PLAN_BUSINESS + '/10/' }), _defineProperty(_business, 'spareparts-unlim', { event: TARIFF_PLAN_BUSINESS + '/11/' }), _defineProperty(_business, 'spareparts-batch-update-20', { event: TARIFF_PLAN_BUSINESS + '/18/' }), _defineProperty(_business, 'spareparts-batch-update-35', { event: TARIFF_PLAN_BUSINESS + '/19/' }), _defineProperty(_business, 'spareparts-batch-update-70', { event: TARIFF_PLAN_BUSINESS + '/20/' }), _defineProperty(_business, 'spareparts-batch-update-100', { event: TARIFF_PLAN_BUSINESS + '/21/' }), _defineProperty(_business, 'spareparts-batch-update-150', { event: TARIFF_PLAN_BUSINESS + '/22/' }), _defineProperty(_business, 'spareparts-batch-update-200', { event: TARIFF_PLAN_BUSINESS + '/23/' }), _defineProperty(_business, 'spareparts-batch-update-400', { event: TARIFF_PLAN_BUSINESS + '/24/' }), _business)), _defineProperty(_advert, 'dealership', {
    'spareparts-500': { event: TARIFF_PLAN + '/7/' },
    'spareparts-1000': { event: TARIFF_PLAN + '/8/' },
    'spareparts-2000': { event: TARIFF_PLAN + '/9/' },
    'spareparts-3000': { event: TARIFF_PLAN + '/10/' },
    'spareparts-unlim': { event: TARIFF_PLAN + '/11/' },
    'spareparts-batch-update-20': { event: TARIFF_PLAN + '/18/' },
    'spareparts-batch-update-35': { event: TARIFF_PLAN + '/19/' },
    'spareparts-batch-update-70': { event: TARIFF_PLAN + '/20/' },
    'spareparts-batch-update-100': { event: TARIFF_PLAN + '/21/' },
    'spareparts-batch-update-150': { event: TARIFF_PLAN + '/22/' },
    'spareparts-batch-update-200': { event: TARIFF_PLAN + '/23/' },
    'spareparts-batch-update-400': { event: TARIFF_PLAN + '/24/' }
  }), _advert),
  leasing: {
    'data-lens-event': { event: 'leasingRequestClick' },
    'page-view': { event: 'leasingPageView' },

    // Automoney
    'automoney-monthly-calculation-show-form-click': {
      event: 'automoney-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'automoney-monthly-calculation-form-sumbit': {
      event: 'automoney-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'automoney-monthly-consultation-form-sumbit': {
      event: 'automoney-LeasingMonthly-Consultation-Form-Submit'
    },
    'automoney-questions-form-sumbit': { event: 'automoney-leasingMonthly-questions-Form-Submit' },
    'automoney-lead-create-success': { event: 'automoney-lead-created-success' },
    'automoney-lead-create-fail': { event: 'automoney-lead-create-fail' },
    'automoney-monthly-calculation-show-form-click-advertcard': {
      event: 'automoney-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'automoney-monthly-calculation-form-sumbit-advertcard': {
      event: 'automoney-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'automoney-monthly-consultation-form-sumbit-advertcard': {
      event: 'automoney-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    'automoney-lead-create-success-advertcard': {
      event: 'automoney-myauto-lead-create-success-advertCard'
    },
    'automoney-lead-create-fail-advertcard': {
      event: 'automoney-myauto-lead-create-fail-advertCard'
    },

    // Microcredit
    'microcredit-consultation-show-form-click': {
      event: 'microcredit-Consultation-Show-Form-Click'
    },
    'microcredit-consultation-form-sumbit': { event: 'microcredit-Consultation-Form-Submit' },
    'microcredit-lead-create-success': { event: 'microcredit-lead-created-success' },
    'microcredit-lead-create-fail': { event: 'microcredit-lead-create-fail' },

    'microcredit-consultation-show-form-click-advertcard': {
      event: 'microcredit-Consultation-Show-Form-Click-advertCard'
    },
    'microcredit-consultation-form-sumbit-advertcard': {
      event: 'microcredit-Consultation-Form-Submit-advertCard'
    },
    'microcredit-lead-create-success-advertcard': {
      event: 'microcredit-lead-created-success-advertCard'
    },
    'microcredit-lead-create-fail-advertcard': { event: 'microcredit-lead-create-fail-advertCard' },

    // Creditmarket
    'creditmarket-consultation-show-form-click': {
      event: 'creditmarket-Consultation-Show-Form-Click'
    },
    'creditmarket-consultation-form-sumbit': { event: 'creditmarket-Consultation-Form-Submit' },
    'creditmarket-lead-create-success': { event: 'creditmarket-lead-created-success' },
    'creditmarket-lead-create-fail': { event: 'creditmarket-lead-create-fail' },

    'creditmarket-consultation-show-form-click-advertcard': {
      event: 'creditmarket-Consultation-Show-Form-Click-advertCard'
    },
    'creditmarket-consultation-form-sumbit-advertcard': {
      event: 'creditmarket-Consultation-Form-Submit-advertCard'
    },
    'creditmarket-lead-create-success-advertcard': {
      event: 'creditmarket-lead-created-success-advertCard'
    },
    'creditmarket-lead-create-fail-advertcard': {
      event: 'creditmarket-lead-create-fail-advertCard'
    },
    'creditmarket-questions-form-sumbit': {
      event: 'creditmarket-leasingMonthly-questions-Form-Submit'
    },

    // MyAuto
    'monthly-calculation-show-form-click': { event: 'leasingMonthly-Calculation-Show-Form-Click' },
    'monthly-calculation-form-sumbit': { event: 'leasingMonthly-Calculation-Form-Sumbit' },
    'monthly-consultation-form-sumbit': { event: 'leasingMonthly-Consultation-Form-Submit' },
    'questions-form-sumbit': { event: 'leasingMonthly-questions-Form-Submit' },
    'lead-create-success-questions': { event: 'lead-create-success-questions' },
    'lead-create-fail-questions': { event: 'lead-create-fail-questions' },
    'lead-create-success': { event: 'lead-create-success' },
    'lead-create-fail': { event: 'lead-create-fail' },
    'monthly-calculation-show-form-click-advertcard': {
      event: 'leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'monthly-calculation-form-sumbit-advertcard': {
      event: 'leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'monthly-consultation-form-sumbit-advertcard': {
      event: 'leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'questions-form-sumbit-advertcard': { event: `leasingMonthly-questions-Form-Submit-advertCard` },
    'lead-create-success-advertcard': { event: 'lead-create-success-advertCard' },
    'lead-create-fail-advertcard': { event: 'lead-create-fail-advertCard' },
    'lead-create-success-advertcard-sidebar': { event: 'lead-create-success-advertCard-sidebar' },
    'lead-create-fail-advertcard-sidebar': { event: 'lead-create-fail-advertCard-sidebar' },

    // Hapai
    'hapai-monthly-calculation-show-form-click': {
      event: 'hapai-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'hapai-monthly-calculation-form-sumbit': {
      event: 'hapai-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'hapai-monthly-consultation-form-sumbit': {
      event: 'hapai-LeasingMonthly-Consultation-Form-Submit'
    },
    'hapai-questions-form-sumbit': { event: 'hapai-leasingMonthly-questions-Form-Submit' },
    'hapai-lead-create-success': { event: 'hapai-lead-created-success' },
    'hapai-lead-create-success-questions': { event: 'hapai-lead-create-success-questions' },
    'hapai-lead-create-fail-questions': { event: 'hapai-lead-create-fail-questions' },
    'hapai-lead-create-fail': { event: 'hapai-lead-create-fail' },
    'hapai-monthly-calculation-show-form-click-advertcard': {
      event: 'hapai-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'hapai-monthly-calculation-form-sumbit-advertcard': {
      event: 'hapai-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'hapai-monthly-consultation-form-sumbit-advertcard': {
      event: 'hapai-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'hapai-questions-form-sumbit-advertcard': { event: `hapai-leasingMonthly-questions-Form-Submit-advertCard` },
    'hapai-lead-create-success-advertcard': { event: 'hapai-lead-create-success-advertCard' },
    'hapai-lead-create-fail-advertcard': { event: 'hapai-lead-create-fail-advertCard' },
    'hapai-lead-create-success-advertcard-sidebar': {
      event: 'hapai-lead-create-success-advertCard-sidebar'
    },
    'hapai-lead-create-fail-advertcard-sidebar': {
      event: 'hapai-lead-create-fail-advertCard-sidebar'
    },

    // Ulf24
    'ulf24-monthly-calculation-show-form-click': {
      event: 'ulf24-LeasingMonthly-Calculation-Show-Form-Click'
    },
    'ulf24-monthly-calculation-form-sumbit': {
      event: 'ulf24-LeasingMonthly-Calculation-Form-Sumbit'
    },
    'ulf24-monthly-consultation-form-sumbit': {
      event: 'ulf24-LeasingMonthly-Consultation-Form-Submit'
    },
    'ulf24-questions-form-sumbit': { event: 'ulf24-leasingMonthly-questions-Form-Submit' },
    'ulf24-lead-create-success': { event: 'ulf24-lead-created-success' },
    'ulf24-lead-create-fail': { event: 'ulf24-lead-create-fail' },
    'ulf24-monthly-calculation-show-form-click-advertcard': {
      event: 'ulf24-leasingMonthly-Calculation-Show-Form-Click-advertCard'
    },
    'ulf24-monthly-calculation-form-sumbit-advertcard': {
      event: 'ulf24-leasingMonthly-Calculation-Form-Sumbit-advertCard'
    },
    'ulf24-monthly-consultation-form-sumbit-advertcard': {
      event: 'ulf24-leasingMonthly-Consultation-Form-Submit-advertCard'
    },
    // 'ulf24-questions-form-sumbit-advertcard': { event: `ulf24-leasingMonthly-questions-Form-Submit-advertCard` },
    'ulf24-lead-create-success-advertcard': {
      event: 'ulf24-myauto-lead-create-success-advertCard'
    },
    'ulf24-lead-create-fail-advertcard': { event: 'ulf24-myauto-lead-create-fail-advertCard' },

    'ulf24-monthly-consultation-form-sumbit-advertcard-sidebar': {
      event: 'ulf24-leasingMonthly-Consultation-Form-Submit-advertCard-sidebar'
    },
    'ulf24-lead-create-success-advertcard-sidebar': {
      event: 'ulf24-lead-create-success-advertCard-sidebar'
    },
    'ulf24-lead-create-fail-advertcard-sidebar': {
      event: 'ulf24-lead-create-fail-advertCard-sidebar'
    },

    // Other events
    online: {
      'Popup-Used-Click': { event: 'leasingOnline-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingOnline-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingOnline-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingOnline-Sidebar-New-Click' },
      LinkUnderThePrice: { event: 'leasingOnline_LinkUnderThePrice' }
    },
    consultation: {
      'Popup-Used-Click': { event: 'leasingConsultation-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingConsultation-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingConsultation-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingConsultation-Sidebar-New-Click' },
      'Hapai-Popup-Used-Click': { event: 'hapai-leasingConsultation-Popup-Used-Click' },
      'Hapai-Popup-New-Click': { event: 'hapai-leasingConsultation-Popup-New-Click' },
      'Hapai-Sidebar-Used-Click': { event: 'hapai-leasingConsultation-Sidebar-Used-Click' },
      'Hapai-Sidebar-New-Click': { event: 'hapai-leasingConsultation-Sidebar-New-Click' },
      'Ulf24-Popup-Used-Click': { event: 'ulf24-leasingConsultation-Popup-Used-Click' },
      'Ulf24-Popup-New-Click': { event: 'ulf24-leasingConsultation-Popup-New-Click' },
      'Ulf24-Sidebar-Used-Click': { event: 'ulf24-leasingConsultation-Sidebar-Used-Click' },
      'Ulf24-Sidebar-New-Click': { event: 'ulf24-leasingConsultation-Sidebar-New-Click' }
    },

    codeVerification: {
      'Popup-Used-Click': { event: 'leasingOnlineCodeVerification-Popup-Used-Click' },
      'Popup-New-Click': { event: 'leasingOnlineCodeVerification-Popup-New-Click' },
      'Sidebar-Used-Click': { event: 'leasingOnlineCodeVerification-Sidebar-Used-Click' },
      'Sidebar-New-Click': { event: 'leasingOnlineCodeVerification-Sidebar-New-Click' }
    }
  },

  NAVIGATION_LINK: {
    'headerNavigation/avto/avtosalony/': { event: 'avtosalony_nav_legkovye' },
    'headerNavigation/avtosalony/': { event: 'avtosalony_nav_avtosalony' },
    'headerNavigation/avtosalony/avtosalony/avto/': { event: 'avtosalony_nav_avtosalony_avto' },
    'subHeader/avtosalony/': { event: 'avtosalony_sub-nav_avtosalony' }
  },

  DEALERS: {
    showNubmer: { event: 'avtosalony_listing_show-nubmer' },
    testDrive: { event: 'avtosalony_listing_test-drive' },
    tradeIn: { event: 'avtosalony_listing_trade-in' },

    formTestDrive: { event: 'avtosalony_listing_form_test-drive' },
    formTradeIn: { event: 'avtosalony_listing_form_trade-in' }
  },

  DEALER_ADV: {
    showNubmer: { event: 'avtosalony_car_show-number' },
    tradeIn: { event: 'avtosalony_car_trade-in' },
    testDrive: { event: 'avtosalony_car_testDrive' },
    callback: { event: 'avtosalony_car_callback' },

    formTradeIn: { event: 'avtosalony_car_form_trade-in' },
    formTestDrive: { event: 'avtosalony_car_form_testDrive' },
    formCallback: { event: 'avtosalony_car_form_callback' }
  },

  DEALER_CARD: {
    showNubmer: { event: 'avtosalony_card_show-number' },
    goToSite: { event: 'avtosalony_card_site' },

    tradeIn: { event: 'avtosalony_card_trade-in' },
    testDrive: { event: 'avtosalony_card_test-drive' },

    formTradeIn: { event: 'avtosalony_card_form_trade-in' },
    formTestDrive: { event: 'avtosalony_card_form_test-drive' }
  }
};

/***/ }),

/***/ 1244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_components_App__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var withFetch = function withFetch(WrappedComponent) {
  var Component = function Component(props) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_1_shared_components_App__["a" /* ContextConsumer */], {}, void 0, function (_ref) {
      var fetch = _ref.fetch;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, props, { fetch: fetch }));
    });
  };
  Component.displayName = 'withFetch(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')';

  return Component;
};

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1309);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./UIStyle.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./UIStyle.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1356)();
}

/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "583766ba.svg";

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__ = __webpack_require__(1261);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Helpers

var withInjectLocations = function withInjectLocations() {
  for (var _len = arguments.length, locationTypes = Array(_len), _key = 0; _key < _len; _key++) {
    locationTypes[_key] = arguments[_key];
  }

  return function (item) {
    return _extends({}, item, {
      injectLocations: locationTypes
    });
  };
};

//

var avto = [{
  title: 'Объявления',
  route: '/avto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
},
// {
//   title: 'Каталог',
//   route: '/avto/catalog',
// },
{
  title: 'Автосалоны',
  route: '/avtosalony/',
  slug: '/avtosalony/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var moto = [{
  title: 'Мотоциклы',
  route: '/mototsikl/',
  slug: '/mototsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Скутеры',
  route: '/skuter/',
  slug: '/skuter/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Картинг',
  route: '/karting/',
  slug: '/karting/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Квадроциклы',
  route: '/kvadrotsikl/',
  slug: '/kvadrotsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мопеды',
  route: '/moped/',
  slug: '/moped/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Багги',
  route: '/baggi/',
  slug: '/baggi/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Трициклы',
  route: '/tritsikl/',
  slug: '/tritsikl/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var truck = [{
  title: 'Грузовики',
  route: '/gruzovye/',
  slug: '/gruzovye/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Автобусы',
  route: '/avtobus/',
  slug: '/avtobus/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Прицепы',
  route: '/pritsepy/',
  slug: '/pritsepy/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Водный транспорт',
  route: '/vodnyi-transport/',
  slug: '/vodnyi-transport/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Спецтехника',
  route: '/spetstehnika/',
  slug: '/spetstehnika/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var AVTOSALONS_LINKS = [{
  title: 'Авто',
  route: '/avtosalony/',
  slug: '/avtosalony/avto/'
}, {
  title: 'Мото',
  route: '/avtosalony/mototsikl/',
  slug: '/avtosalony/mototsikl/'
}, {
  title: 'Автобусы',
  route: '/avtosalony/avtobus/',
  slug: '/avtosalony/avtobus/'
}, {
  title: 'Грузовики',
  route: '/avtosalony/gruzovye/',
  slug: '/avtosalony/gruzovye/'
}, {
  title: 'Водный транспорт',
  route: '/avtosalony/vodnyi-transport/',
  slug: '/avtosalony/vodnyi-transport/'
}, {
  title: 'Спецтехника',
  route: '/avtosalony/spetstehnika/',
  slug: '/avtosalony/spetstehnika/'
}, {
  title: 'Прицепы',
  route: '/avtosalony/pritsepy/',
  slug: '/avtosalony/pritsepy/'
}];

var FIRMS_TAGS_LINKS = [{
  title: 'СТО',
  route: '/katalog-kompaniy/sto/',
  slug: '/katalog-kompaniy/sto/'
}, {
  title: 'Авторазборка',
  route: '/katalog-kompaniy/avtorazborka/',
  slug: '/katalog-kompaniy/avtorazborka//'
}, {
  title: 'Автовыкуп',
  route: '/katalog-kompaniy/avtovykup/',
  slug: '/katalog-kompaniy/avtovykup/'
}, {
  title: 'Запчасти',
  route: '/katalog-kompaniy/zapchasti/',
  slug: '/katalog-kompaniy/zapchasti/'
}, {
  title: 'Автотовары',
  route: '/katalog-kompaniy/avtotovary/',
  slug: '/katalog-kompaniy/avtotovary/'
}, {
  title: 'ТСЦ',
  route: '/katalog-kompaniy/teritorialni-servisni-centri/',
  slug: '/katalog-kompaniy/teritorialni-servisni-centri/'
}];

var HEADER = [{
  title: 'Легковые',
  route: '/avto/',
  name: 'avto',
  items: [{
    title: 'C пробегом',
    route: '/avto/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }, {
    title: 'Новые',
    route: '/avto/novye/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  },
  // {
  //   title: 'Каталог',
  //   route: '/avto/catalog',
  // },
  {
    title: 'Автосалоны',
    route: '/avtosalony/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }, {
    title: 'Лизинг авто',
    route: '/leasing/',
    injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  }],
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мото',
  route: '/moto/',
  items: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Коммерческие',
  route: '/commercial/',
  items: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
  // {
  //   title: 'Спецтехника',
  //   route: '/spetstehnika/',
  //   items: [
  //     {
  //       title: 'Автокран',
  //       route: '/avtokran',
  //     },
  //     {
  //       title: 'Бульдозеры',
  //       route: '/buldozer',
  //     },
  //     {
  //       title: 'Автопогрузчики',
  //       route: '/avtopogruzchik',
  //     },
  //     {
  //       title: 'Эскаваторы',
  //       route: '/ekskavator',
  //     },
  //     {
  //       title: 'Самопогрузчики',
  //       route: '/samopogruzchik',
  //     },
  //     {
  //       title: 'Коммунальная',
  //       route: '/kommunalnaya',
  //     },
  //     {
  //       title: 'Cтроительная техника',
  //       route: '/stroitelnaya',
  //     },
  //   ],
  // },
}, {
  title: 'Запчасти',
  route: '/zapchasti/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY],
  items: [
    // {
    //   title: 'Запчасти',
    //   route: '/zapchasti/',
    //   injectLocations: [LOCATION_TYPES.CITY],
    // },
    // {
    //   title: 'Новые',
    //   route: '/zapchasti?isNew=1',
    // },
    // {
    //   title: 'Б/y',
    //   route: '/zapchasti?isUsed=1',
    // },
    // {
    //   title: 'Каталог компаний',
    //   route: '/katalog-kompaniy/',
    //   injectLocations: [LOCATION_TYPES.CITY],
    // },
  ]
}, {
  title: 'Автосалоны',
  route: '/avtosalony/',
  items: AVTOSALONS_LINKS
}, {
  title: 'Каталог',
  route: '/katalog-kompaniy/sto/',
  items: FIRMS_TAGS_LINKS,
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
},
// {
//   title: 'Журнал',
//   route: '/zhurnal/',
//   items: [
//     {
//       title: 'Видео',
//       route: '/zhurnal/video/',
//     },
//     {
//       title: 'Новости',
//       route: '/zhurnal/',
//     },
//     {
//       title: 'Акции',
//       route: '/zhurnal/aktsii/',
//     },
//     {
//       title: 'Статьи',
//       route: '/zhurnal/stati/',
//     },
//     {
//       title: 'Тест-драйвы',
//       route: '/zhurnal/test-draiv/',
//     },
//     {
//       title: 'Обзоры',
//       route: '/zhurnal/obzory/',
//     },
//   ],
// },
{
  title: 'Сервисы',
  route: '/service/ocenka-avto/',
  items: [{
    title: 'Оценка стоимости авто',
    route: '/service/ocenka-avto/'
  }, {
    title: 'Пригон авто',
    route: '/service/prygon-avto/'
  }, {
    title: 'Страховка',
    route: '/insurance/orders/'
  }, {
    title: 'Подписки на поиск',
    route: '/service/search-subscriptions/'
  }]
}];

var FOOTER = [
//

{
  title: 'Разместить рекламу',
  route: '/advertising/'
}, {
  title: 'Бизнесу',
  route: '/biznes-paket/'
}, {
  title: 'Автосалонам',
  route: '/for-dealers/'
}, {
  title: 'Запчасти',
  route: '/info-zapchasti/'
}, {
  title: 'Автосервисам',
  route: '/for-services/'
}, {
  title: 'Помощь',
  route: '/help/'
}, {
  title: 'Частным лицам',
  route: '/for-privates/'
}];

var SPARES_LINKS = [{
  title: 'Авто',
  route: '/zapchasti/',
  slug: '/zapchasti/avto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Мото',
  route: '/zapchasti/moto/',
  slug: '/zapchasti/moto/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Автобусы',
  route: '/zapchasti/avtobus/',
  slug: '/zapchasti/avtobus/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Грузовики',
  route: '/zapchasti/gruzovye/',
  slug: '/zapchasti/gruzovye/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Водный транспорт',
  route: '/zapchasti/vodnyi-transport/',
  slug: '/zapchasti/vodnyi-transport/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Спецтехника',
  route: '/zapchasti/spetstehnika/',
  slug: '/zapchasti/spetstehnika/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}, {
  title: 'Прицепы',
  route: '/zapchasti/pritsepy/',
  slug: '/zapchasti/pritsepy/',
  injectLocations: [__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY]
}];

var PROFILE = [{
  title: 'Мои объявления',
  route: '/my/'
}, {
  title: 'Сообщения',
  route: '/dialogs/'
}, {
  title: 'Баланс',
  route: '/billing/'
}, {
  title: 'Избранное',
  route: '/favorites/'
},
// {
//   title: 'Мои поиски',
//   route: '/my-searches',
// },
{
  title: 'Страховка',
  route: '/insurance/orders/'
}, {
  title: 'Подписки на поиск',
  route: '/service/search-subscriptions/'
}, {
  title: 'Настройки',
  route: '/profile/'
}];

var SEARCH = {
  avto: avto,
  //
  moto: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  mototsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  skuter: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  karting: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  kvadrotsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  tritsikl: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  moped: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  baggi: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  snegohod: moto.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  //
  gruzovye: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  avtobus: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  pritsepy: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  spetstehnika: truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY)),
  'vodnyi-transport': truck.map(withInjectLocations(__WEBPACK_IMPORTED_MODULE_0_shared_constants_locationTypes__["a" /* default */].CITY))
};

var SPARES = [
  // {
  //   title: 'Запчасти',
  //   route: '/zapchasti/',
  // },
  // {
  //   title: 'Новые',
  //   route: '/zapchasti?isNew=1',
  // },
  // {
  //   title: 'Б/y',
  //   route: '/zapchasti?isUsed=1',
  // },
  // {
  //   title: 'Каталог компаний',
  //   route: '/katalog-kompaniy/',
  // },
];

var LINKS = {
  HEADER: HEADER,
  FOOTER: FOOTER,
  PROFILE: PROFILE,
  SEARCH: SEARCH,
  SPARES: SPARES,
  AVTOSALONS_LINKS: AVTOSALONS_LINKS,
  FIRMS_TAGS_LINKS: FIRMS_TAGS_LINKS,
  SPARES_LINKS: SPARES_LINKS,
  moto: moto
};

/* harmony default export */ __webpack_exports__["a"] = (LINKS);

/***/ }),

/***/ 1249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Loader_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var _ref = _jsx('i', {
  className: 'fa fa-2x fa-spinner fa-spin'
});

function Loader(props) {
  var isLoading = props.isLoading,
      children = props.children,
      isHidden = props.isHidden,
      className = props.className,
      loaderElement = props.loaderElement,
      defaultClassName = props.defaultClassName;


  if (isHidden) {
    return null;
  }

  return isLoading ? _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a.root, className)
  }, void 0, loaderElement || _ref) : _jsx('div', {
    className: defaultClassName
  }, void 0, children);
}

Loader.defaultProps = {
  isLoading: false,
  isHidden: false,
  children: '',
  className: '',
  defaultClassName: '',
  loaderElement: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Loader_css___default.a)(Loader));

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Append the element into the DOM on mount. We'll render
      // into the modal container element (see the HTML tab).
      var modalRoot = document.getElementById('modal');
      modalRoot.appendChild(this.el);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove the element from the DOM when we unmount
      var modalRoot = document.getElementById('modal');
      modalRoot.removeChild(this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      // Use a portal to render the children into the element
      return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      this.props.children,
      // A DOM element
      this.el);
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),

/***/ 1251:
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NOTIFICATION_TYPES = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  INFO: 'INFO'
};

/* harmony default export */ __webpack_exports__["a"] = (NOTIFICATION_TYPES);

/***/ }),

/***/ 1255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var RegexpInput = function (_React$Component) {
  _inherits(RegexpInput, _React$Component);

  function RegexpInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RegexpInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegexpInput.__proto__ || Object.getPrototypeOf(RegexpInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          pattern = _this$props.pattern,
          onChange = _this$props.onChange;


      if (value.match(pattern) || value === '') {
        onChange(value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RegexpInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          inputRef = _props.inputRef,
          type = _props.type,
          props = _objectWithoutProperties(_props, ['onChange', 'inputRef', 'type']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ type: type, onChange: this.handleChange, ref: inputRef }, props));
    }
  }]);

  return RegexpInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RegexpInput.defaultProps = {
  pattern: '',
  value: undefined,
  inputRef: undefined,
  onChange: function onChange() {},
  type: 'text'
};


/* harmony default export */ __webpack_exports__["a"] = (RegexpInput);

/***/ }),

/***/ 1256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var isClient = true;

function ModalContainer(props) {
  var children = props.children,
      onClose = props.onClose,
      isOpen = props.isOpen,
      modalCN = props.modalCN;

  if (!isClient) return null;
  return isOpen && _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Modal__["a" /* default */], {}, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.root
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.background,
    onClick: onClose
  }), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.content, modalCN || __WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a.contentParams)
  }, void 0, children)));
}

ModalContainer.defaultProps = {
  isOpen: false,
  modalCN: '',
  onClose: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__ModalContainer_css___default.a)(ModalContainer));

/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var withBalance = function withBalance(forceUpdate) {
  return function (WrappedComponent) {
    var _class, _temp;

    var Component = (_temp = _class = function (_React$Component) {
      _inherits(Component, _React$Component);

      function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
      }

      _createClass(Component, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (forceUpdate || this.props.balance === null) {
            this.props.fetchBalance();
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              __ = _props.fetchBalance,
              props = _objectWithoutProperties(_props, ['fetchBalance']);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
        }
      }]);

      return Component;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withBalance(' + __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
      balance: null
    }, _temp);

    var mapStateToProps = function mapStateToProps(_ref) {
      var user = _ref.user;
      return {
        balance: user.balance.amount,
        isFetching: user.balance.isFetching
      };
    };
    var mapDispatchToProps = {
      fetchBalance: __WEBPACK_IMPORTED_MODULE_3_shared_actions_user__["g" /* fetchBalance */]
    };

    return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(Component);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withBalance);

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(319);
var TAG = __webpack_require__(86)('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),

/***/ 1261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CITY: 'city',
  COUNTRY: 'country'
});

/***/ }),

/***/ 1262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_routes__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__NavigationLink_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var NavigationLink = function (_React$Component) {
  _inherits(NavigationLink, _React$Component);

  function NavigationLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavigationLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavigationLink.__proto__ || Object.getPrototypeOf(NavigationLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          link = _this$props.link,
          eventPrefix = _this$props.eventPrefix,
          onClick = _this$props.onClick;

      onClick(e);
      if (!eventPrefix) return;

      var route = link.slug || link.route;
      var pattern = new RegExp('[/]{2,}', 'g');
      var slug = ('' + eventPrefix + route).replace(pattern, '/');
      var event = __WEBPACK_IMPORTED_MODULE_12_shared_constants_gtmEvents__["a" /* EVENTS */].NAVIGATION_LINK[slug];
      if (event) _this.props.setDataLayer(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavigationLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          including = _props.including,
          locationType = _props.locationType,
          currentRoute = _props.currentRoute,
          link = _props.link,
          className = _props.className,
          activeClassName = _props.activeClassName,
          t = _props.t;
      var route = link.route,
          injectLocations = link.injectLocations,
          title = link.title,
          _link$count = link.count,
          count = _link$count === undefined ? '' : _link$count;


      var isActive = false;
      if (currentRoute) {
        isActive = including ? currentRoute.includes(((link.slug || link.route) + '/').replace(/\/\//g, '/')) : currentRoute === ((link.slug || link.route) + '/').replace(/\/\//g, '/');
      }

      return isActive ? _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(className, activeClassName)
      }, void 0, t(title), count && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a.count
      }, void 0, ' ', count)) : _jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_Link_Link__["a" /* default */], {
        onClick: this.handleClick,
        to: location && injectLocations && injectLocations.includes(locationType) && __WEBPACK_IMPORTED_MODULE_8_shared_helpers_routes__["b" /* isValidLeasingLocationRoute */](route, location.slug) ? __WEBPACK_IMPORTED_MODULE_7_shared_helpers_locale__["d" /* injectLocationIntoHref */](route, location.slug) : route,
        className: className
      }, void 0, t(title), count && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a.count
      }, void 0, ' ', count));
    }
  }]);

  return NavigationLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavigationLink.defaultProps = {
  currentRoute: null,
  location: null,
  shouldCalculateActiveState: true,
  including: false,
  className: '',
  activeClassName: '',
  onClick: function onClick() {},
  eventPrefix: ''
};


var mapStateToProps = function mapStateToProps(_ref2) {
  var globals = _ref2.globals;
  return {
    location: globals.location,
    locationType: __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_countries_json___default.a.find(function (city) {
      return city.slug === (globals.location && globals.location.slug);
    }) ? __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__["a" /* default */].COUNTRY : __WEBPACK_IMPORTED_MODULE_10_shared_constants_locationTypes__["a" /* default */].CITY
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDataLayer: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_14__NavigationLink_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_13_shared_hocs_withTranslate__["a" /* withTranslate */](NavigationLink))));

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4c77a327.svg";

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1375);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Footer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1267:
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3C?xml version='1.0' encoding='iso-8859-1'?%3E %3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='792.033px' height='792.033px' viewBox='0 0 792.033 792.033' style='enable-background:new 0 0 792.033 792.033;' xml:space='preserve'%3E %3Cg%3E %3Cg id='_x38_'%3E %3Cg%3E %3Cpath d='M617.858,370.896L221.513,9.705c-13.006-12.94-34.099-12.94-47.105,0c-13.006,12.939-13.006,33.934,0,46.874 l372.447,339.438L174.441,735.454c-13.006,12.94-13.006,33.935,0,46.874s34.099,12.939,47.104,0l396.346-361.191 c6.932-6.898,9.904-16.043,9.441-25.087C627.763,386.972,624.792,377.828,617.858,370.896z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E\""

/***/ }),

/***/ 1268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/UI/InputText/InputText.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UIStyle_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var InputText = function InputText(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      inputParams = _objectWithoutProperties(_ref, ['changeHandler', 'name']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({
    className: __WEBPACK_IMPORTED_MODULE_3__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    }
  }, inputParams));
};

/* harmony default export */ var InputText_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__UIStyle_css__)(InputText));
// CONCATENATED MODULE: ./src/shared/components/UI/InputBirthday/InputBirthday.js
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UIStyle_css__);
var InputBirthday__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputBirthday__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var InputBirthday = function InputBirthday(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      mask = _ref.mask,
      placeholder = _ref.placeholder,
      inputParams = InputBirthday__objectWithoutProperties(_ref, ['changeHandler', 'name', 'mask', 'placeholder']);

  return InputBirthday___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, InputBirthday__extends({
    className: __WEBPACK_IMPORTED_MODULE_4__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    },
    placeholder: placeholder,
    mask: mask,
    maskChar: ' '
  }, inputParams));
};

InputBirthday.defaultProps = {
  value: '',
  mask: '99/99/9999',
  placeholder: '01/01/1990'
};

/* harmony default export */ var InputBirthday_defaultExport = (InputBirthday___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__UIStyle_css__)(InputBirthday));
// CONCATENATED MODULE: ./src/shared/components/UI/ContactButton/ContactButton.js
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ContactButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ContactButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactButton_css__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var isMobile = "desktop" === 'mobile';

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041D\u0435\u0442 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043E\u0432'
});

var ShowedContacts = function ShowedContacts(_ref) {
  var phones = _ref.phones;
  return _jsx('div', {
    className: isMobile ? null : __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.showedContainerDesktop
  }, void 0, phones.length ? phones.map(function (phone) {
    var nPhone = __WEBPACK_IMPORTED_MODULE_4_shared_modules__["j" /* phoneNormalize */](phone);
    return _jsx('a', {
      href: 'tel:' + nPhone,
      className: isMobile ? __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.showedPhoneMobile : null
    }, phone, nPhone);
  }) : _ref2);
};

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u0435\u043B\u0435\u0444\u043E\u043D'
});

var HidedContacts = function HidedContacts(_ref3) {
  var clickHandler = _ref3.clickHandler;
  return _jsx('button', {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hided, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hidedMobile, isMobile)),
    onClick: clickHandler
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hidedContent
  }, void 0, _ref4, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.hiddenPhone
  }, void 0, _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.Plus
  }, void 0, '+'), _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a.Dots
  }, void 0, '\u2022\u2022\u2022 \u2022\u2022 \u2022\u2022\u2022 \u2022\u2022 \u2022\u2022'))));
};

var ContactButton = function (_React$Component) {
  _inherits(ContactButton, _React$Component);

  function ContactButton() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = ContactButton.__proto__ || Object.getPrototypeOf(ContactButton)).call.apply(_ref5, [this].concat(args))), _this), _this.state = {
      isShowed: false,
      phones: []
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactButton, [{
    key: 'onClick',
    value: function onClick(e) {
      var _this2 = this;

      this.props.loadPhones(function (phones) {
        _this2.setState({ isShowed: true, phones: phones });
      });
      this.props.clickHandler(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var phonesState = this.props.phones.length ? this.props.phones : this.state.phones;
      var phones = phonesState.map(function (phone) {
        return phone.number ? phone.number : phone;
      });
      return _jsx(ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, this.state.isShowed ? _jsx(ShowedContacts, {
        phones: phones
      }) : _jsx(HidedContacts, {
        clickHandler: function clickHandler(e) {
          return _this3.onClick(e);
        }
      }));
    }
  }]);

  return ContactButton;
}(ContactButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContactButton.defaultProps = {
  phones: [],
  clickHandler: function clickHandler() {},
  loadPhones: function loadPhones(cb) {
    return cb([]);
  }
};


ShowedContacts.defaultProps = {
  phones: []
};

HidedContacts.defaultProps = {
  clickHandler: function clickHandler() {}
};

/* harmony default export */ var ContactButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__ContactButton_css___default.a)(ContactButton));
// CONCATENATED MODULE: ./src/shared/components/UI/InputPhoneNumber/InputPhoneNumber.js
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(479);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css___default = __webpack_require__.n(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__);
var InputPhoneNumber__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputPhoneNumber__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var InputPhoneNumber = function InputPhoneNumber(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      mask = _ref.mask,
      placeholder = _ref.placeholder,
      inputParams = InputPhoneNumber__objectWithoutProperties(_ref, ['changeHandler', 'name', 'mask', 'placeholder']);

  return InputPhoneNumber___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, InputPhoneNumber__extends({
    className: InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__["inputGeneral"],
    onChange: function onChange(e) {
      return changeHandler(name, e.target.value);
    }
  }, inputParams, {
    placeholder: placeholder,
    mask: mask,
    maskChar: ' ',
    type: 'tel'
  }));
};

InputPhoneNumber.defaultProps = {
  value: '',
  mask: '+3\\8 \\099 999 99 99',
  placeholder: '+38 (0**) *** ** **'
};

/* harmony default export */ var InputPhoneNumber_defaultExport = (InputPhoneNumber___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(InputPhoneNumber___WEBPACK_IMPORTED_MODULE_4__UIStyle_css__)(InputPhoneNumber));
// CONCATENATED MODULE: ./src/shared/components/UI/CheckBox/CheckBox.js
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CheckBox_css__);
var CheckBox__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CheckBox__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function CheckBox__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var CheckBox = function CheckBox(_ref) {
  var changeHandler = _ref.changeHandler,
      name = _ref.name,
      text = _ref.text,
      inputParams = CheckBox__objectWithoutProperties(_ref, ['changeHandler', 'name', 'text']);

  return CheckBox__jsx('label', {
    className: __WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default.a.checkbox
  }, void 0, CheckBox___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', CheckBox__extends({ type: 'checkbox', name: name, onChange: changeHandler }, inputParams)), ' ', CheckBox__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
    id: text
  }));
};

CheckBox.defaultProps = {
  changeHandler: function changeHandler() {}
};

/* harmony default export */ var CheckBox_defaultExport = (CheckBox___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__CheckBox_css___default.a)(CheckBox));
// CONCATENATED MODULE: ./src/shared/components/UI/TagButton/TagButton.js
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagButton_css__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TagButton_css__);
var TagButton__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TagButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function TagButton__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TagButton__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var TagButton = function TagButton(_ref) {
  var _cx;

  var title = _ref.title,
      clickHandler = _ref.clickHandler,
      Icon = _ref.Icon,
      disabled = _ref.disabled,
      className = _ref.className,
      inputParams = TagButton__objectWithoutProperties(_ref, ['title', 'clickHandler', 'Icon', 'disabled', 'className']);

  return TagButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    TagButton__extends({
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a((_cx = {}, TagButton__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a.tag, true), TagButton__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a.disabled, disabled), TagButton__defineProperty(_cx, className, !!className), _cx)),
      onClick: function onClick(e) {
        clickHandler(e, title);
      }
    }, inputParams),
    Icon ? TagButton__jsx(Icon, {}) : null,
    title
  );
};

TagButton.defaultProps = {
  disabled: false,
  className: '',
  Icon: null,
  clickHandler: function clickHandler() {}
};

/* harmony default export */ var TagButton_defaultExport = (TagButton___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__TagButton_css___default.a)(TagButton));
// CONCATENATED MODULE: ./src/shared/components/UI/Select/Select.js
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Select___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(477);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_css__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Select_css__);
var Select__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function Select__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var SelectWrapper = function SelectWrapper(params) {
  return Select__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Select_css___default.a.root, Select__defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Select_css___default.a['theme-' + params.theme], params.theme && __WEBPACK_IMPORTED_MODULE_4__Select_css___default.a['theme-' + params.theme]))
  }, void 0, Select___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], params));
};

/* harmony default export */ var Select_defaultExport = (Select___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Select_css___default.a)(SelectWrapper));
// CONCATENATED MODULE: ./src/shared/components/UI/NumberInputWithSelect/SelectInput/SelectInput.js
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_css__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelectInput_css__);
var SelectInput__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SelectInput__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SelectInput__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SelectInput__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SelectInput__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




 // eslint-disable-line css-modules/no-unused-class

var DEFAULT_SELECT_VALUE = 'default';
var stringOrNumberPropType = SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, SelectInput___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]);

var SelectInput__ref2 = SelectInput__jsx('i', {
  className: 'fa fa-angle-down'
});

var SelectInput = function (_React$Component) {
  SelectInput__inherits(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this, _ret;

    SelectInput__classCallCheck(this, SelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SelectInput__possibleConstructorReturn(this, (_ref = SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name,
          options = _this$props.options;

      var selectedOption = options[e.target.selectedIndex];

      onChange(name, selectedOption);
    }, _temp), SelectInput__possibleConstructorReturn(_this, _ret);
  }

  SelectInput__createClass(SelectInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          disabled = _props.disabled,
          titleKey = _props.titleKey;

      var selected = options.find(function (option) {
        return option.val === value;
      });

      return SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.root
      }, void 0, SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.selectContainer
      }, void 0, SelectInput__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.hint
      }, void 0, selected && (selected[titleKey] || selected.title) || '', SelectInput__ref2), SelectInput__jsx('select', {
        disabled: disabled,
        className: __WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a.select,
        onChange: this.handleSelectChange,
        value: value || DEFAULT_SELECT_VALUE
      }, void 0, options.map(function (item) {
        return SelectInput__jsx('option', {
          value: item.val || DEFAULT_SELECT_VALUE
        }, item.val + item.title, item[titleKey] || item.title);
      }))));
    }
  }]);

  return SelectInput;
}(SelectInput___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SelectInput.defaultProps = {
  options: [],
  onChange: function onChange() {},
  value: null,
  name: null,
  disabled: false,
  titleKey: 'title'
};


/* harmony default export */ var SelectInput_defaultExport = (SelectInput___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__SelectInput_css___default.a)(SelectInput));
// CONCATENATED MODULE: ./src/shared/components/UI/NumberInputWithSelect/NumberInputWithSelect.js
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_DecimalInput_DecimalInput__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css__);
var NumberInputWithSelect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var NumberInputWithSelect__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var NumberInputWithSelect__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NumberInputWithSelect__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function NumberInputWithSelect__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function NumberInputWithSelect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NumberInputWithSelect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NumberInputWithSelect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var NumberInputWithSelect_NumberInputWithSelect = function (_React$Component) {
  NumberInputWithSelect__inherits(NumberInputWithSelect, _React$Component);

  function NumberInputWithSelect() {
    var _ref;

    var _temp, _this, _ret;

    NumberInputWithSelect__classCallCheck(this, NumberInputWithSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = NumberInputWithSelect__possibleConstructorReturn(this, (_ref = NumberInputWithSelect.__proto__ || Object.getPrototypeOf(NumberInputWithSelect)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectChange = function (name, optionInfo) {
      var val = optionInfo.val,
          option = NumberInputWithSelect__objectWithoutProperties(optionInfo, ['val']);

      _this.props.onUnitsChange(option);
    }, _temp), NumberInputWithSelect__possibleConstructorReturn(_this, _ret);
  }

  NumberInputWithSelect__createClass(NumberInputWithSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          placeholder = _props.placeholder,
          unitsSwitchValue = _props.unitsSwitchValue,
          className = _props.className,
          error = _props.error,
          errorClassName = _props.errorClassName,
          onChange = _props.onChange,
          required = _props.required,
          decimal = _props.decimal,
          disabled = _props.disabled,
          Icon = _props.Icon,
          titleKey = _props.titleKey,
          theme = _props.theme,
          type = _props.type;

      var value = this.props.value || '';
      var unitsSwitchOptions = this.props.unitsSwitchOptions.filter(function (x) {
        return x;
      });

      var inputProps = {
        value: value,
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.input,
        placeholder: placeholder,
        onChange: onChange,
        disabled: disabled,
        type: type
      };

      return NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.root, className, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a['theme-' + theme], theme && __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a['theme-' + theme]))
      }, void 0, title && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.title, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.required, required))
      }, void 0, title), NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.inline, NumberInputWithSelect__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.hasIcon, !!Icon))
      }, void 0, !!Icon && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.icon
      }, void 0, NumberInputWithSelect__jsx(Icon, {})), decimal ? NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_components_DecimalInput_DecimalInput__["a" /* default */], inputProps) : NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__["a" /* default */], NumberInputWithSelect__extends({ inputMode: 'numeric' }, inputProps))), unitsSwitchOptions && unitsSwitchOptions.length > 0 && NumberInputWithSelect__jsx('div', {
        className: '' + __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.switch
      }, void 0, NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.switchDivider
      }), unitsSwitchOptions.length === 1 && NumberInputWithSelect__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a.singleOptionLabel
      }, void 0, unitsSwitchOptions[0][titleKey] || unitsSwitchOptions[0].title || ''), unitsSwitchOptions.length > 1 && NumberInputWithSelect__jsx(SelectInput_defaultExport, {
        options: unitsSwitchOptions.map(function (option) {
          return NumberInputWithSelect__extends({}, option, { val: option.id });
        }),
        onChange: this.handleSelectChange,
        value: unitsSwitchValue && unitsSwitchValue.id,
        titleKey: titleKey
      })), error && NumberInputWithSelect__jsx('p', {
        className: errorClassName
      }, void 0, error));
    }
  }]);

  return NumberInputWithSelect;
}(NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NumberInputWithSelect_NumberInputWithSelect.defaultProps = {
  title: null,
  className: '',
  errorClassName: '',
  placeholder: '',
  unitsSwitchOptions: [],
  onChange: function onChange() {},
  onUnitsChange: function onUnitsChange() {},
  value: null,
  unitsSwitchValue: null,
  error: null,
  required: false,
  decimal: false,
  disabled: false,
  Icon: null,
  titleKey: 'title',
  theme: '',
  type: 'text'
};


/* harmony default export */ var NumberInputWithSelect_defaultExport = (NumberInputWithSelect___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__NumberInputWithSelect_css___default.a)(NumberInputWithSelect_NumberInputWithSelect));
// CONCATENATED MODULE: ./src/shared/components/UI/InputPriceWithCurrencies/InputPriceWithCurrencies.js
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_searchForm__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UIStyle_css__);
var InputPriceWithCurrencies__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function InputPriceWithCurrencies__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










// import { MoneyIcon } from 'shared/components/Icons';



var sluggifiedCurrency = __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_currency_json___default.a.map(function (item) {
  return InputPriceWithCurrencies__extends({}, item, { id: item.slug });
});

var InputPriceWithCurrencies_InputPriceWithCurrencies = function InputPriceWithCurrencies(_ref) {
  var currency = _ref.currency,
      actions = _ref.actions,
      onChange = _ref.onChange,
      inputParams = InputPriceWithCurrencies__objectWithoutProperties(_ref, ['currency', 'actions', 'onChange']);

  return InputPriceWithCurrencies___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NumberInputWithSelect_defaultExport, InputPriceWithCurrencies__extends({}, inputParams, {
    // Icon={MoneyIcon}
    unitsSwitchOptions: sluggifiedCurrency,
    unitsSwitchValue: currency,
    onUnitsChange: function onUnitsChange(e) {
      actions.set.currency(e);
      onChange(inputParams.value);
    },
    onChange: onChange,
    titleKey: 'symbol'
  }));
};

InputPriceWithCurrencies_InputPriceWithCurrencies.defaultProps = {
  currency: sluggifiedCurrency[0],
  onChange: function onChange() {}
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var formState = _ref2.searchForm.selected;
  return {
    currency: formState.currency
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: {
      set: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */]({
        currency: __WEBPACK_IMPORTED_MODULE_6_shared_actions_searchForm__["m" /* selectedActions */].set.currency
      }, dispatch)
    }
  };
};

/* harmony default export */ var InputPriceWithCurrencies_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__UIStyle_css__)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(InputPriceWithCurrencies_InputPriceWithCurrencies)));
// CONCATENATED MODULE: ./src/shared/components/UI/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_Button__ = __webpack_require__(1287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_Button__["a"]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return InputText_defaultExport; });
/* unused concated harmony import InputBirthday */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return InputBirthday_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return ContactButton_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return InputPhoneNumber_defaultExport; });
/* unused concated harmony import CheckBox */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return CheckBox_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return TagButton_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return Select_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return NumberInputWithSelect_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return InputPriceWithCurrencies_defaultExport; });












/***/ }),

/***/ 1269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_hocs_withBalance__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import p24Img from './payment-4.svg';
// import billImg from './receipt.svg';


var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0433\u0440\u043D'
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0411\u0430\u043B\u0430\u043D\u0441'
});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u0433\u0440\u043D'
});

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C'
});

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0438 \u043E\u043F\u043B\u0430\u0442\u0435 \u0443\u0441\u043B\u0443\u0433 \u0438\u043B\u0438 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0441\u0432\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438'
});

var _ref7 = _jsx('a', {
  href: '/public-contract/',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430'
}));

var PaymentModal = function (_React$Component) {
  _inherits(PaymentModal, _React$Component);

  function PaymentModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PaymentModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaymentModal.__proto__ || Object.getPrototypeOf(PaymentModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedItem: _this.props.items[0],
      balanceRefillMode: false,
      isChecked: true
    }, _this.handleItemChosen = function (selectedItem) {
      _this.setState({ selectedItem: selectedItem });
      _this.props.agreeHandler(selectedItem);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PaymentModal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          balance = _props.balance,
          isFetching = _props.isFetching;


      if (prevProps.isFetching && !isFetching) {
        var selectedItem = this.state.selectedItem;
        var _props2 = this.props,
            amount = _props2.amount,
            items = _props2.items,
            balanceRefillMode = _props2.balanceRefillMode;

        var isBalanceEnough = amount <= balance;
        var isPayingForService = !isBalanceEnough || balanceRefillMode;
        var newSelectedItem = isPayingForService ? items.find(function (item) {
          return item.slug !== __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE;
        }) : selectedItem;

        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedItem: newSelectedItem,
          balanceRefillMode: isPayingForService
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var intl = this.props.intl;
      var _props3 = this.props,
          amount = _props3.amount,
          closeHandler = _props3.closeHandler,
          title = _props3.title,
          isLoading = _props3.isLoading,
          items = _props3.items,
          balance = _props3.balance,
          isFetching = _props3.isFetching;
      var _state = this.state,
          balanceRefillMode = _state.balanceRefillMode,
          isChecked = _state.isChecked;

      var isMobile = "desktop" === 'mobile';

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.root
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.bg,
        onClick: closeHandler
      }), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.container
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.column
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Loader_Loader__["a" /* default */], {
        isLoading: isFetching,
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.loader
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.columnWrapper
      }, void 0, _jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.h3
      }, void 0, title && _jsx('span', {}, void 0, title, ' - '), amount, ' ', _ref2), !isFetching && balance > 0 && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.balance
      }, void 0, _ref3, ':', ' ', _jsx('b', {}, void 0, balance, ' ', _ref4)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.list
      }, void 0, items.map(function (item) {
        var shouldDisable = !item.isBalanceRefillOption && balanceRefillMode || item.isBalanceRefillOption && !balanceRefillMode;
        // || (item.slug === PAYMENT_METHODS.INVOICE && !this.props.balanceRefillMode);
        if (_this2.props.disableBalance) {
          shouldDisable = item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE && _this2.props.disableBalance || item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].INVOICE && !_this2.props.balanceRefillMode;
        }
        if (item.slug === __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].FONDY_P24) shouldDisable = true;
        // todo delete this functionality when privat24 will working
        return shouldDisable ? null : _jsx('button', {
          className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.payment, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.disabled, isLoading)),
          onClick: function onClick() {
            return _this2.handleItemChosen(item);
          },
          disabled: isLoading || !isChecked
        }, item.slug, _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.paymentContents
        }, void 0, _jsx('img', {
          src: item.imgSrc,
          width: 60,
          alt: ''
        }), _jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.paymentTitle
        }, void 0, intl.formatMessage({ id: item.title }))));
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.actions
      }, void 0, _jsx('button', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.button,
        onClick: closeHandler
      }, void 0, _ref5)), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.contractOffer
      }, void 0, _jsx('label', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.checkbox, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.disabled, isChecked), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a.mobile, isMobile)),
        onClick: function onClick() {
          return _this2.setState({ isChecked: !isChecked });
        }
      }, void 0, _jsx('input', {
        type: 'checkbox',
        defaultChecked: isChecked
      })), _ref6, ' ', _ref7))))));
    }
  }]);

  return PaymentModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PaymentModal.defaultProps = {
  balance: null,
  items: [{
    title: 'Оплатить с личного счёта',
    imgSrc: __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default.a,
    slug: __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE,
    isBalanceRefillOption: false
  }, {
    title: 'Оплатить картой',
    imgSrc: __WEBPACK_IMPORTED_MODULE_8__assets_images_credit_card_svg___default.a,
    slug: __WEBPACK_IMPORTED_MODULE_7__constants_payment__["h" /* PAYMENT_METHODS */].MONO,
    isBalanceRefillOption: true
  }],
  isLoading: false,
  balanceRefillMode: false,
  disableBalance: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__PaymentModal_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_5_shared_hocs_withBalance__["a" /* default */](true)(PaymentModal))));

/***/ }),

/***/ 1270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DesktopButtonMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DesktopButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DesktopRightSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannersBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sticky__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_sticky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_modules_googletag_contentRollAdsense__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lazyload__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BannerAll_css__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












var MARGIN_TOP = 63;
var MARGIN_BOTTOM = 100;

var distanceFromBottom = 0;

var _ref2 = _jsx('div', {});

var DesktopButtonMark = function DesktopButtonMark() {
  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -68,
    disableCompensation: true
  }, void 0, function (_ref) {
    var distance = _ref.distanceFromBottom;

    distanceFromBottom = Number(distance);
    return _ref2;
  }));
};

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_modules_googletag_contentRollAdsense__["a" /* ContentRollAdsense */], {});

var DesktopButton = __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a)(function () {
  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -68,
    disableCompensation: true
  }, void 0, function (_ref3) {
    var distance = _ref3.distanceFromBottom;

    distanceFromBottom = Number(distance);
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.advertContainerButoon,
      id: 'div-gpt-ad-desktop_button-all'
    }, void 0, _ref4);
  }));
}); /* data.children */

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
}));

var _ref7 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref8 = _jsx('div', {
  id: 'height-div-gpt-ad-1510224251147-0'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
})));

var _ref10 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510239331518-1'
}));

var _ref11 = _jsx(__WEBPACK_IMPORTED_MODULE_8_react_lazyload___default.a, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1510224251147-0'
}));

var DesktopRightSidebar = __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a)(function (data) {
  if (data.scrollNo) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref5), data && data.children || '', _ref6);
  } else if (data.fixedSecondBanner) {
    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      id: 'height-div-gpt-ad-1510239331518-1'
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref7), data && data.children || ''), _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.homeSideBar
    }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
      topOffset: -MARGIN_TOP,
      disableCompensation: true
    }, void 0, function (props) {
      var style = props.style,
          bottomDistance = props.distanceFromBottom;

      var customStyle = _extends({}, style, { top: MARGIN_TOP + 'px' });

      if (+bottomDistance < MARGIN_BOTTOM) {
        customStyle = _extends({}, style, { top: bottomDistance - 20 });
      }
      return _jsx('div', {
        style: customStyle
      }, void 0, _ref8);
    })));
  }

  return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["StickyContainer"], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_sticky__["Sticky"], {
    topOffset: -MARGIN_TOP,
    disableCompensation: true
  }, void 0, function (_ref9) {
    var _ref9$style = _ref9.style,
        style = _ref9$style === undefined ? { transform: 'translateZ(0)' } : _ref9$style,
        distanceFromTop = _ref9.distanceFromTop,
        distanceFromBottomValue = _ref9.distanceFromBottom;

    var padding = 35;
    var scroll = MARGIN_TOP;
    var scrollTwo = 0;
    var bodyABIdBlockHeight = 0;
    var blockHeight = 0;
    var blockHeightAbove600 = false;
    var bodyABIdBlockHeightAbove = false;
    var doNotScroll = 0;

    var bannerBlock1 = 0;
    var bannerBlock2 = 0;

    if (true) {
      var heightDivDptAd1510239331518 = window.document.getElementById('height-div-gpt-ad-1510239331518-1') || {};
      var heightDivGptAd15102242511470 = window.document.getElementById('height-div-gpt-ad-1510224251147-0') || {};
      var bodyABIdBlock = window.document.getElementById('bodyABIdBlock') || {};
      bodyABIdBlockHeight = Number(bodyABIdBlock.clientHeight);
      blockHeight = Number(heightDivDptAd1510239331518.clientHeight);
      scroll = Number('-' + heightDivDptAd1510239331518.clientHeight) || MARGIN_TOP;
      scrollTwo = Number('-' + heightDivGptAd15102242511470.clientHeight) || 0;
      blockHeightAbove600 = blockHeight > 600;
      bodyABIdBlockHeightAbove = bodyABIdBlockHeight > Math.abs(distanceFromTop) + Math.abs(scrollTwo) + padding + 20 + 35;

      bannerBlock1 = Number(heightDivDptAd1510239331518.clientHeight) || 0;
      bannerBlock2 = Number(heightDivGptAd15102242511470.clientHeight) || 0;

      doNotScroll = bodyABIdBlockHeight - 130 < bannerBlock1 + bannerBlock2;
    }

    if (distanceFromBottomValue - padding - bannerBlock2 < 0) {
      scroll += distanceFromBottomValue - padding - bannerBlock2 + 35;
    } else if (!bodyABIdBlockHeightAbove) {
      scroll += bodyABIdBlockHeight - Math.abs(distanceFromTop) - Math.abs(scrollTwo) - padding - 20;
    } else if (blockHeightAbove600) {
      if (distanceFromBottom + scrollTwo + padding < 100) {
        if (distanceFromBottom + scrollTwo - MARGIN_TOP > scroll) {
          scroll = distanceFromBottom + scrollTwo;
        } else {
          scroll += padding;
        }
      } else {
        scroll = MARGIN_TOP;
      }
    } else {
      scroll = distanceFromTop;
    }

    var fun = function fun() {
      var obj = {};
      if (!blockHeightAbove600 && distanceFromTop < Number('-' + blockHeight)) {
        obj.position = 'fixed';
        obj.top = Math.abs(distanceFromTop - MARGIN_TOP) + 'px';
      }
      return obj;
    };

    return _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.sideBar)
    }, void 0, _jsx('div', {
      style: doNotScroll ? {} : _extends({}, style, { top: scroll + 'px' })
    }, void 0, _jsx('div', {
      id: 'height-div-gpt-ad-1510239331518-1'
    }, void 0, _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_9__BannerAll_css___default.a.gptPremium
    }, void 0, _ref10), data && data.children || ''), _jsx('div', {
      style: fun(),
      id: 'height-div-gpt-ad-1510224251147-0'
    }, void 0, _ref11)));
  }));
});

var BannersBuffer = __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](function (_ref12) {
  var globals = _ref12.globals;
  return {
    bannerNotErr: globals.banner && globals.banner.bannerNotErr
  };
})(function () {
  function BannersBuffer(props) {
    var bannerNotErr = props.bannerNotErr;

    return _jsx('div', {
      style: { display: 'none' }
    }, void 0, Object.keys(bannerNotErr).map(function (a) {
      return _jsx('div', {
        id: a
      }, a, '.');
    }));
  }

  BannersBuffer.defaultProps = {
    bannerNotErr: {}
  };
  return BannersBuffer;
}());

/***/ }),

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return posted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createdDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return shortCreatedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFullDate; });
/* unused harmony export getShotDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__ = __webpack_require__(190);



var posted = function posted(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';

  if (__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](__WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__["default"](new Date(time)), 'yyyy-MM-dd') === __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](__WEBPACK_IMPORTED_MODULE_1_date_fns_endOfDay__["default"](new Date()), 'yyyy-MM-dd')) {
    return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'H:mm');
  }
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'MMMM d, yyyy', locale);
};

var createdDate = function createdDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'MMMM d, yyyy', locale);
};

var shortCreatedDate = function shortCreatedDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'dd.MM', locale);
};

var getFullDate = function getFullDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'H:mm, MMMM d, yyyy', locale);
};

var getShotDate = function getShotDate(time) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ru';
  return __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](time, 'dd-MM-yyyy', locale);
};

/***/ }),

/***/ 1272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserThing; });
/* unused harmony export formatPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return verifyYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getYearsOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getParamByKey; });
/* unused harmony export rewriteMinMaxYear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return correctionYears; });
/* unused harmony export getActiveAdvsCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isSlotAvailable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_arrays__ = __webpack_require__(104);



var getUserName = function getUserName(_ref) {
  var _ref$first_name = _ref.first_name,
      firstName = _ref$first_name === undefined ? null : _ref$first_name,
      _ref$last_name = _ref.last_name,
      lastName = _ref$last_name === undefined ? null : _ref$last_name;
  return firstName || lastName ? [firstName, lastName].filter(function (i) {
    return !!i;
  }).join(' ') : null;
};

var getUserThing = function getUserThing(_ref2) {
  var email = _ref2.email,
      _ref2$phones = _ref2.phones,
      phones = _ref2$phones === undefined ? [] : _ref2$phones,
      name = _ref2.name;

  var verifiedPhones = phones.filter(function (phone) {
    return phone.is_verified;
  });
  var emailAndPhones = verifiedPhones.length > 0 ? '' + verifiedPhones[0].number : email;
  return name || emailAndPhones;
};

var formatPhone = function formatPhone(phone) {
  var numberPhone = phone.replace(/[+\s_()]/g, '');
  return '380' + numberPhone.slice(-9);
};

var verifyYear = function verifyYear(year) {
  return year && (year < 1900 || year > +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy')));
};

var getYearsOptions = function getYearsOptions() {
  var YEAR_FROM = 1901;
  var YEAR_TO = new Date().getFullYear();
  var YEARS = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_arrays__["c" /* getRange */](YEAR_FROM, YEAR_TO);

  return YEARS.map(function (year) {
    return { title: year, val: year };
  }).reverse();
};

var getParamByKey = function getParamByKey(arr, key) {
  if (arr && arr.length) return arr[0][key];
  return null;
};

var rewriteMinMaxYear = function rewriteMinMaxYear(year) {
  if (!year) return year;else if (+year < 1900) return 1900;else if (+year > +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy'))) return +Number(__WEBPACK_IMPORTED_MODULE_0_shared_helpers_locale__["c" /* getFormattedDateFns */](new Date(), 'yyyy'));
  return +year;
};

var correctionYears = function correctionYears(formState) {
  var yearTo = formState.yearTo,
      yearFrom = formState.yearFrom;


  yearTo = rewriteMinMaxYear(yearTo);
  yearFrom = rewriteMinMaxYear(yearFrom);

  if (yearTo && yearFrom && yearTo < yearFrom) return { yearTo: yearFrom, yearFrom: yearTo };
  return { yearTo: yearTo, yearFrom: yearFrom };
};

/**
 * Get count of activated adverts
 * @returns {Number}
 */
var getActiveAdvsCount = function getActiveAdvsCount(user) {
  if (!user || !user.id) return 0;
  var activeKeys = Object.keys(user.active_adverts);
  var count = activeKeys.reduce(function (acc, value) {
    return acc + user.active_adverts[value];
  }, 0);
  return count;
};

/**
 * Get count of activated adverts
 * @returns {Boolean}
 */
var isSlotAvailable = function isSlotAvailable(user) {
  if (getActiveAdvsCount(user) === 0) return true;
  return !!user.tariff && user.tariff.slots_limit > getActiveAdvsCount(user);
};

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(1285);

/***/ }),

/***/ 1274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getFieldFromRootOrCharacteristics; });
/* unused harmony export getNumberOrTitleFromRootOrCharacteristics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCapacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getMileageText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return constructModification; });
/* unused harmony export getModification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return carPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return carPriceBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getPriceBySlug; });
/* unused harmony export getCurrencyTitleBySlug */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getSymbolTitleBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getPriceValueBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getPriceWithCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isLocationCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertMlToKm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getMileageString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCapacityUnitTitleById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getCountryById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdvertStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdvertOgImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getTransportInfoFiltered; });
/* unused harmony export getIconsByFieldName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getTechnicalsSpecifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__arrays__ = __webpack_require__(104);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












var getFieldFromRootOrCharacteristics = function getFieldFromRootOrCharacteristics(key, advert) {
  if (!advert || !key) {
    return null;
  }

  var characteristics = advert.characteristics || {};
  if (advert[key] && advert[key].title && advert[key].id) {
    return advert[key];
  } else if (characteristics[key] && characteristics[key].title && characteristics[key].id) {
    return characteristics[key];
  }

  return null;
};

var getNumberOrTitleFromRootOrCharacteristics = function getNumberOrTitleFromRootOrCharacteristics(key, advert) {
  var result = getFieldFromRootOrCharacteristics(key, advert);

  if (result && result.number) {
    return result.number;
  } else if (result && result.title) return result.title;

  return result;
};

var getPower = function getPower(advert, t) {
  var powerUnit = __WEBPACK_IMPORTED_MODULE_0_shared_constants_json_powerUnits_json___default.a.find(function (item) {
    return item.id === advert.power_unit;
  });
  var power = getNumberOrTitleFromRootOrCharacteristics('power', advert);

  return power ? '(' + power + ' ' + (powerUnit && t(powerUnit.title)) + ')' : '';
};

/**
 * @param advert {object}
 * @param key {string} - one of ['capacity', 'capacity_body', 'capacity_bucket']
 * @param t {function}
 * @returns {string}
 */
var getCapacity = function getCapacity(advert, t) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'capacity';

  var capacityUnit = __WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json___default.a.find(function (item) {
    return item.id === advert.capacity_unit;
  });
  var capacity = getNumberOrTitleFromRootOrCharacteristics(key, advert);

  return capacity && capacityUnit ? '' + capacity + t(capacityUnit.title) : '';
};

var getMileageText = function getMileageText(advert, t) {
  var mileage = advert.mileage,
      mileageUnitId = advert.mileage_unit,
      isNew = advert.is_new;

  var mileageUnit = __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json___default.a.find(function (item) {
    return item.id === mileageUnitId;
  });

  var mileageText = mileage > 0 ? mileage + ' ' + t(__WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](mileageUnit)) : null;
  if (isNew) {
    mileageText = t('новый');
  }

  return mileageText;
};

var constructModification = function constructModification(advert, t) {
  var gearbox = getFieldFromRootOrCharacteristics('gearbox', advert);
  var power = getPower(advert, t);
  var capacity = getCapacity(advert, t);

  return __WEBPACK_IMPORTED_MODULE_9__arrays__["a" /* cleanArray */]([capacity, __WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](gearbox).toLowerCase(), power]).join(' ').trim();
};

var getModification = function getModification(advert, t) {
  if (advert.modification && advert.modification.id) {
    return advert.modification.title || '';
  }

  return constructModification(advert, t);
};

var carPrice = function carPrice(price, currency) {
  var priceString = __WEBPACK_IMPORTED_MODULE_8__common__["k" /* numberWithSpaces */](price);
  var currencyTitle = currency.symbol || currency.title;

  return priceString + ' ' + currencyTitle;
};

var carPriceBySlug = function carPriceBySlug(prices, currency) {
  if (!currency || !prices) {
    return '';
  }

  var price = prices.find(function (item) {
    return item.currency === currency.slug;
  });
  if (!price) {
    return '';
  }

  return carPrice(price.value, currency);
};

var getPriceBySlug = function getPriceBySlug(prices, slug) {
  var getNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!slug || !prices) {
    return '';
  }

  var currency = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (c) {
    return c.slug === slug;
  });
  var price = prices.find(function (item) {
    return item.currency === currency.slug;
  });
  if (!price) {
    return '';
  }
  if (getNumber) return price.value;
  return carPrice(price.value, currency);
};

var getCurrencyTitleBySlug = function getCurrencyTitleBySlug(slug) {
  var currentCurrencyObj = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (item) {
    return item.slug === slug;
  });

  var _ref = currentCurrencyObj || {},
      title = _ref.title;

  return title;
};

var getSymbolTitleBySlug = function getSymbolTitleBySlug(slug) {
  var currentCurrencyObj = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (item) {
    return item.slug === slug;
  });

  var _ref2 = currentCurrencyObj || {},
      symbol = _ref2.symbol;

  return symbol;
};

var getPriceValueBySlug = function getPriceValueBySlug(prices, slug) {
  var currentPriceObj = prices.find(function (price) {
    return price.currency === slug;
  });

  return currentPriceObj ? currentPriceObj.value : null;
};

var getPriceWithCurrency = function getPriceWithCurrency(prices, slug) {
  var value = getPriceValueBySlug(prices, slug);
  var currency = getCurrencyTitleBySlug(slug);

  if (typeof value !== 'number' || !currency) {
    return null;
  }

  return slug === 'usd' ? currency + ' ' + __WEBPACK_IMPORTED_MODULE_8__common__["k" /* numberWithSpaces */](value) : __WEBPACK_IMPORTED_MODULE_8__common__["k" /* numberWithSpaces */](value) + ' ' + currency;
};

var isLocationCountry = function isLocationCountry(location) {
  if (!location || !location.id) {
    return null;
  }

  return !!__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json___default.a.find(function (country) {
    return country.id === location.id;
  });
};

var convertMlToKm = function convertMlToKm(car) {
  if (car.mileage_unit === 0) {
    return car.mileage;
  } else if (car.mileage_unit === 1) {
    return car.mileage * 1.61;
  }
};

var getMileageString = function getMileageString(mileage, mileageUnitId) {
  if (!mileage || typeof mileageUnitId !== 'number') {
    return null;
  }

  var mileageUnitTitle = __WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_mileageUnits_json___default.a.find(function (unit) {
    return unit.id === mileageUnitId;
  }));

  return mileage + ' ' + mileageUnitTitle.replace(/[.]/g, '');
};

var getCapacityUnitTitleById = function getCapacityUnitTitleById(unitId) {
  return __WEBPACK_IMPORTED_MODULE_8__common__["h" /* getTitleOrEmpty */](__WEBPACK_IMPORTED_MODULE_1_shared_constants_json_capacityUnits_json___default.a.find(function (unit) {
    return unit.id === unitId;
  }));
};

var getCountryById = function getCountryById(id) {
  return __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_countries_json___default.a.find(function (item) {
    return item.id === id;
  });
};

var translateTitle = function translateTitle(item, intl) {
  return item.title ? _extends({}, item, { title: intl.formatMessage({ id: item.title }) }) : item;
};

var getAdvertStatuses = function getAdvertStatuses(advert, intl) {
  return [].concat(_toConsumableArray([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5_shared_constants_json_statuses_json___default.a), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_priceStatuses_json___default.a), [{ title: 'авто не в Украине', id: 'abroad' }]).filter(function (status) {
    return advert[status.id];
  }).map(function (item) {
    return translateTitle(item, intl);
  })), _toConsumableArray(advert.is_not_cleared ? [] : [{ id: '__is_not_cleared', title: '' + intl.formatMessage({ id: 'растаможен' }) }]), _toConsumableArray(advert.driven_from && advert.driven_from.id && !!getCountryById(advert.driven_from.id) ? [{
    title: '\u0430\u0432\u0442\u043E ' + getCountryById(advert.driven_from.id).from[intl.locale],
    id: 'driven_from'
  }] : []));
};

var getAdvertOgImage = function getAdvertOgImage(advert) {
  return advert && advert.photos && advert.photos.length > 0 && advert.photos[0] && advert.photos[0].image ? advert.photos[0].image : undefined;
};

var getTechnicalsSpecification = function getTechnicalsSpecification(advert, item, t) {
  switch (item) {
    case 'engine':
      return getFieldFromRootOrCharacteristics('engine', advert);
    case 'mileage':
      return {
        slug: item,
        id: 999,
        title: getMileageText(advert, t)
      };
    case 'gearbox':
      return getFieldFromRootOrCharacteristics('gearbox', advert);
    case 'drive':
      return getFieldFromRootOrCharacteristics('drive', advert);
    case 'year':
      return {
        slug: item,
        id: 888,
        title: advert.year
      };
    case 'location':
      return {
        slug: item,
        id: 777,
        title: advert.location.title
      };
    default:
      return {
        slug: '',
        id: 0,
        title: ''
      };
  }
};

var getTransportInfoFiltered = function getTransportInfoFiltered() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'avto';

  var types = {
    avto: ['location', 'year', 'modification', 'mileage', 'body', 'color', 'engine', 'gearbox', 'drive', 'vin']
  };
  return types[type] ? types[type] : [];
};

var getIconsByFieldName = function getIconsByFieldName() {
  return {
    mileage: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["o" /* SpeedIcon */],
    gearbox: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["h" /* GearboxIcon */],
    year: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["b" /* CalendarIcon */],
    engine: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["f" /* EngineIcon */],
    drive: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["d" /* ChassisIcon */],
    location: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["l" /* LocationIcon */],
    color: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["e" /* ColorIcon */],
    vin: __WEBPACK_IMPORTED_MODULE_7_shared_components_Icons__["s" /* VinIcon */]
  };
};

var getTechnicalsSpecifications = function getTechnicalsSpecifications(advert, items, t) {
  var icons = getIconsByFieldName();
  return items.map(function (slug) {
    var params = getTechnicalsSpecification(advert, slug, t);
    return _extends({
      icon: icons[slug] || null
    }, params);
  }).filter(function (item) {
    return item && item.title;
  });
};

/***/ }),

/***/ 1275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function ModalWrapper(props) {
  return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, props.show && _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
    modalCN: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.modal,
    onClose: props.toggleModal,
    isOpen: props.show
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.rootModal
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.rootModalContainer
  }, void 0, props.children, _jsx('i', {
    className: 'fa fa-times ' + __WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a.closeBtnIcon,
    onClick: props.toggleModal
  })))));
}

ModalWrapper.defaultProps = {
  children: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ModalWrapper_css___default.a)(ModalWrapper));

/***/ }),

/***/ 1276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IGNORE_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */

function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          var handlerOptions = null;
          var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

          if (isTouchEvent && passiveEventSupport) {
            handlerOptions = {
              passive: !_this.props.preventDefault
            };
          }

          document.addEventListener(eventName, handlersMap[_this._uid], handlerOptions);
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn);
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */

    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["a"] = (onClickOutsideHOC);

/***/ }),

/***/ 1277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/leasing/myAutoCalculate.js
/**
 * Формула коэффициента аннуитета:
 * К = (i * (1 + i)^n) / ((1+i)^n-1)
 * где i – процентная ставка за месяц, результат деления годовой ставки на 12;
 * n – срок кредита в месяцах.
 */
function getAnnuityFactor(rate, term) {
  var i = rate / 12 / 100;
  var n = term;
  return i * Math.pow(1 + i, n) / (Math.pow(1 + i, n) - 1);
}

/**
   * Месячный платеж по аннуитету
   * sum * annuityFactor
   */
function getAnnuityMonthPayment(sum, rate, term) {
  var factor = getAnnuityFactor(rate, term);
  return sum * factor;
}
// getAnnuityMonthPayment
// этот надо вызывать
// sum - цена тачки минус аванс
// rate - до 10 лет 40%, до 17 - 45%, иначе - 49%
// ß - 84

function getAnnuityRate(year) {
  var currentYear = new Date().getFullYear();
  var diff = currentYear - year;
  if (diff <= 17) return 45;
  if (diff <= 10) return 40;
  return 49;
}
// CONCATENATED MODULE: ./src/shared/helpers/leasing/utils.js
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCleanDeviceId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return execPostRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLeasingParms; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getCapacity;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLeasingArgumentsByAdv;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateExchange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMonthlyPrice; });
/* unused harmony export calculateMonthlyPayment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateMonthlyPaymentV2; });
/* unused harmony export isHapaiLeasing */
/* unused harmony export isAutoMoneyLeasing */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isUlfLeasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isUlf24Leasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getMothlyPaymentFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return userFormValidation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_regexp__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_google__ = __webpack_require__(499);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



// import API from 'shared/constants/api';







var isClient = true;
var HOST = process.env.HOST || process.env.WEBSITE_HOSTNAME;

/**
 *
 * @param {String} deviceId
 * @returns
 */
var getCleanDeviceId = function getCleanDeviceId(deviceId) {
  return deviceId.replace(/^"(.*)"$/, '$1');
};

/**
 *
 * @param {String} path
 * @param {Object} body
 * @param {Function} fetch
 * @param {Object} headers
 * @param {String} action
 * @returns
 */
var execPostRequest = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path, body, fetch) {
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var action = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'addlead';
    var result, gtoken, data, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            result = null;
            // const headers = { 'Content-Type': 'application/json', addHeaders }; // 'x-access-key': X_ACCESS_KEY_VRF

            _context.prev = 1;

            if (!action) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_6_shared_helpers_google__["a" /* getGoogleCaptchaToken */](action);

          case 5:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;

          case 8:
            _context.t0 = '';

          case 9:
            gtoken = _context.t0;
            data = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', headers: headers, gtoken: gtoken },
              body: JSON.stringify(body)
            };
            _context.next = 13;
            return fetch(path, data);

          case 13:
            response = _context.sent;
            _context.next = 16;
            return response.json();

          case 16:
            result = _context.sent;
            _context.next = 21;
            break;

          case 19:
            _context.prev = 19;
            _context.t1 = _context['catch'](1);

          case 21:
            return _context.abrupt('return', result);

          case 22:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 19]]);
  }));

  return function execPostRequest(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

// TODO; MOVE METHODS TO MyCredits !!!

var getLeasingParms = function getLeasingParms(advert) {
  var finUp = advert.fin_up_verification;

  if (finUp && finUp.payload && finUp.payload.monthlyPayment) {
    return finUp.payload;
  }
  return null;
};

function getFeatures(options) {
  if (!Array.isArray(options) || !options.length) return [];
  var features = [];
  for (var i = 0, l = options.length; i < l; i += 1) {
    var _options$i = options[i],
        title = _options$i.title,
        parents = _options$i.parents;

    if (__WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["d" /* FEATURES */][title]) {
      features.push(__WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["d" /* FEATURES */][title]);
    } else if (parents[1] && __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["d" /* FEATURES */][parents[1].title + '-' + title]) {
      features.push(__WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["d" /* FEATURES */][parents[1].title + '-' + title]);
    }
  }
  return features;
}

function getCapacity(adv) {
  var cpcty = adv.characteristics.capacity ? adv.characteristics.capacity.number : adv.capacity;
  var capacity = cpcty / 100 > 0.1 ? cpcty : cpcty * 1000;
  return capacity;
}

function getGeo(adv) {
  var obl = adv.location && adv.location.parents && adv.location.parents.pop();
  var geo = obl && obl.title + ', ' + adv.location.title || (adv.location && adv.location.title ? adv.location.title : adv.location);
  return geo;
}

function getLeasingArgumentsByAdv(adv) {
  var generation = adv.modification.generation && adv.modification.generation.title;
  var geo = getGeo(adv);
  var photos = (adv.photos || []).map(function (photo) {
    return photo.image;
  }) || [];
  var name = adv.author && adv.author.first_name && adv.author.first_name || '';
  var phones = adv.agency && Array.isArray(adv.agency.phones) && adv.agency.phones.map(function (phone) {
    return phone.number;
  }) || [];

  var params = {
    localId: '' + adv.id,
    brand: adv.make.slug || adv.make_title,
    model: adv.model.slug || adv.model_title,
    generation: generation,
    year: adv.year,
    engineType: adv.engine && __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["c" /* ENGINES_CONVERTER */][adv.engine.slug],
    transmission: adv.gearbox && __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["e" /* GEARBOX_CONVERTER */][adv.gearbox.slug],
    engineVolumeMl: getCapacity(adv),
    mileageKm: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["d" /* convertMlToKm */](adv) * 1000,
    description: adv.description,
    features: getFeatures(adv.options),
    geo: geo,
    photos: photos,
    wheelDrive: adv.drive && __WEBPACK_IMPORTED_MODULE_0_shared_constants_adverts__["g" /* WHELL_DRIVE */][adv.drive.slug],
    contact: {
      name: name,
      phones: phones
    }
  };

  var path = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_urls__["g" /* generateUrl */](adv);
  var host = isClient && location && location.host || HOST || 'avtobazar.ua';
  var url = 'https://' + host + path;
  var options = {
    sum: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["n" /* getPriceValueBySlug */](adv.price, 'usd'),
    url: url,
    currency: 'USD'
  };
  return { params: params, options: options };
}

// export const calculateExchange = (prices, value, currency) => {
//   const isUsdCurrent = prices.find(data => data.exchange_rate === 1 && data.currency === 'usd');
//   const isUsdCurrent = prices.find(data => data.exchange_rate === 1 && data.currency === 'eur');

//   const ukExchangeRate = prices.find(
//     exchangeItem =>
//       isUsdCurrent ? exchangeItem.currency === 'uah' : exchangeItem.currency === 'usd',
//   ).exchange_rate;

//   let result = 0;
//   if (currency === 'usd') result = isUsdCurrent ? value / ukExchangeRate : value * ukExchangeRate;
//   else result = isUsdCurrent ? value * ukExchangeRate : value / ukExchangeRate;

//   return parseInt(result, 10);
// };

var calculateExchange = function calculateExchange(prices, value, toCurrency) {
  var fromCurrency = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'usd';

  var toCurr = prices.find(function (data) {
    return data.currency === toCurrency;
  });
  var fromCurr = prices.find(function (data) {
    return data.currency === fromCurrency;
  });

  if (toCurrency.exchange_rate === 1) {
    return parseInt(toCurr.exchange_rate * value, 10);
  }
  if (fromCurrency.exchange_rate === 1) {
    return parseInt(value / fromCurr.exchange_rate, 10);
  }
  return parseInt(value / fromCurr.exchange_rate * toCurr.exchange_rate, 10);
};

/**
 *
 * @param {Object} advert
 * @param {Number} monthly
 * @param {String} currencySlug
 * @param {String} formated
 * @returns
 */
var getMonthlyPrice = function getMonthlyPrice(advert, monthly) {
  var currencySlug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'uah';
  var formated = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!advert || !monthly) return 0;
  var prices = [];

  if (Array.isArray(advert.prices)) prices = advert.prices;else if (Array.isArray(advert.price)) prices = advert.price;

  var result = calculateExchange(prices, monthly, currencySlug);

  return formated ? __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["k" /* numberWithSpaces */](result) : result;
};

var calculateMonthlyPayment = function calculateMonthlyPayment(advert) {
  var TERM = 84;
  var PREPAID = 0.3;

  var year = advert.year;


  var price = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_advert__["c" /* getPrice */](advert.price || advert.prices, ['usd']);
  var sum = price - price * PREPAID;
  var rate = getAnnuityRate(year);
  var monthly = getAnnuityMonthPayment(sum, rate, TERM);
  // console.log(`PRICE: ${price}, SUN: ${sum}, RATE: ${rate}, TERM: ${TERM} RESULT : ${monthly}`);

  return monthly;
};

var calculateMonthlyPaymentV2 = function calculateMonthlyPaymentV2(data) {
  var year = data.year,
      term = data.term,
      price = data.price,
      prepaid = data.prepaid,
      comission = data.comission,
      rate = data.rate;

  var sum = price - (prepaid - comission);
  var monthly = getAnnuityMonthPayment(sum, rate || getAnnuityRate(year), term || 84);

  return Math.round(monthly);
};

var isHapaiLeasing = function isHapaiLeasing(lp) {
  return lp && lp.extendedParams && lp.extendedParams.hapai;
};
var isAutoMoneyLeasing = function isAutoMoneyLeasing(lp) {
  return false;
}; // lp && lp.isAutoMoneyCalculated;
var isUlfLeasing = function isUlfLeasing(lp) {
  return lp && lp.isUlfCalculated;
};
var isUlf24Leasing = function isUlf24Leasing(lp) {
  return lp && lp.isUlf24Calculated;
};

var getMothlyPaymentFormatted = function getMothlyPaymentFormatted(lp) {
  return lp && lp.extendedParams && (lp.extendedParams.hapai && lp.extendedParams.hapai.monthlyPaymentUAHFormatted || lp.extendedParams.monthlyPaymentUAHFormatted);
};

var userFormValidation = function userFormValidation(data) {
  var phoneToTest = '';
  var tempPhone = data.phone.replace(/\s/g, '');
  if (tempPhone.charAt(0) !== '+') {
    phoneToTest = '+' + tempPhone;
  } else {
    phoneToTest = tempPhone;
  }

  if (!__WEBPACK_IMPORTED_MODULE_5_shared_constants_regexp__["b" /* default */].phone.test(phoneToTest) || phoneToTest.charAt(4) === '0' || phoneToTest.length !== 13) {
    return 'Некорректный номер мобильного телефона';
  }

  if (!__WEBPACK_IMPORTED_MODULE_5_shared_constants_regexp__["b" /* default */].name.test(data.userName)) {
    return 'Некорректное имя';
  }
  return '';
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(250)))

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1260);
var ITERATOR = __webpack_require__(86)('iterator');
var Iterators = __webpack_require__(187);
module.exports = __webpack_require__(30).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CircleTimer_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref2 = _jsx('circle', {
  fill: 'rgba(255, 217, 6, 0.2)',
  stroke: 'rgba(255, 217, 6, 0.2)',
  strokeWidth: '2',
  cx: '50%',
  cy: '50%',
  r: '50'
});

var CircleTimer = function (_React$Component) {
  _inherits(CircleTimer, _React$Component);

  function CircleTimer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CircleTimer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CircleTimer.__proto__ || Object.getPrototypeOf(CircleTimer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      formatedTime: '0:00',
      iId: 0,
      time: 0
    }, _this.componentDidMount = function () {
      _this.setState({
        time: _this.props.time,
        formatedTime: _this.formatTime(_this.props.time)
      });
      _this.startTimer();
    }, _this.componentWillUnmount = function () {
      _this.stopTimer();
    }, _this.formatTime = function (time) {
      var minutes = Math.floor(time / 60);
      var seconds = time % 60;
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return minutes + ':' + seconds;
    }, _this.startTimer = function () {
      var self = _this;
      var _this$props = _this.props,
          time = _this$props.time,
          repeat = _this$props.repeat,
          timeUp = _this$props.timeUp;


      var callCallback = function callCallback() {
        setTimeout(timeUp);
      };

      var iId = setInterval(function () {
        if (self.state.time < 1) {
          if (!repeat) {
            try {
              self.stopTimer();
              callCallback();
            } catch (err) {}
          } else {
            self.state.time = time;
          }
        } else {
          self.state.time -= 1;
        }

        var formatedTime = self.formatTime(self.state.time);
        self.setState({ formatedTime: formatedTime });
      }, 1000);
      self.setState({ iId: iId });
    }, _this.stopTimer = function () {
      clearInterval(_this.state.iId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CircleTimer, [{
    key: 'render',
    value: function render() {
      var seconds = this.props.time + 's';
      var animationFill = this.props.repeat ? 'remove' : 'freeze';
      return _jsx('svg', {
        className: 'circle-chart',
        viewBox: '0 0 110 110',
        width: '120',
        height: '120',
        xmlns: 'http://www.w3.org/2000/svg'
      }, void 0, _ref2, _jsx('circle', {
        className: __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a.circleTimerProgress,
        stroke: '#FFD906',
        strokeWidth: '2',
        strokeDasharray: '0,314',
        strokeDashoffset: '314',
        strokeLinecap: 'round',
        fill: 'none',
        cx: '50%',
        cy: '50%',
        r: '50'
      }, void 0, _jsx('animate', {
        attributeName: 'stroke-dasharray',
        dur: seconds,
        begin: '0',
        values: '0,314;314,0',
        fill: animationFill
      })), _jsx('g', {}, void 0, _jsx('text', {
        className: __WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a.circleTimerText,
        x: '50%',
        y: '50%',
        alignmentBaseline: 'central',
        textAnchor: 'middle'
      }, void 0, this.state.formatedTime)));
    }
  }]);

  return CircleTimer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CircleTimer.defaultProps = {
  time: 300,
  repeat: false,
  timeUp: function timeUp() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__CircleTimer_css___default.a)(CircleTimer));

/***/ }),

/***/ 1281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_RegexpInput_RegexpInput__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_regexp__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NumberInput = function (_React$Component) {
  _inherits(NumberInput, _React$Component);

  function NumberInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.setInputRef = function (inputRef) {
      _this.inputRef = inputRef;
    }, _this.updateSelection = function () {
      var length = _this.inputRef.value.length;


      setTimeout(function () {
        if (_this.inputRef && _this.inputRef.setSelectionRange && _this.inputRef.type === 'text') {
          _this.inputRef.setSelectionRange(length, length);
        }
      }, 0);
    }, _this.handleChange = function (value) {
      return _this.props.onChange(value.replace(/\s/g, ''));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumberInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.inputRef && this.props.autoFocus) {
        this.inputRef.focus();
        this.updateSelection();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.updateSelection();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          value = _props.value,
          separateThousands = _props.separateThousands,
          props = _objectWithoutProperties(_props, ['value', 'separateThousands']);

      var safeValue = value || '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_components_RegexpInput_RegexpInput__["a" /* default */], _extends({}, props, {
        pattern: __WEBPACK_IMPORTED_MODULE_4_shared_constants_regexp__["c" /* numberWithSpacesRegexp */],
        value: separateThousands ? __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["k" /* numberWithSpaces */](safeValue) : safeValue,
        onChange: this.handleChange,
        inputRef: this.setInputRef
      }));
    }
  }]);

  return NumberInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NumberInput.defaultProps = {
  onChange: function onChange() {},
  value: '',
  autoFocus: false,
  separateThousands: true
};
/* harmony default export */ __webpack_exports__["a"] = (NumberInput);

/***/ }),

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/ChooseLanguageDialog/ChooseLanguageDialog.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_CircleTimer_CircleTimer__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import { FormattedMessage } from 'react-intl';














var cookieKey = 'chlc';

var ChooseLanguageDialog = function (_React$Component) {
  _inherits(ChooseLanguageDialog, _React$Component);

  function ChooseLanguageDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChooseLanguageDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChooseLanguageDialog.__proto__ || Object.getPrototypeOf(ChooseLanguageDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModal: true
    }, _this.onChoose = function (lang) {
      __WEBPACK_IMPORTED_MODULE_3_js_cookie__["set"](cookieKey, lang);
      var redirectUrl = __WEBPACK_IMPORTED_MODULE_10_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location.pathname, lang);
      _this.props.changeLocation(redirectUrl);
      __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].push(redirectUrl);
      window.location.reload();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChooseLanguageDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var locale = this.props.intl.locale;


      var pathname = __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location && __WEBPACK_IMPORTED_MODULE_12__history__["a" /* default */].location.pathname;
      var lng = __WEBPACK_IMPORTED_MODULE_3_js_cookie__["get"](cookieKey);
      if (locale === 'uk' || lng || pathname !== '/') return null;

      var time = 10;

      return _jsx(__WEBPACK_IMPORTED_MODULE_8_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: function toggleModal() {},
        show: this.state.showModal
      }, void 0, _jsx('h3', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.title
      }, void 0, '\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043C\u043E\u0432\u043D\u0443 \u0432\u0435\u0440\u0441\u0456\u044E \u0441\u0430\u0439\u0442\u0443'), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.text
      }, void 0, '\u042F\u043A\u0449\u043E \u0432\u0438 \u043D\u0435 \u0437\u0440\u043E\u0431\u0438\u0442\u0435 \u0432\u0438\u0431\u0456\u0440, \u0412\u0430\u0441 \u0431\u0443\u0434\u0435 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430 \u0432\u0435\u0440\u0441\u0456\u044E \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u043E\u044E \u043C\u043E\u0432\u043E\u044E \u0447\u0435\u0440\u0435\u0437 10 \u0441\u0435\u043A\u0443\u043D\u0434\u2026'), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.timer + ' container-center'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_CircleTimer_CircleTimer__["a" /* default */], {
        time: time,
        timeUp: function timeUp() {
          _this2.onChoose('uk');
        }
      })), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a.buttons
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_UI__["a" /* Button */], {
        type: 'button',
        userTranslate: false,
        text: '\u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438\u0441\u044C \u043D\u0430 \u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0456\u0439',
        onClick: function onClick() {
          return _this2.onChoose('uk');
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_11_shared_components_UI__["a" /* Button */], {
        type: 'button',
        userTranslate: false,
        text: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0440\u043E\u0441\u0456\u0439\u0441\u044C\u043A\u0443',
        theme: 'DisabledStyle',
        onClick: function onClick() {
          return _this2.onChoose('ru');
        }
      })));
    }
  }]);

  return ChooseLanguageDialog;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeLocation: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["r" /* setLocation */], dispatch)
  };
};
/* harmony default export */ var ChooseLanguageDialog_defaultExport = (__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */](null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_13__ChooseLanguageDialog_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](ChooseLanguageDialog))));
// CONCATENATED MODULE: ./src/shared/components/Logo/Logo.js
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Logo_css__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Logo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Logo_css__);
var Logo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












function Logo(props) {
  var t = props.t;

  var logo = t('locale') === 'uk' ? __WEBPACK_IMPORTED_MODULE_6_shared_assets_icons_logo_uk_svg___default.a : __WEBPACK_IMPORTED_MODULE_5_shared_assets_icons_logo_svg___default.a;
  return Logo__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_7__Logo_css___default.a.brandLogo,
    to: '/'
  }, void 0, Logo__jsx('img', {
    src: logo,
    width: '155',
    height: '36',
    style: { display: 'block' },
    title: t('Купить и продать авто в Украине на Автобазар'),
    alt: t('Покупка и продажа авто в Украине на Автобазар')
  }));
}

Logo.defaultProps = {};


/* harmony default export */ var Logo_defaultExport = (Logo___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Logo_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](Logo)));
// CONCATENATED MODULE: ./src/shared/helpers/abtesting.js
// import { experimentDebugger, emitter } from '@marvelapp/react-ab-test';

var setToDataLayer = function setToDataLayer() {
  window.dataLayer.push(arguments);
};

// const implementExperiment = (experimentName, value) => {
//   console.log(`Experiment: ${experimentName}, Set value ${value}`);
//   emitter.setActiveVariant(experimentName, value);
// };

// export const initOptimizeExperiment = (
//   experimentName,
//   variants = ['0', '1'],
//   defaultVariant = '0',
// ) => {
//   if (process.env.BROWSER && window.App && window.App.optimize && !window.App.optimize.debug) {
//     const experiment = window.App.optimize.experiments.find(e => e.name === experimentName);
//     if (experiment && experiment.id) {
//       setTimeout(() => {
//         setToDataLayer('event', 'optimize.callback', {
//           name: experiment.id,
//           callback: value => {
//             implementExperiment(experimentName, value);
//           },
//         });
//       }, 1);
//     }
//   } else {
//     experimentDebugger.enable();
//   }

//   emitter.defineVariants(experimentName, variants);
//   emitter.setActiveVariant(experimentName, defaultVariant);
// };

var initOptimizeExperiment = function initOptimizeExperiment(experimentName) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (true && window.App && window.App.optimize && !window.App.optimize.debug) {
    var experiment = window.App.optimize.experiments.find(function (e) {
      return e.name === experimentName;
    });
    if (experiment && experiment.id) {
      setTimeout(function () {
        setToDataLayer('event', 'optimize.callback', {
          name: experiment.id,
          callback: callback
        });
      }, 1);
    }
  } else {
    callback('0');
  }
};
// CONCATENATED MODULE: ./src/desktop/components/Navigation/NavigationItem/NavigationItem.js
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css__);
var NavigationItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function NavigationItem(props) {
  var isActive = props.isActive;

  var _props$item = props.item,
      childItems = _props$item.items,
      item = _objectWithoutProperties(_props$item, ['items']);

  return NavigationItem__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.active, isActive))
  }, void 0, NavigationItem__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.link,
    link: item,
    eventPrefix: props.eventPrefix
  }), childItems && childItems.length > 0 && NavigationItem__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.dropdown
  }, void 0, childItems.map(function (child) {
    return NavigationItem__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a.dLink,
      link: child,
      eventPrefix: '' + props.eventPrefix + item.route
    }, child.title);
  })));
}

NavigationItem.defaultProps = {
  isActive: false,
  eventPrefix: ''
};


/* harmony default export */ var NavigationItem_defaultExport = (NavigationItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__NavigationItem_css___default.a)(NavigationItem));
// CONCATENATED MODULE: ./src/desktop/components/Navigation/ProfileButton/ProfileButton.js
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ProfileButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ProfileButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_users__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css__);
var ProfileButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











var ProfileButton__ref = ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u044B\u0439\u0442\u0438'
});

function ProfileButton(props) {
  var user = props.user;

  var buttonTitle = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_users__["d" /* getUserThing */](user);
  var avatar = user.avatar;
  var avatarImg = avatar && avatar.replace('http:', 'https:');
  return ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.root
  }, void 0, ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.link,
    to: '/my/'
  }, void 0, avatarImg && ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.avatarContainer
  }, void 0, ProfileButton__jsx('img', {
    alt: '',
    src: avatarImg,
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.avatar
  })), ProfileButton__jsx('div', {
    title: buttonTitle,
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.btnTitle
  }, void 0, buttonTitle)), ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdown
  }, void 0, ProfileButton__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownList
  }, void 0, __WEBPACK_IMPORTED_MODULE_5_desktop_constants_navigation__["a" /* default */].PROFILE.map(function (link) {
    return ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownLink,
      to: link.route
    }, link.route, ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedMessage */], {
      id: link.title
    }));
  }), ProfileButton__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    onClick: props.logout,
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.dropdownLink, __WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a.logout),
    to: '/login/'
  }, void 0, ProfileButton__ref))));
}

ProfileButton.defaultProps = {
  logout: function logout() {}
};


/* harmony default export */ var ProfileButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__ProfileButton_css___default.a)(ProfileButton));
// CONCATENATED MODULE: ./src/desktop/components/Navigation/Navigation.js
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Navigation___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_actions_user__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Navigation_css__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Navigation_css__);
var Navigation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Navigation__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Navigation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Navigation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Navigation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var _ref2 = Navigation__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_12_shared_assets_images_add_plus_button_white_svg___default.a,
  width: '16',
  height: '16',
  alt: '\u041F\u0440\u043E\u0434\u0430\u0442\u044C'
});

var _ref3 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u043E\u0434\u0430\u0442\u044C'
});

var _ref4 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u0412\u043E\u0439\u0442\u0438'
});

var Navigation_Navigation = function (_React$Component) {
  Navigation__inherits(Navigation, _React$Component);

  function Navigation() {
    var _ref;

    var _temp, _this, _ret;

    Navigation__classCallCheck(this, Navigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Navigation__possibleConstructorReturn(this, (_ref = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      addLink: '/add/avto/',
      addRel: ''
    }, _this.componentDidMount = function () {
      initOptimizeExperiment('AddFormAB', function (value) {
        var addLinks = {
          '0': { link: '/add/avto/', rel: '' },
          '1': { link: '/addv2/avto/', rel: 'nofollow' }
        };
        if (value && addLinks[value]) {
          _this.setState({
            addLink: addLinks[value].link,
            addRel: addLinks[value].rel
          });
        }
      });
    }, _this.handleSellClick = function () {
      _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_9_shared_constants_gtmEvents__["a" /* EVENTS */].sellCarButtonClick);
    }, _temp), Navigation__possibleConstructorReturn(_this, _ret);
  }

  Navigation__createClass(Navigation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          history = _props.history,
          current = _props.current,
          shouldSetNoIndex = _props.shouldSetNoIndex;

      var token = user && user.token;

      var currentPath = history.currentPath;

      var currentRoute = current || __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__["a" /* default */].HEADER.filter(function (a) {
        var route = typeof a.route === 'string' && a.route || '';
        currentPath = typeof currentPath === 'string' && currentPath || '';
        return new RegExp('^' + route, 'mi').test(currentPath);
      })[0];

      return Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.root,
        role: 'navigation'
      }, void 0, Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.left
      }, void 0, Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.flexRow
      }, void 0, __WEBPACK_IMPORTED_MODULE_7_desktop_constants_navigation__["a" /* default */].HEADER.map(function (item, i) {
        return Navigation__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.navItem)
        }, i, Navigation__jsx(NavigationItem_defaultExport, {
          item: item,
          isActive: item === currentRoute,
          eventPrefix: 'headerNavigation'
        }));
      }))), Navigation__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.right
      }, void 0, Navigation__jsx(Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        onClick: this.handleSellClick,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.link, __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.sell),
        to: this.state.addLink,
        rel: this.state.addRel
      }, void 0, _ref2, '\xA0', _ref3), token && user ? Navigation__jsx(ProfileButton_defaultExport, {
        logout: this.props.userLogout,
        user: user.user
      }) : Navigation__jsx(Navigation___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.link, __WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a.highlight),
        shouldSetNoIndex: shouldSetNoIndex,
        to: '/login',
        rel: 'nofollow'
      }, void 0, _ref4)));
    }
  }]);

  return Navigation;
}(Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Navigation_Navigation.defaultProps = {
  user: {},
  history: {},
  current: null,
  shouldSetNoIndex: true
};


var Navigation_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    userLogout: function userLogout() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_8_shared_actions_user__["t" /* userLogout */]());
    },
    setDataLayer: __WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_10_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user,
    history: state.history
  };
};

/* harmony default export */ var Navigation_defaultExport = (__WEBPACK_IMPORTED_MODULE_13_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_16__Navigation_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps, Navigation_mapDispatchToProps)(Navigation_Navigation)));
// CONCATENATED MODULE: ./src/desktop/components/Header/Header.js
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_nprogress__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header_css__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Header_css__);
var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Header__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Header__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Header__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Header__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var NProgresStart = false;
var NProgresTimeoutStart = void 0;
var NProgresTimeoutDone = void 0;

var Header__ref = Header__jsx(Logo_defaultExport, {});

var Header__ref2 = Header__jsx(Navigation_defaultExport, {});

var Header = function (_React$Component) {
  Header__inherits(Header, _React$Component);

  function Header() {
    Header__classCallCheck(this, Header);

    return Header__possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  Header__createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.configure({
        showSpinner: false
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var loading = this.props.loading;

      if (loading.start && !NProgresStart) {
        NProgresStart = true;
        NProgresTimeoutStart = setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.start();
        }, 300);
      }

      if (!loading.start) {
        clearTimeout(NProgresTimeoutDone);
        NProgresTimeoutDone = setTimeout(function () {
          clearTimeout(NProgresTimeoutStart);
          NProgresStart = false;
          __WEBPACK_IMPORTED_MODULE_3_react_nprogress___default.a.done();
        }, 500);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return Header__jsx('div', {
        className: Header___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.root, __WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.fixed)
      }, void 0, Header__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__Header_css___default.a.container
      }, void 0, Header__ref, Header__ref2));
    }
  }]);

  return Header;
}(Header___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Header.defaultProps = {
  location: null,
  locations: null
};


var Header_mapStateToProps = function mapStateToProps(_ref3) {
  var loading = _ref3.loading;
  return {
    loading: loading
  };
};

/* harmony default export */ var Header_defaultExport = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__Header_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](Header_mapStateToProps)(Header)));
// CONCATENATED MODULE: ./src/desktop/components/Balance/Balance.js
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Balance___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Balance___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_onclickoutside__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_desktop_components_BalanceRefill_BalanceRefill__ = __webpack_require__(1288);
/* harmony import */ var Balance___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withBalance__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balance_css__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balance_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Balance_css__);
var Balance__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Balance__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Balance__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Balance__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Balance__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Balance = function (_React$Component) {
  Balance__inherits(Balance, _React$Component);

  function Balance() {
    var _ref;

    var _temp, _this, _ret;

    Balance__classCallCheck(this, Balance);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Balance__possibleConstructorReturn(this, (_ref = Balance.__proto__ || Object.getPrototypeOf(Balance)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isPopupOpened: false,
      shouldFreeze: false
    }, _this.togglePopup = function (e) {
      e.preventDefault();
      _this.setState(function (_ref2) {
        var isPopupOpened = _ref2.isPopupOpened;
        return { isPopupOpened: !isPopupOpened };
      });
    }, _this.handleClickOutside = function () {
      if (!_this.state.shouldFreeze) {
        _this.setState({ isPopupOpened: false });
      }
    }, _this.handleModalOpen = function () {
      _this.setState({ shouldFreeze: true });
    }, _this.handleModalClose = function () {
      _this.setState({ shouldFreeze: false });
    }, _temp), Balance__possibleConstructorReturn(_this, _ret);
  }

  Balance__createClass(Balance, [{
    key: 'render',
    value: function render() {
      var balance = this.props.balance;
      var isPopupOpened = this.state.isPopupOpened;


      if (balance === null) {
        return null;
      }

      return Balance__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.root
      }, void 0, Balance__jsx(Balance___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
        to: '/billing/',
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.content,
        onClick: this.togglePopup
      }, void 0, Balance__jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.icon,
        src: __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_credit_card_svg___default.a,
        alt: '',
        height: 22
      }), '  ', ' ', Balance__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.title
      }, void 0, balance, ' \u0433\u0440\u043D')), Balance__jsx(__WEBPACK_IMPORTED_MODULE_4_react_addons_css_transition_group___default.a, {
        transitionName: 'fadeUp',
        transitionEnterTimeout: 100,
        transitionLeaveTimeout: 100
      }, void 0, isPopupOpened && Balance__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a.popup
      }, void 0, Balance__jsx(__WEBPACK_IMPORTED_MODULE_5_desktop_components_BalanceRefill_BalanceRefill__["a" /* default */], {
        onModalOpen: this.handleModalOpen,
        onModalClose: this.handleModalClose
      }))));
    }
  }]);

  return Balance;
}(Balance___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Balance.defaultProps = {
  balance: null
};


/* harmony default export */ var Balance_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Balance_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withBalance__["a" /* default */]()(__WEBPACK_IMPORTED_MODULE_2_react_onclickoutside__["a" /* default */](Balance))));
// CONCATENATED MODULE: ./src/desktop/components/SubHeader/SubHeader.js
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InlineNav_InlineNav__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubHeader_css__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css__);
var SubHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var SubHeader__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SubHeader__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SubHeader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SubHeader__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SubHeader__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SubHeader__ref2 = SubHeader__jsx(Balance_defaultExport, {});

var SubHeader = function (_React$Component) {
  SubHeader__inherits(SubHeader, _React$Component);

  function SubHeader() {
    var _ref;

    var _temp, _this, _ret;

    SubHeader__classCallCheck(this, SubHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = SubHeader__possibleConstructorReturn(this, (_ref = SubHeader.__proto__ || Object.getPrototypeOf(SubHeader)).call.apply(_ref, [this].concat(args))), _this), _this.isActive = function (tariff) {
      var expireDate = tariff && tariff.expire_date && new Date(tariff.expire_date);
      var today = new Date();

      return expireDate > today;
    }, _temp), SubHeader__possibleConstructorReturn(_this, _ret);
  }

  SubHeader__createClass(SubHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          navLinks = _props.navLinks,
          currentRoute = _props.currentRoute,
          personalSubheader = _props.personalSubheader,
          user = _props.user,
          including = _props.including,
          intl = _props.intl;

      var sparePartsTariff = user && user.spareparts_tariff;

      return SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.root,
        role: 'navigation'
      }, void 0, SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.container
      }, void 0, SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.left
      }, void 0, SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_7__InlineNav_InlineNav__["a" /* default */], {
        navLinks: navLinks,
        currentRoute: currentRoute,
        including: including,
        eventPrefix: 'subHeader'
      })), SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.right
      }, void 0, personalSubheader && SubHeader__jsx('div', {}, void 0, sparePartsTariff && sparePartsTariff.slug && SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: '/profile/',
        className: SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.tariff, SubHeader__defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.nonActiveTariff, !this.isActive(sparePartsTariff))),
        title: this.isActive(sparePartsTariff) ? undefined : intl.formatMessage({ id: 'Действие пакета закончилось' })
      }, void 0, SubHeader__jsx(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: sparePartsTariff.title
      })), user.tariff && user.tariff.is_business && SubHeader__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link__["a" /* default */], {
        to: '/profile/',
        className: SubHeader___WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.tariff, SubHeader__defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.nonActiveTariff, !this.isActive(user.tariff))),
        title: this.isActive(user.tariff) ? undefined : intl.formatMessage({ id: 'Действие пакета закончилось' })
      }, void 0, SubHeader__jsx(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
        id: user.tariff.title
      })), SubHeader__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a.balance
      }, void 0, SubHeader__ref2)))));
    }
  }]);

  return SubHeader;
}(SubHeader___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SubHeader.defaultProps = {
  currentRoute: ''
};


var SubHeader_mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    user: user.user
  };
};

/* harmony default export */ var SubHeader_defaultExport = (SubHeader___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__SubHeader_css___default.a)(SubHeader___WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](SubHeader_mapStateToProps, {})(SubHeader___WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](SubHeader))));
// CONCATENATED MODULE: ./src/shared/hocs/withFooterLocations.js
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(withFooterLocations___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__history__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_urls__ = __webpack_require__(312);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withFooterLocations__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withFooterLocations__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withFooterLocations__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withFooterLocations__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var withFooterLocations = function withFooterLocations(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_React$Component) {
    withFooterLocations__inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      withFooterLocations__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withFooterLocations__possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.getPath = function (routeName, state, location) {
        var transport = state.transport || _this.props.seoSearchUrlResponse && _this.props.seoSearchUrlResponse.transport;
        var make = state.make && state.make.slug || _this.props.seoSearchUrlResponse && _this.props.seoSearchUrlResponse.make;

        var params = _extends({}, state, { make: make, transport: transport, location: location });

        switch (routeName) {
          case 'search':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["e" /* generateSearchUrl */](params);
          case 'moto':
            return '/moto/' + (location ? location.slug : '') + '/';
          case 'commercial':
            return '/commercial/' + (location ? location.slug : '') + '/';
          case 'dealers':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["a" /* generateDealersSearchUrl */](params);
          case 'firms':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["b" /* generateFirmsSearchUrl */](params);
          case 'auto-parts':
            return __WEBPACK_IMPORTED_MODULE_8__helpers_urls__["f" /* generateSparesSearchUrl */](params);

          default:
            if (transport && transport.slug) {
              return '/' + transport.slug + '/' + (location ? location.slug : '') + '/';
            }

            return location ? location.slug : '';
        }
      }, _this.handleLinkClick = function (e, location) {
        var routeName = _this.props.routeName;

        e.preventDefault();
        _this.props.onLocationChange(location);

        if (routeName) {
          __WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].push(_this.updateUrl(location));
        } else {
          __WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].push();
        }
      }, _this.updateUrl = function (location, url) {
        var _this$props = _this.props,
            formState = _this$props.formState,
            locale = _this$props.locale,
            routeName = _this$props.routeName;

        var state = _extends({}, formState, { location: location });
        var pathname = _this.getPath(routeName, state, location);

        if (url) {
          return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */](url), locale);
        }

        if (routeName === 'home' && typeof pathname === 'string' && pathname.includes('avto/')) {
          return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */](pathname), locale);
        }

        return __WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_6_shared_modules__["v" /* urlReplaceSlash */]('/' + (routeName === 'home' ? 'avto/' : '') + pathname + '/'), locale);
      }, _temp), withFooterLocations__possibleConstructorReturn(_this, _ret);
    }

    withFooterLocations__createClass(_class, [{
      key: 'render',
      value: function render() {
        return withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, {
          getPath: this.getPath,
          updateUrl: this.updateUrl,
          handleLinkClick: this.handleLinkClick
        }));
      }
    }]);

    return _class;
  }(withFooterLocations___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withFooterLocations(' + __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    list: [],
    className: '',
    historyStore: {},
    locationLinkBuilder: null,
    routeName: null,
    resetHeader: null,
    seoSearchUrlResponse: {}
  }, _temp2;
};

var withFooterLocations_mapStateToProps = function mapStateToProps(_ref2) {
  var globals = _ref2.globals,
      historyState = _ref2.history,
      searchForm = _ref2.searchForm;
  return {
    locale: globals.locale,
    location: globals.location,
    routeName: historyState && historyState.currentRouteName,
    formState: searchForm && searchForm.selected,
    currentPath: historyState.currentPath,
    seoSearchUrlResponse: globals.seoSearchUrlResponse
  };
};
var withFooterLocations_mapDispatchToProps = {
  onLocationChange: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["r" /* setLocation */]
};

/* harmony default export */ var withFooterLocations_defaultExport = (function (component) {
  return __WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](withFooterLocations_mapStateToProps, withFooterLocations_mapDispatchToProps)(withFooterLocations(component));
});
// CONCATENATED MODULE: ./src/desktop/components/Footer/ColumnList/ColumnList.js
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var ColumnList___WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColumnList_css__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css__);
var ColumnList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var ColumnList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ColumnList__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ColumnList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ColumnList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ColumnList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ColumnList__ref2 = ColumnList__jsx('span', {}, void 0, '> ');

var ColumnList = function (_React$Component) {
  ColumnList__inherits(ColumnList, _React$Component);

  function ColumnList() {
    var _ref;

    var _temp, _this, _ret;

    ColumnList__classCallCheck(this, ColumnList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = ColumnList__possibleConstructorReturn(this, (_ref = ColumnList.__proto__ || Object.getPrototypeOf(ColumnList)).call.apply(_ref, [this].concat(args))), _this), _this.buildBreadCrumbs = function (selectedLocation, titleKey) {
      if (selectedLocation.is_admin_center) {
        var region = selectedLocation.parents.find(function (item) {
          return item.is_region;
        });
        return ColumnList__jsx(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
          to: _this.props.updateUrl(region),
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.cursorPointer)
        }, void 0, ColumnList__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.hideHover
        }, void 0, '> '), region[titleKey]), ColumnList__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs)
        }, void 0, ColumnList__ref2, selectedLocation[titleKey]));
      }
      return ColumnList__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.curentBreadCrumbs)
      }, void 0, '> ', selectedLocation[titleKey]);
    }, _temp), ColumnList__possibleConstructorReturn(_this, _ret);
  }

  ColumnList__createClass(ColumnList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          className = _props.className,
          resetHeader = _props.resetHeader,
          updateUrl = _props.updateUrl,
          search = _props.search,
          selectedLocation = _props.selectedLocation,
          isRegion = _props.isRegion,
          titleKey = _props.titleKey;


      return ColumnList__jsx('div', {
        className: !isRegion ? __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.root : ''
      }, void 0, ColumnList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.breadCrumbsBlock
      }, void 0, search ? ColumnList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationText
      }, void 0, resetHeader) : isRegion && ColumnList__jsx(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
        to: updateUrl(null),
        className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.resetLocationLink
      }, void 0, resetHeader), selectedLocation && this.buildBreadCrumbs(selectedLocation, titleKey))), ColumnList__jsx('div', {
        className: className
      }, void 0, list.map(function (columnItems) {
        return ColumnList__jsx('ul', {
          className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.column
        }, columnItems[0].id, columnItems.map(function (columnItem) {
          if ((columnItem.disabled || columnItem.selectedLocation) && !search) {
            return ColumnList__jsx('p', {
              className: __WEBPACK_IMPORTED_MODULE_6_classnames___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.disabledCity, ColumnList__defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.selLocation, columnItem.selectedLocation))
            }, columnItem.id, columnItem[titleKey]);
          }
          return ColumnList__jsx('li', {
            className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.item
          }, columnItem.id + '-link', ColumnList__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Link_Link__["a" /* default */], {
            to: search ? updateUrl(null, columnItem.url) : updateUrl(columnItem),
            className: __WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a.link,
            title: columnItem.hint
          }, void 0, columnItem[titleKey]));
        }));
      })));
    }
  }]);

  return ColumnList;
}(ColumnList___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ColumnList.defaultProps = {
  list: [],
  className: '',
  titleKey: 'title',
  locationLinkBuilder: null,
  routeName: null,
  resetHeader: null,
  search: false,
  isRegion: false,
  selectedLocation: undefined
};


/* harmony default export */ var ColumnList_defaultExport = (withFooterLocations_defaultExport(ColumnList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__ColumnList_css___default.a)(ColumnList___WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */](ColumnList))));
// CONCATENATED MODULE: ./src/desktop/components/Footer/LocationList/LocationList.js
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationList_css__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LocationList_css__);
var LocationList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LocationList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function LocationList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LocationList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LocationList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var isMobile = "desktop" === 'mobile';

var LocationList_LocationList = function (_Component) {
  LocationList__inherits(LocationList, _Component);

  function LocationList() {
    var _ref;

    var _temp, _this, _ret;

    LocationList__classCallCheck(this, LocationList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LocationList__possibleConstructorReturn(this, (_ref = LocationList.__proto__ || Object.getPrototypeOf(LocationList)).call.apply(_ref, [this].concat(args))), _this), _this.createColumns = function (arr, columnCount) {
      var maxColumnLength = Math.ceil(arr.length / columnCount);

      return arr.reduce(function (result, item, i) {
        return i % (maxColumnLength > 6 ? 6 : maxColumnLength) === 0 ? [].concat(_toConsumableArray(result), [[item]]) : [].concat(_toConsumableArray(result.slice(0, result.length - 1)), [[].concat(_toConsumableArray(result[result.length - 1]), [item])]);
      }, []);
    }, _temp), LocationList__possibleConstructorReturn(_this, _ret);
  }

  LocationList__createClass(LocationList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cities = _props.cities,
          columnCount = _props.columnCount,
          search = _props.search,
          selectedLocation = _props.selectedLocation,
          isRegion = _props.isRegion,
          titleKey = _props.titleKey,
          title = _props.title;

      var citiesColumns = this.createColumns(cities, columnCount);
      var rooClass = isMobile ? __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.rootMobile : __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.root;
      return LocationList__jsx('div', {
        className: rooClass
      }, void 0, title && LocationList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.title
      }, void 0, title), LocationList__jsx('div', {}, void 0, LocationList__jsx(ColumnList_defaultExport, {
        selectedLocation: selectedLocation,
        search: search,
        isRegion: isRegion,
        resetHeader: isRegion ? LocationList__jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
          id: search ? 'Популярные запросы' : 'Вся Украина'
        }) : '',
        list: citiesColumns,
        className: __WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a.citiesList,
        titleKey: titleKey
      })));
    }
  }]);

  return LocationList;
}(LocationList___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LocationList_LocationList.defaultProps = {
  countries: [],
  cities: [],
  columnCount: 5,
  search: false,
  isRegion: false,
  selectedLocation: undefined,
  titleKey: 'title',
  title: ''
};


/* harmony default export */ var LocationList_defaultExport = (LocationList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LocationList_css___default.a)(LocationList_LocationList));
// CONCATENATED MODULE: ./src/desktop/components/Footer/Footer.js
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_navigation__ = __webpack_require__(1248);
var Footer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
















var Footer__ref4 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438'
});

var _ref5 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439'
});

var _ref6 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440'
});

var _ref7 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u2122'
});

var _ref8 = Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u2013 \u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u0430\u0442\u044C \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435'
});

function Footer(props) {
  var languages = props.languages,
      currentPath = props.currentPath,
      intl = props.intl,
      locale = props.locale,
      hideLocations = props.hideLocations,
      _props$seoSearchUrlRe = props.seoSearchUrlResponse,
      make = _props$seoSearchUrlRe.make,
      trends = _props$seoSearchUrlRe.trends,
      seoLocations = _props$seoSearchUrlRe.locations,
      selectedLocation = _props$seoSearchUrlRe.location;


  var socialLinks = [{ icon: 'twitter', link: 'https://twitter.com/avtobazar' }, { icon: 'facebook', link: 'https://www.facebook.com/AvtoBazar' }, { icon: 'instagram', link: 'https://www.instagram.com/avtobazar_ua/' }, { icon: 'youtube-play', link: 'https://www.youtube.com/avtobazar' }];
  var allLocations = Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["b" /* getAllLocations */]().map(Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["g" /* setActiveLocations */](seoLocations, selectedLocation));
  var cities = allLocations.filter(function (item) {
    return item.is_admin_center;
  }).sort(__WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["b" /* compareByTitle */]);
  var regions = allLocations.filter(function (item) {
    return item.is_region;
  }).sort(__WEBPACK_IMPORTED_MODULE_7_shared_helpers_arrays__["b" /* compareByTitle */]);

  var hideRegLocValues = ['/add/', '/zhurnal/', '/service/'];
  var hideRegLocations = hideRegLocValues.some(function (item) {
    return currentPath.includes(item);
  });

  var formattedTrends = [];
  if (trends) {
    formattedTrends = trends.map(function (a, b) {
      return {
        id: b,
        slug: '',
        title: a['title_' + intl.locale],
        hint: a['text_' + intl.locale],
        url: a.url
      };
    }).filter(function (a, b) {
      return b < 30;
    });
  }
  var titleKey = locale === 'uk' ? 'uk_title' : 'title';

  return Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.root
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.container
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.flexContainer
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.left
  }, void 0, Footer__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.nav
  }, void 0, __WEBPACK_IMPORTED_MODULE_10__constants_navigation__["a" /* default */].FOOTER.map(function (item) {
    return Footer__jsx('li', {}, item.title, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.link,
      to: item.route,
      rel: 'nofollow'
    }, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: item.title
    })));
  }))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.right
  }, void 0, Footer__jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.tel
  }, void 0, '+380 44 206-56-06'), Footer__jsx('div', {}, void 0, languages.map(function (item) {
    return Footer__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.lang
    }, item.slug, locale === item.slug ? Footer__jsx('span', {}, void 0, item.title) : Footer__jsx('a', {
      href: Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["h" /* toLocalized */](Footer___WEBPACK_IMPORTED_MODULE_5_shared_helpers_locale__["e" /* removeLocaleFromHref */](currentPath), item.slug),
      'data-lang-code': item.slug
    }, void 0, item.title));
  })))), trends && trends[0] ? Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide,
    style: { margin: '8px 0 8px 0' }
  }), Footer__jsx(LocationList_defaultExport, {
    countries: undefined,
    cities: formattedTrends,
    search: true
  })) : '', !hideLocations && Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide,
    style: { margin: '8px 0 0px 0' }
  }), !hideRegLocations && !hideLocations && Footer__jsx(LocationList_defaultExport, {
    cities: regions,
    search: false,
    selectedLocation: selectedLocation,
    isRegion: true,
    titleKey: titleKey
  }), !hideLocations && Footer__jsx(LocationList_defaultExport, {
    cities: cities,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey,
    isRegion: hideRegLocations
  }), Footer__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.divide
  }), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.flexContainer
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.left
  }, void 0, Footer__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.nav
  }, void 0, Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/law/',
    rel: 'nofollow'
  }, void 0, Footer__ref4)), Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/advertising-conditions/',
    rel: 'nofollow'
  }, void 0, _ref5)), Footer__jsx('li', {}, void 0, Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/public-contract/',
    rel: 'nofollow'
  }, void 0, _ref6)))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.right
  }, void 0, Footer__jsx('a', {
    href: 'mailto:support@ab.ua',
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.tel,
    rel: 'nofollow'
  }, void 0, 'support@ab.ua'), Footer__jsx(SocialLinks, {
    socialLinks: socialLinks
  })))), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.footerCopyRight
  }, void 0, Footer__jsx('p', {}, void 0, '\xA9 ', new Date().getFullYear(), '\xA0', Footer__jsx(Footer___WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.smallLink,
    to: '/'
  }, void 0, _ref7), _ref8)));
}

Footer.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }],
  routeName: null,
  seoSearchUrlResponse: {},
  hideLocations: false
};


function SocialLinks(_ref) {
  var socialLinks = _ref.socialLinks;

  return Footer__jsx('div', {}, void 0, socialLinks.map(function (_ref2) {
    var link = _ref2.link,
        icon = _ref2.icon;
    return Footer__jsx('a', {
      href: link,
      target: '_blank',
      rel: 'nofollow noopener noreferrer',
      className: __WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a.socialLink
    }, icon, Footer__jsx('i', {
      className: 'fa fa-' + icon
    }));
  }));
}


var Footer_mapStateToProps = function mapStateToProps(_ref3) {
  var history = _ref3.history,
      searchForm = _ref3.searchForm,
      globals = _ref3.globals;
  return {
    currentPath: history.currentPath,
    routeName: history && history.currentRouteName,
    countries: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_countries_json___default.a,
    formState: searchForm && searchForm.selected,
    seoSearchUrlResponse: globals.seoSearchUrlResponse,
    locale: globals.locale
  };
};

/* harmony default export */ var Footer_defaultExport = (Footer___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Footer_css___default.a)(Footer___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](Footer_mapStateToProps)(Footer___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](Footer))));
// CONCATENATED MODULE: ./src/desktop/components/Footer/LanguageList/LanguageList.js
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageList_css__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LanguageList_css__);
var LanguageList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// / import withFooterLocations from 'shared/hocs/withFooterLocations';
// import Link from 'shared/components/Link/Link';
// import { injectIntl } from 'react-intl';



function LanguageList(props) {
  var languages = props.languages,
      locale = props.locale,
      currentPath = props.currentPath;


  return LanguageList__jsx('div', {}, void 0, languages.map(function (item) {
    return LanguageList__jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default.a.lang
    }, item.slug, locale === item.slug ? LanguageList__jsx('span', {}, void 0, item.title) : LanguageList__jsx('a', {
      href: __WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["h" /* toLocalized */](__WEBPACK_IMPORTED_MODULE_4_shared_helpers_locale__["e" /* removeLocaleFromHref */](currentPath), item.slug),
      'data-lang-code': item.slug
    }, void 0, item.title));
  }));
}

LanguageList.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }]
};


var LanguageList_mapStateToProps = function mapStateToProps(_ref) {
  var globals = _ref.globals,
      history = _ref.history;
  return {
    currentPath: history.currentPath,
    locale: globals.locale
  };
};

/* harmony default export */ var LanguageList_defaultExport = (LanguageList___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LanguageList_css___default.a)(LanguageList___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](LanguageList_mapStateToProps)(LanguageList)));
// CONCATENATED MODULE: ./src/desktop/components/Footer/FooterLeasing.js
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Footer_css__);
var FooterLeasing__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







// import {
//   removeLocaleFromHref,
//   toLocalized,
//   setActiveLocations,
//   getAllLocations,
// } from 'shared/helpers/locale';

// import { compareByTitle } from 'shared/helpers/arrays';







// import LINKS from '../../constants/navigation';




var FooterLeasing__ref4 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438'
});

var FooterLeasing__ref5 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439'
});

var FooterLeasing__ref6 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440'
});

var FooterLeasing__ref7 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440\u2122'
});

var FooterLeasing__ref8 = FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u2013 \u041A\u0443\u043F\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u0430\u0432\u0442\u043E \u0438\u043B\u0438 \u043F\u0440\u043E\u0434\u0430\u0442\u044C \u0431\u0443 \u0441 \u043F\u0440\u043E\u0431\u0435\u0433\u043E\u043C \u0432 \u0423\u043A\u0440\u0430\u0438\u043D\u0435'
});

function LeasingFooter(props) {
  var languages = props.languages,
      currentPath = props.currentPath,
      intl = props.intl,
      locale = props.locale,
      hideLocations = props.hideLocations,
      _props$seoSearchUrlRe = props.seoSearchUrlResponse,
      make = _props$seoSearchUrlRe.make,
      trends = _props$seoSearchUrlRe.trends,
      seoLocations = _props$seoSearchUrlRe.locations,
      selectedLocation = _props$seoSearchUrlRe.location;


  var socialLinks = [{ icon: 'twitter', link: 'https://twitter.com/avtobazar' }, { icon: 'facebook', link: 'https://www.facebook.com/AvtoBazar' }, { icon: 'instagram', link: 'https://www.instagram.com/avtobazar_ua/' }, { icon: 'youtube-play', link: 'https://www.youtube.com/avtobazar' }];
  // const allLocations = getAllLocations().map(setActiveLocations(seoLocations, selectedLocation));
  // const cities = allLocations.filter(item => item.is_admin_center).sort(compareByTitle);
  // const regions = allLocations.filter(item => item.is_region).sort(compareByTitle);

  // const hideRegLocValues = ['/add/', '/zhurnal/', '/service/'];
  // const hideRegLocations = hideRegLocValues.some(item => currentPath.includes(item));

  // let formattedTrends = [];
  // if (trends) {
  //   formattedTrends = trends
  //     .map((a, b) => ({
  //       id: b,
  //       slug: '',
  //       title: a[`title_${intl.locale}`],
  //       hint: a[`text_${intl.locale}`],
  //       url: a.url,
  //     }))
  //     .filter((a, b) => b < 30);
  // }
  var titleKey = locale === 'uk' ? 'uk_title' : 'title';
  var listBav = [{
    titleHeader: 'Информация по телефону',
    title: '+380 44 206-56-06'
  }, {
    titleHeader: 'Адрес',
    title: intl.formatMessage({ id: 'Украина, г. Киев, ул. Лейпцигская 15а' })
  }, {
    titleHeader: 'Почта',
    title: 'support@ab.ua'
  }];
  return FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.root
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.container
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.flexContainer
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.left
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasing
  }, void 0, listBav.map(function (item) {
    return FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingItem
    }, item.title, FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingTitleHeader
    }, void 0, FooterLeasing__jsx(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: item.titleHeader
    })), FooterLeasing__jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.navLeasingTitle
    }, void 0, item.title));
  }))), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.right
  }, void 0, FooterLeasing__jsx(LanguageList_defaultExport, {
    languages: languages
  }), FooterLeasing__jsx(FooterLeasing_SocialLinks, {
    socialLinks: socialLinks
  }))), FooterLeasing__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.divide
  }), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.leasingList
  }, void 0, FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_7_shared_constants_json_leasingLinksPopular_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  }), FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_8_shared_constants_json_leasingLinksPopularBrands_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  }), FooterLeasing__jsx(LocationList_defaultExport, {
    title: __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default.a.title,
    cities: __WEBPACK_IMPORTED_MODULE_9_shared_constants_json_leasingLinksPopularCities_json___default.a.items,
    search: false,
    selectedLocation: selectedLocation,
    titleKey: titleKey
  })), FooterLeasing__jsx('hr', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.divide
  }), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.flexContainer
  }, void 0, FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.left
  }, void 0, FooterLeasing__jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.nav
  }, void 0, FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/law/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref4)), FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/advertising-conditions/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref5)), FooterLeasing__jsx('li', {}, void 0, FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/public-contract/',
    rel: 'nofollow'
  }, void 0, FooterLeasing__ref6)))))), FooterLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.footerCopyRight
  }, void 0, FooterLeasing__jsx('p', {}, void 0, '\xA9 ', new Date().getFullYear(), '\xA0', FooterLeasing__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.smallLink,
    to: '/'
  }, void 0, FooterLeasing__ref7), FooterLeasing__ref8)));
}

LeasingFooter.defaultProps = {
  languages: [{
    title: 'рус',
    slug: 'ru'
  }, {
    title: 'укр',
    slug: 'uk'
  }],
  routeName: null,
  seoSearchUrlResponse: {},
  hideLocations: false
};


function FooterLeasing_SocialLinks(_ref) {
  var socialLinks = _ref.socialLinks;

  return FooterLeasing__jsx('div', {}, void 0, socialLinks.map(function (_ref2) {
    var link = _ref2.link,
        icon = _ref2.icon;
    return FooterLeasing__jsx('a', {
      href: link,
      target: '_blank',
      rel: 'nofollow noopener noreferrer',
      className: __WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a.socialLink
    }, icon, FooterLeasing__jsx('i', {
      className: 'fa fa-' + icon
    }));
  }));
}


var FooterLeasing_mapStateToProps = function mapStateToProps(_ref3) {
  var history = _ref3.history,
      searchForm = _ref3.searchForm,
      globals = _ref3.globals;
  return {
    currentPath: history.currentPath,
    routeName: history && history.currentRouteName,
    countries: __WEBPACK_IMPORTED_MODULE_6_shared_constants_json_countries_json___default.a,
    formState: searchForm && searchForm.selected,
    seoSearchUrlResponse: globals.seoSearchUrlResponse,
    locale: globals.locale
  };
};

/* harmony default export */ var FooterLeasing_defaultExport = (FooterLeasing___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_12__Footer_css___default.a)(FooterLeasing___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](FooterLeasing_mapStateToProps)(FooterLeasing___WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](LeasingFooter))));
// CONCATENATED MODULE: ./src/shared/hocs/withNotifications.js
/* harmony import */ var withNotifications___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(withNotifications___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var withNotifications__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var withNotifications__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function withNotifications__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function withNotifications__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function withNotifications__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var withNotifications_mapStateToProps = function mapStateToProps(_ref) {
  var notifications = _ref.notifications;
  return { messageQueue: notifications };
};
var withNotifications_mapDispatchToProps = { shift: __WEBPACK_IMPORTED_MODULE_2_shared_actions_notifications__["b" /* shiftNotification */] };

var withNotifications = function withNotifications(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](withNotifications_mapStateToProps, withNotifications_mapDispatchToProps)((_temp2 = _class = function (_React$Component) {
    withNotifications__inherits(_class, _React$Component);

    function _class() {
      var _ref2;

      var _temp, _this, _ret;

      withNotifications__classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = withNotifications__possibleConstructorReturn(this, (_ref2 = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
        activeMessage: null
      }, _this.tick = function () {
        var _this$props = _this.props,
            duration = _this$props.duration,
            shift = _this$props.shift;

        var lastMessage = _this.props.messageQueue[0];

        if (lastMessage) {
          _this.setState({ activeMessage: lastMessage }, function () {
            delay(duration).then(function () {
              shift();
              _this.setState({ activeMessage: null }, function () {
                delay(duration / 4).then(function () {
                  return _this.tick();
                });
              });
            });
          });
        }
      }, _temp), withNotifications__possibleConstructorReturn(_this, _ret);
    }

    withNotifications__createClass(_class, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.state.activeMessage) {
          this.tick();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.messageQueue.length < this.props.messageQueue.length && !this.state.activeMessage) {
          this.tick();
        }
      }
    }, {
      key: 'render',
      value: function render() {

        return withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, withNotifications__extends({ activeMessage: this.state.activeMessage }, this.props));
      }
    }]);

    return _class;
  }(withNotifications___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withNotifications(' + __WEBPACK_IMPORTED_MODULE_3_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    duration: 4000
  }, _temp2));
};

/* harmony default export */ var withNotifications_defaultExport = (withNotifications);
// CONCATENATED MODULE: ./src/desktop/components/Layout/NotificationBar/NotificationBar.js
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css__);
var NotificationBar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function NotificationBar__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function NotificationBar(props) {
  var activeMessage = props.activeMessage;

  var type = activeMessage && activeMessage.type;

  return NotificationBar__jsx('div', {
    className: NotificationBar___WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.root, NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.active, activeMessage),
    //
    NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.error, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].ERROR), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.success, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].SUCCESS), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.warning, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].WARNING), NotificationBar__defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.info, type === __WEBPACK_IMPORTED_MODULE_5_shared_actions_notificationTypes__["a" /* default */].INFO))
  }, void 0, activeMessage && NotificationBar__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a.label
  }, void 0, activeMessage.text));
}

NotificationBar.defaultProps = {
  activeMessage: null
};


/* harmony default export */ var NotificationBar_defaultExport = (NotificationBar___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__NotificationBar_css___default.a)(withNotifications_defaultExport(NotificationBar)));
// CONCATENATED MODULE: ./src/desktop/components/Layout/Layout.js
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_lazyload__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_datepicker_dist_react_datepicker_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_global_styles_desktop_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Layout_css__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Layout_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Layout_css__);
var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Layout__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Layout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { updateBranding } from 'shared/helpers/adsAndMetrics';




















// eslint-disable-next-line css-modules/no-unused-class


var isClient = true;
var localCurrentPage = '';

var Layout__ref = Layout__jsx(NotificationBar_defaultExport, {});

var Layout__ref2 = Layout__jsx(Header_defaultExport, {});

var Layout__ref3 = Layout__jsx(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a, {}, void 0, Layout__jsx(Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__["a" /* Googletag */], {
  id: 'div-gpt-ad-1514298874616-0'
}));

var Layout__ref4 = Layout__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_BannerAll__["a" /* BannersBuffer */], {});

var Layout__ref5 = Layout__jsx(ChooseLanguageDialog_defaultExport, {});

var Layout_Layout = function (_React$Component) {
  Layout__inherits(Layout, _React$Component);

  function Layout() {
    Layout__classCallCheck(this, Layout);

    return Layout__possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
  }

  Layout__createClass(Layout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!isClient) return;
      var targetNode = window.document.body;
      var bannerTopAB = window.document.getElementById('banner-top-AB');
      var changeObserver = function changeObserver() {
        if (targetNode.style.backgroundImage) {
          window.document.getElementById('bodyABIdBlock').style.margin = '68px auto 0  auto';
        } else if (bannerTopAB && Number(bannerTopAB.clientHeight) > 30) {
          // bannerTopAB.style.marginTop = '20px';
          bannerTopAB.style.display = 'flex';
        }
      };

      var observer = new MutationObserver(changeObserver);
      var observerTop = new MutationObserver(changeObserver);
      observer.observe(targetNode, { attributes: true, childList: true });
      if (bannerTopAB) {
        observerTop.observe(bannerTopAB, { attributes: true, childList: true });
      }
      // updateBranding();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var currentPath = this.props.history.currentPath;

      if (true && '' + location.pathname + location.search !== currentPath && currentPath !== localCurrentPage) {
        // updateBranding();
        localCurrentPage = currentPath;
      }
    }
  }, {
    key: 'getFooter',
    value: function getFooter() {
      var _props = this.props,
          hideLocations = _props.hideLocations,
          footer = _props.footer;

      if (footer === 'leasing') return Layout__jsx(FooterLeasing_defaultExport, {
        hideLocations: hideLocations
      });
      return Layout__jsx(Footer_defaultExport, {
        hideLocations: hideLocations
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          navLinks = _props2.navLinks,
          currentRoute = _props2.currentRoute,
          including = _props2.including,
          personalSubheader = _props2.personalSubheader,
          currentPath = _props2.history.currentPath;


      return Layout__jsx('div', {
        id: !navLinks ? 'fakeSubHeader' : '',
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.root
      }, void 0, Layout__ref, Layout__ref2, navLinks && !!navLinks.length && Layout__jsx(SubHeader_defaultExport, {
        including: including,
        navLinks: navLinks,
        currentRoute: currentRoute,
        personalSubheader: personalSubheader
      }), !new Set(Layout___WEBPACK_IMPORTED_MODULE_6_shared_modules__["g" /* ignoreTopBanner */]).has(currentPath) && !/\/edit\//.test(currentPath) ? Layout__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.brandingAdv,
        id: 'banner-top-AB'
      }, void 0, Layout__ref3) : '', Layout__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.layout,
        id: 'bodyABIdBlock'
      }, void 0, this.props.children), Layout__jsx('main', {
        className: __WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a.mainFooter
      }, void 0, this.getFooter()), Layout__ref4, isClient && Layout__ref5);
    }
  }]);

  return Layout;
}(Layout___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Layout_Layout.defaultProps = {
  history: {},
  currentRoute: null,
  navLinks: null,
  withBranding: false,
  personalSubheader: false,
  including: true,
  targetingArguments: {},
  shouldInitAds: true,
  hideLocations: false,
  string: '',
  footer: ''
};


/* harmony default export */ __webpack_exports__["a"] = (Layout___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_20__Layout_css___default.a)(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */](function (_ref6) {
  var history = _ref6.history;
  return {
    history: history
  };
})(Layout_Layout)));

/***/ }),

/***/ 1283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DecimalInput = function (_React$Component) {
  _inherits(DecimalInput, _React$Component);

  function DecimalInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DecimalInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DecimalInput.__proto__ || Object.getPrototypeOf(DecimalInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      tempValue: _this.props.value,
      isInDotMode: false
    }, _this.handleChange = function (e) {
      var value = e.target.value;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          delimiters = _this$props.delimiters;


      value = value.replace(new RegExp('[' + delimiters + ']', 'g'), '.');

      if (value && value.startsWith('.')) {
        value = '';
      }

      if (value === '' || value.match(/^\d+(\.\d+)?$/)) {
        _this.setState({ isInDotMode: false });
        onChange(value);
      } else if (value.match(/^\d+\.$/)) {
        _this.setState({
          tempValue: value,
          isInDotMode: true
        });
      }
    }, _this.handleBlur = function () {
      if (_this.state.isInDotMode) {
        _this.setState(function (_ref2) {
          var tempValue = _ref2.tempValue;

          var newValue = '' + parseInt(tempValue, 10);
          _this.props.onChange(newValue);
          return { tempValue: newValue };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DecimalInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var value = this.props.value;
      var _state = this.state,
          isInDotMode = _state.isInDotMode,
          tempValue = _state.tempValue;


      if (!isInDotMode && '' + tempValue !== '' + value) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ tempValue: value ? '' + value : value });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inputRef = _props.inputRef,
          props = _objectWithoutProperties(_props, ['inputRef']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, props, {
        type: 'tel',
        ref: inputRef,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        value: this.state.tempValue || ''
      }));
    }
  }]);

  return DecimalInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DecimalInput.defaultProps = {
  value: undefined,
  inputRef: undefined,
  onChange: function onChange() {},
  delimiters: '.,'
};


/* harmony default export */ __webpack_exports__["a"] = (DecimalInput);

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_NavigationLink_NavigationLink__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InlineNav_css__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InlineNav_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function InlineNav(props) {
  var navLinks = props.navLinks,
      including = props.including,
      currentRoute = props.currentRoute;

  var route = (currentRoute + '/').replace('//', '/');
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.root,
    role: 'navigation'
  }, void 0, _jsx('ul', {
    className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.list
  }, void 0, navLinks.map(function (item) {
    return _jsx('li', {
      className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.item
    }, item.route, _jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_NavigationLink_NavigationLink__["a" /* default */], {
      link: item,
      currentRoute: route,
      including: including,
      className: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.link,
      activeClassName: __WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a.active,
      eventPrefix: props.eventPrefix
    }));
  })));
}

InlineNav.defaultProps = {
  including: true,
  currentRoute: null,
  count: null,
  withCount: false,
  eventPrefix: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__InlineNav_css___default.a)(InlineNav));

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(1358);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1361);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(1264);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';

CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ 1286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentRollAdsense; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var isDev = false;

var _ref = _jsx('div', {}, void 0, '________________slot_________________');

var _ref2 = _jsx('div', {}, void 0, '_________ContentRollAdsense__________');

var _ref3 = _jsx('div', {}, void 0, '________________STYLE_________________');

var _ref4 = _jsx('div', {}, void 0, '________________end_block_________________');

function ContentRollAdsenseClass(props) {
  var adClient = props.adClient,
      adSlot = props.adSlot,
      other = _objectWithoutProperties(props, ['adClient', 'adSlot']);

  var devStyle = {
    width: '100%',
    minHeight: '200px',
    backgroundColor: '#ffb900',
    border: '3px solid #a73c3c'
  };
  if (isDev) {
    return _jsx('div', {
      style: devStyle
    }, void 0, _ref, _ref2, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, adSlot), _ref3, _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, JSON.stringify(other.style)), _ref4);
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ins', _extends({}, other, { className: 'adsbygoogle', 'data-ad-client': adClient, 'data-ad-slot': adSlot }));
}

ContentRollAdsenseClass.defaultProps = {
  adClient: 'ca-pub-8183181871645898',
  adSlot: '7650493142'
};


var ContentRollAdsense = ContentRollAdsenseClass;

/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UIStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var ButtonGeneral = function ButtonGeneral(_ref) {
  var _cx;

  var text = _ref.text,
      type = _ref.type,
      theme = _ref.theme,
      clickHandler = _ref.clickHandler,
      Icon = _ref.Icon,
      className = _ref.className,
      isProcessing = _ref.isProcessing,
      disabled = _ref.disabled,
      userTranslate = _ref.userTranslate,
      iconAfterText = _ref.iconAfterText,
      inputParams = _objectWithoutProperties(_ref, ['text', 'type', 'theme', 'clickHandler', 'Icon', 'className', 'isProcessing', 'disabled', 'userTranslate', 'iconAfterText']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    _extends({
      disabled: disabled || isProcessing,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonGeneral"], (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonTransparent"], theme === 'Transparent'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonTransparentYellow"], theme === 'TransparentYellow'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonYellow"], theme === 'Yellow'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonWhite"], theme === 'White'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonYellowFlat"], theme === 'YellowFlat'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonDisabledStyle"], theme === 'DisabledStyle'), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonProcessing"], isProcessing), _defineProperty(_cx, className, !!className), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["iconAfterText"], iconAfterText), _cx)),
      type: type,
      onClick: clickHandler
    }, inputParams),
    _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Loader_Loader__["a" /* default */], {
      isLoading: isProcessing,
      className: __WEBPACK_IMPORTED_MODULE_6__UIStyle_css__["ButtonLoader"]
    }),
    Icon && !iconAfterText ? _jsx(Icon, {}) : null,
    userTranslate ? _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
      id: text
    }) : text,
    Icon && iconAfterText ? _jsx(Icon, {}) : null
  );
};

ButtonGeneral.defaultProps = {
  type: 'submit',
  theme: 'Yellow',
  className: '',
  Icon: null,
  disabled: false,
  clickHandler: function clickHandler() {},
  isProcessing: false,
  userTranslate: true,
  iconAfterText: false
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__UIStyle_css__)(ButtonGeneral));

/***/ }),

/***/ 1288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/hocs/withMonoPayment.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__history__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var throwIfResponseNotOkay = function throwIfResponseNotOkay() {
  return function (response) {
    if (!response.ok) {
      throw new Error('Произошла ошибка');
    }

    return response;
  };
};

var getMonoOrderData = function getMonoOrderData(fetch, token, data) {
  return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.MONO_ORDER_CHECKOUT, {
    method: 'POST',
    headers: {
      Authorization: 'JWT ' + token
    },
    body: JSON.stringify(data)
  });
};

var updateAdvertParams = function updateAdvertParams(advertParams, fetch, token, advertID, promoteInSocial) {
  if (advertParams.kind && advertParams.kind === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["d" /* PACKAGES */].C2C_TURBO && promoteInSocial) {
    fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].ADVERT.ITEM(advertID), {
      method: 'PATCH',
      headers: {
        Authorization: 'JWT ' + token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ promote_in_social: promoteInSocial })
    });
  }
};

var withMonoPayment = function withMonoPayment(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        fondyFrameUrl: '',
        fondyCb: null,
        showModal: false,
        showInvoiceModal: false,
        billAmount: null,
        accountNumber: null,
        eventCounter: 1
      }, _this.setGtmEvent = function (gtmId) {
        if (!gtmId) return;

        var eventCounter = _this.state.eventCounter;

        var dataLayer = window && Array.isArray(window.dataLayer) && window.dataLayer;
        var gtmDataLayerValue = dataLayer && dataLayer.find(function (el) {
          return el.event === gtmId.event;
        });

        if (gtmDataLayerValue) {
          var newCounter = eventCounter + 1;
          _this.setState({ eventCounter: newCounter });
          _this.props.setDataLayer(_extends({}, gtmId, { event: '' + gtmId.event + newCounter + '/' }));
        } else {
          _this.props.setDataLayer(gtmId);
        }
      }, _this.getGtmEvent = function (gtmType) {
        var user = _this.props.user;

        var isBusiness = user.user.tariff && user.user.tariff.is_business;
        var isDealership = user.user.tariff && user.user.tariff.slug === 'b2c-plus';

        if (isDealership) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.dealership[gtmType];
        } else if (isBusiness) {
          return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert.business[gtmType];
        }
        return __WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].advert[gtmType];
      }, _this.sendGtmMetrics = function (params) {
        if (params.kind === 'subscription') _this.setGtmEvent(_this.getGtmEvent(params.details.tariff));else if (params.kind === 'c2c-free' && params.details && params.details.promos) {
          params.details.promos.map(function (item) {
            return _this.setGtmEvent(_this.getGtmEvent(item));
          });
        } else _this.setGtmEvent(_this.getGtmEvent(params.kind));
      }, _this.openMonoOrderWindow = function (token, params, redirectUrl, paymentMethod, cb) {
        var _this$props = _this.props,
            fetch = _this$props.fetch,
            intl = _this$props.intl,
            promoteInSocial = _this$props.promoteInSocial;
        var locale = intl.locale;

        var redirectUrlLocalized = __WEBPACK_IMPORTED_MODULE_10__helpers_locale__["h" /* toLocalized */](redirectUrl, locale);
        var advertId = params.details && params.details.advert_id;

        __WEBPACK_IMPORTED_MODULE_9__helpers_common__["j" /* iniRedirectToCheckout */]();
        return function () {
          return fetch(__WEBPACK_IMPORTED_MODULE_5_shared_constants_api__["a" /* default */].PAYMENT.orders(), {
            method: 'POST',
            headers: {
              Authorization: 'JWT ' + token
            },
            body: JSON.stringify(params)
          }).then(throwIfResponseNotOkay()).then(function (r) {
            return r.json();
          }).then(function (_ref2) {
            var number = _ref2.number,
                status = _ref2.status;

            if (status === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["c" /* ORDER_STATUSES */].PAID || paymentMethod === __WEBPACK_IMPORTED_MODULE_11__constants_payment__["h" /* PAYMENT_METHODS */].BALANCE) {
              _this.sendGtmMetrics(params);
              _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
              _this.props.enqueueNotification({
                text: intl.formatMessage({ id: 'Оплата прошла успешно' }),
                type: __WEBPACK_IMPORTED_MODULE_6_shared_actions_notificationTypes__["a" /* default */].SUCCESS
              });
              updateAdvertParams(params, fetch, token, advertId, promoteInSocial);
              if (cb) cb({ number: number, status: status });else __WEBPACK_IMPORTED_MODULE_13__history__["a" /* default */].push(redirectUrlLocalized);
            } else {
              var handlerUrl = __WEBPACK_IMPORTED_MODULE_11__constants_payment__["j" /* URLS */].HANDLER_URL_FULL + '?redirectUrl=' + redirectUrlLocalized;
              return getMonoOrderData(fetch, token, {
                order_number: number,
                response_url: handlerUrl,
                lang: locale
              }).then(throwIfResponseNotOkay()).then(function (r) {
                return r.json();
              }).then(function (data) {
                _this.sendGtmMetrics(params);
                _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_8_shared_constants_gtmEvents__["a" /* EVENTS */].paidAdSent);
                var url = data.checkout_url;
                updateAdvertParams(params, fetch, token, advertId, promoteInSocial);

                __WEBPACK_IMPORTED_MODULE_9__helpers_common__["d" /* doRedirectToCheckout */](url);
              });
            }

            return Promise.resolve();
          });
        }().catch(function (e) {
          _this.props.enqueueNotification(intl.formatMessage({ id: e.message ? e.message : e }));
          if (cb) cb(null, e.message ? e.message : e);
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { openMonoOrderWindow: this.openMonoOrderWindow }));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withOrders(' + __WEBPACK_IMPORTED_MODULE_9__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2);

  var mapDispatchToProps = {
    enqueueNotification: __WEBPACK_IMPORTED_MODULE_12__actions_notifications__["a" /* enqueueNotification */],
    setDataLayer: __WEBPACK_IMPORTED_MODULE_3_shared_actions_globals__["j" /* setDataLayer */]
  };

  var mapStateToProps = function mapStateToProps(_ref3) {
    var globals = _ref3.globals,
        user = _ref3.user;
    return {
      promoteInSocial: globals.promoteInSocial,
      user: user
    };
  };

  return __WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](__WEBPACK_IMPORTED_MODULE_7_shared_hocs_withFetch__["a" /* withFetch */](Component)));
};

/* harmony default export */ var withMonoPayment_defaultExport = (withMonoPayment);
// CONCATENATED MODULE: ./src/desktop/components/BalanceRefill/BalanceRefill.js
/* harmony import */ var BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Modal__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_PaymentModal__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_payment__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var BalanceRefill__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function BalanceRefill__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BalanceRefill__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BalanceRefill__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_react_intl__["a" /* FormattedMessage */], {
  id: '\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C'
});

var BalanceRefill = function (_React$Component) {
  BalanceRefill__inherits(BalanceRefill, _React$Component);

  function BalanceRefill() {
    var _ref;

    var _temp, _this, _ret;

    BalanceRefill__classCallCheck(this, BalanceRefill);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = BalanceRefill__possibleConstructorReturn(this, (_ref = BalanceRefill.__proto__ || Object.getPrototypeOf(BalanceRefill)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      refillAmount: 99,
      showModal: false
    }, _this.handleChange = function (e) {
      var value = e.target.value;


      if (value === '') {
        _this.setState({ refillAmount: null });
      } else {
        var intValue = parseInt(value, 10);

        if (intValue) {
          _this.setState({ refillAmount: intValue });
        }
      }
    }, _this.handleShow = function () {
      // this.props.onModalOpen();
      // this.setState({ showModal: true });
      var _this$props = _this.props,
          token = _this$props.token,
          openMonoOrderWindow = _this$props.openMonoOrderWindow;
      var refillAmount = _this.state.refillAmount;


      openMonoOrderWindow(token, {
        kind: __WEBPACK_IMPORTED_MODULE_8_shared_constants_payment__["b" /* KINDS */].BALANCE_REFILL,
        details: {
          refill_amount: refillAmount
        }
      }, '' + window.location.pathname + window.location.search, // return to where we are
      'mono');
    }, _this.handleHide = function () {
      _this.props.onModalClose();
      _this.setState({ showModal: false });
    }, _this.renderModal = function () {
      return _jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Modal__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_PaymentModal__["a" /* default */], {
        title: _this.props.intl.formatMessage({ id: 'Пополнение баланса' }),
        description: _this.props.intl.formatMessage({
          id: 'Пополнение внутреннего баланса в аккаунте avtobazar.ua'
        }),
        closeHandler: _this.handleHide,
        amount: _this.state.refillAmount,
        balanceRefillMode: true
      }));
    }, _temp), BalanceRefill__possibleConstructorReturn(_this, _ret);
  }

  // handlePaymentMethodChosen = paymentMethodInfo => {
  //   const { token, openMonoOrderWindow } = this.props;
  //   const { refillAmount } = this.state;

  //   openMonoOrderWindow(
  //     token,
  //     {
  //       kind: KINDS.BALANCE_REFILL,
  //       details: {
  //         refill_amount: refillAmount,
  //       },
  //     },
  //     `${window.location.pathname}${window.location.search}`, // return to where we are
  //     paymentMethodInfo.slug,
  //   );
  // };

  BalanceRefill__createClass(BalanceRefill, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          refillAmount = _state.refillAmount,
          showModal = _state.showModal;


      return _jsx('div', {}, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.inputContainer
      }, void 0, _jsx('input', {
        type: 'text',
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.input),
        value: refillAmount || '',
        onChange: this.handleChange
      }), _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.hrn
      }, void 0, '\u0433\u0440\u043D'), _jsx('button', {
        onClick: this.handleShow,
        className: __WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a.inlineButton,
        disabled: !refillAmount
      }, void 0, _ref2)), showModal && this.renderModal());
    }
  }]);

  return BalanceRefill;
}(BalanceRefill___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BalanceRefill.defaultProps = {
  onModalOpen: function onModalOpen() {},
  onModalClose: function onModalClose() {}
};


var mapStateToProps = function mapStateToProps(_ref3) {
  var user = _ref3.user;
  return {
    token: user.token
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__BalanceRefill_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */](mapStateToProps)(withMonoPayment_defaultExport(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](BalanceRefill)))));

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1290)();
}

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1291);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1293);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1296);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1294), __esModule: true };

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
__webpack_require__(478);
module.exports = __webpack_require__(1295);

/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1260);
var ITERATOR = __webpack_require__(86)('iterator');
var Iterators = __webpack_require__(187);
module.exports = __webpack_require__(30).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined || '@@iterator' in O
  // eslint-disable-next-line no-prototype-builtins
  || Iterators.hasOwnProperty(classof(O));
};

/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1297), __esModule: true };

/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
__webpack_require__(478);
module.exports = __webpack_require__(1298);

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(105);
var get = __webpack_require__(1279);
module.exports = __webpack_require__(30).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1300);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BannerAll.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BannerAll.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2I0F2{margin-bottom:20px}._3DEYy{position:relative}.K2GWo{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}._1VCyV,.K2GWo{display:-webkit-box;display:-ms-flexbox;display:flex}._1VCyV{-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px;margin-bottom:20px}._1VCyV>div{margin-bottom:10px;margin-top:10px}._3coG7{height:100%}", ""]);

// exports
exports.locals = {
	"gptPremium": "_2I0F2",
	"flexCell": "_3DEYy",
	"sideBar": "K2GWo",
	"advertContainerButoon": "_1VCyV",
	"homeSideBar": "_3coG7"
};

/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1302);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalContainer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalContainer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1302:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3ubq_{position:fixed;z-index:3005;background-color:rgba(50,50,50,.5);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._8Koz-{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3006;backdrop-filter:blur(4px)}.NhUO6{background-color:#fff;border:1px solid #bfbfbf;-ms-flex-item-align:center;align-self:center;z-index:3007}._2Ncf4{max-width:600px;width:90%;min-height:300px;padding:15px 20px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
exports.locals = {
	"root": "_3ubq_",
	"background": "_8Koz-",
	"content": "NhUO6",
	"contentParams": "_2Ncf4"
};

/***/ }),

/***/ 1303:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1304);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalWrapper.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ModalWrapper.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1304:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._cLKp{padding:20px 15px}._21JFC{overflow-y:auto;max-height:100vh;margin:0 auto}._2lSzg{position:relative;border-radius:10px;max-width:330px}._1BONa,._18jW-{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}._18jW-:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"rootModalContainer": "_cLKp",
	"rootModal": "_21JFC",
	"modal": "_2lSzg",
	"closeBtnIcon": "_1BONa",
	"closeBtn": "_18jW-"
};

/***/ }),

/***/ 1305:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1306);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CircleTimer.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CircleTimer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3B1TS{font-size:32px;color:#000}._1H7x_{-webkit-transform-origin:center center;transform-origin:center center;-webkit-transform:rotate(-92deg);transform:rotate(-92deg)}", ""]);

// exports
exports.locals = {
	"circleTimerText": "_3B1TS",
	"circleTimerProgress": "_1H7x_"
};

/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1308);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Loader.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Loader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._23UJ_{text-align:center;padding:10px 0}", ""]);

// exports
exports.locals = {
	"root": "_23UJ_"
};

/***/ }),

/***/ 1309:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1s4zB{position:relative;padding:7px 8px;border-radius:2px;height:42px;line-height:30px;border:1px solid #c4c4c4;outline:none;font-size:13px;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._1s4zB::-webkit-input-placeholder{color:gray}._1s4zB::-moz-placeholder{color:gray}._1s4zB:-ms-input-placeholder{color:gray}._1s4zB::placeholder{color:gray}.vJnum{position:relative;margin:0 auto 10px;width:100%;padding:10px 0;font-size:14px;color:#000;font-weight:700;border-width:1px;border-style:solid;outline:none;cursor:pointer;line-height:1.1;border-radius:3px;white-space:nowrap}.vJnum:disabled,.vJnum:disabled>.hX4eV{color:rgba(0,0,0,.25);pointer-events:none}._1F-aN{color:rgba(0,0,0,.25)}._2YtbV,._3bKRW{background-color:#ffd906;border-color:#ffd906}._2YtbV,._3bKRW:hover{background-color:#ffc107;border-color:#ffc107}._2YtbV{border:none}._2YtbV:disabled{background-color:#f5f5f5}._1AWF-{background-color:#fff;border-color:#c4c4c4}._1AWF-:hover{background-color:#fffceb}._2DyKI{background-color:transparent}._2DyKI:hover,._38ptx:hover{background-color:#ffc10744}._38ptx{background-color:transparent;border:1px solid #ffc107}.vJnum.aO6AT>:not(._289M5){visibility:hidden}._15Egm{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding:0;font-size:11px}.zoFvb>svg{margin-left:6px}.vJnum:not(.zoFvb)>svg{margin-right:6px}", ""]);

// exports
exports.locals = {
	"inputGeneral": "_1s4zB",
	"ButtonGeneral": "vJnum",
	"btnInfo": "hX4eV",
	"ButtonDisabledStyle": "_1F-aN",
	"ButtonYellowFlat": "_2YtbV",
	"ButtonYellow": "_3bKRW",
	"ButtonWhite": "_1AWF-",
	"ButtonTransparent": "_2DyKI",
	"ButtonTransparentYellow": "_38ptx",
	"buttonLoader": "aO6AT",
	"ButtonProcessing": "_289M5",
	"ButtonLoader": "_15Egm",
	"iconAfterText": "zoFvb"
};

/***/ }),

/***/ 1310:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1311);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ContactButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ContactButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1311:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3z1Cv{min-height:60px;width:190px;background-color:#ffd906;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:auto;text-align:center}._3z1Cv,._3z1Cv a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3z1Cv a{padding:7px 16px 4px;font-weight:600;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1D5tw{min-height:60px;width:190px}._1D5tw,.a06XJ{font-size:14px;background-color:#ffd906;border-radius:2px;border:1px solid #ffd906;padding:7px 16px 4px;color:#000;cursor:pointer;text-align:center;line-height:1.52;outline:none;font-weight:600;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:auto}._1D5tw a,._3YwyV a,._3z1Cv a,.a06XJ a{color:#000}._3z1Cv{cursor:default;background-color:#f5f5f5;border:1px solid transparent}._1D5tw:hover,._3z1Cv:hover{background-color:#ffc107;border:1px solid #ffc107}._31u6D{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3T3i5,._31u6D{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._254Zh{padding-bottom:2px;padding-left:4px}._3vtyf,._254Zh{line-height:12px;font-size:14px}._3YwyV,.a06XJ{width:100%;min-height:42px}._3YwyV>._31u6D{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.a06XJ{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"showedContainerDesktop": "_3z1Cv",
	"hided": "_1D5tw",
	"showedPhoneMobile": "a06XJ",
	"hidedMobile": "_3YwyV",
	"hidedContent": "_31u6D",
	"hiddenPhone": "_3T3i5",
	"Plus": "_254Zh",
	"Dots": "_3vtyf"
};

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1313);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckBox.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CheckBox.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Vsl7{position:relative;display:inline-block;cursor:pointer;font-weight:400;font-size:13px;color:#000;padding-left:20px;white-space:nowrap}._3Vsl7:hover{color:#ff5a5f}._3Vsl7 input{position:absolute;left:0;border:1px solid #aaa;border-radius:2px;cursor:pointer}._3Vsl7 input,._3Vsl7 input:checked{-webkit-appearance:none;width:15px;height:15px;outline:none}._3Vsl7 input:checked{border:1px solid #ffd906;background-color:#ffd906;border-radius:2px}._3Vsl7 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:2;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}", ""]);

// exports
exports.locals = {
	"checkbox": "_3Vsl7"
};

/***/ }),

/***/ 1314:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1315);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1315:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1hjln{white-space:nowrap;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:6px 6px 6px 0;height:32px;padding:0 8px;font-size:12px;color:#333;min-width:90px;border-radius:2px;border:1px solid #ffd906;cursor:pointer}._1hjln>svg{margin-right:8px}._1hjln:hover{background-color:#ffd906;-webkit-transition:.3s;-o-transition:.3s;transition:.3s}._1hjln:last-child{margin-right:0}._1SOx4{border:1px solid #c4c4c4;border-radius:2px;pointer-events:none;color:#c4c4c4}._1SOx4 path{fill:#c4c4c4}", ""]);

// exports
exports.locals = {
	"tag": "_1hjln",
	"disabled": "_1SOx4"
};

/***/ }),

/***/ 1316:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1317);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Select.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1pNgY .Select-control{height:42px}._1pNgY .Select-placeholder,._1pNgY .Select-value{line-height:42px;height:42px;font-weight:400}._1dne7 .Select-control{border:none}", ""]);

// exports
exports.locals = {
	"root": "_1pNgY",
	"theme-flat": "_1dne7"
};

/***/ }),

/***/ 1318:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1319);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SelectInput.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SelectInput.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1319:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3hl6h{min-width:65px;font-weight:400}._3hl6h,._3Y3JC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._3Y3JC{position:relative}._3Y3JC:hover ._1ZTEB{background-color:#f1f1f18c}._1ZTEB{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#000;font-size:16px;border-radius:4px;font-weight:400;cursor:pointer;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._1ZTEB .fa{margin-left:8px}._3yfgi{width:100%;opacity:0;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "_3hl6h",
	"selectContainer": "_3Y3JC",
	"hint": "_1ZTEB",
	"select": "_3yfgi stretched"
};

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1321);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSelect.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSelect.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2CTZv{width:100%;position:relative}._2CTZv,._3nhOc{display:-webkit-box;display:-ms-flexbox;display:flex}._3nhOc{margin:0;margin-right:2px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.DRK7t{width:16px;height:16px;position:absolute;left:15px;top:8px}.jWUNC{width:100%;height:42px}._3Imj3>.jWUNC{padding-left:36px}._2byyi{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;height:42px;position:relative}._2byyi input[type=number]{-moz-appearance:textfield}._2byyi input[type=number]::-webkit-inner-spin-button,._2byyi input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}._3nGhT{color:#000;font-size:16px;margin-left:5px;position:absolute;right:0;height:42px;display:-webkit-box;display:-ms-flexbox;display:flex}._-5BW7{border-right:1px solid rgba(0,0,0,.15);width:0;margin:4px 0}.J0LiY{padding-left:8px}._11n11 .input{border:none}", ""]);

// exports
exports.locals = {
	"root": "_2CTZv",
	"title": "_3nhOc questionTitle",
	"icon": "DRK7t",
	"input": "jWUNC input",
	"hasIcon": "_3Imj3",
	"inline": "_2byyi",
	"switch": "_3nGhT",
	"switchDivider": "_-5BW7",
	"singleOptionLabel": "J0LiY",
	"required": "_1_Rl_ required",
	"theme-flat": "_11n11"
};

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1323);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ChooseLanguageDialog.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ChooseLanguageDialog.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2zlxK{font-weight:700}._2zlxK,._22XDT{margin-bottom:13px}._22XDT{text-align:justify}._2rIjY{font-weight:700;margin-bottom:13px}._17hGk{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"title": "_2zlxK",
	"text": "_22XDT",
	"timer": "_2rIjY",
	"buttons": "_17hGk"
};

/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1325);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css", function() {
        content = require("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./normalize.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1327);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./font-awesome.min.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./font-awesome.min.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1327:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1329);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-select.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-select.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1331);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-datepicker.min.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./react-datepicker.min.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1333);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./nprogress.css", function() {
        content = require("!!../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../css-loader/index.js??ref--1-rules-1-1!../postcss-loader/lib/index.js??ref--1-rules-3!./nprogress.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1333:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1334:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1335);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./slick.css", function() {
        content = require("!!../../extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../css-loader/index.js??ref--1-rules-1-1!../../postcss-loader/lib/index.js??ref--1-rules-3!./slick.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1337);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../node_modules/extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../node_modules/css-loader/index.js??ref--1-rules-1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./desktop.css", function() {
        content = require("!!../../node_modules/extract-text-webpack-plugin/loader.js??ref--1-rules-1-0!../../node_modules/css-loader/index.js??ref--1-rules-1-1!../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./desktop.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function (root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
    module.exports = factory();
  } else {
    root.NProgress = factory();
  }
})(this, function () {
  var NProgress = {};

  NProgress.version = '0.1.6';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function (options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function (n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = n === 1 ? null : n;

    var progress = NProgress.render(!started),
        bar = progress.querySelector(Settings.barSelector),
        speed = Settings.speed,
        ease = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function (next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, {
          transition: 'none',
          opacity: 1
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function () {
          css(progress, {
            transition: 'all ' + speed + 'ms linear',
            opacity: 0
          });
          setTimeout(function () {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function () {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function () {
    if (!NProgress.status) NProgress.set(0);

    var work = function work() {
      setTimeout(function () {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function (force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function (amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function () {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   * 
   * @param $promise jQUery Promise
   */
  (function () {
    var initial = 0,
        current = 0;

    NProgress.promise = function ($promise) {
      if (!$promise || $promise.state() == "resolved") {
        return this;
      }

      if (current == 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function () {
        current--;
        if (current == 0) {
          initial = 0;
          NProgress.done();
        } else {
          NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };
  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function (fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');

    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar = progress.querySelector(Settings.barSelector),
        perc = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent = document.querySelector(Settings.parent),
        spinner;

    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function () {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function () {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function () {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = 'WebkitTransform' in bodyStyle ? 'Webkit' : 'MozTransform' in bodyStyle ? 'Moz' : 'msTransform' in bodyStyle ? 'ms' : 'OTransform' in bodyStyle ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }

  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d(' + toBarPerc(n) + '%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate(' + toBarPerc(n) + '%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n) + '%' };
    }

    barCSS.transition = 'all ' + speed + 'ms ' + ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = function () {
    var pending = [];

    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function (fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  }();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = function () {
    var cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'],
        cssProps = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function (match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function (element, properties) {
      var args = arguments,
          prop,
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    };
  }();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return;

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3de37e7e.svg";

/***/ }),

/***/ 1340:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e968b6a0.svg";

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1342);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Logo.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Logo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2DdTy{text-decoration:none!important;font-size:10px;font-weight:600;color:#ffd906;padding-bottom:5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:48px}._2DdTy:active,._2DdTy:focus,._2DdTy:hover{color:#ffd906;text-decoration:none}", ""]);

// exports
exports.locals = {
	"brandLogo": "_2DdTy"
};

/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1344);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Header.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".CjTMX{position:relative;background-color:#fff;color:#000;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.12);box-shadow:0 2px 8px rgba(0,0,0,.12);z-index:99}._3v0wi{position:fixed;left:0;right:0;top:0;z-index:100}._1KXxC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding:0 15px;height:60px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media print{.CjTMX{display:none}}", ""]);

// exports
exports.locals = {
	"root": "CjTMX",
	"fixed": "_3v0wi",
	"container": "_1KXxC container"
};

/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f33d7fc5.svg";

/***/ }),

/***/ 1346:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1347);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationLink.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationLink.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1347:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1h7t-{padding:0 4px;font-weight:400;margin-left:-2px;background-color:#ededed;border-radius:10rem}", ""]);

// exports
exports.locals = {
	"count": "_1h7t-"
};

/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1349);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationItem.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NavigationItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1349:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._34VVu{position:relative;font-size:13px;border-bottom:2px solid transparent;border-top:2px solid transparent;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.m5hBM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#000;font-weight:700;text-decoration:none;padding:13px 12px;height:100%}._1ojmC{display:none;position:absolute;top:100%;left:0;z-index:101;background-color:#fff;border-bottom:1px solid #ddd;border-right:1px solid #ddd;border-left:1px solid #ddd;-webkit-box-shadow:0 12px 16px rgba(0,0,0,.08);box-shadow:0 12px 16px rgba(0,0,0,.08)}._34VVu:hover{background-color:#f5f5f5;color:#e73232}._34VVu._2Rphr,._34VVu:hover{border-top:2px solid #ffd906}._34VVu:hover .m5hBM{color:#e73232}._34VVu:hover ._1ojmC,.BOSU4{display:block}.BOSU4{color:#000;font-weight:400;font-size:14px;text-decoration:none;padding:12px;white-space:nowrap}.BOSU4:hover{background-color:#f5f5f5;color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_34VVu",
	"link": "m5hBM",
	"dropdown": "_1ojmC",
	"active": "_2Rphr",
	"dLink": "BOSU4"
};

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1351);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ProfileButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ProfileButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".cSaip{position:relative;font-size:13px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;padding:0 12px;min-width:150px}._2vqlh{color:#000;max-width:150px;font-weight:700;text-decoration:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0 -12px;padding:0 11px;border-top:0 solid transparent}.cSaip:hover ._2vqlh{background-color:#f5f5f5;border-top:0 solid #ffd906;color:#e73232}.MEvex{max-width:150px;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}._2Esyq{display:none;position:absolute;width:100%;top:100%;left:0;z-index:101;background-color:#fff;border-bottom:1px solid #ddd;border-right:1px solid #ddd;border-left:1px solid #ddd;-webkit-box-shadow:0 12px 16px rgba(0,0,0,.08);box-shadow:0 12px 16px rgba(0,0,0,.08);-webkit-box-sizing:border-box;box-sizing:border-box}.cSaip:hover ._2Esyq{display:block}.r6XJg{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.cdK6z>span{white-space:pre-wrap}.cdK6z{display:block;color:#000;font-weight:400;font-size:14px;text-decoration:none;padding:12px;white-space:nowrap;text-align:left}.cdK6z:hover{background-color:#f5f5f5;color:#000}._1-5lQ{border-top:1px solid #ededed;font-weight:700;padding:12px}._2ST8r{height:35px;width:35px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:50%;overflow:hidden;margin-right:10px}._1JQVF{width:100%}", ""]);

// exports
exports.locals = {
	"root": "cSaip",
	"link": "_2vqlh",
	"btnTitle": "MEvex",
	"dropdown": "_2Esyq",
	"dropdownList": "r6XJg",
	"dropdownLink": "cdK6z",
	"logout": "_1-5lQ",
	"avatarContainer": "_2ST8r",
	"avatar": "_1JQVF"
};

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1353);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Navigation.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".s3Ylh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;min-width:935px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-item-align:stretch;align-self:stretch}._3BN4_{margin-right:8px;margin-left:8px;border-radius:3px;color:#000}._3BN4_:hover{color:#e73232}._29C-n{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.BZPWi{position:relative;height:100%}.BZPWi,.dmyLG{display:-webkit-box;display:-ms-flexbox;display:flex}.dmyLG{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-left:10px}._1XlLA{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;height:100%}._3L2yd{display:inline-block;text-decoration:none;font-weight:700;font-size:13px;padding:15px 20px 15px 18px}._3PRKw{background-color:#ffd906;color:#000;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3PRKw:hover{background-color:#ffc107;color:#000}._3PRKw img{margin-right:10px}", ""]);

// exports
exports.locals = {
	"root": "s3Ylh",
	"highlight": "_3BN4_",
	"left": "_29C-n",
	"navItem": "BZPWi",
	"right": "dmyLG",
	"flexRow": "_1XlLA",
	"link": "_3L2yd",
	"sell": "_3PRKw"
};

/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1355);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineNav.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineNav.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3ALPP{z-index:1}._3ALPP,.mCAa6{position:relative;margin:0;padding:0}.mCAa6{list-style:none}._3PRCE{position:relative}._3PRCE,._HsNd{display:inline-block}._HsNd{text-decoration:none;font-weight:400;font-size:12px;padding:15px 10px 9px;border-bottom:4px solid transparent;cursor:pointer;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;text-transform:uppercase;letter-spacing:.1em}._HsNd:hover{color:#e73232}._HsNd:hover,.A7cFq{border-bottom:4px solid #ffd906}.A7cFq{position:relative;color:#000;font-weight:700}", ""]);

// exports
exports.locals = {
	"root": "_3ALPP",
	"list": "mCAa6",
	"item": "_3PRCE",
	"link": "_HsNd",
	"active": "A7cFq"
};

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1357);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _chainFunction = __webpack_require__(1359);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(318);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1360);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';

TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ 1359:
/***/ (function(module, exports) {


module.exports = function chain() {
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++) {
    args[i] = arguments[i];
  }args = args.filter(function (fn) {
    return fn != null;
  });

  if (args.length === 0) return undefined;
  if (args.length === 1) return args[0];

  return args.reduce(function (current, next) {
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  });
};

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(11);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _addClass = __webpack_require__(1362);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1364);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1365);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(1366);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1246);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(38);

var _PropTypes = __webpack_require__(1264);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';

CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1363));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ 1364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1263));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */

var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1251);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1263));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1368);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PaymentModal.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PaymentModal.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2aYHp{position:fixed;z-index:3005;background-color:rgba(50,50,50,.2);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:400}.Qt1yN{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3006}._8VETH{position:relative;background-color:#fff;width:600px;min-height:400px;padding:10px 20px 18px;margin:5px;-ms-flex-item-align:center;align-self:center;z-index:3007}._2ux5J{font-size:21px;font-weight:400;padding-bottom:15px;margin-bottom:11px;border-bottom:1px solid #eee}._1DP-n{margin-bottom:5px}.pu5sx{position:relative;-ms-flex-line-pack:stretch;align-content:stretch;margin:20px 0 35px}.pu5sx,.sMEF2{display:-webkit-box;display:-ms-flexbox;display:flex}.sMEF2{width:100%;max-width:50%;padding:20px 15px;margin:0 20px 0 auto;border:2px solid #eee;border-radius:2px;text-align:center;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;background:transparent;outline:none}.sMEF2:last-of-type{margin-right:auto}._2zCrj{margin:auto}._3ZjNy{padding-top:7px}._3o5Yq{height:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3o5Yq,._3v-gG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column wrap;flex-flow:column wrap}._3v-gG{position:relative}.sMEF2:not(._2FvZr):hover{color:#000;border-color:#ffd906;background-color:#fffbd3;cursor:pointer;outline:none}.VjrcA{text-align:right}._3gU1v,.VjrcA{position:relative}._3gU1v{margin-left:10px;border:1px solid #d0d0d0;background-color:#fff;color:#000;padding:8px 16px;overflow:hidden}._3gU1v:hover{cursor:pointer;border-color:#ffd906}._3gU1v._2FvZr>:not(._2si0B){visibility:hidden}._1EHnC{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._1ofkJ{padding-top:21px;padding-left:18px;font-size:13px;font-weight:400;color:#aaa;margin:0 0 6px}._3_uNl{margin:5px;bottom:21px;position:absolute;left:-4px}@media screen and (max-width:380px){.pu5sx{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0}.sMEF2{margin:10px auto}}._2FvZr{opacity:.6}._3s_hN{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;position:relative;font-weight:400;color:#000;padding-left:20px}._3s_hN:hover{color:#ff5a5f}._3s_hN input{cursor:pointer;position:absolute;left:4px;border:1px solid #aaa;border-radius:2px}._3s_hN input,._3s_hN input:checked{margin-left:-4px;top:1px;-webkit-appearance:none;width:15px;height:15px;outline:none}._3s_hN input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._3s_hN input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:1px;left:-1px;overflow:hidden;width:17px;height:9px;margin-top:-6px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}._3ZsMo input,._3ZsMo input:checked{margin-top:-8px;margin-left:-4px}", ""]);

// exports
exports.locals = {
	"root": "_2aYHp",
	"bg": "Qt1yN",
	"container": "_8VETH",
	"h3": "_2ux5J",
	"balance": "_1DP-n",
	"list": "pu5sx",
	"payment": "sMEF2",
	"paymentContents": "_2zCrj",
	"paymentTitle": "_3ZjNy",
	"column": "_3o5Yq",
	"columnWrapper": "_3v-gG",
	"disabled": "_2FvZr",
	"actions": "VjrcA",
	"button": "_3gU1v",
	"buttonLoader": "_2si0B",
	"loader": "_1EHnC",
	"contractOffer": "_1ofkJ",
	"contractCheckbox": "_3_uNl",
	"checkbox": "_3s_hN",
	"mobile": "_3ZsMo"
};

/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1370);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BalanceRefill.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BalanceRefill.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".DmOcI{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;min-height:44px;line-height:44px;font-size:16px;font-weight:400}._3ZFf5{height:44px;background-color:#ffd906;border:1px solid #ffd906;color:#000;padding:10px 12px;border-radius:0 2px 2px 0;cursor:pointer;font-weight:600;outline:none}._3ZFf5:hover{background:#ffc107;border:1px solid #ffc107}._30C05{position:absolute;top:1px;left:110px}.LY1XA{border:1px solid #e0e0e0;font-size:16px;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;outline:none;width:150px;padding:12px 43px 12px 12px;text-align:right;max-height:44px}.LY1XA:active,.LY1XA:focus{outline:none;-webkit-box-shadow:none;box-shadow:none;border:1px solid #ffd906}", ""]);

// exports
exports.locals = {
	"inputContainer": "DmOcI",
	"inlineButton": "_3ZFf5",
	"hrn": "_30C05",
	"input": "LY1XA"
};

/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1372);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Balance.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Balance.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1uFAv{position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding-right:8px}._2B6Dt{font-weight:600;color:inherit;text-decoration:none}._2O5JS{position:absolute;top:100%;right:0;padding:10px 8px 8px;background:#fff;-webkit-box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75);box-shadow:-1px 14px 28px -14px rgba(0,0,0,.75)}._3iQnl{vertical-align:text-bottom}._2xW05{vertical-align:top}", ""]);

// exports
exports.locals = {
	"root": "_1uFAv",
	"content": "_2B6Dt",
	"popup": "_2O5JS",
	"icon": "_3iQnl",
	"title": "_2xW05"
};

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1374);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SubHeader.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SubHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1D_Nn{position:relative;background-color:#fff;z-index:7;padding:0 15px}._1ediK{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._1ediK,._2cKE_,.TpfX0{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.TpfX0{display:-webkit-box;display:-ms-flexbox;display:flex;text-align:right;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:10px;height:44px;line-height:42px;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._3YhcH{border:0;background:none}._3c7Db,._3YhcH,.vuYGG{display:inline-block}.vuYGG{font-weight:600;color:inherit;text-decoration:none}.vuYGG+.vuYGG{margin-left:30px}._3c7Db{margin-left:28px}._1dKSE{color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_1D_Nn",
	"container": "_1ediK container",
	"left": "_2cKE_",
	"right": "TpfX0",
	"locationSelect": "_3YhcH",
	"tariff": "vuYGG",
	"balance": "_3c7Db",
	"nonActiveTariff": "_1dKSE"
};

/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".zDFkx{position:relative;font-size:13px;line-height:18px;min-width:920px;padding:15px 0 30px;color:hsla(0,0%,100%,.5);background:#212121;z-index:3;min-height:200px}._3RtQ6{padding:0 20px;margin:0 auto}.fb9ID{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._20qxe{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.NYfbf{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:265px;text-align:right;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._35XCD{list-style:none;margin:10px 0;padding:0;min-width:790px}._35XCD li{display:inline-block;margin-right:20px}._19Cat{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0}._2Rxe3{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;margin-bottom:8px}._3EfAE{font-weight:500;font-size:18px;line-height:120%;color:#fff}._2-_Wn{font-size:12px}._2Dlbx{font-weight:400;text-decoration:none;font-size:14px;color:hsla(0,0%,100%,.85);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}._2xcDA{font-weight:400}._2xcDA,.Oogak{text-decoration:none;font-size:13px;color:hsla(0,0%,100%,.5);-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.Oogak{position:relative;margin:10px 0;font-weight:700;display:inline-block;letter-spacing:.05em}._2Dlbx:hover,._2xcDA:hover,.Oogak:hover{color:#fff;cursor:pointer}._2-8Mr{border-top:1px solid #4e4e4e;margin:16px 0}._2rdKT{font-size:22px;color:#fff;text-decoration:none;opacity:.8;padding-left:14px}._2rdKT:hover{opacity:1}._1AipK a,span{color:inherit;text-decoration:none}._1AipK:after{content:\" | \";margin:0 10px}._1AipK:last-child:after{content:none}._3pz-l{text-align:center;margin-top:20px}@media print{.zDFkx{display:none}}._3rXoJ ul{padding:0}", ""]);

// exports
exports.locals = {
	"root": "zDFkx",
	"container": "_3RtQ6 container",
	"flexContainer": "fb9ID",
	"left": "_20qxe",
	"right": "NYfbf",
	"nav": "_35XCD",
	"navLeasing": "_19Cat",
	"navLeasingItem": "_2Rxe3",
	"navLeasingTitle": "_3EfAE",
	"navLeasingTitleHeader": "_2-_Wn",
	"link": "_2Dlbx",
	"smallLink": "_2xcDA",
	"tel": "Oogak",
	"divide": "_2-8Mr",
	"socialLink": "_2rdKT",
	"lang": "_1AipK",
	"footerCopyRight": "_3pz-l",
	"leasingList": "_3rXoJ"
};

/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1377);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColumnList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ColumnList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".JoFQz{margin-top:20px}._3QNtp{width:200px}._2iDdE{list-style:none}._2fQe9{font-size:11px;color:inherit;text-decoration:none;margin-top:0;margin-bottom:1em;white-space:nowrap;overflow:hidden;display:block}._1LE5p{cursor:pointer;text-decoration:none}._1LE5p,._2XVd2{padding:10px;font-size:14px;font-weight:700;display:inline-block;color:hsla(0,0%,100%,.5)}.wcDf5{color:#dedede!important;font-size:12px}._3oo16{color:rgba(64,64,64,.98);font-size:12px;font-weight:700}._35FVL{display:block;padding-left:0;margin-left:-6px;font-size:12px;cursor:auto}.r4Dcm{cursor:pointer}._1gtiU{color:hsla(0,0%,100%,.5)!important}._1mQCi{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}", ""]);

// exports
exports.locals = {
	"root": "JoFQz",
	"column": "_3QNtp",
	"item": "_2iDdE",
	"link": "_2fQe9",
	"resetLocationLink": "_1LE5p",
	"resetLocationText": "_2XVd2",
	"selLocation": "wcDf5",
	"disabledCity": "_3oo16",
	"curentBreadCrumbs": "_35FVL",
	"cursorPointer": "r4Dcm",
	"hideHover": "_1gtiU",
	"breadCrumbsBlock": "_1mQCi"
};

/***/ }),

/***/ 1378:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1379);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LocationList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1379:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1PNMZ,._3G2DH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1PNMZ ._3Lg2h{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}._1PNMZ ._3Lg2h,._3G2DH ._3Lg2h{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;list-style:none;margin:0}._3G2DH ._3Lg2h{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._3Lg2h{font-weight:400}.f2F2C{font-size:14px;color:#c4c4c4}", ""]);

// exports
exports.locals = {
	"root": "_1PNMZ",
	"rootMobile": "_3G2DH",
	"citiesList": "_3Lg2h",
	"title": "f2F2C"
};

/***/ }),

/***/ 1380:
/***/ (function(module, exports) {

module.exports = {"title":"Популярные разделы","uk_title":"Популярні розділи","items":[{"id":1,"title":"Б/у авто в лизинг","uk_title":"Б/у авто в лізинг","slug":"/leasing/used-avto/"},{"id":2,"title":"Новые авто в лизинг","uk_title":"Нові авто в лізинг","slug":"/leasing/novyye-avto/"},{"id":3,"title":"Легковые авто в лизинг","uk_title":"Легкові авто в лізинг","slug":"/leasing/leasing-legkovykh-avto/"},{"id":4,"title":"Лизинг авто для физических лиц","uk_title":"Лізинг авто для фізичних осіб","slug":"/leasing/leasing-avto-fizicheskikh-lits/"}]}

/***/ }),

/***/ 1381:
/***/ (function(module, exports) {

module.exports = {"title":"Популярные Марки авто в лизинг","uk_title":"Популярні Марки авто в лізинг","items":[{"id":1,"title":"bmw в лизинг","uk_title":"bmw у лізинг","slug":"/leasing/bmw/"},{"id":2,"title":"peugeot в лизинг","uk_title":"peugeot у лізинг","slug":"/leasing/peugeot/"},{"id":3,"title":"volvo в лизинг","uk_title":"volvo у лізинг","slug":"/leasing/volvo/"},{"id":4,"title":"toyota в лизинг","uk_title":"toyota у лізинг","slug":"/leasing/toyota/"},{"id":5,"title":"mazda в лизинг","uk_title":"mazda у лізинг","slug":"/leasing/mazda/"},{"id":6,"title":"skoda в лизинг","uk_title":"skoda у лізинг","slug":"/leasing/skoda/"},{"id":7,"title":"газель в лизинг","uk_title":"газель у лізинг","slug":"/leasing/gaz/"},{"id":8,"title":"volkswagen в лизинг","uk_title":"volkswagen у лізинг","slug":"/leasing/volkswagen/"},{"id":9,"title":"порше в лизинг","uk_title":"порше у лізинг","slug":"/leasing/porsche/"},{"id":10,"title":"ауди в лизинг","uk_title":"ауди у лізинг","slug":"/leasing/audi/"},{"id":11,"title":"citroen в лизинг","uk_title":"citroen у лізинг","slug":"/leasing/citroen/"},{"id":12,"title":"mercedes benz в лизинг","uk_title":"mercedes benz у лізинг","slug":"/leasing/mercedes-benz/"},{"id":13,"title":"ford в лизинг","uk_title":"ford у лізинг","slug":"/leasing/ford/"},{"id":14,"title":"nissan в лизинг","uk_title":"nissan у лізинг","slug":"/leasing/nissan/"},{"id":15,"title":"hyundai в лизинг","uk_title":"hyundai у лізинг","slug":"/leasing/hyundai/"},{"id":16,"title":"renault в лизинг","uk_title":"renault у лізинг","slug":"/leasing/renault/"}]}

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1383);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LanguageList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LanguageList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._11JjB a,span{color:inherit;text-decoration:none}._11JjB:after{content:\" | \";margin:0 10px}._11JjB:last-child:after{content:none}", ""]);

// exports
exports.locals = {
	"lang": "_11JjB"
};

/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1385);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotificationBar.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NotificationBar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".KSaKz{position:fixed;top:0;left:0;width:100%;background:rgba(0,0,0,.8);padding:13px 20px;-webkit-transform:translateY(-100%);transform:translateY(-100%);-webkit-transition:-webkit-transform .1s linear;transition:-webkit-transform .1s linear;-o-transition:transform .1s linear;transition:transform .1s linear;transition:transform .1s linear,-webkit-transform .1s linear;z-index:10000}._2sO61{background:#e73232;color:#fff}._2A3gx{background:#ffd906;color:#000}._1aLfe{background:#4caf10;color:#fff}._2pXnf{background:#2196f3;color:#fff}.bzlx8{-webkit-transform:translateY(0);transform:translateY(0)}._1WJlP{color:#fff;text-align:center;max-width:800px;margin:0 auto}@media print{.KSaKz{display:none}}", ""]);

// exports
exports.locals = {
	"root": "KSaKz",
	"error": "_2sO61",
	"warning": "_2A3gx",
	"success": "_1aLfe",
	"info": "_2pXnf",
	"active": "bzlx8",
	"label": "_1WJlP"
};

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1387);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Layout.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".-lRLO{position:relative;padding-top:10px;padding-bottom:10px;margin:0 auto;text-align:center}._35_nZ{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around}._3aSLj,._35_nZ{display:-webkit-box;display:-ms-flexbox;display:flex}._3aSLj{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1I3Gw{font-size:14px;font-weight:400;text-align:center;color:#000}._1I3Gw,.iXl6a{margin-bottom:20px}.iXl6a{float:right}._3w_FE{color:#2196f3;display:inline-block;cursor:pointer}._3w_FE:hover{color:#154088;border-bottom:.07em solid}._3w_FE:active{color:#497ddd;border-bottom:1px dashed}._18Fb4{display:inline-block;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;font-weight:400;font-size:15px;color:#000}._18Fb4 input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._18Fb4 input,._18Fb4 input:checked{top:3px;-webkit-appearance:none;width:15px;height:15px;outline:none}._18Fb4 input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._18Fb4 input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:0;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}._3IYbg input{margin-left:0;position:absolute;left:0;border:1px solid #aaa;border-radius:2px}._3IYbg input,._3IYbg input:checked{top:0;-webkit-appearance:none;width:15px;height:15px;outline:none}._3IYbg input:checked{border:1px solid #2196f3;background-color:#fff;border-radius:2px}._3IYbg input:checked:after{-webkit-appearance:none;position:absolute;font:0/0 a;z-index:15;top:-3px;left:-1px;overflow:hidden;width:17px;height:9px;content:\" \";pointer-events:none;border-width:0 0 2px 2px;border-style:solid;border-color:#222;border-radius:1px;background:0 0;-webkit-transform:rotate(315deg);transform:rotate(315deg)}body{font-family:OpenSans,sans-serif;padding:0 2px 0 0;color:#000;font-weight:400}a:focus{text-decoration:none}:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}.ant-form-item{margin:0}.ant-btn,button,input,optgroup,select,textarea{line-height:normal}._1ONYX{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;padding:17px 16px;width:100%;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;font-size:18px;line-height:1.3333333;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;margin:10px 0}._1ONYX::-webkit-input-placeholder{color:#6c6868cf;opacity:1}._1ONYX::-moz-placeholder{color:#6c6868cf;opacity:1}._1ONYX:-ms-input-placeholder{color:#6c6868cf;opacity:1}._1ONYX::placeholder{color:#6c6868cf;opacity:1}._3oObU::-webkit-input-placeholder{color:#6c6868cf;opacity:1}._3oObU::-moz-placeholder{color:#6c6868cf;opacity:1}._3oObU:-ms-input-placeholder{color:#6c6868cf;opacity:1}._3oObU::placeholder{color:#6c6868cf;opacity:1}._3oObU{padding:17px 16px;height:60px;outline:0;border:1px solid #ccc;-webkit-appearance:none;border-radius:2px;background:#fff;color:#616161;-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}._2RHEP,._3oObU{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;font-size:16px;line-height:1.3333333;margin-top:10px}._2RHEP{position:relative;margin-bottom:20px;height:46px;border:0;border-radius:3px;background:#ffd906;text-align:center;text-decoration:none;cursor:pointer;outline:none}._2RHEP>p{margin:0}._2RHEP:hover{background:#ffc1076b}._2RHEP:disabled,._2RHEP[disabled]{background:#ffc1077c;cursor:auto;color:rgba(0,0,0,.5)}.has-error>span>input{border-color:#f5222d}.ant-form-explain{color:#f5222d;padding:0 8px}.czsUy{text-align:center;padding:15px 0 40px}.ant-form-item{margin-bottom:5px}.eTG0E{font-size:13px;line-height:18px;margin:25px 0 20px;color:#555;letter-spacing:.34px;font-weight:400}.Nmq1p{text-decoration:none;font-size:15px;cursor:pointer}._2gUqb{cursor:pointer;float:right}._1SYqv{width:100%;text-align:right;margin:10px 0}._37Srk{font-size:14px;font-weight:400;text-align:center;color:#000;margin-top:20px;font-weight:600}._1frkA{position:relative;background-color:#fff}._1frkA,._1gBiv{margin-bottom:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1gBiv{max-width:740px}._1gBiv>div>div>iframe,._1gBiv>div>iframe,._1gBiv>iframe{max-width:100%}._1frkA>div{margin-bottom:0}._1frkA>div>div{padding-top:10px}._1frkA>div>div,._3lJEn,._31HIU{margin-bottom:20px}._3lJEn{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;margin-top:20px;padding:0 45px}._3lJEn>div{margin-bottom:10px;margin-top:10px}#banner{display:none}._2s_Y4{position:relative;margin-top:-18px;padding-left:15px;max-width:1100px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:10px;-webkit-box-sizing:border-box;box-sizing:border-box;margin-bottom:20px}._2s_Y4,._30-Va>div{display:-webkit-box;display:-ms-flexbox;display:flex}._30-Va>div{width:100vw;-ms-flex-pack:distribute;justify-content:space-around}.is-focused:not(.is-open)>.Select-control{border-color:#ff5a5f;-webkit-box-shadow:none;box-shadow:none}.Select-control{border-radius:0;border:1px solid #e0e0e0}.Select-placeholder{color:#777}.d-advertSlot{margin-bottom:20px}.adunitContainer,.d-advertSlot{position:relative;text-align:center}.adunitContainer>:last-child{margin-bottom:20px}#app{position:relative;z-index:2;padding-top:63px;height:100%}.ap-script-wrapper>div{padding:20px}.F0IVy{min-width:1100px;position:relative;z-index:auto}._2azA2{margin-top:30px}html{color:#222;font-weight:100;font-size:1em;line-height:1.375}button,html{font-family:OpenSans,sans-serif}body{margin:0;background-color:#f5f5f5}a{color:#0074c2}a[class=meta-title-link-next],a[class=meta-title-link]{text-decoration:none}a[class=meta-title-link]+a[class=meta-title-link]:before,span[class=meta-title-link]+span[class=meta-title-link]:before{content:\"\";background-image:url(" + __webpack_require__(1267) + ");background-size:contain;background-repeat:no-repeat;display:inline-block;cursor:default;height:8px;width:10px}a[class=meta-title-link-next]:before,span[class=meta-title-link-next]:before{content:\"\";background-image:url(" + __webpack_require__(1267) + ");background-size:contain;background-repeat:no-repeat;display:inline-block;cursor:default;height:8px;width:10px}::-moz-selection{background:#b3d4fc;text-shadow:none}::selection{background:#b3d4fc;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}._3RoS6{min-width:1070px;max-width:1100px;background:#f5f5f5;margin:8px auto 0;z-index:4;position:relative}._1agwl>div>iframe{margin-top:25px}._1HUfQ{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-sizing:border-box;box-sizing:border-box}.imgCover{position:absolute;top:50%;left:50%;width:100%;height:auto;max-width:none;max-height:none;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@supports ((-o-object-fit:cover) or (object-fit:cover)){.imgCover{position:static;top:auto;left:auto;width:100%;height:100%;-webkit-transform:none;transform:none;-o-object-fit:cover;object-fit:cover}}.page{padding:0;position:relative}.container{min-width:1070px;max-width:1100px;margin:0 auto}.card{background-color:#fff;z-index:1;padding:10px 20px}.flexRow{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}.questionTitle{font-size:21px;font-weight:700;margin-bottom:10px}.required:after{content:\"*\";display:inline-block;margin-left:2px;color:#c00}.input:active,.input:focus{outline:none;border:1px solid #ffc107}", ""]);

// exports
exports.locals = {
	"sbsGL": "-lRLO",
	"flexCenterGl": "_35_nZ",
	"flexCenterAlignGl": "_3aSLj",
	"titleNellGl": "_1I3Gw",
	"linkLeahs": "iXl6a",
	"linkLeah": "_3w_FE",
	"checkboxGl": "_18Fb4",
	"checkboxMobileGl": "_3IYbg",
	"inputFormGl": "_1ONYX",
	"inputFormMobilGl": "_3oObU",
	"buttonFormGl": "_2RHEP",
	"submitSectionGl": "czsUy",
	"agreementGl": "eTG0E",
	"urlGl": "Nmq1p",
	"linkTextGl": "_2gUqb",
	"linkBlockGl": "_1SYqv",
	"titleGl": "_37Srk",
	"advertContainerGl": "_1frkA",
	"banerAllStyleGl": "_1gBiv",
	"gptPremium": "_31HIU",
	"advertContainerButoonGl": "_3lJEn",
	"brandingAdvGl": "_2s_Y4",
	"mobileWebTop": "_30-Va",
	"root": "F0IVy",
	"mainFooter": "_2azA2",
	"layout": "_3RoS6",
	"banerTop": "_1agwl",
	"brandingAdv": "_1HUfQ"
};

/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(501);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 1391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_common__ = __webpack_require__(184);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import PropTypes from 'prop-types';

// import { setRatio } from 'shared/actions/globals';


var setRatioImage = function setRatioImage(image, ratio, width, height) {
  var fit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'cover';

  if (!image) {
    return image;
  }

  var aS3Regexp = /^(https:\/\/a[\d].s3.ua)/;
  var cndRegexp = /^(https:\/\/cdn.+(ab|s3).ua)/;
  var awsWithoutIRHRegexp = /^((https:\/\/d2wkv3iadoqiil.cloudfront.net\/)(\w*\/)?(\w*\/)?(.{32})(\..*)?)/;
  var awsWithIRHRegexp = /^((https:\/\/d1672trkrgk4ug.cloudfront.net\/)(.*))/;
  var dimensions = [width, height].map(function (x) {
    return x ? Math.round(x * ratio) : '';
  }).join('x');
  var httpsImage = image.replace('http:', 'https:');

  if (width || height) {
    if (httpsImage.match(cndRegexp)) {
      return httpsImage.replace('/image/', '/unsafe/' + dimensions + '/');
    }

    if (httpsImage.match(aS3Regexp)) {
      return httpsImage.replace(aS3Regexp, '$1/' + dimensions);
    }

    if (httpsImage.match(awsWithoutIRHRegexp)) {
      var groups = httpsImage.match(awsWithoutIRHRegexp);
      var size = 'large';
      if (width) {
        if (width * ratio <= 600) {
          size = 'small';
        } else if (width * ratio <= 900) {
          size = 'medium';
        }
      }

      var root = groups[3] && groups[3] === 'original/' ? '' : groups[3];
      return '' + (groups[2] + (root || '')) + size + '/' + (groups[5] + (groups[6] || ''));
    }

    if (httpsImage.match(awsWithIRHRegexp)) {
      var _groups = httpsImage.match(awsWithIRHRegexp);
      var imageRequest = JSON.stringify({
        key: '' + _groups[3],
        edits: {
          resize: {
            width: width ? Math.round(width * ratio) : null,
            height: height ? Math.round(height * ratio) : null,
            fit: fit
          }
        }
      });

      return '' + _groups[2] + Buffer.from(imageRequest).toString('base64');
    }
  }

  return httpsImage;
};

/*
const mapStateToProps = ({ globals }) => ({ ratio: globals.ratio });
const mapDispatchToProps = { setRatio };
*/
var mapStateToProps = function mapStateToProps() {
  return {};
};
var mapDispatchToProps = {};

// TODO: Commented code can be removed after testing, and be sure this code do not have some side effects.

var withPixelRatio = function withPixelRatio(WrappedComponent) {
  var _class, _temp2;

  return __WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)((_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.setRatioImage = function (image) {
        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 240;
        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var fit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cover';
        return setRatioImage(image, 1, width, height, fit);
      }, _this.setRatioAlbum = function (images, width, height) {
        return images.map(function (_ref2) {
          var image = _ref2.image,
              rest = _objectWithoutProperties(_ref2, ['image']);

          return _extends({}, rest, {
            image: _this.setRatioImage(image, width, height)
          });
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /*
    static propTypes = {
      // setRatio: PropTypes.func.isRequired,
      ratio: PropTypes.number,
    };
    static defaultProps = {
      ratio: null,
    }; */

    /*
    componentDidMount() {
      if (!this.props.ratio) {
        this.props.setRatio();
      }
    }
    */

    /*
    setRatioImage = (image, width = 240, height = null) =>
      setRatioImage(image, this.props.ratio, width, height);
    */


    _createClass(_class, [{
      key: 'render',
      value: function render() {
        // const { ratio, ...props } = this.props;
        var ratio = 1;

        var props = _objectWithoutProperties(this.props, []);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
          setRatioAlbum: this.setRatioAlbum,
          setRatioImage: this.setRatioImage,
          ratio: ratio
        }, props));
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withPixelRatio(' + __WEBPACK_IMPORTED_MODULE_2__helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _temp2));
};

/* harmony default export */ __webpack_exports__["a"] = (withPixelRatio);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(492).Buffer))

/***/ }),

/***/ 1392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getVehicleMicroMarkingJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductMicroMarkingJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBreadcrumbsListData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isVIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDrivenFromTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_countries_json__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_constants_json_countries_json__);




var AB_PATH = 'https://avtobazar.ua';

var getVehicleMicroMarkingJson = function getVehicleMicroMarkingJson(advertInfo) {
  var title = advertInfo.title,
      make = advertInfo.make,
      year = advertInfo.year,
      model = advertInfo.model,
      permalink = advertInfo.permalink,
      body = advertInfo.body,
      price = advertInfo.price,
      description = advertInfo.description,
      color = advertInfo.color,
      engine = advertInfo.engine,
      gearbox = advertInfo.gearbox,
      mileage = advertInfo.mileage,
      active = advertInfo.active,
      sold = advertInfo.sold,
      transport = advertInfo.transport;


  var discontinued = active === -2 || !active;
  var availabilityKey = 'InStock';

  if (sold) availabilityKey = 'SoldOut';else if (discontinued) availabilityKey = 'Discontinued';

  var _model$model_class = model.model_class,
      modelClass = _model$model_class === undefined ? null : _model$model_class;

  var modelTitle = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](model) + ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](modelClass);
  var usdPrice = price.find(function (item) {
    return item.currency === 'usd';
  }).value || '';

  var MAIN_TYPES = {
    avto: 'Car',
    mototsikl: 'Motorcycle',
    moped: 'MotorizedBicycle',
    skuter: 'MotorizedBicycle'
  };

  return {
    '@context': 'https://schema.org/',
    '@type': MAIN_TYPES[transport.slug] || 'Vehicle',
    name: title,
    model: modelTitle,
    productionDate: year,
    description: description,
    color: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](color),
    fuelType: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](engine),
    vehicleTransmission: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](gearbox),
    bodyType: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](body),
    mileageFromOdometer: {
      '@type': 'QuantitativeValue',
      value: mileage && mileage + ' 000'
    },
    brand: {
      '@type': 'Brand',
      name: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](make)
    },
    offers: {
      '@type': 'Offer',
      name: title,
      url: '' + AB_PATH + permalink,
      priceCurrency: 'USD',
      price: usdPrice,
      availability: 'http://schema.org/' + availabilityKey
    }
  };
};

var getProductMicroMarkingJson = function getProductMicroMarkingJson(advertInfo) {
  var make = advertInfo.make,
      model = advertInfo.model,
      permalink = advertInfo.permalink,
      price = advertInfo.price,
      title = advertInfo.title;
  var _model$model_class2 = model.model_class,
      modelClass = _model$model_class2 === undefined ? null : _model$model_class2;


  var modelTitle = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](model) + ' ' + __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](modelClass);
  var usdPrice = price.find(function (item) {
    return item.currency === 'usd';
  }).value || '';

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: modelTitle.replace(/\s/g, '') ? modelTitle : title,
    description: '',
    brand: {
      '@type': 'Thing',
      name: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_common__["h" /* getTitleOrEmpty */](make)
    },
    offers: {
      '@type': 'Offer',
      url: '' + AB_PATH + permalink,
      priceCurrency: 'USD',
      price: usdPrice
    }
  };
};

var getBreadcrumbsListData = function getBreadcrumbsListData(searchData, breadcrumbLinks) {
  var paramArr = ['transport', 'make', 'model', 'year', 'location'];

  var breadcrumbItemListEl = paramArr.map(function (itemName, index) {
    if (breadcrumbLinks[itemName]) {
      var name = itemName === 'year' ? searchData[itemName] : searchData[itemName].title;
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': breadcrumbLinks[itemName],
          name: index === 0 ? __WEBPACK_IMPORTED_MODULE_0_shared_modules__["n" /* replaceToUpperCase */](name) : name
        }
      };
    }
    return false;
  });

  return {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItemListEl
  };
};

var getPrice = function getPrice(prices) {
  var currenncy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['uah', 'uah', 'грн', 'грн.'];

  var price = (Array.isArray(prices) && prices || []).find(function (p) {
    return currenncy.includes(p.currency);
  });
  return price && price.value;
};

var isTop = function isTop(advert) {
  return advert && advert.top_date && new Date() < new Date(advert.top_date);
};
var isVIP = function isVIP(advert) {
  return advert && advert.vip_date && new Date() < new Date(advert.vip_date);
};

var getDrivenFromTitle = function getDrivenFromTitle(drivenFrom, t) {
  var drivenFromCoutry = null;
  if (drivenFrom && drivenFrom.id) drivenFromCoutry = __WEBPACK_IMPORTED_MODULE_2_shared_constants_json_countries_json___default.a.find(function (country) {
    return country.id === drivenFrom.id;
  });

  return drivenFromCoutry && t('пригнан') + ' ' + drivenFromCoutry.from[t('locale')];
};

/***/ }),

/***/ 1394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addBitrixLead */
/* unused harmony export addFinupLead */
/* unused harmony export addAFinanceLead */
/* unused harmony export fetchFinupVerification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isLeasingProposalAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isCreditmarketProposalAvailable; });
/* unused harmony export isAutoMoneyProposalAvailable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isCreditmarketNotClearedProposalAvailable; });
/* unused harmony export isMicroCreditProposalAvailable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isUlf24LeasingProposalAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isUlfSomeDealersLeasingProposalAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCommonLeasingProposalAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFinupVerification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchRequestId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return sendCodeVerification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return prepareParamsForLeasingLeadRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createMyAutoLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAFinanceLeda; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createAutoMoneyLead; });
/* unused harmony export getRate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_advertForm__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_locale__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1277);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








// import { fetchUsersTemperature } from './finup';

// TODO: Should be removed;
var addBitrixLead = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(props, fetch) {
    var userStorageId, title, userName, permalink, make, model, year, capacity, engine, gearbox, price, term, phone, isMobile, popularity, liquidityDays, comment, temperature, recommendedPrice, bkiApproved, prepaid, isBkiApproved, commentWithAddData, crmData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            userStorageId = props.userStorageId, title = props.title, userName = props.userName, permalink = props.permalink, make = props.make, model = props.model, year = props.year, capacity = props.capacity, engine = props.engine, gearbox = props.gearbox, price = props.price, term = props.term, phone = props.phone, isMobile = props.isMobile, popularity = props.popularity, liquidityDays = props.liquidityDays, comment = props.comment, temperature = props.temperature, recommendedPrice = props.recommendedPrice, bkiApproved = props.bkiApproved, prepaid = props.prepaid;
            isBkiApproved = '';

            if (typeof bkiApproved === 'boolean') {
              isBkiApproved = bkiApproved ? 'Одобрено' : 'Не Одобрено';
            }
            commentWithAddData = [comment, 'https://api.finup.lv/view/profile/' + userStorageId].join('\n');
            crmData = {
              FIELDS: {
                ID_EXTERNAL: userStorageId,
                TITLE: title,
                NAME: userName, // Имя пользо`вателя:
                LAST_NAME: '',
                UF_CRM_1627546218: userStorageId, // device id
                UF_CRM_1614238143: '', // Название финансового продукта:
                UF_CRM_1614238195: make.title, // Марка: Renault (вынести в заголовок)
                UF_CRM_1614238206: model.title, // Модель: Logan (вынести в заголовок)
                UF_CRM_1614238220: year, // Год: 2018 (вынести в заголовок)
                UF_CRM_1614238276: capacity, // Объём двигателя: 1.6 ERROR Значение поля "Объём двигателя" должно быть числом
                UF_CRM_1614238356: engine && engine.title || '-', // Топливо: бензин (метан)
                UF_CRM_1614238365: gearbox && gearbox.title || '-', // КПП: механика
                OPPORTUNITY: price, // Сумма финансирования: 5950 usd
                UF_CRM_1614238293: term || 0, //  Срок финансирования: 36
                PHONE: [{ VALUE: phone, VALUE_TYPE: 'WORK' }], // Номер телефона пользователя: +375298335599
                SOURCE_DESCRIPTION: isMobile ? 'мобильная версия' : 'десктопная версия', // Источник: мобильная версияUF_CRM_1614238143
                COMMENTS: '<a href="https://avtobazar.ua' + permalink + '" > avtobazar.ua' + permalink + '</a>', // URL объявления, с которого отправлена заявка: https://cars.av.by/renault/logan/100203304
                UF_CRM_1614238619: '',
                UF_CRM_1614238771: '',
                UF_CRM_1614238633: '',
                UF_CRM_1614238795: '',
                CURRENCY_ID: 'USD',
                UF_CRM_1624343369: temperature || 0, //  темперетура, тип: число
                UF_CRM_1624957919: popularity || 0, // Популярность  double - popularity
                UF_CRM_1624957948: liquidityDays || 0, // Ликвидность (дней) double
                UF_CRM_1624958095: recommendedPrice || 0, // Оптимальная цена по модели  money  - recommendedPrice
                UF_CRM_1624559672749: isBkiApproved, // / Результат скоринга
                UF_CRM_1626182545: prepaid, // / Рекомендованный аванс %
                UF_CRM_1624958123: commentWithAddData // Комментарий string - comment
                // UF_CRM_1624957985: 'test', // Падение цены в следующие 12 месяцев, (%)  double   - deflation
                // UF_CRM_1624958019: 'test', // Отклонение от рыночной цены. (%)  double   - marketPriceDeviation
                // UF_CRM_1624958062: 'test', // Медиана по рынку  money  - medianPrice
              }
            };
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.ADD_BITRIX_LEAD, crmData, fetch, {}, 'addlead'));

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function addBitrixLead(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// "annualRate": 0,
// "bkiRequestId": "string",
// "comment": "string",
// "currency": "USD",
// "deviceId": "string",
// "email": "string",
// "fullName": "string",
// "localId": "string",
// "phone": "string",
// "prepaid": 0,
// "sum": 0,
// "term": 0,
// "verificationId": "string"

// accepted: true
// additional: {showLeasingForm: true}
// annualRate: 40
// comment: ""
// currency: "USD"
// dailyPayment: 12.11
// id: "0c777818-659b-4f88-abc4-5de8809ffd2e"
// liquidityDays: 12
// maxPrepaid: 50
// maxTerm: 84
// minPrepaid: 43
// minTerm: 84
// monthlyPayment: 363.22
// popularity: 0.97
// prepaid: 43
// prepaidCommission: 895
// prepaidSum: 8592
// pricePrediction: {0: {price: 14627, max: 17900, min: 11900}, 1: {price: 12854, max: 16400, min: 10500},…}
// shapResponse: null
// sum: 17900
// term: 84

var addFinupLead = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params, verifyParams, fetch) {
    var userName, permalink, price, phone, crmData;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // const { userStorageId, userName, permalink, price, term, phone, prepaid, localId } = params;
            userName = params.userName, permalink = params.permalink, price = params.price, phone = params.phone;
            crmData = {
              // "annualRate": 0,
              // "bkiRequestId": "string",
              // comment: `<a href="https://ab.ua${permalink}" > ab.ua${permalink}</a>`,
              // // currency: "USD",
              // deviceId: userStorageId,
              // // "email": "string",
              // fullName: userName,
              // localId,
              // phone,
              // prepaid,
              // sum: price,
              // term,
              // verificationId: verifyParams.id,

              date: new Date(),
              name: userName,
              phone: phone,
              price: price,
              currency: 'USD',
              comments: '',
              link: 'https://ab.ua' + permalink
            };
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.ADD_FINUP_LEAD, crmData, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function addFinupLead(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var addAFinanceLead = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params, fetch) {
    var userName, permalink, price, term, phone, prepaid, localId, crmData;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            userName = params.userName, permalink = params.permalink, price = params.price, term = params.term, phone = params.phone, prepaid = params.prepaid, localId = params.localId;
            crmData = {
              comment: params.title,
              fullName: userName,
              link: 'http://avtobazar.ua' + permalink,
              localId: localId,
              phone: phone,
              prepaid: prepaid,
              sum: price,
              term: term
            };
            return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.ADD_AFINANCE_LEAD, crmData, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function addAFinanceLead(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var addAutoMoneyLead = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params, fetch) {
    var userName, permalink, price, term, phone, prepaid, localId, crmData;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            userName = params.userName, permalink = params.permalink, price = params.price, term = params.term, phone = params.phone, prepaid = params.prepaid, localId = params.localId;
            crmData = {
              comment: params.title,
              fullName: userName,
              link: 'http://avtobazar.ua' + permalink,
              localId: localId,
              phone: phone,
              prepaid: prepaid,
              sum: price,
              term: term
            };
            return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.ADD_AUTOMONEY_LEAD, crmData, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function addAutoMoneyLead(_x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Finup /v1/verification
  * @param {Object} paramCar  {
    "brand": "string",
    "description": "string",
    "engineType": "D",
    "engineVolumeMl": 0,
    "features": [
      "ABS"
    ],
    "generation": "string",
    "mileageKm": 0,
    "model": "string",
    "transmission": "A",
    "year": 0
  }
 * @param {Object} paramOptions { "currency": "USD",  "sum": 0,  "url": "string" }
 * @param {Function} fetch 
 */
var fetchFinupVerification = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(paramCar, paramOptions, fetch) {
    var car, options, body;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            car = _extends({
              brand: '',
              description: '',
              engineType: '',
              engineVolumeMl: 0,
              features: [],
              generation: '',
              mileageKm: 0,
              model: '',
              transmission: '',
              year: 0
            }, paramCar);
            options = _extends({
              currency: 'USD',
              sum: 0,
              url: ''
            }, paramOptions);
            body = _extends({}, options, {
              car: car
            });
            return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.GET_PARAMS, body, fetch, {}, 'verification'));

          case 4:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function fetchFinupVerification(_x10, _x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Checks is it advert available for leasing.
 * @param {Object} advertData
 * @returns {Boolean}
 */
var isLeasingProposalAvailable = function isLeasingProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      price = advertData.price,
      year = advertData.year,
      isNotCleared = advertData.is_not_cleared,
      isNew = advertData.is_new;


  if (__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* getLeasingParms */](advertData)) return true;

  var isAvto = (transport || category || {}).slug === 'avto';
  var usd = price.find(function (p) {
    return p.currency === 'usd';
  }) || {};
  var isAvailable = active === 1 && isAvto && !isNew && isNotCleared === false && usd.value >= 3000 && year >= 2001;
  return isAvailable;
};

var isCreditmarketProposalAvailable = function isCreditmarketProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      price = advertData.price,
      isNotCleared = advertData.is_not_cleared;


  var isAvto = (transport || category || {}).slug === 'avto';
  var usd = price.find(function (p) {
    return p.currency === 'usd';
  }) || {};
  var isAvailable = active === 1 && isAvto && isNotCleared === false && usd.value < 3000;
  return isAvailable;
};

var isAutoMoneyProposalAvailable = function isAutoMoneyProposalAvailable(advertData) {
  var available = isLeasingProposalAvailable(advertData);
  if (!available) return false;

  var disabledRegions = ['odeska-oblast', 'mykolaivska-oblast', 'cherkaska-oblast', 'sumska-oblast', 'zaporizka-oblast', 'kharkivska-oblast', 'luhanska-oblast', 'donetska-oblast'];

  var disabledCities = ['odessa'];

  if (advertData.location && advertData.location.slug && disabledCities.includes(advertData.location.slug)) {
    return false;
  }

  if (advertData.location && Array.isArray(advertData.location.parents)) {
    var inDisabledRegion = advertData.location.parents.find(function (region) {
      return region && region.slug && disabledRegions.includes(region.slug);
    });
    return !inDisabledRegion;
  }
  return available;
};

var isCreditmarketNotClearedProposalAvailable = function isCreditmarketNotClearedProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      isNotCleared = advertData.is_not_cleared;


  var isAvto = (transport || category || {}).slug === 'avto';
  var isAvailable = active === 1 && isAvto && isNotCleared === true;
  return isAvailable;
};

var isMicroCreditProposalAvailable = function isMicroCreditProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      price = advertData.price,
      isNotCleared = advertData.is_not_cleared;


  var isAvto = (transport || category || {}).slug === 'avto';
  var usd = price.find(function (p) {
    return p.currency === 'usd';
  }) || {};
  var isAvailable = active === 1 && isAvto && isNotCleared === false && usd.value < 3000;
  return isAvailable;
};

var isUlf24LeasingProposalAvailable = function isUlf24LeasingProposalAvailable(advertData) {
  var active = advertData.active,
      category = advertData.category,
      transport = advertData.transport,
      isNotCleared = advertData.is_not_cleared,
      isNew = advertData.is_new;


  var isAvto = (transport || category || {}).slug === 'avto';
  var isAvailable = active === 1 && isAvto && isNotCleared === false && isNew;
  return isAvailable;
};

var isUlfSomeDealersLeasingProposalAvailable = function isUlfSomeDealersLeasingProposalAvailable(advertData) {
  // const available = isLeasingProposalAvailable(advertData);
  // if (!available) return false;
  var availableDealers = ['kij-avto-nissan', 'kij-avto-renault'];
  var slug = advertData && advertData.agency && advertData.agency.slug || '';
  return availableDealers.includes(slug);
};

var isCommonLeasingProposalAvailable = function isCommonLeasingProposalAvailable(advertData) {
  var agency = advertData.agency;
  // TODO: should be change to some flag from Admin area.

  if (agency && agency.slug === '1-j-avtocentr-skoda') return false;
  return true;
};

var getFinupVerification = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(adv, fetch) {
    var lp, _getLeasingArgumentsB, params, options, reult;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(!adv || !adv.modification)) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt('return', {});

          case 2:
            lp = __WEBPACK_IMPORTED_MODULE_4__utils__["g" /* getLeasingParms */](adv);

            if (!lp) {
              _context6.next = 5;
              break;
            }

            return _context6.abrupt('return', lp);

          case 5:
            _getLeasingArgumentsB = __WEBPACK_IMPORTED_MODULE_4__utils__["f" /* getLeasingArgumentsByAdv */](adv), params = _getLeasingArgumentsB.params, options = _getLeasingArgumentsB.options;
            _context6.next = 8;
            return fetchFinupVerification(params, options, fetch);

          case 8:
            reult = _context6.sent;
            return _context6.abrupt('return', reult);

          case 10:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function getFinupVerification(_x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();

var fetchRequestId = function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(params, fetch) {
    var body;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            body = {
              bdate: __WEBPACK_IMPORTED_MODULE_3_shared_helpers_locale__["c" /* getFormattedDateFns */](params.birthday, 'yyyy-MM-dd'),
              deviceId: __WEBPACK_IMPORTED_MODULE_4__utils__["e" /* getCleanDeviceId */](params.deviceId),
              phone: (params.phone || '').replace(/\s/g, '')
            };
            return _context7.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.REQUEST_ID, body, fetch, {}, ''));

          case 2:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function fetchRequestId(_x15, _x16) {
    return _ref7.apply(this, arguments);
  };
}();

var sendCodeVerification = function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(params, fetch) {
    var body;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            body = params || {
              otp: params.otp,
              requestId: params.requestId
            };
            return _context8.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.SCORING, body, fetch, {}, ''));

          case 2:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function sendCodeVerification(_x17, _x18) {
    return _ref8.apply(this, arguments);
  };
}();

var prepareParamsForLeasingLeadRequest = function prepareParamsForLeasingLeadRequest(params, advert, leasingParams, moreLeasingParams) {
  var phone = params.phone,
      userName = params.userName;

  var _leasingParams$moreLe = _extends({}, leasingParams, moreLeasingParams),
      term = _leasingParams$moreLe.term,
      popularity = _leasingParams$moreLe.popularity,
      liquidityDays = _leasingParams$moreLe.liquidityDays,
      comment = _leasingParams$moreLe.comment,
      pricePrediction = _leasingParams$moreLe.pricePrediction,
      prepaid = _leasingParams$moreLe.prepaid,
      bkiApproved = _leasingParams$moreLe.bkiApproved;

  var decimalLength = 2;
  var intLength = 1;

  var make = advert.make,
      model = advert.model,
      title = advert.title,
      year = advert.year,
      permalink = advert.permalink,
      price = advert.price,
      vehregCapacity = advert.vehreg_info.capacity,
      characterCapacity = advert.characteristics.capacity,
      simpleCapacity = advert.capacity;


  var userStorageId = localStorage.getItem('applensDeviceId') || '';
  var engine = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('engine', advert);
  var gearbox = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["j" /* getFieldFromRootOrCharacteristics */]('gearbox', advert);
  var capacity = characterCapacity && characterCapacity.title || simpleCapacity || __WEBPACK_IMPORTED_MODULE_2_shared_helpers_advertForm__["k" /* parseDecimal */](vehregCapacity / 1000, intLength, decimalLength);
  var usaPrice = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_transportInfo__["n" /* getPriceValueBySlug */](price, 'usd');
  var recommendedPrice = pricePrediction && pricePrediction[0] && pricePrediction[0].price;

  return {
    userStorageId: userStorageId,
    title: title,
    userName: userName,
    permalink: permalink,
    make: make,
    model: model,
    year: year,
    capacity: capacity,
    engine: engine,
    gearbox: gearbox,
    price: usaPrice,
    term: term,
    phone: phone,
    isMobile: "desktop" === 'mobile',
    popularity: popularity,
    liquidityDays: liquidityDays,
    comment: comment,
    recommendedPrice: recommendedPrice,
    prepaid: prepaid,
    bkiApproved: bkiApproved
  };
};

var createMyAutoLead = function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(params, advert, fetch) {
    var result, verifyParams, finupParams;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            result = null;
            _context9.prev = 1;
            _context9.next = 4;
            return getFinupVerification(advert, fetch);

          case 4:
            verifyParams = _context9.sent;
            finupParams = _extends({}, params, { localId: advert.id });
            _context9.next = 8;
            return addFinupLead(finupParams, verifyParams, fetch);

          case 8:
            result = _context9.sent;

            if (!(!result || !result.id)) {
              _context9.next = 11;
              break;
            }

            throw Error('getFinupVerification error');

          case 11:
            _context9.next = 15;
            break;

          case 13:
            _context9.prev = 13;
            _context9.t0 = _context9['catch'](1);

          case 15:
            return _context9.abrupt('return', result);

          case 16:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this, [[1, 13]]);
  }));

  return function createMyAutoLead(_x19, _x20, _x21) {
    return _ref9.apply(this, arguments);
  };
}();

var createAFinanceLeda = function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(params, advert, fetch) {
    var result, finupParams;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            result = null;
            _context10.prev = 1;
            finupParams = _extends({}, params, { localId: advert.id });
            _context10.next = 5;
            return addAFinanceLead(finupParams, fetch);

          case 5:
            result = _context10.sent;

            if (!(!result || !result.id)) {
              _context10.next = 8;
              break;
            }

            throw Error('getFinupVerification error');

          case 8:
            _context10.next = 12;
            break;

          case 10:
            _context10.prev = 10;
            _context10.t0 = _context10['catch'](1);

          case 12:
            return _context10.abrupt('return', result);

          case 13:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this, [[1, 10]]);
  }));

  return function createAFinanceLeda(_x22, _x23, _x24) {
    return _ref10.apply(this, arguments);
  };
}();

var createAutoMoneyLead = function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(params, advert, fetch) {
    var result, finupParams;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            result = null;
            _context11.prev = 1;
            finupParams = _extends({}, params, { localId: advert.id });
            _context11.next = 5;
            return addAutoMoneyLead(finupParams, fetch);

          case 5:
            result = _context11.sent;

            if (!(!result || !result.id)) {
              _context11.next = 8;
              break;
            }

            throw Error('addAutoMoneyLead error');

          case 8:
            _context11.next = 12;
            break;

          case 10:
            _context11.prev = 10;
            _context11.t0 = _context11['catch'](1);

          case 12:
            return _context11.abrupt('return', result);

          case 13:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this, [[1, 10]]);
  }));

  return function createAutoMoneyLead(_x25, _x26, _x27) {
    return _ref11.apply(this, arguments);
  };
}();

var getRate = function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(params, fetch) {
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.GET_RATE, params, fetch, {}, 'rate'));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this);
  }));

  return function getRate(_x28, _x29) {
    return _ref12.apply(this, arguments);
  };
}();

/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1554);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingOnlineBanner.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingOnlineBanner.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/Icons/ExchangeIcon.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref = _jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, _jsx("path", {
  d: "M2.06917 13.2835C1.19201 11.1658 1.19196 8.83324 2.06917 6.71555C2.80615 4.93637 4.08826 3.48803 5.73515 2.55018V6.09019H7.15107V0.709961H1.77079V2.12587H3.8359C0.390508 4.82385 -0.993499 9.58957 0.761005 13.8253C1.42965 15.4396 2.5106 16.8534 3.88706 17.9142C5.22151 18.9426 6.80728 19.6228 8.47282 19.8812L8.68997 18.482C5.70037 18.0181 3.22535 16.0747 2.06917 13.2835Z",
  fill: "#FFC107"
}), _jsx("path", {
  d: "M19.2337 13.8257C20.2555 11.3586 20.2555 8.64115 19.2337 6.17407C18.565 4.55983 17.4841 3.14595 16.1076 2.08524C14.7731 1.05682 13.1873 0.376615 11.5218 0.118164L11.3047 1.51737C14.2942 1.98127 16.7693 3.92466 17.9254 6.71594C18.8026 8.83362 18.8026 11.1662 17.9254 13.2838C17.1885 15.063 15.9064 16.5114 14.2595 17.4492V13.9092H12.8436V19.2894H18.2238V17.8735H16.1649C17.5078 16.8249 18.5639 15.4425 19.2337 13.8257Z",
  fill: "#FFC107"
}));

var ExchangeIcon = function ExchangeIcon() {
  return _ref;
};

/* harmony default export */ var ExchangeIcon_defaultExport = (ExchangeIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/IncomminCallIcon.js
/* harmony import */ var IncomminCallIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var IncomminCallIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(IncomminCallIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var IncomminCallIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var IncomminCallIcon__ref = IncomminCallIcon__jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, IncomminCallIcon__jsx("g", {}, void 0, IncomminCallIcon__jsx("path", {
  d: "M17.2248 15.2125C17.2247 15.2125 17.2247 15.2125 17.2248 15.2125L14.1958 13.222C13.4747 12.7482 12.5387 12.7894 11.8665 13.3242C11.2777 13.7928 10.4326 13.7449 9.90057 13.2128L6.82514 10.1374C6.29321 9.60545 6.2453 8.76026 6.71375 8.17158C7.24872 7.49927 7.28977 6.56314 6.81598 5.84215L4.82546 2.81311C4.47741 2.28347 3.93755 1.96654 3.30522 1.92061C2.67289 1.87499 2.09306 2.11059 1.67237 2.58453C-0.659189 5.20998 -0.539712 9.21223 1.94428 11.6961L8.34187 18.0938C9.6343 19.3863 11.3376 20.0384 13.0445 20.0384C14.6178 20.0384 16.1941 19.4841 17.4536 18.3657C17.9273 17.9449 18.1631 17.3649 18.1173 16.7327C18.0714 16.1006 17.7545 15.5607 17.2248 15.2125ZM16.6754 17.4896C14.513 19.4099 11.2163 19.3113 9.17027 17.2653L2.77269 10.8677C0.726622 8.82161 0.62805 5.52492 2.54838 3.36258C2.71104 3.17932 2.91352 3.0867 3.15141 3.0867C3.17399 3.0867 3.19703 3.08761 3.22053 3.08929C3.48817 3.10867 3.69875 3.23227 3.84615 3.45673L5.83667 6.48562C6.03473 6.78714 6.01901 7.1625 5.79684 7.4419C4.95699 8.49735 5.0429 10.0123 5.99658 10.9659L9.07201 14.0414C10.0257 14.9951 11.5406 15.081 12.596 14.2411C12.8754 14.0188 13.2508 14.0032 13.5522 14.2013L16.5812 16.1918C16.8055 16.3392 16.9291 16.5498 16.9485 16.8174C16.968 17.0852 16.876 17.3114 16.6754 17.4896Z",
  fill: "#FFC107"
}), IncomminCallIcon__jsx("path", {
  d: "M19.8277 0.210115C19.7134 0.0959781 19.5637 0.0390625 19.414 0.0390625C19.2639 0.0390625 19.1136 0.0964359 18.9991 0.211183L12.4618 6.76533L12.4619 4.64785C12.4619 4.32437 12.1996 4.06207 11.8761 4.06207C11.5525 4.06207 11.2902 4.32437 11.2902 4.64785L11.29 8.18242C11.29 8.33776 11.3517 8.48684 11.4617 8.5967C11.5716 8.70656 11.7205 8.76836 11.8758 8.76836H15.4105C15.7342 8.76836 15.9965 8.50606 15.9965 8.18242C15.9965 7.85893 15.7342 7.59663 15.4105 7.59663H13.2877L19.8287 1.03867C20.0573 0.809483 20.0569 0.43854 19.8277 0.210115Z",
  fill: "#FFC107"
})));

var IncomminCallIcon = function IncomminCallIcon() {
  return IncomminCallIcon__ref;
};

/* harmony default export */ var IncomminCallIcon_defaultExport = (IncomminCallIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/VerifiedIcon.js
/* harmony import */ var VerifiedIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VerifiedIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VerifiedIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var VerifiedIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var VerifiedIcon__ref = VerifiedIcon__jsx("svg", {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, VerifiedIcon__jsx("path", {
  d: "M13.5896 2.49984C10.8594 2.49984 8.76785 1.71982 6.99919 0C5.23072 1.71982 3.13924 2.49984 0.409309 2.49984C0.409309 6.9786 -0.517435 13.3944 6.99915 16C14.5163 13.3944 13.5896 6.97865 13.5896 2.49984ZM6.45326 10.3812L4.25772 8.18537L5.24075 7.20239L6.45326 8.41518L8.75787 6.11053L9.74085 7.09351L6.45326 10.3812Z",
  fill: "#6CBE00"
}));

var VerifiedIcon = function VerifiedIcon() {
  return VerifiedIcon__ref;
};

/* harmony default export */ var VerifiedIcon_defaultExport = (VerifiedIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/GuaranteedIcon.js
/* harmony import */ var GuaranteedIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var GuaranteedIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(GuaranteedIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var GuaranteedIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var GuaranteedIcon__ref = GuaranteedIcon__jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, GuaranteedIcon__jsx("g", {}, void 0, GuaranteedIcon__jsx("path", {
  d: "M13.7933 9.95967C13.4067 10.1997 13.04 10.3863 12.7133 10.5197C12.4867 10.6197 12.24 10.6663 12 10.6663C11.76 10.6663 11.5133 10.6197 11.2867 10.5197C10.7067 10.2797 10 9.87967 9.31333 9.33301H2.94667L3.93333 7.06634C4.04 6.82634 4.28 6.66634 4.54 6.66634H7.16667C6.98 6.25301 6.83333 5.80634 6.75333 5.33301H4.54C3.74667 5.33301 3.02667 5.80634 2.70667 6.53301L1.38667 9.56634C1.38 9.57968 1.38667 9.59301 1.38 9.61301C0.566667 10.0263 0 10.8597 0 11.833V14.333C0 15.253 0.746667 15.9997 1.66667 15.9997C2.58667 15.9997 3.33333 15.253 3.33333 14.333V13.9997H11.3333V14.333C11.3333 15.253 12.08 15.9997 13 15.9997C13.92 15.9997 14.6667 15.253 14.6667 14.333V11.833C14.6667 11.0797 14.3267 10.4063 13.7933 9.95967ZM4 12.6663H2.66667C2.3 12.6663 2 12.3663 2 11.9997C2 11.633 2.3 11.333 2.66667 11.333H4C4.36667 11.333 4.66667 11.633 4.66667 11.9997C4.66667 12.3663 4.36667 12.6663 4 12.6663ZM12 12.6663H10.6667C10.3 12.6663 10 12.3663 10 11.9997C10 11.633 10.3 11.333 10.6667 11.333H12C12.3667 11.333 12.6667 11.633 12.6667 11.9997C12.6667 12.3663 12.3667 12.6663 12 12.6663Z",
  fill: "#7F46CA"
}), GuaranteedIcon__jsx("path", {
  d: "M15.6607 1.21767L12.1607 0.027C12.0567 -0.009 11.9433 -0.009 11.8393 0.027L8.33933 1.21767C8.136 1.28633 8 1.477 8 1.691V4.36967C8 7.639 11.6493 9.22833 11.8047 9.29433C11.93 9.347 12.07 9.347 12.1953 9.29433C12.3507 9.22833 16 7.639 16 4.36967V1.691C16 1.477 15.864 1.28633 15.6607 1.21767ZM14.1907 3.74567L12.3573 6.079C12.124 6.377 11.6867 6.42033 11.4 6.17367L10.2333 5.17367C9.95333 4.93433 9.92067 4.513 10.1613 4.23367C10.4007 3.95433 10.822 3.92233 11.1007 4.16167L11.7393 4.709L13.1427 2.923C13.37 2.63367 13.7887 2.58233 14.0787 2.811C14.368 3.037 14.4187 3.45633 14.1907 3.74567Z",
  fill: "#7F46CA"
})));

var GuaranteedIcon = function GuaranteedIcon() {
  return GuaranteedIcon__ref;
};

/* harmony default export */ var GuaranteedIcon_defaultExport = (GuaranteedIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/TestDriveIcon.js
/* harmony import */ var TestDriveIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TestDriveIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TestDriveIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var TestDriveIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var TestDriveIcon__ref = TestDriveIcon__jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, TestDriveIcon__jsx("path", {
  d: "M10 0C4.4934 0 0 4.4941 0 10C0 15.5066 4.4941 20 10 20C15.5066 20 20 15.5059 20 10C20 4.49336 15.5059 0 10 0ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z",
  fill: "#FFC107"
}), TestDriveIcon__jsx("path", {
  d: "M10 2.34375C5.80715 2.34375 2.34375 5.78238 2.34375 10C2.34375 14.2004 5.7909 17.6562 10 17.6562C14.2051 17.6562 17.6562 14.2054 17.6562 10C17.6562 5.77773 14.1885 2.34375 10 2.34375ZM10 3.51562C12.4918 3.51562 14.6594 4.92859 15.7447 6.9952C14.2962 6.45676 12.2516 5.89844 10 5.89844C7.74836 5.89844 5.70383 6.45676 4.25531 6.9952C5.34062 4.92859 7.50824 3.51562 10 3.51562ZM3.85215 12.063L4.34699 12.1337C6.16012 12.3927 7.60734 13.8399 7.86633 15.653L7.93703 16.1479C6.01813 15.5022 4.49773 13.9818 3.85215 12.063ZM12.063 16.1479L12.1337 15.653C12.3927 13.8399 13.8399 12.3927 15.653 12.1337L16.1479 12.063C15.5023 13.9818 13.9819 15.5022 12.063 16.1479ZM15.4873 10.9736C13.1619 11.3057 11.3057 13.1619 10.9736 15.4873L10.8388 16.4302C10.5641 16.4658 10.2842 16.4844 10 16.4844C9.71578 16.4844 9.43586 16.4658 9.16117 16.4302L9.02645 15.4873C8.69426 13.1618 6.83813 11.3057 4.5127 10.9736L3.5698 10.8389C3.53418 10.5642 3.51562 10.2842 3.51562 10C3.51562 9.47914 3.57777 8.97254 3.6943 8.48691C4.99598 7.91113 7.35094 7.07031 10 7.07031C12.6491 7.07031 15.004 7.91113 16.3057 8.48691C16.4222 8.97254 16.4844 9.47914 16.4844 10C16.4844 10.2842 16.4658 10.5642 16.4302 10.8389L15.4873 10.9736Z",
  fill: "#FFC107"
}), TestDriveIcon__jsx("path", {
  d: "M10 8.24219C9.03074 8.24219 8.24219 9.03074 8.24219 10C8.24219 10.9693 9.03074 11.7578 10 11.7578C10.9693 11.7578 11.7578 10.9693 11.7578 10C11.7578 9.03074 10.9693 8.24219 10 8.24219ZM10 10.5859C9.67691 10.5859 9.41406 10.3231 9.41406 10C9.41406 9.67691 9.67691 9.41406 10 9.41406C10.3231 9.41406 10.5859 9.67691 10.5859 10C10.5859 10.3231 10.3231 10.5859 10 10.5859Z",
  fill: "#FFC107"
}));

var TestDriveIcon = function TestDriveIcon() {
  return TestDriveIcon__ref;
};
/* harmony default export */ var TestDriveIcon_defaultExport = (TestDriveIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/InfoIcon.js
/* harmony import */ var InfoIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var InfoIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(InfoIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var InfoIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var InfoIcon__ref = InfoIcon__jsx("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, InfoIcon__jsx("circle", {
  cx: "7",
  cy: "7",
  r: "6",
  stroke: "#1575C3"
}), InfoIcon__jsx("path", {
  d: "M6.32935 4.30514C6.32935 3.87954 6.55157 3.66675 6.99601 3.66675C7.44046 3.66675 7.66268 3.87954 7.66268 4.30514C7.66268 4.50794 7.60645 4.66646 7.494 4.78072C7.38423 4.89211 7.21823 4.94781 6.99601 4.94781C6.55157 4.94781 6.32935 4.73359 6.32935 4.30514ZM7.60645 10.3334H6.38155V5.54335H7.60645V10.3334Z",
  fill: "#1575C3"
}));

var InfoIcon = function InfoIcon() {
  return InfoIcon__ref;
};

/* harmony default export */ var InfoIcon_defaultExport = (InfoIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/CalendarIcon.js
/* harmony import */ var CalendarIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CalendarIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CalendarIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var CalendarIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var CalendarIcon = function CalendarIcon() {
  return CalendarIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, CalendarIcon__jsx('use', {
    xlinkHref: __WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#calendar'
  }));
};

/* harmony default export */ var CalendarIcon_defaultExport = (CalendarIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/GearboxIcon.js
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(GearboxIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var GearboxIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var GearboxIcon = function GearboxIcon() {
  return GearboxIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, GearboxIcon__jsx('use', {
    xlinkHref: GearboxIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#gearbox'
  }));
};

/* harmony default export */ var GearboxIcon_defaultExport = (GearboxIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/EngineIcon.js
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(EngineIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var EngineIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var EngineIcon = function EngineIcon() {
  return EngineIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, EngineIcon__jsx('use', {
    xlinkHref: EngineIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#engine'
  }));
};

/* harmony default export */ var EngineIcon_defaultExport = (EngineIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SpeedIcon.js
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SpeedIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var SpeedIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SpeedIcon = function SpeedIcon() {
  return SpeedIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, SpeedIcon__jsx('use', {
    xlinkHref: SpeedIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#speed'
  }));
};

/* harmony default export */ var SpeedIcon_defaultExport = (SpeedIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/ChassisIcon.js
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ChassisIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var ChassisIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var ChassisIcon = function ChassisIcon() {
  return ChassisIcon__jsx('svg', {
    width: '10',
    height: '10'
  }, void 0, ChassisIcon__jsx('use', {
    xlinkHref: ChassisIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#chassis'
  }));
};

/* harmony default export */ var ChassisIcon_defaultExport = (ChassisIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/LocationIcon.js
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LocationIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var LocationIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var LocationIcon = function LocationIcon() {
  return LocationIcon__jsx('svg', {
    width: '8',
    height: '10'
  }, void 0, LocationIcon__jsx('use', {
    xlinkHref: LocationIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#location'
  }));
};

/* harmony default export */ var LocationIcon_defaultExport = (LocationIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/CarIcon.js
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(CarIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var CarIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var CarIcon = function CarIcon() {
  return CarIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, CarIcon__jsx('use', {
    xlinkHref: CarIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#car'
  }));
};

/* harmony default export */ var CarIcon_defaultExport = (CarIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/ColorIcon.js
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ColorIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var ColorIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var ColorIcon = function ColorIcon() {
  return ColorIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, ColorIcon__jsx('use', {
    xlinkHref: ColorIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#color'
  }));
};

/* harmony default export */ var ColorIcon_defaultExport = (ColorIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/VinIcon.js
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VinIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var VinIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var VinIcon = function VinIcon() {
  return VinIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, VinIcon__jsx('use', {
    xlinkHref: VinIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#vin'
  }));
};

/* harmony default export */ var VinIcon_defaultExport = (VinIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/VipIcon.js
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(VipIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var VipIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var VipIcon = function VipIcon() {
  return VipIcon__jsx('svg', {
    width: '12',
    height: '11'
  }, void 0, VipIcon__jsx('use', {
    xlinkHref: VipIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#vip'
  }));
};

/* harmony default export */ var VipIcon_defaultExport = (VipIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SubscribeSearch.js
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SubscribeSearch___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var SubscribeSearch__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SubscribeSearch = function SubscribeSearch() {
  return SubscribeSearch__jsx('svg', {
    width: '18',
    height: '18'
  }, void 0, SubscribeSearch__jsx('use', {
    xlinkHref: SubscribeSearch___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#save-search'
  }));
};

/* harmony default export */ var SubscribeSearch_defaultExport = (SubscribeSearch);
// CONCATENATED MODULE: ./src/shared/components/Icons/AvatarIcon.js
/* harmony import */ var AvatarIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AvatarIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AvatarIcon___WEBPACK_IMPORTED_MODULE_0_react__);
var AvatarIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var AvatarIcon__ref = AvatarIcon__jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, void 0, AvatarIcon__jsx("g", {
  clipPath: "url(#clip0_2232:2596)"
}, void 0, AvatarIcon__jsx("path", {
  d: "M9.99957 0C7.22547 0 4.96875 2.25672 4.96875 5.03082C4.96875 7.80492 7.22547 10.0616 9.99957 10.0616C12.7737 10.0616 15.0304 7.80492 15.0304 5.03082C15.0304 2.25672 12.7737 0 9.99957 0ZM9.99957 8.58199C8.04148 8.58199 6.4484 6.98891 6.4484 5.03082C6.4484 3.07273 8.04148 1.47965 9.99957 1.47965C11.9577 1.47965 13.5507 3.07273 13.5507 5.03082C13.5507 6.98891 11.9577 8.58199 9.99957 8.58199Z",
  fill: "#808080"
}), AvatarIcon__jsx("path", {
  d: "M9.99988 11.8398C5.57473 11.8398 2.1084 15.4253 2.1084 20.0026H3.58805C3.58805 16.1925 6.34465 13.3195 9.99988 13.3195C13.6551 13.3195 16.4117 16.1927 16.4117 20.0026H17.8914C17.8914 15.4253 14.425 11.8398 9.99988 11.8398Z",
  fill: "#808080"
})), AvatarIcon__jsx("defs", {}, void 0, AvatarIcon__jsx("clipPath", {
  id: "clip0_2232:2596"
}, void 0, AvatarIcon__jsx("rect", {
  width: "20",
  height: "20",
  fill: "white"
}))));

var AvatarIcon = function AvatarIcon() {
  return AvatarIcon__ref;
};

/* harmony default export */ var AvatarIcon_defaultExport = (AvatarIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SettingsIcon.js
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SettingsIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var SettingsIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SettingsIcon = function SettingsIcon() {
  return SettingsIcon__jsx('svg', {
    width: '12',
    height: '12'
  }, void 0, SettingsIcon__jsx('use', {
    xlinkHref: SettingsIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#settings'
  }));
};

/* harmony default export */ var SettingsIcon_defaultExport = (SettingsIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/MoneyIcon.js
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MoneyIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg__);
var MoneyIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var MoneyIcon = function MoneyIcon() {
  return MoneyIcon__jsx('svg', {
    width: '16',
    height: '16'
  }, void 0, MoneyIcon__jsx('use', {
    xlinkHref: MoneyIcon___WEBPACK_IMPORTED_MODULE_1_shared_assets_icons_sprites_carCard_svg___default.a + '#money'
  }));
};

/* harmony default export */ var MoneyIcon_defaultExport = (MoneyIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/SpriteIcon.js
/* harmony import */ var SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SpriteIcon__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var SpriteIcon = function SpriteIcon(params) {
  var width = params.width,
      height = params.height,
      className = params.className,
      id = params.id,
      otherParams = _objectWithoutProperties(params, ['width', 'height', 'className', 'id']);

  return SpriteIcon___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({ width: width || 10, height: height || 10, className: className || '' }, otherParams),
    SpriteIcon__jsx('use', {
      xlinkHref: __WEBPACK_IMPORTED_MODULE_2_shared_assets_icons_sprites_carCard_svg___default.a + '#' + id
    })
  );
};

SpriteIcon.defaultProps = {
  width: '',
  height: '',
  className: '',
  id: ''
};

/* harmony default export */ var SpriteIcon_defaultExport = (SpriteIcon);
// CONCATENATED MODULE: ./src/shared/components/Icons/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return ExchangeIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return IncomminCallIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return VerifiedIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return GuaranteedIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return TestDriveIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return InfoIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return CalendarIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return GearboxIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return EngineIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return SpeedIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return ChassisIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return LocationIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return CarIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return ColorIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return VinIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return VipIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return SubscribeSearch_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return AvatarIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return SettingsIcon_defaultExport; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return MoneyIcon_defaultExport; });
/* unused concated harmony import SpriteIcon */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return SpriteIcon_defaultExport; });



























/***/ }),

/***/ 1398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDefaultImageByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSpareDefaultImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg__);








var defaultImages = {
  avto: __WEBPACK_IMPORTED_MODULE_0_shared_assets_images_transport_car_svg___default.a,
  moto: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  mototsikl: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  skuter: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  baggi: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  moped: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  kvadrotsikl: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  tritsikl: __WEBPACK_IMPORTED_MODULE_1_shared_assets_images_transport_motorcycle_svg___default.a,
  gruzovye: __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_transport_lorry_svg___default.a,
  avtobus: __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_transport_bus_side_svg___default.a,
  pritsepy: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_transport_caravan_svg___default.a,
  spetstehnika: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_transport_loader_svg___default.a,
  zapchasti: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_parts_svg___default.a
};

var getDefaultImageByType = function getDefaultImageByType(transport) {
  if (!transport) {
    return undefined;
  } else if (transport.slug && defaultImages[transport.slug]) {
    return defaultImages[transport.slug];
  } else if (transport.parents && transport.parents.length > 0 && defaultImages[transport.parents[0].slug]) {
    return defaultImages[transport.parents[0].slug];
  }

  return undefined;
};

var getSpareDefaultImage = function getSpareDefaultImage() {
  return defaultImages.zapchasti;
};

/* harmony default export */ __webpack_exports__["a"] = (defaultImages);

/***/ }),

/***/ 1402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export emailRegexp */
/* unused harmony export itnRegex */
/* unused harmony export vinRegex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isValidEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isValidPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isValidITN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isValidVIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isValidDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_isDate__ = __webpack_require__(321);


/* eslint-disable no-useless-escape */

var emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var itnRegex = /^\d{10}$/;
var vinRegex = /^[\d\w]{17}$/;

var isValidEmail = function isValidEmail(email) {
  return email && !!email.match(emailRegexp);
};

var isValidPhone = function isValidPhone(phoneNumber) {
  var regexp = '^(\\+[0-9]{2}\\(([0-9]{3})\\)[0-9]{3}-[0-9]{2}-[0-9]{2}|(\\+38|38|8)?([0-9]{3})[0-9]{7})$';
  return !!phoneNumber.match(regexp);
};

var isUrl = function isUrl(str) {
  var regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  return regexp.test(str);
};

// Individual Tax Number
var isValidITN = function isValidITN(itn) {
  return itn && itnRegex.test(itn);
};

// Vehicle Identification Number
var isValidVIN = function isValidVIN(vin) {
  return vin && vinRegex.test(vin);
};

var isValidDate = function isValidDate(date) {
  return __WEBPACK_IMPORTED_MODULE_0_date_fns_isDate__["default"](date);
};

/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "864d7492.svg";

/***/ }),

/***/ 1436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/ThumbCarousel/ThumbCarousel.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ThumbCarousel = function (_React$Component) {
  _inherits(ThumbCarousel, _React$Component);

  function ThumbCarousel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ThumbCarousel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThumbCarousel.__proto__ || Object.getPrototypeOf(ThumbCarousel)).call.apply(_ref, [this].concat(args))), _this), _this.handleSlideMouseOver = function (index) {
      _this.props.onMouseOver(index);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ThumbCarousel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          album = _props.album,
          index = _props.index;


      if (!Array.isArray(album) || album.length < 2) {
        return null;
      }

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.thumbCarousel
      }, void 0, album.map(function (imageObj, i) {
        return _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.slide, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.currentSlide, index === i)),
          onMouseOver: function onMouseOver() {
            return _this2.handleSlideMouseOver(i);
          }
        }, imageObj.id + '-' + i, _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a.slideButton
        }));
      }));
    }
  }]);

  return ThumbCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ThumbCarousel.defaultProps = {
  album: []
};


/* harmony default export */ var ThumbCarousel_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ThumbCarousel_css___default.a)(ThumbCarousel));
// CONCATENATED MODULE: ./src/desktop/components/Thumb/Thumb.js
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Thumb___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Thumb___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Thumb___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Thumb_css__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Thumb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Thumb_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Thumb__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Thumb__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Thumb__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Thumb__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Thumb__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Thumb__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import LazyLoad from 'react-lazyload';



var DEFAULT_HEIGHT = 170;

var Thumb_Thumb = function (_React$Component) {
  Thumb__inherits(Thumb, _React$Component);

  function Thumb() {
    var _ref;

    var _temp, _this, _ret;

    Thumb__classCallCheck(this, Thumb);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Thumb__possibleConstructorReturn(this, (_ref = Thumb.__proto__ || Object.getPrototypeOf(Thumb)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      index: 0
    }, _this.getResizedImages = function () {
      var _this$props = _this.props,
          photos = _this$props.photos,
          width = _this$props.width,
          style = _this$props.style,
          setRatioAlbum = _this$props.setRatioAlbum;

      var height = parseInt(style.height, 10);

      return setRatioAlbum(photos, width, height || DEFAULT_HEIGHT);
    }, _this.handleSlideMouseOver = function (index) {
      var photos = _this.getResizedImages();
      var image = new Image();

      image.src = photos[index] && photos[index].image;
      image.onload = function () {
        _this.setState({ index: index });
      };
    }, _temp), Thumb__possibleConstructorReturn(_this, _ret);
  }

  Thumb__createClass(Thumb, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          maxCount = _props.maxCount,
          link = _props.link,
          style = _props.style,
          className = _props.className,
          defaultImg = _props.defaultImg,
          lensEvent = _props.lensEvent,
          alt = _props.alt,
          isLazy = _props.isLazy;


      var photos = this.getResizedImages();
      var index = this.state.index;

      var album = photos.length && photos.length > maxCount ? photos.slice(0, maxCount) : photos;

      var hasPhotos = photos.length > 0 && photos[index].image;
      var thumbnail = hasPhotos && photos[index].image ? photos[index].image : defaultImg || __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_car_svg___default.a;

      return Thumb__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a.tmb, className, Thumb__defineProperty({}, __WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a.placeholderImg, !hasPhotos)),
        style: style
      }, void 0, link ? Thumb__jsx(__WEBPACK_IMPORTED_MODULE_2_shared_components_Link__["a" /* default */], {
        to: link,
        'data-lens-event': lensEvent
      }, void 0, Thumb__jsx(ThumbCarousel_defaultExport, {
        index: index,
        album: album,
        onMouseOver: this.handleSlideMouseOver
      })) : Thumb__jsx(ThumbCarousel_defaultExport, {
        index: index,
        album: album,
        onMouseOver: this.handleSlideMouseOver
      }), Thumb___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({}, isLazy ? { loading: 'lazy' } : {}, {
        className: __WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a.img,
        src: thumbnail.image || thumbnail,
        alt: alt,
        width: '230',
        height: '194'
      })));
    }
  }]);

  return Thumb;
}(Thumb___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Thumb_Thumb.defaultProps = {
  photos: [],
  maxCount: 5,
  link: '',
  lensEvent: '',
  style: {},
  defaultImg: null,
  className: '',
  alt: '',
  width: 240,
  isLazy: true
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__Thumb_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withPixelRatio__["a" /* default */](Thumb_Thumb)));

/***/ }),

/***/ 1446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/Title/Title.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Title_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Title = function (_Component) {
  _inherits(Title, _Component);

  function Title() {
    _classCallCheck(this, Title);

    return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
  }

  _createClass(Title, [{
    key: 'render',
    value: function render() {
      var title = this.props.title;


      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.titleContainer
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.title
      }, void 0, title));
    }
  }]);

  return Title;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ var Title_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__Title_css___default.a)(Title));
// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/MakesItem/MakesItem.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesItem_css__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MakesItem_css__);
var MakesItem__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MakesItem__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MakesItem__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MakesItem__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MakesItem__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import LazyLoad from 'react-lazyload';







var MakesItem = function (_Component) {
  MakesItem__inherits(MakesItem, _Component);

  function MakesItem() {
    var _ref;

    var _temp, _this, _ret;

    MakesItem__classCallCheck(this, MakesItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MakesItem__possibleConstructorReturn(this, (_ref = MakesItem.__proto__ || Object.getPrototypeOf(MakesItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleLinkClick = function (link) {
      if (window) {
        window.open(link);
      }
    }, _temp), MakesItem__possibleConstructorReturn(_this, _ret);
  }

  MakesItem__createClass(MakesItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          link = _props.link,
          models = _props.models,
          logo = _props.logo,
          className = _props.className,
          setRatioImage = _props.setRatioImage;


      return MakesItem__jsx('div', {
        className: className || __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.makesItem
      }, void 0, MakesItem__jsx('span', {
        onClick: function onClick() {
          return _this2.handleLinkClick(link);
        }
      }, void 0), MakesItem__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.makeWithModels
      }, void 0, MakesItem__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.make,
        onClick: function onClick() {
          return _this2.handleLinkClick(link);
        }
      }, void 0, title), MakesItem__jsx('p', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.models
      }, void 0, models.map(function (model) {
        return MakesItem__jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a.model,
          onClick: function onClick() {
            return _this2.handleLinkClick(model.link);
          }
        }, model.id, '' + model.title);
      }))));
    }
  }]);

  return MakesItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MakesItem.defaultProps = {
  models: [],
  logo: '',
  className: ''
};


/* harmony default export */ var MakesItem_defaultExport = (MakesItem___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__MakesItem_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withPixelRatio__["a" /* default */](MakesItem)));
// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/MakesList/MakesList.js
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MakesList___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(MakesList___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesList_css__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MakesList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MakesList_css__);
var MakesList__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MakesList__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MakesList__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MakesList__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MakesList__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var MakesList_MakesList = function (_Component) {
  MakesList__inherits(MakesList, _Component);

  function MakesList() {
    MakesList__classCallCheck(this, MakesList);

    return MakesList__possibleConstructorReturn(this, (MakesList.__proto__ || Object.getPrototypeOf(MakesList)).apply(this, arguments));
  }

  MakesList__createClass(MakesList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          list = _props.list,
          itemCN = _props.itemCN;


      return MakesList__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__MakesList_css___default.a.makesList
      }, void 0, list.map(function (make) {
        return MakesList__jsx(MakesItem_defaultExport, {
          title: make.title,
          logo: make.logo,
          models: make.models,
          link: make.link,
          className: itemCN
        }, make.id);
      }));
    }
  }]);

  return MakesList;
}(MakesList___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MakesList_MakesList.defaultProps = {
  list: [],
  itemCN: ''
};


/* harmony default export */ var MakesList_defaultExport = (MakesList___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__MakesList_css___default.a)(MakesList_MakesList));
// CONCATENATED MODULE: ./src/desktop/components/MakesSidebar/MakesSidebar.js
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var MakesSidebar___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(MakesSidebar___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css__);
var MakesSidebar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var MakesSidebar__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MakesSidebar__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MakesSidebar__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MakesSidebar__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var MakesSidebar_MakesSidebar = function (_Component) {
  MakesSidebar__inherits(MakesSidebar, _Component);

  function MakesSidebar() {
    MakesSidebar__classCallCheck(this, MakesSidebar);

    return MakesSidebar__possibleConstructorReturn(this, (MakesSidebar.__proto__ || Object.getPrototypeOf(MakesSidebar)).apply(this, arguments));
  }

  MakesSidebar__createClass(MakesSidebar, [{
    key: 'render',


    // componentDidMount = () => {
    //   document.addEventListener('scroll', this.handleScrollPage);
    // };

    // handleScrollPage = () => {
    //   console.dir(this.sidebar);
    //   const a = this.sidebar.offsetTop;
    //   const parent = this.sidebar.parentNode;
    //   const { top } = parent.getBoundingClientRect();
    //   if (top < a) {
    //     this.sidebar.style.top = `${-top - a}px`;
    //   }
    // };

    value: function render() {
      var intl = this.props.intl;
      var _props = this.props,
          _props$title = _props.title,
          title = _props$title === undefined ? intl.formatMessage({ id: 'Популярные марки и модели' }) : _props$title,
          makes = _props.makes,
          itemCN = _props.itemCN;


      return MakesSidebar__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css___default.a.makesSidebar
      }, void 0, MakesSidebar__jsx(Title_defaultExport, {
        title: title
      }), MakesSidebar__jsx(MakesList_defaultExport, {
        list: makes,
        itemCN: itemCN
      }));
    }
  }]);

  return MakesSidebar;
}(MakesSidebar___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MakesSidebar_MakesSidebar.defaultProps = {
  makes: __WEBPACK_IMPORTED_MODULE_4_shared_constants_json_makes_json___default.a,
  itemCN: '',
  title: undefined
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__MakesSidebar_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](MakesSidebar_MakesSidebar)));

/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4502f606.svg";

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a7b38a8e.svg";

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1e0c590.svg";

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a07b27d5.svg";

/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f233450.svg";

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "113bf7af.svg";

/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "428c5185.svg";

/***/ }),

/***/ 1454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









// eslint-disable-next-line css-modules/no-unused-class


function UserDataForm(props) {
  var userName = props.userName,
      phone = props.phone,
      errorMessage = props.errorMessage,
      successMessage = props.successMessage,
      t = props.t,
      changeHandler = props.changeHandler,
      onSubmitHandler = props.onSubmitHandler,
      disableBtnLeasing = props.disableBtnLeasing;


  var disabledBtn = disableBtnLeasing || !userName || !phone;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.containerCenter
  }, void 0, _jsx('form', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.requestForm
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_UI__["c" /* InputPhoneNumber */], {
    name: 'phone',
    value: phone,
    changeHandler: changeHandler
  }), _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_UI__["e" /* InputText */], {
    name: 'userName',
    value: userName,
    placeholder: userName || t('Ваше имя'),
    changeHandler: changeHandler
  }), (errorMessage || successMessage) && _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.errorMessage, errorMessage), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.successMessage, successMessage))
  }, void 0, t(errorMessage || successMessage)), _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_UI__["a" /* Button */], {
    disabled: disabledBtn,
    type: 'button',
    onClick: function onClick(e) {
      return onSubmitHandler(e, 'call');
    },
    text: '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E'
  })));
}

UserDataForm.defaultProps = {
  toggleLeasingModal: function toggleLeasingModal() {},
  disableBtnLeasing: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](UserDataForm)));

/***/ }),

/***/ 1455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/Title/Title.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Title_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Title_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var Title = function Title(_ref) {
  var title = _ref.title;
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.titleContainer
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__Title_css___default.a.title
  }, void 0, title));
};

/* harmony default export */ var Title_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__Title_css___default.a)(Title));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/UserDataForm/UserDataFormWithPhotoDialogWrapper.js
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__);
var UserDataFormWithPhotoDialogWrapper__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








// eslint-disable-next-line css-modules/no-unused-class


var _ref = UserDataFormWithPhotoDialogWrapper__jsx('br', {});

function UserDataFormWithPhotoDialogWrapper(props) {
  var t = props.t,
      children = props.children,
      advertInfo = props.advertInfo,
      showTitle = props.showTitle,
      showAgreemant = props.showAgreemant;
  var photos = advertInfo.photos,
      transport = advertInfo.transport;


  var advertImage = photos && photos[0] && photos[0].image || __WEBPACK_IMPORTED_MODULE_4_shared_constants_defaultImages__["b" /* getDefaultImageByType */](transport);
  var locale = t('locale') === 'ru' ? '' : t('locale') + '_';
  var agreementLink = '/pdf/' + locale + 'terms-of-use.pdf';

  var header = props.header;
  var titleHTML = props.titleHTML;


  if (!header) header = t('avtobazar.ua лизинг');

  return UserDataFormWithPhotoDialogWrapper__jsx('div', {}, void 0, showTitle && UserDataFormWithPhotoDialogWrapper__jsx(Title_defaultExport, {
    title: header
  }), UserDataFormWithPhotoDialogWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.LeasingContainerContent
  }, void 0, UserDataFormWithPhotoDialogWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.headBlock
  }, void 0, UserDataFormWithPhotoDialogWrapper__jsx('img', {
    src: advertImage,
    alt: ''
  }), UserDataFormWithPhotoDialogWrapper__jsx('span', {
    dangerouslySetInnerHTML: { __html: titleHTML }
  }, void 0)), children, showAgreemant && UserDataFormWithPhotoDialogWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.agreeInfo
  }, void 0, t('USER_AGREEMENT_DLG_TITLE_1'), _ref, UserDataFormWithPhotoDialogWrapper__jsx('a', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.modalTextLink,
    href: agreementLink,
    rel: 'noopener noreferrer nofollow',
    target: '_blank'
  }, void 0, t('USER_AGREEMENT_DLG_TITLE_2')))));
}

UserDataFormWithPhotoDialogWrapper.defaultProps = {
  showTitle: true,
  showAgreemant: true,
  monthlyPayment: 0,
  header: '',
  titleHTML: ''
};


/* harmony default export */ __webpack_exports__["a"] = (UserDataFormWithPhotoDialogWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](UserDataFormWithPhotoDialogWrapper)));

/***/ }),

/***/ 1463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return uppercaseFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stripMultipleSpaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stripHTML; });
var uppercaseFirst = function uppercaseFirst(str) {
  var safeStr = str || '';
  return safeStr.charAt(0).toUpperCase() + safeStr.substr(1);
};
var stripMultipleSpaces = function stripMultipleSpaces(str) {
  return (str || '').replace(/\s+/g, ' ');
};
var stripHTML = function stripHTML(maybeString) {
  return (maybeString || '').replace(/<(?:.|\n)*?>/gm, '');
};

/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1465);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThumbCarousel.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ThumbCarousel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1G-BW{width:100%;height:100%;padding:0 3px;position:absolute;top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;opacity:0;z-index:5;-webkit-transition:opacity .1s ease-in;-o-transition:opacity .1s ease-in;transition:opacity .1s ease-in;cursor:pointer}._1G-BW:hover{opacity:1}._2cmDv{-webkit-box-flex:1;-ms-flex:1 1 1px;flex:1 1 1px;position:relative}._2cmDv,._3rlOs{-webkit-box-sizing:border-box;box-sizing:border-box}._3rlOs{position:absolute;bottom:3px;left:0;right:0;width:98%;height:3px;background-color:#ffffffa1;margin:auto}.GK0g0 ._3rlOs{background-color:#ffd906}", ""]);

// exports
exports.locals = {
	"thumbCarousel": "_1G-BW",
	"slide": "_2cmDv",
	"slideButton": "_3rlOs",
	"currentSlide": "GK0g0"
};

/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1467);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Thumb.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Thumb.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1467:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Dkcgo{position:relative;width:100%;height:170px;overflow:hidden;padding:0}._3w_xQ{background-color:#f1f1f1}._3w_xQ ._21viN{position:absolute;top:50%;left:50%;width:60%;height:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports
exports.locals = {
	"tmb": "Dkcgo",
	"img": "_21viN imgCover",
	"placeholderImg": "_3w_xQ"
};

/***/ }),

/***/ 1468:
/***/ (function(module, exports) {

module.exports = [{"id":0,"logo":"https://cdn-th1.ab.ua/image/497ad6596a134f46a96bfcc853ac289c/img/classifiers/Volkswagen-logo.png","title":"VW","link":"/avto/volkswagen/","models":[{"id":0,"title":"Passat","link":"/avto/volkswagen/passat/"},{"id":1,"title":"Golf","link":"/avto/volkswagen/golf/"},{"id":3,"title":"Jetta","link":"/avto/volkswagen/jetta/"},{"id":4,"title":"Golf","link":"/avto/volkswagen/touareg/"},{"id":5,"title":"Touareg","link":"/avto/volkswagen/touareg/"},{"id":6,"title":"Tiguan","link":"/avto/volkswagen/tiguan/"},{"id":7,"title":"Touran","link":"/avto/volkswagen/touran/"}]},{"id":1,"logo":"https://cdn-th1.ab.ua/image/dd227bda009c4b02ba53a732c9ad294c/img/classifiers/Ford-logo.png","title":"Ford","link":"/avto/ford/","models":[{"id":0,"title":"Fiesta","link":"/avto/ford/fiesta/"},{"id":1,"title":"Edge","link":"/avto/ford/edge/"},{"id":2,"title":"Kuga","link":"/avto/ford/kuga/"},{"id":3,"title":"Focus","link":"/avto/ford/focus/"},{"id":4,"title":"Focus","link":"/avto/ford/focus/"},{"id":5,"title":"Fusion","link":"/avto/ford/fusion/"},{"id":6,"title":"Escape","link":"/avto/ford/escape/"}]},{"id":2,"logo":"https://cdn-th1.ab.ua/image/b9b1373c2f3342bfaefbd0dd022595a7/img/classifiers/BMW-logo.png","title":"BMW","link":"/avto/bmw/","models":[{"id":0,"title":"X1","link":"/avto/bmw/x1/"},{"id":1,"title":"X3","link":"/avto/bmw/x3/"},{"id":2,"title":"X5","link":"/avto/bmw/x5/"},{"id":3,"title":"3 series","link":"/avto/bmw/3-seriya/"}]},{"id":3,"logo":"https://cdn-th1.ab.ua/image/ca00f6ece6bd43a19d32769a2a038bcc/img/classifiers/Mazda-logo.png","title":"Mazda","link":"/avto/mazda/","models":[{"id":0,"title":"6","link":"/avto/mazda/6/"},{"id":1,"title":"CX-9","link":"/avto/mazda/cx-9/"},{"id":2,"title":"CX-5","link":"/avto/mazda/cx-5/"}]},{"id":4,"logo":"https://cdn-th1.ab.ua/image/dcb79fe827cd4b95967d7b3c3b4fdda1/img/classifiers/Suzuki-logo.png","title":"Suzuki","link":"/avto/suzuki/","models":[{"id":0,"title":"Vitara","link":"/avto/suzuki/vitara/"},{"id":1,"title":"Sx4","link":"/avto/suzuki/sx4/"}]},{"id":5,"logo":"https://cdn-th1.ab.ua/image/ef706262283e475c84cffe15adc6066b/img/classifiers/Kia-logo.png","title":"Kia","link":"/avto/kia/","models":[{"id":0,"title":"Sportage","link":"/avto//kia/sportage"},{"id":1,"title":"Sorento","link":"https://ab.ua/avto/kia/sorento"},{"id":2,"title":"Niro","link":"/avto/kia/niro"}]},{"id":8,"logo":"https://cdn-th1.ab.ua/image/3b3b03df031c41c8b2e3a9d7026d0c1b/img/classifiers/Mitsubishi-logo.png","title":"Mitsubishi","link":"/avto/mitsubishi/","models":[{"id":0,"title":"ASX","link":"/avto/mitsubishi/asx/"},{"id":1,"title":"Outlander","link":"/avto/mitsubishi/outlander/"},{"id":2,"title":"Pajero Sport","link":"/avto/mitsubishi/pajero-sport/"}]},{"id":9,"logo":"https://cdn-th1.ab.ua/image/dedb40ba72e24e2eab443dff021efb8d/img/classifiers/Renault-logo.png","title":"Renault","link":"/avto/renault/","models":[{"id":0,"title":"Duster","link":"/avto/renault/duster/"},{"id":1,"title":"Captur","link":"/avto/renault/captur/"},{"id":2,"title":"Megane","link":"/avto/renault/megane/"},{"id":3,"title":"Sandero","link":"/avto/renault/sandero-1/"},{"id":4,"title":"Logan","link":"/avto/renault/logan/"}]},{"id":10,"logo":"https://cdn-th1.ab.ua/image/aaa7e3f5af0540239a3802b565b7c051/img/classifiers/Peugeot-logo.png","title":"Peugeot","link":"/avto/peugeot/","models":[{"id":0,"title":"208","link":"/avto/peugeot/208/"},{"id":1,"title":"308","link":"/avto/peugeot/308/"},{"id":2,"title":"3008","link":"/avto/peugeot/3008/"}]},{"id":11,"logo":"https://cdn-th1.ab.ua/image/74b998215679498ca93047b032274678/img/classifiers/Skoda-logo.png","title":"Skoda","link":"/avto/skoda/","models":[{"id":0,"title":"Rapid","link":"/avto/skoda/rapid-1/"},{"id":1,"title":"Octavia","link":"/avto/skoda/octavia/"},{"id":2,"title":"Kodiaq","link":"/avto/skoda/octavia/"},{"id":3,"title":"Karoq","link":"/avto/skoda/karoq/"}]},{"id":12,"logo":"https://cdn-th1.ab.ua/image/6cd481e3d49941819ccd6e4c29df2d95/img/classifiers/Mercedes-Benz-logo.png","title":"Mercedes-Benz","link":"/avto/mercedes-benz/","models":[{"id":0,"title":"S","link":"/avto/mercedes-benz/s-klass/"},{"id":1,"title":"GLA","link":"/avto/mercedes-benz/gla-klass/"},{"id":2,"title":"CLA","link":"/avto/mercedes-benz/cla-klass/"}]},{"id":13,"logo":"https://cdn-th1.ab.ua/image/c260d4a2e4a0476a87cd00de992f56cc/img/classifiers/Toyota-logo.png","title":"Toyota","link":"/avto/toyota/","models":[{"id":0,"title":"Corolla","link":"/avto/toyota/"},{"id":1,"title":"Camry","link":"/avto/toyota/camry/"},{"id":2,"title":"RAV 4","link":"/avto/toyota/rav4/"}]}]

/***/ }),

/***/ 1469:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1470);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1470:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3V9RQ{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border-bottom:3px solid #ffeb3b;padding:8px 10px}._2fhat{font-size:16px;font-weight:700;line-height:24px;margin:0;color:#000}", ""]);

// exports
exports.locals = {
	"titleContainer": "_3V9RQ",
	"title": "_2fhat"
};

/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1472);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesItem.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesItem.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1472:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Kv4F{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;padding:6px 0 8px;font-weight:400}._1QEPi{width:30px;margin-right:10px;border:none;cursor:pointer}._1weVC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-right:5px}.zJ6Ue{margin:0;font-size:16px;font-weight:700;line-height:21px;text-decoration:none;color:#000;padding-bottom:3px;cursor:pointer}._3xqxl{margin:0;font-size:12px;line-height:16px}.qT-Bi{color:#666b6f;text-decoration:none;font-size:13px;line-height:1.43;outline:none;cursor:pointer}.qT-Bi:after{content:\", \";display:inline}.qT-Bi:last-child:after{content:none}.qT-Bi:hover{color:#e73232;text-decoration:none}.qT-Bi:hover:after{color:#666b6f}", ""]);

// exports
exports.locals = {
	"makesItem": "_3Kv4F",
	"logo": "_1QEPi",
	"makeWithModels": "_1weVC",
	"make": "zJ6Ue",
	"models": "_3xqxl",
	"model": "qT-Bi"
};

/***/ }),

/***/ 1473:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1474);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesList.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1474:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1dGx7{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;list-style:none;padding:3px 10px 10px;margin:0}", ""]);

// exports
exports.locals = {
	"makesList": "_1dGx7"
};

/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1476);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesSidebar.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./MakesSidebar.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1fc7e{position:relative;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background:#fff;-webkit-box-shadow:0 2px 8px rgba(0,0,0,.04);box-shadow:0 2px 8px rgba(0,0,0,.04);border-radius:2px;margin-bottom:30px}", ""]);

// exports
exports.locals = {
	"makesSidebar": "_1fc7e"
};

/***/ }),

/***/ 1485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ 1492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function CommonLeasingButton(props) {
  var title = props.title,
      showInfoIcon = props.showInfoIcon,
      onClick = props.onClick,
      prefix = props.prefix,
      className = props.className,
      children = props.children;

  return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, !children && _jsx('div', {
    onClick: onClick,
    className: 'leasing-btn ' + className + ' ' + __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a.root
  }, void 0, prefix && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a.prefix
  }, void 0, prefix), !children && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a.title
  }, void 0, title), showInfoIcon && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a.icon
  }, void 0, _jsx('i', {
    className: 'fa fa-info'
  }))), children && _jsx('div', {
    onClick: onClick,
    className: 'leasing-btn ' + className
  }, void 0, children));
}

CommonLeasingButton.defaultProps = {
  className: '',
  onClick: function onClick() {},
  title: '',
  prefix: '',
  showInfoIcon: true,
  children: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__CommonLeasingButton_css___default.a)(CommonLeasingButton));

/***/ }),

/***/ 1493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/leasing/ulfCalculate.js
/* eslint-disable camelcase */

var PREPAYMENT_PERCENT = 30;
var TIME_MONTH = 60;
var ONCE_COMMISSION_PERCENT = 2.5;

var m_summ = 10000;
var m_gps = 0;
var m_registration = 0;
var m_osago = 0;
var m_bonus_manager = 0;
var m_bonus_marketing = 0;
var m_stavka_do = 50 / 100;
var m_stavka_posle = 50 / 100;

function ulfCalculate() {
  var calcSumm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
  var calcAvans = arguments[1];
  var calcTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TIME_MONTH;

  var m_kurs = 10;
  var raz_koms = ONCE_COMMISSION_PERCENT;
  var sum = calcSumm + calcSumm * (raz_koms / 100);
  var avans = calcAvans || calcSumm / 100 * PREPAYMENT_PERCENT;

  var m_stavka = m_stavka_do;
  if (m_summ >= 14000) {
    m_stavka = m_stavka_posle;
  }

  var m_obyazatelnui_rashod = (m_gps + m_registration + m_osago * calcTime / 12) / m_kurs + (sum - avans) / 100 * m_bonus_manager + sum / 100 * m_bonus_marketing;

  var summa_finansirovania = sum - avans + m_obyazatelnui_rashod;
  var calc_procent = m_stavka / 12 * Math.pow(1 + m_stavka / 12, calcTime) / (Math.pow(1 + m_stavka / 12, calcTime) - 1);

  var platej_per_mesec = summa_finansirovania * calc_procent;

  var monthly = Math.round(platej_per_mesec);

  return { monthly: monthly, avans: Math.round(avans) };
}
// CONCATENATED MODULE: ./src/shared/hocs/withLeasingParams.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withLeasingParams_withLeasingParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__withFetch__ = __webpack_require__(1244);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import { autoMoneyCalculate } from 'shared/helpers/leasing/autoMoneyCalculate';






var withLeasingParams_withLeasingParams = function withLeasingParams(WrappedComponent) {
  var _class, _temp2;

  var Component = (_temp2 = _class = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Component);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        leasingParams: {}
      }, _this.componentWillMount = function () {
        var _this$props = _this.props,
            advert = _this$props.advert,
            existsLeasingParams = _this$props.leasingParams;

        var leasingParams = void 0;
        if (!advert || !advert.id) return;

        if (existsLeasingParams && existsLeasingParams.monthlyPayment) {
          leasingParams = existsLeasingParams;
        } else if (__WEBPACK_IMPORTED_MODULE_5_shared_helpers_leasing_myAuto__["k" /* isUlfSomeDealersLeasingProposalAvailable */](advert)) {
          leasingParams = _this.addUlfParams(advert);
        } else {
          //  else if (isUlf24LeasingProposalAvailable(advert)) {
          leasingParams = _this.addUlfParams(advert, true);
        }
        // } else {
        //   leasingParams = this.addAutoMoneyParams(advert);
        // }

        if (leasingParams && leasingParams.monthlyPayment) {
          _this.setState({ leasingParams: _this.addExtendedParams(leasingParams) });
        }
      }, _this.addExtendedParams = function (leasingParams) {
        var advert = _this.props.advert;

        var newLP = _extends({}, leasingParams);

        if (newLP.extendedParams) return newLP;

        var monthlyPaymentUAH = __WEBPACK_IMPORTED_MODULE_3_shared_helpers_leasing_utils__["h" /* getMonthlyPrice */](_this.props.advert, newLP.monthlyPayment, // USD as default
        'uah', false);
        var monthlyPaymentUAHFormatted = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__["k" /* numberWithSpaces */](monthlyPaymentUAH);
        var priceUAH = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_advert__["c" /* getPrice */](advert.price, ['uah']);
        var prepaidUAH = __WEBPACK_IMPORTED_MODULE_3_shared_helpers_leasing_utils__["a" /* calculateExchange */](advert.price, leasingParams.prepaidSum, 'uah');

        newLP.extendedParams = {
          monthlyPaymentUAH: monthlyPaymentUAH,
          monthlyPaymentUAHFormatted: monthlyPaymentUAHFormatted,
          priceUAH: priceUAH,
          prepaidUAH: prepaidUAH
        };
        return newLP;
      }, _this.addUlfParams = function (advert) {
        var isUlf24Calculated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var priceUSD = __WEBPACK_IMPORTED_MODULE_6_shared_helpers_advert__["c" /* getPrice */](advert.price, ['usd']);

        var _ulfCalculate = ulfCalculate(priceUSD),
            monthly = _ulfCalculate.monthly,
            avans = _ulfCalculate.avans;

        var leasingParams = {
          monthlyPayment: monthly,
          prepaidSum: avans,
          isUlfCalculated: !isUlf24Calculated,
          isUlf24Calculated: isUlf24Calculated
        };
        _this.setState({ leasingParams: leasingParams });
        return leasingParams;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * Default currency is USD
     */
    // addAutoMoneyParams = advert => {
    //   const priceUSD = getPrice(advert.price, ['usd']);
    //   const { monthly, avans } = autoMoneyCalculate(priceUSD);
    //   const leasingParams = {
    //     monthlyPayment: monthly,
    //     prepaidSum: avans,
    //     isAutoMoneyCalculated: true,
    //   };
    //   this.setState({ leasingParams });
    //   return leasingParams;
    // };

    _createClass(Component, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { leasingParams: this.state.leasingParams }));
      }
    }]);

    return Component;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'withLeasingParams(' + __WEBPACK_IMPORTED_MODULE_2_shared_helpers_common__["e" /* getDisplayName */](WrappedComponent) + ')', _class.defaultProps = {
    index: 0,
    partner: '',
    leasingParams: null
  }, _temp2);

  return __WEBPACK_IMPORTED_MODULE_7__withFetch__["a" /* withFetch */](Component);
};

/***/ }),

/***/ 1494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addUlfLead */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUlfLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUlfParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1277);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var addUlfLead = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, fetch) {
    var advert, userName, price, term, phone, prepaid, comment, temperature, popularity, liquidityDays, commentWithAddData, userStorageId, type, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            advert = params.advert, userName = params.userName, price = params.price, term = params.term, phone = params.phone, prepaid = params.prepaid, comment = params.comment, temperature = params.temperature, popularity = params.popularity, liquidityDays = params.liquidityDays, commentWithAddData = params.commentWithAddData, userStorageId = params.userStorageId, type = params.type;
            data = {
              type: type,
              vehicle: {
                // manufacturerId: 1, // Необязательный ID марки авто в справочниках AutoRia
                // modelId: 1, // Необязательный ID марки авто в справочниках AutoRia
                manufacturedYear: advert.year, // Необязательный год выпуска
                engineVolume: __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getCapacity */](advert) // Необязательный объем двигателя в см₃
                // bodyId: 1, // Необязательный ID типа кузова в справочниках AutoRia
                // fuelTypeId: 1, // Необязательный ID типа топлива в справочниках AutoRia
                // transmissionTypeId: 1, // Необязательный ID типа трансмисии в справочниках AutoRia
              },
              contact: {
                name: userName,
                // surname: 'Иванов',
                // inn: '1234567890',
                phoneNumber: phone
              },
              productFrontId: 249, // Вид лизинга
              period: term, // Срок лизинга
              amount: price, // Стоимость авто, грн
              prepayment: prepaid, // Предоплата, грн
              comment: comment,
              utm_source: 'partner',
              utm_medium: 'avtobazar',
              // utm_campaign: 'utm_campaign ', // Необязательный utm-метка
              // utm_term: 'utm_term ', // Необязательный utm-метка
              // utm_content: 'utm_content' // Необязательный utm-метка

              UF_CRM_1639391109039: temperature || 0, // Температура (вероятность покупки)
              UF_CRM_1639391200032: popularity || 0, // Популярность
              UF_CRM_1639391221982: liquidityDays || 0, // Ликвидность (дней)
              UF_CRM_1639391239836: prepaid, // Рекомендованный аванс %
              UF_CRM_1639391264973: commentWithAddData, // Комментарий
              UF_CRM_1639391283416: userStorageId // device id
              // UF_CRM_1639391301711: '', // Результат скоринга
            };
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING_ULF.ADD_LEAD, data, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function addUlfLead(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var createUlfLead = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params, fetch) {
    var result, comment, ulfParams;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = null;
            _context2.prev = 1;
            comment = 'https://avtobazar.ua' + params.advert.permalink;
            ulfParams = _extends({}, params, {
              comment: comment,
              commentWithAddData: '',
              temperature: '',
              type: 'ulf'
            });
            _context2.next = 6;
            return addUlfLead(ulfParams, fetch);

          case 6:
            result = _context2.sent;

            if (!(!result || !result.id)) {
              _context2.next = 9;
              break;
            }

            throw Error('createUlf24Lead error');

          case 9:
            _context2.next = 13;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2['catch'](1);

          case 13:
            return _context2.abrupt('return', result);

          case 14:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 11]]);
  }));

  return function createUlfLead(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var getUlfParams = function getUlfParams(_ref3) {
  var phone = _ref3.phone,
      userName = _ref3.userName,
      leasingParams = _ref3.leasingParams,
      advert = _ref3.advert;
  return {
    phone: phone,
    userName: userName,
    advert: advert,
    leasingParams: leasingParams,
    term: leasingParams.term,
    prepaid: leasingParams && leasingParams.prepayment || leasingParams.extendedParams && leasingParams.extendedParams.prepaidUAH,
    price: leasingParams.extendedParams && leasingParams.extendedParams.priceUAH,
    userStorageId: localStorage.getItem('applensDeviceId') || ''
  };
};

/***/ }),

/***/ 1495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/helpers/leasing/finup.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1277);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




/**
 * Fetch car's temperature
 * @param {Number} deviceId 
 * @param {Function} fetch 
 * @returns 
 */
var fetchUsersTemperature = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(deviceId, fetch) {
    var body, temperature, temperatureData;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            body = { deviceId: __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* getCleanDeviceId */](deviceId) };
            temperature = 0;
            temperatureData = {};
            _context.prev = 3;
            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_1__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING.GET_TEMPERATURE, body, fetch, {}, '');

          case 6:
            temperatureData = _context.sent;

            temperature = temperatureData && temperatureData.temperature ? temperatureData.temperature : 0;
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](3);

          case 12:

            // temperature: 0.35
            if (temperature) {} else {}
            return _context.abrupt('return', temperature);

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[3, 10]]);
  }));

  return function fetchUsersTemperature(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/shared/helpers/leasing/ulf24.js
/* unused harmony export getUlf24LeasingParms */
/* unused harmony export addUlf24Lead */
/* unused harmony export monthlyHapaiCalculate */
/* unused harmony export createHapaiLead */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUlf24Lead; });
/* unused harmony export getCalcualations */
/* harmony import */ var ulf24___WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__myAuto__ = __webpack_require__(1394);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ulf24__this = this;

function ulf24__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var getUlf24LeasingParms = function getUlf24LeasingParms(advert) {
  var ulf = advert.ulf_data;

  return ulf && ulf.calcInfo || null;
};

var addUlf24Lead = function () {
  var _ref = ulf24__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, fetch) {
    var advert, userName, price, term, phone, prepaid, comment, temperature, popularity, liquidityDays, commentWithAddData, userStorageId, type, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            advert = params.advert, userName = params.userName, price = params.price, term = params.term, phone = params.phone, prepaid = params.prepaid, comment = params.comment, temperature = params.temperature, popularity = params.popularity, liquidityDays = params.liquidityDays, commentWithAddData = params.commentWithAddData, userStorageId = params.userStorageId, type = params.type;
            data = {
              type: type,
              vehicle: {
                // manufacturerId: 1, // Необязательный ID марки авто в справочниках AutoRia
                // modelId: 1, // Необязательный ID марки авто в справочниках AutoRia
                manufacturedYear: advert.year, // Необязательный год выпуска
                engineVolume: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getCapacity */](advert) // Необязательный объем двигателя в см₃
                // bodyId: 1, // Необязательный ID типа кузова в справочниках AutoRia
                // fuelTypeId: 1, // Необязательный ID типа топлива в справочниках AutoRia
                // transmissionTypeId: 1, // Необязательный ID типа трансмисии в справочниках AutoRia
              },
              contact: {
                name: userName,
                // surname: 'Иванов',
                // inn: '1234567890',
                phoneNumber: phone
              },
              productFrontId: 249, // Вид лизинга
              period: term, // Срок лизинга
              amount: price, // Стоимость авто, грн
              prepayment: prepaid, // Предоплата, грн
              comment: comment,
              utm_source: 'partner',
              utm_medium: 'avtobazar',
              // utm_campaign: 'utm_campaign ', // Необязательный utm-метка
              // utm_term: 'utm_term ', // Необязательный utm-метка
              // utm_content: 'utm_content' // Необязательный utm-метка

              UF_CRM_1639391109039: temperature || 0, // Температура (вероятность покупки)
              UF_CRM_1639391200032: popularity || 0, // Популярность
              UF_CRM_1639391221982: liquidityDays || 0, // Ликвидность (дней)
              UF_CRM_1639391239836: prepaid, // Рекомендованный аванс %
              UF_CRM_1639391264973: commentWithAddData, // Комментарий
              UF_CRM_1639391283416: userStorageId // device id
              // UF_CRM_1639391301711: '', // Результат скоринга
            };
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* execPostRequest */](ulf24___WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING_ULF24.ADD_LEAD, data, fetch, {}, 'addlead'));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, ulf24__this);
  }));

  return function addUlf24Lead(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var monthlyHapaiCalculate = function monthlyHapaiCalculate(carPrice, prepaid, term) {
  return typeof window !== 'undefined' && window.getAnnual ? window.getAnnual(carPrice, prepaid, term) : 0;
};

var createHapaiLead = function () {
  var _ref2 = ulf24__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params, fetch) {
    var result, userStorageId, advert, _ref3, popularity, liquidityDays, comment, verifyParamsId, temperature, finupVerificationUrl, commentWithAddData, hapaiParams;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = null;
            _context2.prev = 1;
            userStorageId = params.userStorageId, advert = params.advert;
            _context2.next = 5;
            return __WEBPACK_IMPORTED_MODULE_3__myAuto__["e" /* getFinupVerification */](advert, fetch);

          case 5:
            _ref3 = _context2.sent;
            popularity = _ref3.popularity;
            liquidityDays = _ref3.liquidityDays;
            comment = _ref3.comment;
            verifyParamsId = _ref3.id;
            _context2.next = 12;
            return fetchUsersTemperature(userStorageId, fetch);

          case 12:
            temperature = _context2.sent;
            finupVerificationUrl = 'https://api.finup.lv/view/verification';
            commentWithAddData = ['https://avtobazar.ua' + advert.permalink, finupVerificationUrl + '/' + verifyParamsId, 'https://api.finup.lv/view/profile/' + userStorageId].join('\n');
            hapaiParams = _extends({}, params, {
              comment: comment,
              popularity: popularity,
              liquidityDays: liquidityDays,
              commentWithAddData: commentWithAddData,
              temperature: temperature,
              type: 'hapai'
            });
            _context2.next = 18;
            return addUlf24Lead(hapaiParams, fetch);

          case 18:
            result = _context2.sent;

            if (!(!result || !result.success)) {
              _context2.next = 21;
              break;
            }

            throw Error('createHapaiLead error ' + JSON.stringify(result));

          case 21:
            _context2.next = 25;
            break;

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2['catch'](1);

          case 25:
            return _context2.abrupt('return', result);

          case 26:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, ulf24__this, [[1, 23]]);
  }));

  return function createHapaiLead(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var createUlf24Lead = function () {
  var _ref4 = ulf24__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params, fetch) {
    var result, comment, ulfParams;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            result = null;
            _context3.prev = 1;
            comment = 'https://avtobazar.ua' + params.advert.permalink;
            ulfParams = _extends({}, params, {
              comment: comment,
              commentWithAddData: '',
              temperature: '',
              type: 'ulf24'
            });
            _context3.next = 6;
            return addUlf24Lead(ulfParams, fetch);

          case 6:
            result = _context3.sent;

            if (!(!result || !result.id)) {
              _context3.next = 9;
              break;
            }

            throw Error('createUlf24Lead error');

          case 9:
            _context3.next = 13;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3['catch'](1);

          case 13:
            return _context3.abrupt('return', result);

          case 14:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, ulf24__this, [[1, 11]]);
  }));

  return function createUlf24Lead(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

var getCalcualations = function () {
  var _ref5 = ulf24__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(advert, leasing, fetch) {
    var result, costUAH, data;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!advert || !advert.make)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt('return', {});

          case 2:
            result = {};
            costUAH = __WEBPACK_IMPORTED_MODULE_1_shared_helpers_advert__["c" /* getPrice */](advert.price, ['uah']);
            _context4.prev = 4;
            data = {
              category: '_ЛЕГКОВЫЕ',
              subcategory: 'ЛЕГКОВЫЕ',
              brand: advert.make.title,
              model: advert.model.title,
              year: advert.year,
              volume: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getCapacity */](advert),
              cnt: 1,
              cost: '' + costUAH,
              prepayment: '' + leasing.prepayment,
              term: leasing.term,
              ccy: 'UAH',
              repayment: 'КЛАССИКА',
              franchise: 0,
              customer: 'ЮЛ',
              format: 1,
              url: 'https://avtobazar.ua' + advert.permalink
            };
            _context4.next = 8;
            return __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* execPostRequest */](ulf24___WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.LEASING_ULF24.CALCULATE, data, fetch);

          case 8:
            result = _context4.sent;
            _context4.next = 14;
            break;

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4['catch'](4);

            result = { error: _context4.t0.message, serviceInfo: { errorCode: 1, errorMessage: _context4.t0.message } };

          case 14:
            return _context4.abrupt('return', result);

          case 15:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, ulf24__this, [[4, 11]]);
  }));

  return function getCalcualations(_x7, _x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();

/***/ }),

/***/ 1496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1511);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 1511:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1512), __esModule: true };

/***/ }),

/***/ 1512:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(478);
__webpack_require__(1513);
module.exports = __webpack_require__(30).Array.from;

/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__(249);
var $export = __webpack_require__(69);
var toObject = __webpack_require__(107);
var call = __webpack_require__(1514);
var isArrayIter = __webpack_require__(1515);
var toLength = __webpack_require__(500);
var createProperty = __webpack_require__(1516);
var getIterFn = __webpack_require__(1279);

$export($export.S + $export.F * !__webpack_require__(1517)(function (iter) {
  Array.from(iter);
}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

/***/ }),

/***/ 1514:
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(105);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),

/***/ 1515:
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(187);
var ITERATOR = __webpack_require__(86)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),

/***/ 1516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(70);
var createDesc = __webpack_require__(136);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
};

/***/ }),

/***/ 1517:
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(86)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),

/***/ 1526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/CreditMarketButton/CreditMarketButton.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreditMarketBanner__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CommonLeasingButton_CommonLeasingButton__ = __webpack_require__(1492);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// import withStyles from 'isomorphic-style-loader/lib/withStyles';






var CreditMarketButton = function (_React$Component) {
  _inherits(CreditMarketButton, _React$Component);

  function CreditMarketButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CreditMarketButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreditMarketButton.__proto__ || Object.getPrototypeOf(CreditMarketButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showModal: false
    }, _this.toggleLeasingModal = function (event) {
      event.stopPropagation();
      var eventPostfix = _this.props.eventPostfix;

      var showModal = !_this.state.showModal;
      _this.setState({ showModal: showModal });
      var eventName = 'creditmarket-consultation-show-form-click' + (eventPostfix ? '-' + eventPostfix : '');
      if (showModal && __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[eventName]) _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[eventName]);
    }, _this.closeModal = function () {
      _this.setState({ showModal: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CreditMarketButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          advert = _props.advert,
          intl = _props.intl,
          eventPostfix = _props.eventPostfix,
          children = _props.children;

      var PRICE_UAH = advert.is_not_cleared ? '300 000' : '140 000';
      var prefix = intl.formatMessage({ id: 'Профинансируем это авто' });
      var title = PRICE_UAH + ' \u0433\u0440\u043D.';
      return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9__CommonLeasingButton_CommonLeasingButton__["a" /* default */], {
        className: 'creditmarket',
        onClick: this.toggleLeasingModal,
        prefix: prefix,
        title: title
      }, void 0, children), this.state.showModal && _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_ModalWrapper_ModalWrapper__["a" /* default */], {
        toggleModal: this.toggleLeasingModal,
        show: this.state.showModal
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__CreditMarketBanner__["a" /* default */], {
        advert: advert,
        modalMode: true,
        onSubmited: this.closeModal,
        eventPostfix: eventPostfix
      })));
    }
  }]);

  return CreditMarketButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CreditMarketButton.defaultProps = {
  eventPostfix: '',
  leasingParams: null,
  isNotCleared: false,
  children: null
};


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDataLayer: __WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_5_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ var CreditMarketButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */](null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](CreditMarketButton)));
// CONCATENATED MODULE: ./src/shared/components/DialogContainer/DialogContainer.js
/* harmony import */ var DialogContainer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var DialogContainer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(DialogContainer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DialogContainer_css__);
var DialogContainer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function DialogContainer(props) {
  return DialogContainer__jsx(DialogContainer___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, props.show && DialogContainer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default.a.root,
    style: props.style
  }, void 0, DialogContainer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default.a.container
  }, void 0, props.children, DialogContainer__jsx('i', {
    className: 'fa fa-times ' + __WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default.a.closeBtnIcon,
    onClick: props.toggleModal
  }))));
}

DialogContainer.defaultProps = {
  children: null,
  style: {}
};


/* harmony default export */ var DialogContainer_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__DialogContainer_css___default.a)(DialogContainer));
// CONCATENATED MODULE: ./src/shared/components/ToolTipWrapper/ToolTipWrapper.js
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ToolTipWrapper___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ToolTipWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var ToolTipWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ToolTipWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css__);
var ToolTipWrapper__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function ToolTipWrapper(props) {
  return ToolTipWrapper__jsx(ToolTipWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, props.show && ToolTipWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css___default.a.root
  }, void 0, ToolTipWrapper__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css___default.a.corner
  }), ToolTipWrapper__jsx(DialogContainer_defaultExport, {
    toggleModal: props.toggleModal,
    show: props.show
  }, void 0, props.children)));
}

ToolTipWrapper.defaultProps = {
  children: null
};


/* harmony default export */ var ToolTipWrapper_defaultExport = (ToolTipWrapper___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ToolTipWrapper_css___default.a)(ToolTipWrapper));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingWithCalculatorBanner.js
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_helpers_leasing_ulf24__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__UserDataForm_UserDataForm__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__UserDataForm_UserDataFormWithPhotoDialogWrapper__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css__);
var LeasingWithCalculatorBanner__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeasingWithCalculatorBanner__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function LeasingWithCalculatorBanner__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingWithCalculatorBanner__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingWithCalculatorBanner__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// import * as Cookies from 'js-cookie';




// import Loader from 'shared/components/Loader/Loader';











// import FormInput from './Inputs/FormInput';





// import { monthlyHapaiCalculate, createHapaiLead } from 'shared/helpers/leasing/ulf24';


// import LeasingCalculateForm from './UserDataForm/LeasingCalculateForm';
// import UserDataFormExtended from './UserDataForm/UserDataFormExtended';


// eslint-disable-next-line css-modules/no-unused-class


var LeasingWithCalculatorBanner = function (_React$Component) {
  LeasingWithCalculatorBanner__inherits(LeasingWithCalculatorBanner, _React$Component);

  function LeasingWithCalculatorBanner(props) {
    LeasingWithCalculatorBanner__classCallCheck(this, LeasingWithCalculatorBanner);

    var _this = LeasingWithCalculatorBanner__possibleConstructorReturn(this, (LeasingWithCalculatorBanner.__proto__ || Object.getPrototypeOf(LeasingWithCalculatorBanner)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        leasingParams = _this$props.leasingParams,
        advertInfo = _this$props.advertInfo,
        user = _this$props.user;

    var userName = user && user.name || '';
    var phone = user && user.phones && user.phones[0].number || '';
    var priceUah = __WEBPACK_IMPORTED_MODULE_13_shared_helpers_advert__["c" /* getPrice */](advertInfo.price, ['uah']);
    var prepaidUah = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["a" /* calculateExchange */](advertInfo.price, leasingParams.prepaidSum, 'uah');
    var comission = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["a" /* calculateExchange */](advertInfo.price, leasingParams.prepaidCommission, 'uah');
    var rate = leasingParams.annualRate;

    _this.state = {
      price: priceUah,
      prepaid: prepaidUah,
      term: leasingParams.term,
      rate: rate,
      comission: comission,
      terms: [12, 24, 36, 48, 60, 72, 84],
      userName: userName,
      birthday: '',
      phone: phone,
      errorMessage: '',
      successMessage: '',
      // step: 'periods',
      step: 'userform',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false,
      //
      loading: false
    };
    return _this;
  }

  LeasingWithCalculatorBanner__createClass(LeasingWithCalculatorBanner, [{
    key: 'fireEvent',


    // submitHapaiLeasingLead = cb => {
    //   const { phone, userName, term, prepaid, price } = this.state;
    //   const { advertInfo, leasingParams, fetch } = this.props;

    //   const leadParams = {
    //     phone,
    //     userName,
    //     advert: advertInfo,
    //     leasingParams,
    //     term,
    //     prepaid,
    //     price,
    //     userStorageId: localStorage.getItem('applensDeviceId') || '',
    //   };
    //   console.log('Create Hapai Lead');
    //   createHapaiLead(leadParams, fetch)
    //     .then(data => cb(data && data.success))
    //     .catch(() => cb(false));

    //   return false;
    // };

    value: function fireEvent() {
      __WEBPACK_IMPORTED_MODULE_15_shared_helpers_rtbHouse__["a" /* fireRTBEvent */]('leasingOld', {
        value: this.props.advertInfo.price && __WEBPACK_IMPORTED_MODULE_13_shared_helpers_advert__["c" /* getPrice */](this.props.advertInfo.price),
        ids: [this.props.advertInfo.id]
      });
      this.pushEvent('monthly-consultation-form-sumbit');
    }
  }, {
    key: 'render',
    value: function render() {
      var _cs;

      var _props = this.props,
          t = _props.t,
          advertInfo = _props.advertInfo,
          leasingParams = _props.leasingParams;
      var _state = this.state,
          step = _state.step,
          term = _state.term,
          prepaid = _state.prepaid,
          price = _state.price,
          rate = _state.rate,
          comission = _state.comission;

      var monthlyPriceUah = void 0;

      // if (isHapaiLeasing(leasingParams)) {
      //   const prePaidPrecent = (prepaid - comission) * 100 / price * 0.01;
      //   monthlyPriceUah = monthlyHapaiCalculate(price, prePaidPrecent, term);
      // } else
      if (leasingParams && leasingParams.extendedParams && leasingParams.extendedParams.monthlyPaymentUAH) {
        monthlyPriceUah = leasingParams.extendedParams.monthlyPaymentUAH;
      } else {
        monthlyPriceUah = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["b" /* calculateMonthlyPaymentV2 */]({
          year: advertInfo.year,
          term: term,
          price: price,
          prepaid: prepaid,
          comission: comission,
          rate: rate
        });
      }

      var symbol = __WEBPACK_IMPORTED_MODULE_12_shared_helpers_transportInfo__["p" /* getSymbolTitleBySlug */]('uah');
      var monthlySum = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_common__["k" /* numberWithSpaces */](monthlyPriceUah);
      var titleHTML = t('Ежемесячный платеж') + ' <br /> <b>' + monthlySum + ' ' + symbol + '</b>';

      return LeasingWithCalculatorBanner__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cs = {}, _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default.a.container, true), _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default.a.LeasingContainerContentSidebar, !this.props.modalMode), _cs))
      }, void 0, LeasingWithCalculatorBanner__jsx(__WEBPACK_IMPORTED_MODULE_20__UserDataForm_UserDataFormWithPhotoDialogWrapper__["a" /* default */], {
        advertInfo: this.props.advertInfo,
        showTitle: !this.props.modalMode,
        titleHTML: titleHTML,
        showAgreemant: step === 'userform'
      }, void 0, LeasingWithCalculatorBanner__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default.a.LeasingMyAutoBanner
      }, void 0, LeasingWithCalculatorBanner__jsx(__WEBPACK_IMPORTED_MODULE_19__UserDataForm_UserDataForm__["a" /* default */], {
        disableBtnLeasing: this.state.disableBtnLeasing,
        userName: this.state.userName,
        phone: this.state.phone,
        birthday: this.state.birthday,
        errorMessage: this.state.errorMessage,
        successMessage: this.state.successMessage,
        monthlyPayment: this.state.monthlyPayment,
        changeHandler: this.changeHandler,
        onSubmitHandler: this.onSubmitUesrDataForm,
        toggleLeasingModal: this.state.toggleLeasingModal
      }))));
    }
  }]);

  return LeasingWithCalculatorBanner;
}(LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingWithCalculatorBanner.defaultProps = {
  user: null,
  modalMode: true,
  leasingParams: null,
  onSubmited: function onSubmited() {},
  eventPostfix: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onLeadCreated = function (success) {
    _this2.pushEvent('lead-create-' + (success ? 'success' : 'fail'));
  };

  this.onSubmitExtendedDataForm = function () {
    _this2.pushEvent('monthly-calculation-form-sumbit');
    _this2.setState({ step: 'userform' });
  };

  this.onSubmitUesrDataForm = function (e) {
    var _props2 = _this2.props,
        onSubmited = _props2.onSubmited,
        enqueueNotif = _props2.enqueueNotif,
        t = _props2.t,
        leasingParams = _props2.leasingParams;

    e.preventDefault();
    var _state2 = _this2.state,
        phone = _state2.phone,
        userName = _state2.userName;

    var errorMsg = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["l" /* userFormValidation */]({ phone: phone, userName: userName });

    if (errorMsg) {
      _this2.setState({ errorMessage: errorMsg });
      return;
    }

    _this2.fireEvent();
    _this2.setState({ disableBtnLeasing: true });
    var submit = void 0;

    // if (isAutoMoneyLeasing(leasingParams) && Cookies.get('leasing_partner') % 2) {
    //   submit = this.submitAutomoneyLeasingLead;
    // // } else if (isAutoMoneyLeasing(leasingParams)) {
    // //   submit = this.submitMyAutoLeasingLead;
    // } else
    if (__WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["j" /* isUlf24Leasing */](leasingParams)) {
      submit = _this2.submitUlf24LeasingLead;
    } else if (__WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_utils__["k" /* isUlfLeasing */](leasingParams)) {
      submit = _this2.submitUlfLeasingLead;
    } else {
      submit = _this2.submitAFinanceLeasingLead;
    }

    submit(function (isSUccess) {
      _this2.setState({ disableBtnLeasing: false });
      var errorMessage = !isSUccess ? 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже' : '';
      _this2.setState({
        userName: '',
        phone: '',
        errorMessage: errorMessage,
        successMessage: ''
      });
      if (isSUccess) {
        onSubmited();
        enqueueNotif(t('Ваша заявка отправлена!'));
        _this2.onLeadCreated(true);
      } else {
        _this2.onLeadCreated(false);
      }
    });
  };

  this.submitAFinanceLeasingLead = function (cb, moreLeasingParams) {
    var _state3 = _this2.state,
        phone = _state3.phone,
        userName = _state3.userName,
        term = _state3.term,
        prepaid = _state3.prepaid,
        price = _state3.price;
    var _props3 = _this2.props,
        advertInfo = _props3.advertInfo,
        leasingParams = _props3.leasingParams,
        fetch = _props3.fetch;


    var prepaidPercent = prepaid * 100 / price;

    var leadsParams = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */]({ phone: phone, userName: userName }, advertInfo, leasingParams, { term: term, prepaid: prepaidPercent }, moreLeasingParams);

    __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["a" /* createAFinanceLeda */](leadsParams, advertInfo, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function () {
      return cb(false);
    });

    return false;
  };

  this.submitMyAutoLeasingLead = function (cb, moreLeasingParams) {
    var _state4 = _this2.state,
        phone = _state4.phone,
        userName = _state4.userName,
        term = _state4.term,
        prepaid = _state4.prepaid,
        price = _state4.price;
    var _props4 = _this2.props,
        advertInfo = _props4.advertInfo,
        leasingParams = _props4.leasingParams,
        fetch = _props4.fetch;


    var prepaidPercent = prepaid * 100 / price;

    var leadsParams = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */]({ phone: phone, userName: userName }, advertInfo, leasingParams, { term: term, prepaid: prepaidPercent }, moreLeasingParams);

    __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["c" /* createMyAutoLead */](leadsParams, advertInfo, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function () {
      return cb(false);
    });

    return false;
  };

  this.submitAutomoneyLeasingLead = function (cb, moreLeasingParams) {
    var _state5 = _this2.state,
        phone = _state5.phone,
        userName = _state5.userName,
        term = _state5.term,
        prepaid = _state5.prepaid,
        price = _state5.price;
    var _props5 = _this2.props,
        advertInfo = _props5.advertInfo,
        leasingParams = _props5.leasingParams,
        fetch = _props5.fetch;


    var prepaidPercent = prepaid * 100 / price;
    // TODO: sould be refactord for AutomoneyLeasingLead
    var leadsParams = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */]({ phone: phone, userName: userName }, advertInfo, leasingParams, { term: term, prepaid: prepaidPercent }, moreLeasingParams);

    __WEBPACK_IMPORTED_MODULE_16_shared_helpers_leasing_myAuto__["b" /* createAutoMoneyLead */](leadsParams, advertInfo, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function () {
      return cb(false);
    });

    return false;
  };

  this.submitUlfLeasingLead = function (cb) {
    var _state6 = _this2.state,
        phone = _state6.phone,
        userName = _state6.userName;
    var _props6 = _this2.props,
        advertInfo = _props6.advertInfo,
        leasingParams = _props6.leasingParams,
        fetch = _props6.fetch;


    var leadParams = __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({
      phone: phone,
      userName: userName,
      leasingParams: leasingParams,
      advert: advertInfo
    });

    __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__["a" /* createUlfLead */](leadParams, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function (e) {
      cb(false);
    });

    return false;
  };

  this.submitUlf24LeasingLead = function (cb) {
    var _state7 = _this2.state,
        phone = _state7.phone,
        userName = _state7.userName;
    var _props7 = _this2.props,
        advertInfo = _props7.advertInfo,
        leasingParams = _props7.leasingParams,
        fetch = _props7.fetch;


    var leadParams = __WEBPACK_IMPORTED_MODULE_17_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({
      phone: phone,
      userName: userName,
      leasingParams: leasingParams,
      advert: advertInfo
    });

    __WEBPACK_IMPORTED_MODULE_18_shared_helpers_leasing_ulf24__["a" /* createUlf24Lead */](leadParams, fetch).then(function (data) {
      return cb(!!data);
    }).catch(function (e) {
      cb(false);
    });

    return false;
  };

  this.changeHandler = function (field, value) {
    var _this2$setState;

    _this2.setState((_this2$setState = {}, _defineProperty(_this2$setState, field, value), _defineProperty(_this2$setState, 'errorMessage', ''), _this2$setState));
  };

  this.pushEvent = function (eventName) {
    var _props8 = _this2.props,
        eventPostfix = _props8.eventPostfix,
        leasingParams = _props8.leasingParams;

    var partnert = ''; // isAutoMoneyLeasing(leasingParams) ? 'automoney-' : '';
    var event = '' + partnert + eventName + (eventPostfix ? '-' + eventPostfix : '');
    if (LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]) _this2.props.setDataLayer(LeasingWithCalculatorBanner___WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]);else {}
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user && state.user.user
  };
};

var LeasingWithCalculatorBanner_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    enqueueNotif: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__["a" /* enqueueNotification */], dispatch),
    setDataLayer: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ var LeasingWithCalculatorBanner_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_21__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, LeasingWithCalculatorBanner_mapDispatchToProps)(LeasingWithCalculatorBanner)))));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton.js
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withLeasingParams__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_ModalWrapper_ModalWrapper__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CommonLeasingButton_CommonLeasingButton__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LeasingWithCalculatorButton_css__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LeasingWithCalculatorButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__LeasingWithCalculatorButton_css__);
var LeasingWithCalculatorButton__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeasingWithCalculatorButton__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeasingWithCalculatorButton__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingWithCalculatorButton__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingWithCalculatorButton__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import withHapai from 'shared/hocs/withHapai';





// import { toggleHalfScreen } from 'shared/helpers/adsAndMetrics';

// import { getSymbolTitleBySlug } from 'shared/helpers/transportInfo';

// import { isHapaiLeasing } from 'shared/helpers/leasing/utils';
// import { getMonthlyPrice } from 'shared/helpers/leasing/utils';


// eslint-disable-next-line css-modules/no-unused-class


// const isMobile = __APP__ === 'mobile';

var LeasingWithCalculatorButton_LeasingWithCalculatorButton = function (_React$Component) {
  LeasingWithCalculatorButton__inherits(LeasingWithCalculatorButton, _React$Component);

  function LeasingWithCalculatorButton() {
    var _ref;

    var _temp, _this, _ret;

    LeasingWithCalculatorButton__classCallCheck(this, LeasingWithCalculatorButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LeasingWithCalculatorButton__possibleConstructorReturn(this, (_ref = LeasingWithCalculatorButton.__proto__ || Object.getPrototypeOf(LeasingWithCalculatorButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showDialog: false
    }, _this.getTitle = function () {
      var _this$props = _this.props,
          intl = _this$props.intl,
          leasingParams = _this$props.leasingParams;

      var price = 0;
      // if (leasingParams && leasingParams.extendedParams && leasingParams.extendedParams.hapai) {
      //   price = leasingParams.extendedParams.hapai.monthlyPaymentUAHFormatted;
      // } else
      if (leasingParams && leasingParams.extendedParams) {
        price = leasingParams.extendedParams.monthlyPaymentUAHFormatted;
      }

      var symbol = 'грн'; // getSymbolTitleBySlug(currencySlug);
      var moth = intl.formatMessage({ id: 'мес' });
      return price + ' ' + symbol + '/' + moth;
    }, _this.toggleLeasingModal = function (event) {
      if (event) event.stopPropagation();
      var show = _this.props.useToolTip ? _this.props.showDialog : _this.state.showDialog;
      var showDialog = !show;

      if (!_this.props.useToolTip) _this.setState({ showDialog: showDialog });

      if (showDialog) {
        _this.pushEvent('monthly-calculation-show-form-click');
      }

      _this.props.toggleLeasingModal();
      // if (isMobile) toggleHalfScreen(!showDialog);
    }, _this.pushEvent = function (eventName) {
      var eventPostfix = _this.props.eventPostfix;
      // const { eventPostfix, leasingParams } = this.props;

      var partnert = ''; // isHapaiLeasing(leasingParams) ? 'hapai-' : '';
      var event = '' + partnert + eventName + (eventPostfix ? '-' + eventPostfix : '');
      if (__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]) _this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]);else {}
    }, _temp), LeasingWithCalculatorButton__possibleConstructorReturn(_this, _ret);
  }

  LeasingWithCalculatorButton__createClass(LeasingWithCalculatorButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          advert = _props.advert,
          leasingParams = _props.leasingParams,
          useToolTip = _props.useToolTip,
          children = _props.children;

      var ComponentWrapper = useToolTip ? ToolTipWrapper_defaultExport : __WEBPACK_IMPORTED_MODULE_11_shared_components_ModalWrapper_ModalWrapper__["a" /* default */];
      var show = useToolTip ? this.props.showDialog : this.state.showDialog;
      return LeasingWithCalculatorButton__jsx(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, LeasingWithCalculatorButton__jsx(__WEBPACK_IMPORTED_MODULE_12__CommonLeasingButton_CommonLeasingButton__["a" /* default */], {
        title: this.getTitle(),
        onClick: this.toggleLeasingModal,
        className: 'leasing-with-calculator'
      }, void 0, children), LeasingWithCalculatorButton__jsx(ComponentWrapper, {
        toggleModal: this.toggleLeasingModal,
        show: show
      }, void 0, LeasingWithCalculatorButton__jsx(LeasingWithCalculatorBanner_defaultExport, {
        eventPostfix: this.props.eventPostfix,
        advertInfo: advert,
        modalMode: true,
        onSubmited: this.toggleLeasingModal,
        leasingParams: leasingParams
      })));
    }
  }]);

  return LeasingWithCalculatorButton;
}(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingWithCalculatorButton_LeasingWithCalculatorButton.defaultProps = {
  useToolTip: false,
  toggleLeasingModal: function toggleLeasingModal() {},
  showDialog: false,
  leasingParams: null,
  // currencySlug: 'uah',
  eventPostfix: '',
  children: null
};


var LeasingWithCalculatorButton_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDataLayer: __WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ var LeasingWithCalculatorButton_defaultExport = (__WEBPACK_IMPORTED_MODULE_7_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_13__LeasingWithCalculatorButton_css___default.a)(LeasingWithCalculatorButton___WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](null, LeasingWithCalculatorButton_mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withLeasingParams__["a" /* withLeasingParams */](__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](LeasingWithCalculatorButton_LeasingWithCalculatorButton)))));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingButtonWrapper/LeasingButtonWrapper.js
/* harmony import */ var LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_PriceUah_PriceUah__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
var LeasingButtonWrapper__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var LeasingButtonWrapper__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeasingButtonWrapper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingButtonWrapper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingButtonWrapper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var LeasingButtonWrapper_LeasingButtonWrapper = function (_React$Component) {
  LeasingButtonWrapper__inherits(LeasingButtonWrapper, _React$Component);

  function LeasingButtonWrapper() {
    LeasingButtonWrapper__classCallCheck(this, LeasingButtonWrapper);

    return LeasingButtonWrapper__possibleConstructorReturn(this, (LeasingButtonWrapper.__proto__ || Object.getPrototypeOf(LeasingButtonWrapper)).apply(this, arguments));
  }

  LeasingButtonWrapper__createClass(LeasingButtonWrapper, [{
    key: 'checkDefaultButton',
    value: function checkDefaultButton(name) {
      var defaultButtonName = this.props.defaultButtonName;

      if (defaultButtonName === '') return true;
      return name === defaultButtonName;
    }
  }, {
    key: 'renderComponent',
    value: function renderComponent() {
      var _props = this.props,
          advert = _props.advert,
          theme = _props.theme;

      var isCommonLeasingAvailable = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_leasing_myAuto__["f" /* isCommonLeasingProposalAvailable */](advert);
      var isMyAutoOrHapaiAvailable = true; // isLeasingProposalAvailable(advert);
      // const isUlf24Available = false; isUlf24LeasingProposalAvailable(advert);
      var isCreditMarketAvailable = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_leasing_myAuto__["h" /* isCreditmarketProposalAvailable */](advert);
      var isCreditmarketNotClearedAvailable = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_leasing_myAuto__["g" /* isCreditmarketNotClearedProposalAvailable */](advert);

      if (isCommonLeasingAvailable) {
        // if (isUlf24Available && this.checkDefaultButton('LeasingUlfButton'))
        //   return <LeasingUlfButton {...this.props} />;

        if (isCreditMarketAvailable && this.checkDefaultButton('CreditMarketButton')) return LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LeasingWithCalculatorButton_defaultExport, this.props);
        // return <CreditMarketButton {...this.props} />;

        if (isCreditmarketNotClearedAvailable && this.checkDefaultButton('CreditMarketButton')) return LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LeasingWithCalculatorButton_defaultExport, _extends({}, this.props, { isNotCleared: true }));
        // return <CreditMarketButton {...this.props} isNotCleared />;

        if (isMyAutoOrHapaiAvailable && this.checkDefaultButton('LeasingWithCalculatorButton')) return LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LeasingWithCalculatorButton_defaultExport, this.props);

        // if (isMyAutoOrHapaiAvailable && this.checkDefaultButton('LeasingButton'))
        //   return <LeasingButton {...this.props} />;
      }
      return LeasingButtonWrapper__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_PriceUah_PriceUah__["a" /* default */], {
        uah: __WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'uah'),
        theme: theme
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return LeasingButtonWrapper__jsx(LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, this.renderComponent());
    }
  }]);

  return LeasingButtonWrapper;
}(LeasingButtonWrapper___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingButtonWrapper_LeasingButtonWrapper.defaultProps = {
  index: 0,
  theme: 'yellow',
  defaultButtonName: '',
  eventPostfix: ''
};


/* harmony default export */ __webpack_exports__["a"] = (LeasingButtonWrapper_LeasingButtonWrapper);

/***/ }),

/***/ 1527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceUah_css__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceUah_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PriceUah_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






function PriceUah(props) {
  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__PriceUah_css___default.a[props.theme]
  }, void 0, props.uah);
}

PriceUah.defaultProps = {
  theme: 'small'
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__PriceUah_css___default.a)(PriceUah));

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3uigL{padding:0}._2V0fu ._2hPtr,._3uigL{position:relative;background-color:#fff}._2V0fu ._2hPtr{padding:10px}._31vki{max-width:160px;font-size:22px;font-weight:800;line-height:24px;margin-top:10px}._2nW-B{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2nW-B img{width:64px;height:64px;border:3px solid #fff;border-radius:50%;-o-object-fit:cover;object-fit:cover;pointer-events:none}._2nW-B span{font-weight:700;font-size:18px;line-height:140%;padding-left:5px}._2nW-B span b{background:#ffd906}._1-vS1{position:absolute;top:20px;right:10px;display:block;width:64px;height:64px;border:3px solid #fff;border-radius:50%;-o-object-fit:cover;object-fit:cover;pointer-events:none}._1qHDk{margin:0 0 3px;padding-top:10px}._1qHDk,._1qWrk{font-size:14px;line-height:19px}._1qWrk{margin:0;color:#777d82;word-break:break-word;overflow-wrap:break-word}._3EMMJ .Select-control{height:36px;border-radius:3px;right:auto}._3EMMJ .Select-input>input{width:100%!important}.BKsqV{padding:5px;display:block;color:#91979c;line-height:18px;text-align:center}.BKsqV,.Tfqvq{font-size:12px}.Tfqvq{color:#505050}._1qWrk{margin-right:0!important}._2AE8r,._2DQFS{position:relative;color:#d7433d;font-weight:400;font-size:13px;text-align:center;display:block;line-height:1.2;min-height:20px}._2AE8r{color:#2c7e07;font-size:15px;font-weight:500}._3Ckx8>button,._3Ckx8>input{margin:5px 0}._1DHJU{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1593o{margin:5px 20px;text-align:center}.ONa-X>h3{font-weight:700;font-size:18px;margin:0!important}._1ZvgC{padding:15px 0}._1gT3Z{text-align:center;margin:8px 15px}._3I-OT{width:177px}._24rTc{margin:20px}._2jPCK{font-size:18px;font-weight:700;margin:10px 0}._1Sx3L{font-size:12px;color:gray}._1Sx3L>p{text-align:center;margin:0}._10w5A{text-decoration:none;color:#1575c3;font-size:12px;line-height:16px;display:inline-block}._10w5A:hover{color:#2196f3}._2dBrw{height:42px;width:100%;border-radius:3px}._1E2EV,._381a_{padding-top:20px}._1E2EV ._2dBrw,._381a_ ._2dBrw{margin-bottom:20px}._1E2EV ._1T6Ek,._381a_ ._1T6Ek{margin-bottom:9px}.MvwRd{margin-bottom:40px}.MvwRd input{margin:0 0 20px}.MvwRd button{margin:0 auto 10px}._1aqjF{margin-top:-20px;height:20px}", ""]);

// exports
exports.locals = {
	"container": "_3uigL",
	"LeasingContainerContentSidebar": "_2V0fu",
	"LeasingContainerContent": "_2hPtr",
	"title": "_31vki",
	"headBlock": "_2nW-B",
	"carImg": "_1-vS1",
	"price": "_1qHDk",
	"period": "_1qWrk",
	"root": "_3EMMJ",
	"agreeInfo": "BKsqV",
	"btnInfo": "Tfqvq",
	"errorMessage": "_2DQFS",
	"successMessage": "_2AE8r",
	"requestForm": "_3Ckx8",
	"containerCenter": "_1DHJU",
	"containerTextBlock": "_1593o",
	"containerUserDataDialog": "ONa-X",
	"formUserDataDialog": "_1ZvgC",
	"containerVerifyText": "_1gT3Z",
	"containerVerifyForm": "_3I-OT",
	"containerCircleTimer": "_24rTc",
	"containerResultTitle": "_2jPCK",
	"userAgreement": "_1Sx3L",
	"modalTextLink": "_10w5A",
	"input": "_2dBrw input",
	"LeasingUlfBanner": "_381a_",
	"LeasingMyAutoBanner": "_1E2EV",
	"label": "_1T6Ek",
	"userDataFormExtended": "MvwRd",
	"errorMessageBlock": "_1aqjF"
};

/***/ }),

/***/ 1555:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1556);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Title.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1eCUR{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border-bottom:3px solid #ffeb3b;padding:10px}._2O4va{text-align:center;font-size:18px;font-weight:700;line-height:24px;margin:0;color:#000}", ""]);

// exports
exports.locals = {
	"titleContainer": "_1eCUR",
	"title": "_2O4va"
};

/***/ }),

/***/ 1647:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1648);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CommonLeasingButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CommonLeasingButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1648:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Jpsyr{display:inline-block;font-weight:700;padding:5px;border-radius:2px;color:#000;font-weight:600;font-size:16px;background:#ffd906;z-index:10;position:relative;cursor:pointer}.Jpsyr:hover{text-decoration:underline}._1n4yU{font-weight:500;font-size:10px;display:table-cell;vertical-align:middle}._1E6SP{font-weight:600;font-size:14px}._1E6SP,.o83ON{display:table-cell;vertical-align:middle;padding-left:4px}.o83ON{text-align:center}.o83ON>i{font-size:8px;border:1px solid #000;height:14px;width:14px;border-radius:14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-indent:5px}", ""]);

// exports
exports.locals = {
	"root": "Jpsyr",
	"prefix": "_1n4yU",
	"title": "_1E6SP",
	"icon": "o83ON"
};

/***/ }),

/***/ 1649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAnyLeasingAvailable; });
/* unused harmony export getLeasingTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__myAuto__ = __webpack_require__(1394);
/* unused harmony reexport isLeasingProposalAvailable */
/* unused harmony reexport isUlf24LeasingProposalAvailable */
/* unused harmony reexport isCreditmarketProposalAvailable */
/* unused harmony reexport isCreditmarketNotClearedProposalAvailable */
/* unused harmony reexport isCommonLeasingProposalAvailable */




var isAnyLeasingAvailable = function isAnyLeasingAvailable(advertData) {
  var isAvailable = __WEBPACK_IMPORTED_MODULE_0__myAuto__["f" /* isCommonLeasingProposalAvailable */](advertData);
  return isAvailable && (__WEBPACK_IMPORTED_MODULE_0__myAuto__["i" /* isLeasingProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["j" /* isUlf24LeasingProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["g" /* isCreditmarketNotClearedProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["h" /* isCreditmarketProposalAvailable */](advertData));
};

function getLeasingCreditmarketTitle(advertData, t) {
  var PRICE_UAH = advertData.is_not_cleared ? '300 000' : '140 000';
  var prefix = t('Профинансируем это авто');
  var title = PRICE_UAH + ' \u0433\u0440\u043D.';
  return { title: title, prefix: prefix };
}

function getLeasingRegularTitle(leasingParams, t) {
  var price = 0;
  if (leasingParams && leasingParams.extendedParams && leasingParams.extendedParams.hapai) {
    price = leasingParams.extendedParams.hapai.monthlyPaymentUAHFormatted;
  } else if (leasingParams && leasingParams.extendedParams) {
    price = leasingParams.extendedParams.monthlyPaymentUAHFormatted;
  }

  var symbol = 'грн'; // getSymbolTitleBySlug(currencySlug);
  var moth = t('мес');
  var title = price + ' ' + symbol + '/' + moth;
  return { title: title, prefix: '' };
}

var getLeasingTitle = function getLeasingTitle(advertData, leasingParams, t) {
  if (__WEBPACK_IMPORTED_MODULE_0__myAuto__["g" /* isCreditmarketNotClearedProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["h" /* isCreditmarketProposalAvailable */](advertData)) {
    return getLeasingCreditmarketTitle(advertData, t);
  }
  if (__WEBPACK_IMPORTED_MODULE_0__myAuto__["j" /* isUlf24LeasingProposalAvailable */](advertData) || __WEBPACK_IMPORTED_MODULE_0__myAuto__["i" /* isLeasingProposalAvailable */](advertData)) {
    return getLeasingRegularTitle(leasingParams, t);
  }
  return '';
};

/***/ }),

/***/ 1657:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_Icons__["t" /* VipIcon */], {});

function AdvertLabel(props) {
  var advert = props.advert,
      positin = props.positin;

  if (!advert.top_date && !advert.vip_date) return null;
  var posName = 'position-' + positin;
  var posClass = __WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a[posName] && _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a[posName], true) || {};
  if (__WEBPACK_IMPORTED_MODULE_5_shared_helpers_advert__["g" /* isVIP */](advert)) return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a.vip, posClass)
  }, void 0, _ref2, 'VIP');
  if (__WEBPACK_IMPORTED_MODULE_5_shared_helpers_advert__["f" /* isTop */](advert)) return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a.top, posClass)
  }, void 0, '\u0422\u041E\u041F');
  return null;
}

AdvertLabel.defaultProps = {
  positin: 'topRight'
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__AdvertLabel_css___default.a)(AdvertLabel));

/***/ }),

/***/ 1658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






function PriceUsdEuro(props) {
  var prices = [];
  ['uah', 'usd', 'eur'].forEach(function (key) {
    if (props[key]) prices.push(key);
  });

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css___default.a.root
  }, void 0, prices.map(function (key, idx) {
    return _jsx('span', {
      'data-currency': key,
      className: __WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css___default.a.currency
    }, key, props[key], ' ', idx !== prices.length - 1 ? ' • ' : '');
  }));
}

PriceUsdEuro.defaultProps = {
  uah: '',
  usd: '',
  eur: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__PriceUsdEuro_css___default.a)(PriceUsdEuro));

/***/ }),

/***/ 1663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildJournalListingUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildJournalItemUrl; });
/* unused harmony export buildStoVoteLink */
/* JOURNAL */

var genericJournalUrlBuilder = function genericJournalUrlBuilder(slug, tagSlug) {
  return '/zhurnal/' + (slug ? slug + '/' : '') + (tagSlug ? '?tag=' + tagSlug : '');
};

var buildJournalListingUrl = function buildJournalListingUrl(rubrics, rubric, tagSlug) {
  var rubricOrDefault = rubric || rubrics[0];

  return genericJournalUrlBuilder(rubricOrDefault.id === rubrics[0].id ? null : rubricOrDefault.seo_slug, tagSlug);
};

var buildJournalItemUrl = function buildJournalItemUrl(itemSlug, tagSlug) {
  return genericJournalUrlBuilder(itemSlug, tagSlug);
};

/* HOME */

var buildStoVoteLink = function buildStoVoteLink(companyID) {
  return 'https://sto.avtobazar.ua/vote/' + companyID + '/';
};

/***/ }),

/***/ 1699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_creditmarket__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__UserDataForm_UserDataForm__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__UserDataForm_UserDataFormWithPhotoDialogWrapper__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















// import FormInput from './Inputs/FormInput';





// eslint-disable-next-line css-modules/no-unused-class


var CreditMarketBanner = function (_React$Component) {
  _inherits(CreditMarketBanner, _React$Component);

  function CreditMarketBanner(props) {
    _classCallCheck(this, CreditMarketBanner);

    var _this = _possibleConstructorReturn(this, (CreditMarketBanner.__proto__ || Object.getPrototypeOf(CreditMarketBanner)).call(this, props));

    _initialiseProps.call(_this);

    var user = _this.props.user;

    var userName = user && user.name || '';
    var phone = user && user.phones && user.phones[0].number || '';

    _this.state = {
      userName: userName,
      birthday: '',
      phone: phone,
      errorMessage: '',
      successMessage: '',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false
    };
    return _this;
  }

  _createClass(CreditMarketBanner, [{
    key: 'render',
    value: function render() {
      var _cs;

      var _props = this.props,
          t = _props.t,
          advert = _props.advert;

      var PRICE_UAH = advert.is_not_cleared ? '300 000' : '140 000';

      var titleHTML = t('Финансируем') + '<br /> \u0434\u043E <b> ' + PRICE_UAH + ' \u0433\u0440\u043D. </b><br /> ' + t('на этот автомобиль');
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cs = {}, _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css___default.a.container, true), _defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css___default.a.LeasingContainerContentSidebar, !this.props.modalMode), _cs))
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16__UserDataForm_UserDataFormWithPhotoDialogWrapper__["a" /* default */], {
        advertInfo: this.props.advert,
        showTitle: !this.props.modalMode,
        titleHTML: titleHTML
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15__UserDataForm_UserDataForm__["a" /* default */], {
        disableBtnLeasing: this.state.disableSubmit,
        userName: this.state.userName,
        phone: this.state.phone,
        birthday: this.state.birthday,
        errorMessage: this.state.errorMessage,
        successMessage: this.state.successMessage,
        changeHandler: this.changeHandler,
        onSubmitHandler: this.onSubmitUesrDataForm
      })));
    }
  }]);

  return CreditMarketBanner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CreditMarketBanner.defaultProps = {
  eventPostfix: '',
  modalMode: true,
  onSubmited: function onSubmited() {},
  user: null
  // isNotCleared: false,
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSubmitUesrDataForm = function (e) {
    e.preventDefault();
    var _props2 = _this2.props,
        enqueueNotif = _props2.enqueueNotif,
        t = _props2.t;
    var _state = _this2.state,
        phone = _state.phone,
        userName = _state.userName;

    var errorMsg = __WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_utils__["l" /* userFormValidation */]({ phone: phone, userName: userName });
    if (errorMsg) {
      _this2.setState({ errorMessage: errorMsg });
      return;
    }

    _this2.pushEvent('consultation-form-sumbit');
    _this2.setState({ disableSubmit: true });
    _this2.Submit(function (data) {
      _this2.setState({ disableSubmit: false });
      var toState = {
        userName: '',
        phone: '',
        errorMessage: !data || data.result !== 'ok' ? 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже' : '',
        successMessage: ''
      };

      _this2.setState(toState);
      if (data && data.result === 'ok') {
        enqueueNotif(t('Заявка отправлена'));
        _this2.pushEvent('lead-create-success');
      } else {
        enqueueNotif(t('Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'));
        _this2.pushEvent('lead-create-fail');
      }
      _this2.props.onSubmited();
    });
  };

  this.Submit = function (cb) {
    var _state2 = _this2.state,
        phone = _state2.phone,
        userName = _state2.userName;
    var _props3 = _this2.props,
        advert = _props3.advert,
        fetch = _props3.fetch;


    var params = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_creditmarket__["a" /* prepareParamsForCreditMarketRequest */](_extends({}, advert, { phone: phone, userName: userName }));
    __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_creditmarket__["b" /* sendCreditMarket */](params, fetch).then(function (data) {
      return cb(data);
    }).catch(function () {
      return cb(false);
    });
  };

  this.changeHandler = function (field, value) {
    var _this2$setState;

    _this2.setState((_this2$setState = {}, _defineProperty(_this2$setState, field, value), _defineProperty(_this2$setState, 'errorMessage', ''), _this2$setState));
  };

  this.pushEvent = function (eventName) {
    if (eventName === 'lead-create-success') {
      __WEBPACK_IMPORTED_MODULE_11_shared_helpers_rtbHouse__["a" /* fireRTBEvent */]('leasingOld', {
        value: _this2.props.advert.price && __WEBPACK_IMPORTED_MODULE_12_shared_helpers_advert__["c" /* getPrice */](_this2.props.advert.price),
        ids: [_this2.props.advert.id]
      });
    }

    var eventPostfix = _this2.props.eventPostfix;

    var event = 'creditmarket-' + eventName + (eventPostfix ? '-' + eventPostfix : '');
    if (__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]) _this2.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_6_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]);else {}
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user && state.user.user
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    enqueueNotif: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_10_shared_actions_notifications__["a" /* enqueueNotification */], dispatch),
    setDataLayer: __WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */](__WEBPACK_IMPORTED_MODULE_7_shared_actions_globals__["j" /* setDataLayer */], dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_17__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_9_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withTranslate__["a" /* withTranslate */](__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(CreditMarketBanner)))));

/***/ }),

/***/ 1700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prepareParamsForCreditMarketRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendCreditMarket; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1277);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var prepareParamsForCreditMarketRequest = function prepareParamsForCreditMarketRequest(params) {
  return {
    advertId: params.id,
    city: params.location && params.location.title,
    year: params.year,
    name: params.userName,
    make: params.make && params.make.title,
    model: params.model && params.model.title,
    phone: params.phone,
    sum: Math.round(__WEBPACK_IMPORTED_MODULE_2_shared_helpers_transportInfo__["n" /* getPriceValueBySlug */](params.price, 'uah')),
    url: __WEBPACK_IMPORTED_MODULE_1_shared_helpers_urls__["g" /* generateUrl */](params)
  };
};

var sendCreditMarket = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, fetch) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* execPostRequest */](__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ADVERT.CREDIT_MARKET.ADD, params, fetch));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function sendCreditMarket(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 1710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/SimpleLeasingCard/SimpleLeasingCard.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function SimpleLeasingCard(props) {
  var fullPrice = props.fullPrice,
      year = props.year,
      mileageText = props.mileageText,
      engineTitle = props.engineTitle,
      gearboxTitle = props.gearboxTitle,
      make = props.make,
      maker = props.maker,
      model = props.model,
      advert = props.advert;


  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.root
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.info
  }, void 0, year && _jsx('span', {}, void 0, year), mileageText && _jsx('span', {}, void 0, mileageText)), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.info
  }, void 0, engineTitle && _jsx('span', {}, void 0, engineTitle || ''), gearboxTitle && _jsx('span', {}, void 0, gearboxTitle || '')), fullPrice && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a.price
  }, void 0, fullPrice));
}

SimpleLeasingCard.defaultProps = {
  fullPrice: null,
  engineTitle: null,
  gearboxTitle: null,
  year: null,
  maker: null,
  mileageText: null
};


/* harmony default export */ var SimpleLeasingCard_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__SimpleLeasingCard_css___default.a)(SimpleLeasingCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/SimilarLeasingCard/SimilarLeasingCard.js
/* harmony import */ var SimilarLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var SimilarLeasingCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(SimilarLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css__);
var SimilarLeasingCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






// import LeasingButton from 'shared/components/LeasingOnlineBanner/LeasingButton/LeasingButton';




function SimilarLeasingCard(props) {
  var advert = props.advert,
      year = props.year,
      make = props.make,
      maker = props.maker,
      model = props.model,
      shouldEmphasizePrice = props.shouldEmphasizePrice,
      isNegotiablePrice = props.isNegotiablePrice,
      intl = props.intl,
      index = props.index;


  return SimilarLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a.root
  }, void 0, SimilarLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title, ' '), advert && !isNegotiablePrice && SimilarLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a.leasingButton
  }, void 0, SimilarLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__["a" /* default */], {
    advert: advert,
    index: index
  })), isNegotiablePrice && SimilarLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a.contractPrice)
  }, void 0, intl.formatMessage({ id: 'договорная' })));
}

SimilarLeasingCard.defaultProps = {
  fullPrice: null,
  year: null,
  shouldEmphasizePrice: false,
  isNegotiablePrice: false,
  index: 0
};


/* harmony default export */ var SimilarLeasingCard_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__SimilarLeasingCard_css___default.a)(SimilarLeasingCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/DealerAdsLeasingCard/DealerAdsLeasingCard.js
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css__);
var DealerAdsLeasingCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function DealerAdsLeasingCard(props) {
  var fullPrice = props.fullPrice,
      year = props.year,
      make = props.make,
      maker = props.maker,
      model = props.model;


  return DealerAdsLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a.root
  }, void 0, DealerAdsLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title, ' ', DealerAdsLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a.similarYear
  }, void 0, year)), fullPrice && DealerAdsLeasingCard__jsx('div', {
    className: DealerAdsLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a.similarPrice)
  }, void 0, fullPrice));
}

DealerAdsLeasingCard.defaultProps = {
  year: null,
  fullPrice: null
};


/* harmony default export */ var DealerAdsLeasingCard_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__DealerAdsLeasingCard_css___default.a)(DealerAdsLeasingCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/PromoutedLeasingCard/PromoutedLeasingCard.js
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_PriceUah_PriceUah__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_PriceUsdEuro_PriceUsdEuro__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_leasing_leasing__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css__);
var PromoutedLeasingCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();












// import LeasingWithCalculatorButton from 'shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton';
// import MicroCreditButton from 'shared/components/LeasingOnlineBanner/MicroCreditButton/MicroCreditButton';






var _ref = PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["b" /* CalendarIcon */], {});

var PromoutedLeasingCard__ref2 = PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["o" /* SpeedIcon */], {});

var _ref3 = PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["f" /* EngineIcon */], {});

var _ref4 = PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Icons__["h" /* GearboxIcon */], {});

function PromoutedLeasingCard(props) {
  var advert = props.advert,
      fullPrice = props.fullPrice,
      year = props.year,
      mileageText = props.mileageText,
      engineTitle = props.engineTitle,
      gearboxTitle = props.gearboxTitle,
      make = props.make,
      maker = props.maker,
      model = props.model,
      shouldEmphasizePrice = props.shouldEmphasizePrice,
      isNegotiablePrice = props.isNegotiablePrice,
      intl = props.intl,
      priceUAH = props.priceUAH,
      priceUSD = props.priceUSD,
      priceEUR = props.priceEUR,
      index = props.index;


  var isLeasing = __WEBPACK_IMPORTED_MODULE_10_shared_helpers_leasing_leasing__["a" /* isAnyLeasingAvailable */](advert);

  var priceTheme = isLeasing ? 'small' : 'yellow';

  return PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.root
  }, void 0, PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.container
  }, void 0, PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.title
  }, void 0, maker && maker.title || make && make.title, ' ', model && model.title), PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.info
  }, void 0, year && PromoutedLeasingCard__jsx('span', {}, void 0, _ref, year), mileageText && PromoutedLeasingCard__jsx('span', {}, void 0, PromoutedLeasingCard__ref2, mileageText)), PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.info
  }, void 0, engineTitle && PromoutedLeasingCard__jsx('span', {}, void 0, _ref3, engineTitle || ''), gearboxTitle && PromoutedLeasingCard__jsx('span', {}, void 0, _ref4, gearboxTitle || ''))), isLeasing && !isNegotiablePrice && PromoutedLeasingCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.leasingButton
  }, void 0, PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_9_shared_components_LeasingOnlineBanner_LeasingButtonWrapper_LeasingButtonWrapper__["a" /* default */], {
    advert: advert,
    index: index
  })), PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_PriceUah_PriceUah__["a" /* default */], {
    uah: __WEBPACK_IMPORTED_MODULE_8_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'uah'),
    theme: priceTheme
  }), !isNegotiablePrice && PromoutedLeasingCard__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_PriceUsdEuro_PriceUsdEuro__["a" /* default */], {
    usd: __WEBPACK_IMPORTED_MODULE_8_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'usd'),
    eur: __WEBPACK_IMPORTED_MODULE_8_shared_helpers_transportInfo__["m" /* getPriceBySlug */](advert.price, 'eur')
  }), isNegotiablePrice && PromoutedLeasingCard__jsx('div', {
    className: PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a.price)
  }, void 0, intl.formatMessage({ id: 'договорная' })));
}

PromoutedLeasingCard.defaultProps = {
  fullPrice: null,
  mileageText: null,
  engineTitle: '',
  gearboxTitle: '',
  abroadTitle: '',
  drivenFromTitle: '',
  shouldEmphasizePrice: false,
  isNegotiablePrice: false,
  priceUAH: '0',
  priceUSD: '0',
  priceEUR: '0',
  index: 0
};


/* harmony default export */ var PromoutedLeasingCard_defaultExport = (PromoutedLeasingCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_11__PromoutedLeasingCard_css___default.a)(PromoutedLeasingCard));
// CONCATENATED MODULE: ./src/desktop/components/AdvertCarCard/AdvertCarCard.js
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(AdvertCarCard___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var AdvertCarCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(AdvertCarCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_helpers_urls__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_mileageUnits_json__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_mileageUnits_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_constants_json_mileageUnits_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_defaultImages__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_components_AdvertLabel_AdvertLabel__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Thumb_Thumb__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var AdvertCarCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























// eslint-disable-next-line css-modules/no-unused-class


var UAH_CURRENCY = __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default.a.find(function (currency) {
  return currency.slug === 'uah';
});
var USD_CURRENCY = __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default.a.find(function (currency) {
  return currency.slug === 'usd';
});
var EUR_CURRENCY = __WEBPACK_IMPORTED_MODULE_10_shared_constants_json_currency_json___default.a.find(function (currency) {
  return currency.slug === 'eur';
});

var AdvertCarCard_AdvertCarCard = function (_React$Component) {
  _inherits(AdvertCarCard, _React$Component);

  function AdvertCarCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AdvertCarCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdvertCarCard.__proto__ || Object.getPrototypeOf(AdvertCarCard)).call.apply(_ref, [this].concat(args))), _this), _this.buildCarPrice = function (prices, currency) {
      if (!Array.isArray(prices)) {
        return null;
      }

      var priceObj = prices.find(function (price) {
        return price.currency === currency.slug;
      });
      return AdvertCarCard__jsx('span', {}, void 0, priceObj && __WEBPACK_IMPORTED_MODULE_8_shared_helpers_common__["k" /* numberWithSpaces */](priceObj.value), ' ', AdvertCarCard__jsx('small', {}, void 0, currency && currency.title));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdvertCarCard, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          advertClassName = _props.advertClassName,
          advertThumbClassName = _props.advertThumbClassName,
          advertStyle = _props.advertStyle,
          imageStyle = _props.imageStyle,
          currency = _props.currency,
          advert = _props.advert,
          cardType = _props.cardType,
          width = _props.width,
          _props$advert = _props.advert,
          _props$advert$maker = _props$advert.maker,
          maker = _props$advert$maker === undefined ? '' : _props$advert$maker,
          _props$advert$make = _props$advert.make,
          make = _props$advert$make === undefined ? '' : _props$advert$make,
          _props$advert$model = _props$advert.model,
          model = _props$advert$model === undefined ? '' : _props$advert$model,
          _props$advert$year = _props$advert.year,
          year = _props$advert$year === undefined ? '' : _props$advert$year,
          _props$advert$mileage = _props$advert.mileage,
          mileage = _props$advert$mileage === undefined ? '' : _props$advert$mileage,
          _props$advert$mileage2 = _props$advert.mileage_unit,
          mileageUnitTempId = _props$advert$mileage2 === undefined ? 0 : _props$advert$mileage2,
          _props$advert$engine = _props$advert.engine,
          engine = _props$advert$engine === undefined ? '' : _props$advert$engine,
          _props$advert$gearbox = _props$advert.gearbox,
          gearbox = _props$advert$gearbox === undefined ? '' : _props$advert$gearbox,
          _props$advert$price = _props$advert.price,
          price = _props$advert$price === undefined ? '' : _props$advert$price,
          _props$advert$charact = _props$advert.characteristics,
          characteristics = _props$advert$charact === undefined ? '' : _props$advert$charact,
          transport = _props$advert.transport,
          colorDate = _props$advert.color_date,
          isNew = _props$advert.is_new,
          clarifyPriceLink = _props$advert.clarify_price_link,
          isNegotiablePrice = _props$advert.is_negotiable_price,
          linkFromProps = _props.link,
          intl = _props.intl,
          lensEvent = _props.lensEvent,
          index = _props.index;


      var link = linkFromProps || '/' + __WEBPACK_IMPORTED_MODULE_6_shared_helpers_urls__["g" /* generateUrl */](advert);
      var fullPrice = clarifyPriceLink ? null : this.buildCarPrice(price, currency) || __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["a" /* carPrice */](price, currency.slug);

      var mileageUnitId = mileageUnitTempId || 0;
      var engineTitle = engine ? engine.title : characteristics && characteristics.engine && characteristics.engine.title;
      var gearboxTitle = gearbox ? gearbox.title : characteristics && characteristics.gearbox && characteristics.gearbox.title;

      var mileageUnit = __WEBPACK_IMPORTED_MODULE_11_shared_constants_json_mileageUnits_json___default.a.find(function (unit) {
        return unit.id === mileageUnitId;
      });

      var defaultImage = this.props.defaultImage || __WEBPACK_IMPORTED_MODULE_12_shared_constants_defaultImages__["b" /* getDefaultImageByType */](transport);
      var shouldEmphasizePrice = colorDate ? new Date(colorDate) > new Date() : false;

      var mileageUnitTitle = mileageUnit && mileageUnit.title && intl.formatMessage({ id: mileageUnit.title }) || '';

      var mileageText = mileage > 0 ? mileage + ' ' + mileageUnitTitle : null;

      var priceUAH = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["b" /* carPriceBySlug */](price, UAH_CURRENCY);
      var priceUSD = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["b" /* carPriceBySlug */](price, USD_CURRENCY);
      var priceEUR = __WEBPACK_IMPORTED_MODULE_7_shared_helpers_transportInfo__["b" /* carPriceBySlug */](price, EUR_CURRENCY);

      if (isNew) {
        mileageText = intl.formatMessage({ id: 'Новый' });
      }

      var sharedProps = {
        advert: advert,
        maker: maker,
        make: make,
        model: model,
        year: year,
        fullPrice: fullPrice,
        shouldEmphasizePrice: shouldEmphasizePrice,
        isNegotiablePrice: isNegotiablePrice,
        intl: intl,
        priceUAH: priceUAH,
        priceUSD: priceUSD,
        priceEUR: priceEUR
      };

      var _ref2 = AdvertCarCard__jsx(SimpleLeasingCard_defaultExport, {
        make: make,
        model: model
      });

      var renderSwitchParams = function renderSwitchParams() {
        switch (cardType && cardType.toLowerCase()) {
          case 'similar':
            {
              return AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimilarLeasingCard_defaultExport, _extends({}, sharedProps, { index: index }));
            }
          case 'dealerads':
            {
              return AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DealerAdsLeasingCard_defaultExport, sharedProps);
            }
          case 'simple':
            {
              return AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleLeasingCard_defaultExport, _extends({}, sharedProps, {
                mileageText: mileageText,
                engineTitle: engineTitle || '',
                gearboxTitle: gearboxTitle || ''
              }));
            }
          case 'brick':
            {
              return _ref2;
            }
          default:
            {
              return AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PromoutedLeasingCard_defaultExport, _extends({}, sharedProps, {
                index: index,
                mileageText: mileageText,
                engineTitle: engineTitle || '',
                gearboxTitle: gearboxTitle || ''
              }));
            }
        }
      };
      var carTypeStyle = cardType.toLowerCase() || 'promoutedcard';
      return AdvertCarCard__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.root,
        style: advertStyle
      }, void 0, AdvertCarCard__jsx('div', {
        className: AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(advertClassName, (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a[carTypeStyle], !!__WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a[carTypeStyle]), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.isVip, __WEBPACK_IMPORTED_MODULE_9_shared_helpers_advert__["g" /* isVIP */](advert)), _cx))
      }, void 0, AdvertCarCard__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.thumb
      }, void 0, AdvertCarCard__jsx(__WEBPACK_IMPORTED_MODULE_18__Thumb_Thumb__["a" /* default */], {
        photos: advert.photos,
        link: link,
        style: imageStyle,
        className: advertThumbClassName,
        width: width,
        defaultImg: defaultImage,
        lensEvent: lensEvent
      }, Math.random())), AdvertCarCard__jsx('div', {
        className: AdvertCarCard___WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.subInfo, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.brick, cardType && cardType.toLowerCase() === 'brick'))
      }, void 0, renderSwitchParams()), AdvertCarCard__jsx(__WEBPACK_IMPORTED_MODULE_13_shared_components_AdvertLabel_AdvertLabel__["a" /* default */], {
        advert: advert
      }), link && AdvertCarCard__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
        to: link,
        className: __WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a.link,
        'data-lens-event': lensEvent
      })));
    }
  }]);

  return AdvertCarCard;
}(AdvertCarCard___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AdvertCarCard_AdvertCarCard.defaultProps = {
  advertStyle: {},
  imageStyle: {},
  currency: UAH_CURRENCY,
  lensEvent: '',
  advertClassName: '',
  advertThumbClassName: '',
  cardType: '',
  width: 240,
  link: null,
  leasingParams: null,
  defaultImage: null,
  index: 0
};


/* harmony default export */ __webpack_exports__["a"] = (AdvertCarCard___WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_19__AdvertCarCard_css___default.a)(AdvertCarCard___WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](AdvertCarCard_AdvertCarCard)));

/***/ }),

/***/ 1711:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1712);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertLabel.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertLabel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1712:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2vLk7,._GdKl{height:18px;border-radius:2px;font-size:10px;line-height:12px;text-align:center;text-transform:uppercase;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#000!important}._1UkdP{position:absolute;right:5px;top:5px}._2vLk7:hover,._GdKl:hover{color:#000!important}._GdKl{width:35px;background:-webkit-gradient(linear,left bottom,left top,from(rgba(255,217,6,.6)),to(rgba(255,217,6,.6))),#fff;background:-o-linear-gradient(bottom,rgba(255,217,6,.6),rgba(255,217,6,.6)),#fff;background:linear-gradient(0deg,rgba(255,217,6,.6),rgba(255,217,6,.6)),#fff;font-weight:600}._2vLk7{width:38px;background:#ffd906;padding:3px}._2vLk7 svg{margin-right:3px}", ""]);

// exports
exports.locals = {
	"vip": "_2vLk7",
	"top": "_GdKl",
	"position-topRight": "_1UkdP",
	"position-none": "_1UCZh"
};

/***/ }),

/***/ 1713:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1714);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PriceUah.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PriceUah.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2izCF{font-size:14px;line-height:17px;color:#000;margin-bottom:5px}._3TQ81{font-weight:700;padding:5px;border-radius:2px;color:#000;font-weight:600;font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:111px;background:#ffd906}", ""]);

// exports
exports.locals = {
	"small": "_2izCF",
	"yellow": "_3TQ81"
};

/***/ }),

/***/ 1715:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1716);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DialogContainer.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DialogContainer.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1716:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1F-fD{background-color:#fff;-ms-flex-item-align:center;align-self:center;position:relative;-webkit-box-shadow:0 0 30px rgba(0,0,0,.15);box-shadow:0 0 30px rgba(0,0,0,.15);border-radius:3px;max-width:320px;overflow-y:auto;max-height:100vh;margin:0 auto}._1xv5j{padding:20px 15px}._-5-3g{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}", ""]);

// exports
exports.locals = {
	"root": "_1F-fD",
	"container": "_1xv5j",
	"closeBtnIcon": "_-5-3g"
};

/***/ }),

/***/ 1717:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1718);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ToolTipWrapper.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ToolTipWrapper.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1718:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1hlHK{z-index:122;right:-333px;top:0}._1hlHK,.e3SJp{position:absolute}.e3SJp{width:0;height:0;border-style:solid;border-color:transparent #fff transparent transparent;top:20px;border-width:12px 12px 12px 0;left:-12px}", ""]);

// exports
exports.locals = {
	"root": "_1hlHK",
	"corner": "e3SJp"
};

/***/ }),

/***/ 1719:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1720);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingWithCalculatorButton.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingWithCalculatorButton.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1720:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2XcG5{display:inline-block;font-weight:700;padding:5px;border-radius:2px;color:#000;font-weight:600;font-size:16px;background:#ffd906;cursor:pointer;z-index:6;position:relative}._2XcG5:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"priceMonthly": "_2XcG5"
};

/***/ }),

/***/ 1721:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1722);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PriceUsdEuro.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PriceUsdEuro.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1722:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3jTcs{margin-bottom:5px}._3TnWH{font-size:12px;font-weight:400;line-height:14px;color:gray}", ""]);

// exports
exports.locals = {
	"root": "_3jTcs",
	"currency": "_3TnWH"
};

/***/ }),

/***/ 1753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var JsonLdApplication = function JsonLdApplication(data) {
  return _jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: { __html: JSON.stringify(data) }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (JsonLdApplication);

/***/ }),

/***/ 1754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/desktop/components/Carousel/SlideList.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var SlideList = function SlideList(_ref) {
  var items = _ref.items,
      marginLeft = _ref.marginLeft,
      sliderCN = _ref.sliderCN,
      containerCN = _ref.containerCN,
      inputRef = _ref.inputRef;
  return _jsx('div', {
    className: containerCN
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { ref: inputRef, style: { transform: 'translateX(-' + marginLeft + 'px)' }, className: sliderCN },
    items
  ));
};

SlideList.defaultProps = {
  items: [],
  marginLeft: 0,
  sliderCN: '',
  containerCN: ''
};

/* harmony default export */ var SlideList_defaultExport = (SlideList);
// CONCATENATED MODULE: ./src/desktop/components/Carousel/Carousel.js
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Carousel___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Carousel___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Carousel_css__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Carousel_css__);
var Carousel__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Carousel_Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Carousel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      index: 0,
      slidesInfo: []
    }, _this.getChildrenArray = function (item) {
      if (!item.children || item.children.length === 0) {
        return [];
      } else if (item.children.length === 1) {
        return _this.getChildrenArray(item.children[0]);
      }

      return [].concat(_toConsumableArray(item.children));
    }, _this.getFullWidth = function (elem) {
      var _getComputedStyle = getComputedStyle(elem),
          marginLeft = _getComputedStyle.marginLeft,
          marginRight = _getComputedStyle.marginRight;

      return [elem.offsetWidth, marginLeft, marginRight].map(function (i) {
        return parseFloat(i);
      }).reduce(function (result, current) {
        return result + current;
      }, 0);
    }, _this.getSlidesWidth = function (arr) {
      return arr.reduce(function (width, slide) {
        return width + slide.fullWidth;
      }, 0);
    }, _this.setSlidesInfo = function (slidesInfo) {
      _this.setState({ slidesInfo: slidesInfo });
    }, _this.handleNextClick = function () {
      var _this$props = _this.props,
          step = _this$props.step,
          loop = _this$props.loop,
          itemsInRow = _this$props.itemsInRow,
          slideCount = _this$props.items.length;


      _this.setState(function (_ref2) {
        var index = _ref2.index;

        var nextIndex = index + step > slideCount ? slideCount : index + step;
        return {
          index: loop && index >= slideCount - itemsInRow ? 0 : nextIndex
        };
      });
    }, _this.handlePrevClick = function () {
      var _this$props2 = _this.props,
          step = _this$props2.step,
          loop = _this$props2.loop,
          itemsInRow = _this$props2.itemsInRow,
          slideCount = _this$props2.items.length;


      _this.setState(function (_ref3) {
        var index = _ref3.index;

        var nextIndex = index - step < 0 ? 0 : index - step;
        return {
          index: loop && index === 0 ? slideCount - itemsInRow : nextIndex
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var slidesInfo = this.getChildrenArray(this.carousel).map(function (slide) {
        return {
          fullWidth: _this2.getFullWidth(slide)
        };
      });

      this.setSlidesInfo(slidesInfo);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.items !== nextProps.items) {
        this.setState({ index: 0 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          index = _state.index,
          slidesInfo = _state.slidesInfo;
      var _props = this.props,
          loop = _props.loop,
          items = _props.items,
          itemsInRow = _props.itemsInRow,
          itemsPosition = _props.itemsPosition,
          header = _props.header,
          _props$classNames = _props.classNames,
          _props$classNames$mai = _props$classNames.main,
          mainCN = _props$classNames$mai === undefined ? '' : _props$classNames$mai,
          _props$classNames$hea = _props$classNames.header,
          headerCN = _props$classNames$hea === undefined ? '' : _props$classNames$hea,
          bodyCN = _props$classNames.body,
          _props$classNames$sli = _props$classNames.slider,
          sliderCN = _props$classNames$sli === undefined ? '' : _props$classNames$sli;


      var maxLeft = this.carousel && this.getSlidesWidth(slidesInfo) - this.carousel.parentNode.offsetWidth;
      var left = this.getSlidesWidth(slidesInfo.slice(0, index));
      var marginLeft = Math.min(maxLeft, left);
      var roundMarginLeft = maxLeft - marginLeft < 20 ? maxLeft : marginLeft;

      return Carousel__jsx('div', {
        className: mainCN || __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carousel
      }, void 0, Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(headerCN && headerCN, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselHeader)
      }, void 0, header, Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselHeaderContent
      }, void 0, itemsPosition === 'header' && Carousel__jsx(SlideList_defaultExport, {
        items: items,
        marginLeft: roundMarginLeft,
        containerCN: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselContainer,
        sliderCN: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselSlider,
        inputRef: function inputRef(item) {
          _this3.carousel = item;
        }
      })), itemsInRow < items.length && Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselNav
      }, void 0, Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselNavButton, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.disabled, marginLeft === 0 && !loop)),
        onClick: marginLeft > 0 || loop ? this.handlePrevClick : null
      }, void 0, Carousel__jsx('i', {
        className: 'fa fa-angle-left ' + __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.icon
      })), Carousel__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselNavButton, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.disabled, marginLeft >= maxLeft && !loop)),
        onClick: marginLeft < maxLeft || loop ? this.handleNextClick : null
      }, void 0, Carousel__jsx('i', {
        className: 'fa fa-angle-right ' + __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.icon
      })))), Carousel__jsx('div', {
        className: bodyCN || __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselBody
      }, void 0, itemsPosition === 'body' && Carousel__jsx(SlideList_defaultExport, {
        items: items,
        marginLeft: marginLeft,
        containerCN: __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselContainer,
        sliderCN: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(sliderCN && sliderCN, __WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a.carouselSlider),
        inputRef: function inputRef(item) {
          _this3.carousel = item;
        }
      })));
    }
  }]);

  return Carousel;
}(Carousel___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel_Carousel.defaultProps = {
  step: 1,
  itemsInRow: 1,
  itemsPosition: 'body',
  header: '',
  items: [],
  classNames: {},
  loop: false
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__Carousel_css___default.a)(Carousel_Carousel));

/***/ }),

/***/ 1756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setJournalNews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setVideoTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setOrderingField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setVideoFilters; });
/* unused harmony export setSelectedVideoParams */
/* unused harmony export setSelectedVideoData */
/* unused harmony export videoCounter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__ = __webpack_require__(17);


var defaultVideoFilters = {
  make: null,
  model: null,
  generation: null,
  topic: null
};

var setJournalNews = function setJournalNews(news) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_NEWS,
    payload: news
  };
};

var setVideoTopics = function setVideoTopics(topics) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_TOPICS,
    payload: topics
  };
};

var setOrderingField = function setOrderingField(selectedHeadFilter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_HEAD_FILTER,
    payload: selectedHeadFilter
  };
};

var setVideoFilters = function setVideoFilters() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultVideoFilters;
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_VIDEO_FILTERS,
    payload: filters
  };
};

var setSelectedVideoParams = function setSelectedVideoParams(params) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_SELECTED_VIDEO_PARAMS,
    payload: params
  };
};

var setSelectedVideoData = function setSelectedVideoData(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants_actionTypes__["i" /* JOURNAL */].SET_SELECTED_VIDEO_DATA,
    payload: data
  };
};

var videoCounter = function videoCounter(postId) {
  return function (dispatch, getState, _ref) {
    var fetch = _ref.fetch;

    var userId = getState().user.user.id;
    var counterRequest = {
      event: 'view',
      fingerprint: getState().globals.fingerprint,
      object_id: postId,
      object_type: 'post'
    };

    if (userId) counterRequest.user_id = userId;

    fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.SET_STATS(), {
      method: 'POST',
      body: JSON.stringify(counterRequest)
    }).then(function (packages) {
      if (packages.status === 200) {
        return packages.json();
      }
      return null;
    });
    return Promise.resolve();
  };
};

var getVideoContent = function getVideoContent(fetch, dispatch, videoId) {
  return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].JOURNAL.ITEM(videoId)).then(function (r) {
    return r.json();
  }).then(function (results) {
    var content = Array.isArray(results) && results[0].content;
    dispatch(setSelectedVideoData(content));
    dispatch(videoCounter(results[0].id));
  });
};

var getVideoById = function getVideoById() {
  var videoParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return function (dispatch, getState, _ref2) {
    var fetch = _ref2.fetch;

    dispatch(setSelectedVideoParams(videoParams));

    if (videoParams) {
      getVideoContent(fetch, dispatch, videoParams.id);
    } else {
      dispatch(setSelectedVideoData(videoParams));
      dispatch(setSelectedVideoParams(videoParams));
    }
    return Promise.resolve();
  };
};

/***/ }),

/***/ 1759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CircleTimer_CircleTimer__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







// eslint-disable-next-line css-modules/no-unused-class


function RecallForm(props) {
  var t = props.t,
      recallTime = props.recallTime,
      timeUp = props.timeUp;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerCenter
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerCircleTimer
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__CircleTimer_CircleTimer__["a" /* default */], {
    time: recallTime,
    timeUp: timeUp
  })), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerTextBlock
  }, void 0, t('LEASING_FORM_RRECALL_5_MIN')));
}

RecallForm.defaultProps = {
  recallTime: 300,
  timeUp: function timeUp() {}
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](RecallForm)));

/***/ }),

/***/ 1763:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1764);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Carousel.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Carousel.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1764:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".Tw7dU{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;background:#fff;width:100%}._2iLsW{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2iLsW,._12NOM{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._12NOM{overflow:hidden}._20c36{padding:25px}._29nEX{display:block;width:100%;overflow:hidden}._7v6xR{display:-webkit-box;display:-ms-flexbox;display:flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;-webkit-transition:-webkit-transform .6s ease;transition:-webkit-transform .6s ease;-o-transition:transform .6s ease;transition:transform .6s ease;transition:transform .6s ease,-webkit-transform .6s ease}._3GXX0{padding-left:20px}._3GXX0,.TPhLD{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.TPhLD{cursor:pointer;border:1px solid #d0d0d0;width:30px;height:28px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:25px;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}.TPhLD:hover{border:1px solid #999;z-index:2}.TPhLD:first-of-type{border-radius:2px 0 0 2px}.TPhLD:last-of-type{border-radius:0 2px 2px 0;margin-left:-1px}._3etcP{position:relative;top:-1px;font-size:21px}._3ylzU{opacity:.5;cursor:default}", ""]);

// exports
exports.locals = {
	"carousel": "Tw7dU",
	"carouselHeader": "_2iLsW",
	"carouselHeaderContent": "_12NOM",
	"carouselBody": "_20c36",
	"carouselContainer": "_29nEX",
	"carouselSlider": "_7v6xR",
	"carouselNav": "_3GXX0",
	"carouselNavButton": "TPhLD",
	"icon": "_3etcP",
	"disabled": "_3ylzU"
};

/***/ }),

/***/ 1765:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1766);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimpleLeasingCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimpleLeasingCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1766:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._37pT9 span{margin-right:30px}._37pT9{position:relative;display:block;margin-bottom:4px;font-size:14px;color:#888;font-weight:400}._1lZf7{font-weight:700;margin-top:5px;display:inline-block;font-size:17px;padding:2px 0;border-radius:2px;color:#000}._2FUJ6:hover ._31Sad{color:#e73232}._31Sad{font-size:15px;font-weight:700;margin-bottom:4px}", ""]);

// exports
exports.locals = {
	"info": "_37pT9",
	"price": "_1lZf7",
	"root": "_2FUJ6",
	"title": "_31Sad"
};

/***/ }),

/***/ 1767:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1768);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimilarLeasingCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./SimilarLeasingCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1768:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3-CzP{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%;background:#f5f5f5}._3yx4B{font-size:14px;line-height:17px;margin-bottom:7px}._2ZnAI{font-weight:400;padding-top:4px}._3q_pQ{font-weight:400;margin-top:5px;display:inline-block;font-size:14px;color:#000}._1VLp2 small{font-size:70%;font-weight:400}.kn8hp{background-color:#ffeb3b}._3-CzP ._34aet>div{font-size:14px!important;line-height:14px!important;height:24px}._35cTu .microcredits{height:24px}._35cTu .microcredits>div{font-size:10px!important;line-height:10px!important}._35cTu .creditmarket>div:first-child{display:table-row;text-align:right}", ""]);

// exports
exports.locals = {
	"root": "_3-CzP",
	"title": "_3yx4B",
	"similarYear": "_2ZnAI",
	"contractPrice": "_3q_pQ",
	"similarPrice": "_1VLp2",
	"emphasizePrice": "kn8hp",
	"leasing": "_34aet",
	"leasingButton": "_35cTu"
};

/***/ }),

/***/ 1769:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1770);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerAdsLeasingCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./DealerAdsLeasingCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1770:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".wauWL{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%}._3iV59{font-size:14px;font-weight:700;margin-bottom:7px}._1IIwC,._2LeaN{font-weight:400}._2LeaN{display:inline-block;font-size:16px;color:#000}._2LeaN small{font-size:70%;font-weight:400}", ""]);

// exports
exports.locals = {
	"root": "wauWL",
	"title": "_3iV59",
	"similarYear": "_1IIwC",
	"similarPrice": "_2LeaN"
};

/***/ }),

/***/ 1771:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1772);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PromoutedLeasingCard.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./PromoutedLeasingCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1772:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3AdoX{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%}.CV9pu{width:100%;height:90px}._2QZ8G span{-webkit-box-flex:50%;-ms-flex:50% 1 0%;flex:50% 1 0%}._2QZ8G span svg{margin-right:5px}._2QZ8G{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:6px;font-size:12px;line-height:14px;color:gray}._3F7m7{font-style:normal;font-weight:500;font-size:16px;line-height:19px;color:#000;margin-bottom:8px;height:40px}._34z4P{background-color:#ffeb3b}._23cey{margin-top:5px;margin-bottom:5px;max-height:33px}", ""]);

// exports
exports.locals = {
	"root": "_3AdoX",
	"container": "CV9pu",
	"info": "_2QZ8G",
	"title": "_3F7m7",
	"emphasizePrice": "_34z4P",
	"leasingButton": "_23cey"
};

/***/ }),

/***/ 1773:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1774);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertCarCard.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AdvertCarCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1774:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2Oodu{padding:0 5px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1t-By,._2zWWe{border-radius:3px;background:#f5f5f5}._2zWWe{height:360px;position:relative}._1t-By{width:173px}._2zWWe._1RQRQ{background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.2)),to(rgba(253,191,0,.2))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff}._2zWWe:hover{-webkit-box-shadow:0 0 30px rgba(0,0,0,.15);box-shadow:0 0 30px rgba(0,0,0,.15);background:#fff}._1WT0N{text-align:center;vertical-align:middle;overflow:hidden;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;height:170px}._1t-By ._1WT0N{height:125px}._1t-By .XgIVu{height:85px}._2f8em{position:absolute;height:100%;width:100%;top:0;left:0}.XgIVu{position:relative;padding:10px}.VAwNC{position:absolute;top:0;left:0;right:0;width:100%;height:100%;color:#fff;padding:10px;background:#0004}._1WT0N:hover+.VAwNC{opacity:0}", ""]);

// exports
exports.locals = {
	"root": "_2Oodu",
	"isVip": "_1RQRQ",
	"similar": "_1t-By",
	"promoutedcard": "_2zWWe",
	"thumb": "_1WT0N",
	"subInfo": "XgIVu",
	"link": "_2f8em",
	"brick": "VAwNC"
};

/***/ }),

/***/ 1802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/CodeVerificationForm/CodeVerificationForm.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UI__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







// eslint-disable-next-line css-modules/no-unused-class


function CodeVerificationForm(props) {
  var codeVerification = props.codeVerification,
      t = props.t,
      changeHandler = props.changeHandler,
      onSubmitHandler = props.onSubmitHandler,
      errorMessage = props.errorMessage,
      successMessage = props.successMessage;

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.containerCenter
  }, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.containerVerifyText
  }, void 0, t('LEASING_FORM_CODE_VERIF_RQ_CODE')), _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.containerVerifyForm
  }, void 0, _jsx('form', {
    onSubmit: onSubmitHandler,
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.requestForm
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__UI__["e" /* InputText */], {
    name: 'codeVerification',
    value: codeVerification,
    placeholder: codeVerification || t('Введите пароль'),
    changeHandler: changeHandler
  }), (errorMessage || successMessage) && _jsx('span', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.errorMessage, errorMessage), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a.successMessage, successMessage))
  }, void 0, t(errorMessage || successMessage)), _jsx(__WEBPACK_IMPORTED_MODULE_5__UI__["a" /* Button */], {
    type: 'submit',
    text: t('Отправить')
  }))));
}

/* harmony default export */ var CodeVerificationForm_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withTranslate__["a" /* withTranslate */](CodeVerificationForm)));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/ResultForm/ResultForm.js
/* harmony import */ var ResultForm___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ResultForm___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ResultForm___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CircleTimer_CircleTimer__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css__);
var ResultForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







// eslint-disable-next-line css-modules/no-unused-class


var _ref = ResultForm__jsx('br', {});

function ResultForm(props) {
  var t = props.t,
      approved = props.approved,
      timeUp = props.timeUp,
      time = props.time;

  return ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerCenter
  }, void 0, ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerResultTitle
  }, void 0, t('Спасибо!')), approved && ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerTextBlock
  }, void 0, t('Ваша заявка одобрена!'), ' ', _ref), !approved && ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerTextBlock
  }, void 0, t('LEASING_FORM_RESULT_RQ_QUIESTINS')), ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerCircleTimer
  }, void 0, ResultForm__jsx(__WEBPACK_IMPORTED_MODULE_4__CircleTimer_CircleTimer__["a" /* default */], {
    time: time,
    timeUp: timeUp
  })), ResultForm__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a.containerTextBlock
  }, void 0, t('В течении'), ' ', ResultForm__jsx('b', {}, void 0, ' 5 ', t('минут')), ' ', t('с Вами свяжется менеджер')));
}

ResultForm.defaultProps = {
  time: 300,
  timeUp: function timeUp() {}
};


/* harmony default export */ var ResultForm_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](ResultForm)));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingOnlineBanner.js
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_validations_validations__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_rtbHouse__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_helpers_advert__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_ulf__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_ulf24__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_hocs_withLeasingParams__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_helpers_transportInfo__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__UserDataForm_UserDataForm__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RecallForm_RecallForm__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__UserDataForm_UserDataFormWithPhotoDialogWrapper__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css__);
var LeasingOnlineBanner__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function LeasingOnlineBanner__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: Refactoring needed. file to big.









// import { parseDecimal } from 'shared/helpers/advertForm';





// import FormInput from './Inputs/FormInput';







// import withHapai from 'shared/hocs/withHapai';







// import UserDataFormDialogWrapper from './UserDataForm/UserDataFormDialogWrapper';
// import UserDataFormSideBarWrapper from './UserDataForm/UserDataFormSideBarWrapper';


// eslint-disable-next-line css-modules/no-unused-class


// const isMobile = __APP__ === 'mobile';

var LeasingOnlineBanner_LeasingOnlineBanner = function (_React$Component) {
  _inherits(LeasingOnlineBanner, _React$Component);

  function LeasingOnlineBanner(props) {
    _classCallCheck(this, LeasingOnlineBanner);

    var _this = _possibleConstructorReturn(this, (LeasingOnlineBanner.__proto__ || Object.getPrototypeOf(LeasingOnlineBanner)).call(this, props));

    _initialiseProps.call(_this);

    var user = _this.props.user;

    var userName = user && user.name || '';
    var phone = user && user.phones && user.phones[0].number || '';

    _this.state = {
      userName: userName,
      birthday: '',
      phone: phone,
      errorMessage: '',
      successMessage: '',
      step: 'user',
      codeVerification: '',
      requestId: '',
      isLeasingApproved: false,

      disableBtnLeasing: false,
      disableBtnLeasingOnline: false,
      disableBtnCodeVerification: false
    };
    return _this;
  }

  // submitAutoMoneyLeasingLead = (cb, moreLeasingParams) => {
  //   const { phone, userName } = this.state;
  //   const { advert, leasingParams, fetch } = this.props;

  //   const leadsParams = prepareParamsForLeasingLeadRequest(
  //     { phone, userName },
  //     advert,
  //     leasingParams,
  //     moreLeasingParams,
  //   );
  //   console.log('Create AutoMoney Lead');
  //   createAutoMoneyLead(leadsParams, advert, fetch)
  //     .then(data => {
  //       cb(!!data);
  //       this.onLeadCreated(!!data);
  //     })
  //     .catch(() => {
  //       cb(false);
  //       this.onLeadCreated(false);
  //     });

  //   return false;
  // };

  // submitHapaiLeasingLead = cb => {
  //   const { phone, userName } = this.state;
  //   const { advert, leasingParams, fetch } = this.props;

  //   const leadParams = {
  //     phone,
  //     userName,
  //     advert,
  //     leasingParams,
  //     term: leasingParams.term,
  //     prepaid: leasingParams.extendedParams && leasingParams.extendedParams.prepaidUAH,
  //     price: leasingParams.extendedParams && leasingParams.extendedParams.priceUAH,
  //     userStorageId: localStorage.getItem('applensDeviceId') || '',
  //   };
  //   console.log('Create Hapai Lead');
  //   createHapaiLead(leadParams, fetch)
  //     .then(data => {
  //       cb(data && data.success);
  //       this.onLeadCreated(data && data.success);
  //     })
  //     .catch(() => {
  //       cb(false);
  //       this.onLeadCreated(false);
  //     });

  //   return false;
  // };

  _createClass(LeasingOnlineBanner, [{
    key: 'fireEvent',
    value: function fireEvent(source) {
      // const { leasingParams, modalMode, advert } = this.props;
      var _props = this.props,
          modalMode = _props.modalMode,
          advert = _props.advert;

      if (source === 'consultation' || source === 'online') {
        __WEBPACK_IMPORTED_MODULE_9_shared_helpers_rtbHouse__["a" /* fireRTBEvent */]('leasingOld', {
          value: advert.price && __WEBPACK_IMPORTED_MODULE_10_shared_helpers_advert__["c" /* getPrice */](advert.price),
          ids: [advert.id]
        });
      }

      if (!__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[source]) return;
      var lesingBlockType = '';
      // if (isHapaiLeasing(leasingParams)) lesingBlockType += 'Hapai-';
      lesingBlockType += modalMode ? 'Popup' : 'Sidebar';
      lesingBlockType += advert.mileage > 0 ? '-Used-Click' : '-New-Click';

      if (!__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[source][lesingBlockType]) return;
      this.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[source][lesingBlockType]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _cs;

      var _props2 = this.props,
          leasingParams = _props2.leasingParams,
          t = _props2.t; // term

      var price = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__["i" /* getMothlyPaymentFormatted */](leasingParams);
      var symbol = __WEBPACK_IMPORTED_MODULE_16_shared_helpers_transportInfo__["p" /* getSymbolTitleBySlug */]('uah');
      var titleHTML = '<b>' + price + ' ' + symbol + ' ' + t('в месяц') + '</b><br />' + t('за этот автомобиль');

      return LeasingOnlineBanner__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default.a((_cs = {}, LeasingOnlineBanner__defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default.a.container, true), LeasingOnlineBanner__defineProperty(_cs, __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default.a.LeasingContainerContentSidebar, !this.props.modalMode), _cs))
      }, void 0, this.state.step === 'user' && LeasingOnlineBanner__jsx(__WEBPACK_IMPORTED_MODULE_22__UserDataForm_UserDataFormWithPhotoDialogWrapper__["a" /* default */], {
        advertInfo: this.props.advert,
        titleHTML: titleHTML,
        showTitle: !this.props.modalMode
      }, void 0, LeasingOnlineBanner__jsx(__WEBPACK_IMPORTED_MODULE_18__UserDataForm_UserDataForm__["a" /* default */], {
        disableBtnLeasing: this.state.disableBtnLeasing,
        disableBtnLeasingOnline: this.state.disableBtnLeasingOnline,
        userName: this.state.userName,
        phone: this.state.phone,
        birthday: this.state.birthday,
        errorMessage: this.state.errorMessage,
        successMessage: this.state.successMessage,
        monthlyPayment: this.state.monthlyPayment,
        changeHandler: this.changeHandler,
        onSubmitHandler: this.onSubmitUesrDataForm,
        toggleLeasingModal: this.state.toggleLeasingModal
      })), LeasingOnlineBanner__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default.a.LeasingContainerContent
      }, void 0, this.state.step === 'verify' && LeasingOnlineBanner__jsx(CodeVerificationForm_defaultExport, {
        codeVerification: this.state.codeVerification,
        errorMessage: this.state.errorMessage,
        successMessage: this.state.successMessage,
        changeHandler: this.changeHandler,
        onSubmitHandler: this.onSubmitCodeVerificationForm,
        disablBtn: this.state.disableBtnCodeVerification
      }), this.state.step === 'recall' && LeasingOnlineBanner__jsx(__WEBPACK_IMPORTED_MODULE_21__RecallForm_RecallForm__["a" /* default */], {
        timeUp: this.props.toggleLeasingModal
      }), this.state.step === 'result' && LeasingOnlineBanner__jsx(ResultForm_defaultExport, {
        approved: this.state.isLeasingApproved,
        timeUp: this.props.toggleLeasingModal
      })));
    }
  }]);

  return LeasingOnlineBanner;
}(LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingOnlineBanner_LeasingOnlineBanner.defaultProps = {
  user: null,
  modalMode: false,
  toggleLeasingModal: function toggleLeasingModal() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSubmitCodeVerificationForm = function (e) {
    e.preventDefault();
    _this2.fireEvent('codeVerification');
    var _state = _this2.state,
        codeVerification = _state.codeVerification,
        requestId = _state.requestId,
        userName = _state.userName,
        phone = _state.phone,
        birthday = _state.birthday,
        step = _state.step;


    var addLead = function addLead(result) {
      var moreLeasingParams = {
        bkiApproved: result.approved,
        comment: _this2.props.leasingParams.comment + ' | ' + ('API \u043E\u0442\u0432\u0435\u0442 \u043E\u0442 finup: "' + result.message + '" \u0417\u0430\u043F\u0440\u043E\u0441: ' + userName + '|' + phone + '|' + birthday)
      };
      _this2.submitLeasingLead(function (isSUccess) {
        _this2.setState({ disableBtnLeasing: false });
        var toState = {
          disableBtnCodeVerification: false,
          userName: '',
          phone: '',
          step: isSUccess ? 'result' : step,
          errorMessage: !isSUccess && 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
          successMessage: '',
          isLeasingApproved: result && result.approved
        };
        _this2.setState(toState);
      }, moreLeasingParams);
    };

    var submitCodeVerificationForm = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.setState({ disableBtnCodeVerification: true });
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__["m" /* sendCodeVerification */]({
                  otp: codeVerification,
                  requestId: requestId
                }, fetch);

              case 3:
                result = _context.sent;

                if (!(!result || result.error)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', _this2.setState({
                  errorMessage: 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
                }));

              case 6:

                addLead(result);
                return _context.abrupt('return', result);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function submitCodeVerificationForm() {
        return _ref.apply(this, arguments);
      };
    }();

    submitCodeVerificationForm();
  };

  this.onSubmitUesrDataForm = function (e, serviceType) {
    e.preventDefault();

    var _state2 = _this2.state,
        phone = _state2.phone,
        userName = _state2.userName;

    var errorMsg = __WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__["l" /* userFormValidation */]({ phone: phone, userName: userName });

    if (errorMsg) {
      _this2.setState({ errorMessage: errorMsg });
      return;
    }

    if (serviceType === 'call') {
      _this2.fireEvent('consultation');
      _this2.setState({ disableBtnLeasing: true });
      _this2.submitLeasingLead(function (isSUccess) {
        _this2.setState({ disableBtnLeasing: false });
        var toState = {
          userName: '',
          phone: '',
          errorMessage: !isSUccess && 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
          successMessage: '',
          step: isSUccess ? 'recall' : _this2.state.step
        };
        _this2.setState(toState);
      });
    } else {
      _this2.fireEvent('online');
      _this2.setState({ disableBtnLeasingOnline: true });
      _this2.onSubmitLeasingOnline(function (isSUccess) {
        _this2.setState({ disableBtnLeasingOnline: false });
        if (isSUccess) _this2.setState({ step: 'verify' });
      });
    }
  };

  this.onSubmitLeasingOnline = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(cb) {
      var _state3, userName, phone, birthday, deviceId, fetch, success;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _state3 = _this2.state, userName = _state3.userName, phone = _state3.phone, birthday = _state3.birthday;
              deviceId = localStorage.getItem('applensDeviceId') || '';
              fetch = _this2.props.fetch;

              if (_this2.validateForm({ phone: phone, birthday: birthday })) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt('return', cb(false));

            case 5:
              success = function success(data) {
                if (!data.valid) {
                  var message = data.message || data.error && data.error.message;
                  var moreLeasingParams = {
                    comment: _this2.props.leasingParams.comment + ' | ' + ('"\u041E\u043D\u043B\u0430\u0439\u043D \u0420\u0435\u0448\u0435\u043D\u0438\u0435" - API \u043E\u0442\u0432\u0435\u0442 \u043E\u0442 finup: "' + message + '" \u0417\u0430\u043F\u0440\u043E\u0441: ' + userName + '|' + phone + '|' + birthday)
                  };
                  _this2.submitLeasingLead(function (isSUccess) {
                    _this2.setState({ disableBtnLeasing: false });
                    var toState = {
                      userName: '',
                      phone: '',
                      errorMessage: !isSUccess && 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже',
                      successMessage: '',
                      step: isSUccess ? 'recall' : _this2.state.step,
                      isLeasingApproved: false
                    };
                    _this2.setState(toState);
                    cb(false);
                  }, moreLeasingParams);
                } else {
                  _this2.setState({ requestId: data.requestId, errorMessage: '' });
                  cb(true);
                }
                return true;
              };

              __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__["d" /* fetchRequestId */]({ phone: phone, birthday: birthday, deviceId: deviceId }, fetch).then(success).catch(success);
              return _context2.abrupt('return', null);

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.onLeadCreated = function (success) {
    // const { leasingParams, modalMode } = this.props;
    var modalMode = _this2.props.modalMode;

    var partner = '';
    // const partner = isHapaiLeasing(leasingParams) ? 'hapai-' : '';
    var successFlag = success ? '-success' : '-fail';
    var postfix = modalMode ? '' : '-advertcard-sidebar';
    var event = partner + 'lead-create' + successFlag + postfix;
    _this2.props.setDataLayer(__WEBPACK_IMPORTED_MODULE_5_shared_constants_gtmEvents__["a" /* EVENTS */].leasing[event]);
  };

  this.submitAFinanceLeasingLead = function (cb, moreLeasingParams) {
    var _state4 = _this2.state,
        phone = _state4.phone,
        userName = _state4.userName;
    var _props3 = _this2.props,
        advert = _props3.advert,
        leasingParams = _props3.leasingParams,
        fetch = _props3.fetch;


    var leadsParams = __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__["l" /* prepareParamsForLeasingLeadRequest */]({ phone: phone, userName: userName }, advert, leasingParams, moreLeasingParams);

    __WEBPACK_IMPORTED_MODULE_11_shared_helpers_leasing_myAuto__["a" /* createAFinanceLeda */](leadsParams, advert, fetch).then(function (data) {
      cb(!!data);
      _this2.onLeadCreated(!!data);
    }).catch(function () {
      cb(false);
      _this2.onLeadCreated(false);
    });

    return false;
  };

  this.submitUlfLeasingLead = function (cb) {
    var _state5 = _this2.state,
        phone = _state5.phone,
        userName = _state5.userName;
    var _props4 = _this2.props,
        advert = _props4.advert,
        leasingParams = _props4.leasingParams,
        fetch = _props4.fetch;


    var leadParams = __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({ phone: phone, userName: userName, leasingParams: leasingParams, advert: advert });

    __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_ulf__["a" /* createUlfLead */](leadParams, fetch).then(function (data) {
      cb(!!data);
      _this2.onLeadCreated(!!data);
    }).catch(function () {
      cb(false);
      _this2.onLeadCreated(false);
    });

    return false;
  };

  this.submitUlf24LeasingLead = function (cb) {
    var _state6 = _this2.state,
        phone = _state6.phone,
        userName = _state6.userName;
    var _props5 = _this2.props,
        advert = _props5.advert,
        leasingParams = _props5.leasingParams,
        fetch = _props5.fetch;


    var leadParams = __WEBPACK_IMPORTED_MODULE_12_shared_helpers_leasing_ulf__["b" /* getUlfParams */]({ phone: phone, userName: userName, leasingParams: leasingParams, advert: advert });

    __WEBPACK_IMPORTED_MODULE_13_shared_helpers_leasing_ulf24__["a" /* createUlf24Lead */](leadParams, fetch).then(function (data) {
      cb(!!data);
      _this2.onLeadCreated(!!data);
    }).catch(function () {
      cb(false);
      _this2.onLeadCreated(false);
    });

    return false;
  };

  this.submitLeasingLead = function (cb, moreLeasingParams) {
    if (__WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__["k" /* isUlfLeasing */](_this2.props.leasingParams)) {
      _this2.submitUlfLeasingLead(cb);
    } else if (__WEBPACK_IMPORTED_MODULE_14_shared_helpers_leasing_utils__["j" /* isUlf24Leasing */](_this2.props.leasingParams)) {
      _this2.submitUlf24LeasingLead(cb);
      // } else if (isAutoMoneyLeasing(this.props.leasingParams)) {
      //   this.submitAutoMoneyLeasingLead(cb);
    } else {
      _this2.submitAFinanceLeasingLead(cb, moreLeasingParams);
    }
  };

  this.changeHandler = function (field, value) {
    var _this2$setState;

    _this2.setState((_this2$setState = {}, LeasingOnlineBanner__defineProperty(_this2$setState, field, value), LeasingOnlineBanner__defineProperty(_this2$setState, 'errorMessage', ''), _this2$setState));
  };

  this.validateForm = function (params) {
    var phone = params.phone,
        birthday = params.birthday;

    if (phone && !__WEBPACK_IMPORTED_MODULE_7_shared_validations_validations__["e" /* isValidPhone */](phone.replace(/\s/g, ''))) {
      _this2.setState({ errorMessage: 'Некорректный номер телефона' });
      return false;
    }

    if (birthday && !__WEBPACK_IMPORTED_MODULE_7_shared_validations_validations__["b" /* isValidDate */](birthday)) {
      _this2.setState({ errorMessage: 'Некорректная дата рождения' });
      return false;
    }
    return true;
  };
};

var mapDispatchToProps = { setDataLayer: __WEBPACK_IMPORTED_MODULE_6_shared_actions_globals__["j" /* setDataLayer */] };
var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user && state.user.user
  };
};

/* harmony default export */ __webpack_exports__["a"] = (LeasingOnlineBanner___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_23__LeasingOnlineBanner_css___default.a)(__WEBPACK_IMPORTED_MODULE_8_shared_hocs_withFetch__["a" /* withFetch */](__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_15_shared_hocs_withLeasingParams__["a" /* withLeasingParams */](__WEBPACK_IMPORTED_MODULE_17_shared_hocs_withTranslate__["a" /* withTranslate */](LeasingOnlineBanner_LeasingOnlineBanner))))));

/***/ }),

/***/ 1857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_modules__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_JsonLdApplication_JsonLdApplication__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




// import { connect } from 'react-redux';









var AB_PATH = 'https://avtobazar.ua';

var SpanLink = function SpanLink(_ref) {
  var text = _ref.text,
      index = _ref.index,
      intl = _ref.intl;
  return _jsx('span', {}, void 0, index === 0 ? __WEBPACK_IMPORTED_MODULE_6_shared_modules__["n" /* replaceToUpperCase */](intl.formatMessage({ id: text })) : intl.formatMessage({ id: text }));
};

function BreadcrumbsLinks(props) {
  var links = props.links,
      currentPath = props.history.currentPath,
      intl = props.intl;

  var hasQuery = !!currentPath.split('').find(function (item) {
    return item === '?';
  });

  var breadcrumbItemListEl = links.map(function (a, b) {
    return {
      '@type': 'ListItem',
      position: b + 1,
      item: {
        '@id': '' + AB_PATH + a[0] + '/',
        name: b === 0 ? __WEBPACK_IMPORTED_MODULE_6_shared_modules__["n" /* replaceToUpperCase */](intl.formatMessage({ id: a[1] })) : intl.formatMessage({ id: a[1] })
      }
    };
  });

  var breadcrumbListLd = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItemListEl
  };

  return _jsx('div', {}, void 0, _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css___default.a.olNavigationLink)
  }, void 0, links.map(function (a, b) {
    return _jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css___default.a.itemListElement
    }, '' + b + a[2], b + 1 === links.length && !hasQuery ? _jsx('span', {
      className: 'meta-title-link-next'
    }, void 0, _jsx(SpanLink, {
      text: a[1],
      index: b,
      intl: intl
    })) : _jsx('li', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_Link__["a" /* default */], {
      itemProp: 'url',
      to: a[0] + '/',
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a({
        'meta-title-link': b === 0,
        'meta-title-link-next': b !== 0
      })
    }, void 0, _jsx(SpanLink, {
      text: a[1],
      index: b,
      intl: intl
    }))));
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_components_JsonLdApplication_JsonLdApplication__["a" /* default */], breadcrumbListLd));
}

BreadcrumbsLinks.defaultProps = {
  title: '',
  history: {
    currentPath: ''
  }
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__BreadcrumbsLinks_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */](BreadcrumbsLinks)));

/***/ }),

/***/ 1858:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1859);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BreadcrumbsLinks.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./BreadcrumbsLinks.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1859:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Iphx{float:left;margin:0 .3em .3em 0;font-size:14px;color:#888;font-weight:400}._3909O{margin:0;height:18px;list-style-type:none;padding:0}", ""]);

// exports
exports.locals = {
	"itemListElement": "_3Iphx",
	"olNavigationLink": "_3909O"
};

/***/ }),

/***/ 1870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InlineAdvertsBlock_css__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InlineAdvertsBlock_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InlineAdvertsBlock_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_desktop_components_AdvertCarCard_AdvertCarCard__ = __webpack_require__(1710);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// import AdvertCard from '../AdvertCard/AdvertCard';


var uah = __WEBPACK_IMPORTED_MODULE_3_shared_constants_json_currency_json___default.a.find(function (item) {
  return item.slug === 'uah';
});
var IMAGE_WIDTH = 237;

var InlineAdvertsBlock = function (_React$Component) {
  _inherits(InlineAdvertsBlock, _React$Component);

  function InlineAdvertsBlock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InlineAdvertsBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InlineAdvertsBlock.__proto__ || Object.getPrototypeOf(InlineAdvertsBlock)).call.apply(_ref, [this].concat(args))), _this), _this.getImageStyles = function () {
      return {
        height: parseInt(582 / _this.props.itemsInLine, 10)
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InlineAdvertsBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          rows = _props.rows,
          itemsInLine = _props.itemsInLine,
          currency = _props.currency,
          lensEvent = _props.lensEvent;


      if (!items.length) {
        return null;
      }

      var widthStyle = {
        width: 100 / itemsInLine + '%'
      };

      var showedItems = items.slice(0, rows * itemsInLine);

      var advertClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_5__InlineAdvertsBlock_css___default.a.advert, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__InlineAdvertsBlock_css___default.a.multirow, rows > 1));

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__InlineAdvertsBlock_css___default.a.root
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_5__InlineAdvertsBlock_css___default.a.row
      }, void 0, showedItems.map(function (item, idx) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_6_desktop_components_AdvertCarCard_AdvertCarCard__["a" /* default */], {
          advert: item,
          index: idx,
          advertClassName: advertClassName,
          advertStyle: widthStyle,
          currency: currency,
          width: IMAGE_WIDTH,
          lensEvent: lensEvent
        }, item.id);
      })));
    }
  }]);

  return InlineAdvertsBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

InlineAdvertsBlock.defaultProps = {
  rows: 1,
  itemsInLine: 3,
  currency: uah,
  lensEvent: ''
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__InlineAdvertsBlock_css___default.a)(InlineAdvertsBlock));

/***/ }),

/***/ 1871:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(1872);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineAdvertsBlock.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./InlineAdvertsBlock.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 1872:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2Qrxu{position:relative}.Bi16B{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap}._2N9TP{position:relative;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}._2VZLo{margin-bottom:20px}._2N9TP:hover{cursor:pointer;color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_2Qrxu",
	"row": "Bi16B",
	"advert": "_2N9TP",
	"multirow": "_2VZLo"
};

/***/ }),

/***/ 1932:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "607da9c4.svg";

/***/ }),

/***/ 1933:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0706bed3.svg";

/***/ }),

/***/ 1934:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fde6b7e4.svg";

/***/ }),

/***/ 1961:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_left_arrow_line_svg__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_left_arrow_line_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_left_arrow_line_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_angle_gray_svg__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_angle_gray_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_angle_gray_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_right_arrow_line_svg__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_right_arrow_line_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_right_arrow_line_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var _ref = _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_left_arrow_line_svg___default.a,
  width: 12,
  alt: ''
});

var _ref3 = _jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_right_arrow_line_svg___default.a,
  width: 12,
  alt: ''
});

var Breadcrumbs = function (_React$Component) {
  _inherits(Breadcrumbs, _React$Component);

  function Breadcrumbs() {
    _classCallCheck(this, Breadcrumbs);

    return _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).apply(this, arguments));
  }

  _createClass(Breadcrumbs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          prev = _props.prev,
          links = _props.links,
          next = _props.next,
          current = _props.current;


      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.root
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.flexRow
      }, void 0, _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.container, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.left, !!next))
      }, void 0, prev && _jsx('span', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Link__["a" /* default */], {
        to: '',
        className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.back
      }, void 0, _ref, '\xA0', prev.title), _jsx('img', {
        className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.divider,
        src: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_angle_gray_svg___default.a,
        width: '14',
        alt: ''
      })), links && links.map(function (_ref2, i) {
        var title = _ref2.title,
            link = _ref2.link;
        return _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.select
        }, title, _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Link__["a" /* default */], {
          to: link,
          className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.select
        }, void 0, title), (i !== links.length - 1 || current) && _jsx('img', {
          className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.divider,
          src: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_angle_gray_svg___default.a,
          width: '14',
          alt: ''
        }));
      }), current && _jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.select + ' ' + __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.current
      }, void 0, current)), next && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.right
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Link__["a" /* default */], {
        to: next.link,
        className: __WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a.next,
        onClick: this.handleNextAdvertClick
      }, void 0, next.title, '\xA0', _ref3))));
    }
  }]);

  return Breadcrumbs;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Breadcrumbs.defaultProps = {
  prev: null,
  next: null,
  current: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__Breadcrumbs_css___default.a)(Breadcrumbs));

/***/ }),

/***/ 2059:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2060);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Breadcrumbs.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Breadcrumbs.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2060:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3qLsA{background-color:#fff;padding:0 20px;margin-bottom:20px;font-size:13px;font-weight:400}._3qLsA,._34yh6{position:relative}._34yh6{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:nowrap;flex-wrap:nowrap}._3F3jq{position:relative;color:#2196f3;text-decoration:none;padding-right:10px}._3F3jq:after{content:\" \";width:14px;height:40px;display:inline-block;position:absolute;top:-1px;right:0}._2WBs_ img,._3F3jq img{position:relative;top:-2px;margin-right:.2em}._2WBs_ img{margin-right:0;margin-left:.2em}._2WBs_{color:#2196f3;text-decoration:none}.pD8Eo{position:relative;display:inline-block;margin:0 4px}._1wCUi{vertical-align:baseline;line-height:38px}._3aY3r{width:calc(100% - 210px)}._3AWpp{position:relative;display:inline-block;color:#000;padding:0 4px;text-decoration:none}._3AWpp:first-letter{text-transform:capitalize}._3AWpp:hover{color:#2196f3}._3wcxk{max-width:250px;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;vertical-align:top}._3wcxk:hover{color:#000}._2bGUz{text-align:right;width:210px;white-space:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;line-height:38px;vertical-align:baseline}", ""]);

// exports
exports.locals = {
	"root": "_3qLsA",
	"flexRow": "_34yh6 flexRow",
	"back": "_3F3jq",
	"next": "_2WBs_",
	"divider": "pD8Eo",
	"container": "_1wCUi",
	"left": "_3aY3r",
	"select": "_3AWpp",
	"current": "_3wcxk",
	"right": "_2bGUz"
};

/***/ }),

/***/ 2237:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3178)();
}

/***/ }),

/***/ 2238:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d2da1909.png";

/***/ }),

/***/ 2239:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b6345309.png";

/***/ }),

/***/ 2350:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue(arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass(value, newClass) {
		if (!newClass) {
			return value;
		}

		if (value) {
			return value + ' ' + newClass;
		}

		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(87)) === 'object' && __webpack_require__(87)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 2351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clamp = clamp;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = exports.safePreventDefault = void 0;

var _react = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];

  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};

exports.safePreventDefault = safePreventDefault;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


exports.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


exports.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

exports.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

exports.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

exports.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


exports.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

exports.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

exports.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


exports.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


exports.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


exports.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

exports.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread(_objectSpread({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread(_objectSpread({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

exports.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread(_objectSpread({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

exports.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

exports.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

exports.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread(_objectSpread({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }

  return state;
};

exports.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread(_objectSpread({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

exports.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

exports.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

exports.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

exports.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : void 0;
};

exports.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread(_objectSpread({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

exports.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

exports.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

exports.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

exports.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

exports.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

exports.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

exports.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

exports.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

exports.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

exports.canUseDOM = canUseDOM;

/***/ }),

/***/ 2372:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue(arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass(value, newClass) {
		if (!newClass) {
			return value;
		}

		if (value) {
			return value + ' ' + newClass;
		}

		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(87)) === 'object' && __webpack_require__(87)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ 2790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_urlBuilder__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TagList_css__ = __webpack_require__(2791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TagList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__TagList_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C'
});

var TagList = function (_React$Component) {
  _inherits(TagList, _React$Component);

  function TagList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TagList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagList.__proto__ || Object.getPrototypeOf(TagList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      collapsed: !!_this.props.activeTag
    }, _this.showAll = function () {
      _this.setState({ collapsed: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TagList, [{
    key: 'render',
    value: function render() {
      if (!this.props.tags) {
        return null;
      }

      var _props = this.props,
          title = _props.title,
          allTags = _props.tags,
          max = _props.max,
          className = _props.className,
          onTagClick = _props.onTagClick,
          activeTag = _props.activeTag,
          query = _props.query,
          url = _props.url,
          currentRubric = _props.currentRubric,
          rubrics = _props.rubrics;
      var collapsed = this.state.collapsed;

      var tags = max && !collapsed ? allTags.slice(0, max) : allTags;
      var clearLink = __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(_extends({}, query, { tag: undefined }));

      return _jsx('div', {
        className: className || __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.root
      }, void 0, activeTag && _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Link__["a" /* default */], {
        to: '' + url + (clearLink ? '?' + clearLink : ''),
        className: __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.clearFilters
      }, void 0, _ref2), title && _jsx('h4', {
        className: __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.title
      }, void 0, title), _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.list
      }, void 0, tags.map(function (tag) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_Link__["a" /* default */], {
          to: __WEBPACK_IMPORTED_MODULE_8__helpers_urlBuilder__["b" /* buildJournalListingUrl */](rubrics, currentRubric, tag.slug),
          onClick: function onClick() {
            return onTagClick(tag.id);
          },
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a(__WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.tag, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.active, activeTag === tag.slug))
        }, tag.id || tag.title, tag.title, ' ');
      }), tags.length < allTags.length && _jsx('button', {
        onClick: this.showAll,
        className: __WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a.tag
      }, void 0, '...')));
    }
  }]);

  return TagList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TagList.defaultProps = {
  tags: null,
  query: null,
  url: null,
  title: null,
  className: '',
  max: null,
  onTagClick: function onTagClick() {},
  activeTag: null
};


var mapStateToProps = function mapStateToProps(_ref3) {
  var globals = _ref3.globals;
  return {
    rubrics: globals.journal.rubrics
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__TagList_css___default.a)(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */](mapStateToProps)(TagList)));

/***/ }),

/***/ 2791:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2792);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagList.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TagList.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2792:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2u9qF{position:relative;background:#fff;padding:15px;margin-bottom:20px}._1MnP2{font-size:13px;font-weight:400;margin:10px 0}._1Kp1S{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:10px 0}._1Kp1S:not(:first-of-type):last-of-type{margin:0}._2BNfs{margin:0 10px 10px 0;font-size:12px;padding:6px 12px;border:1px solid #ccc;border-radius:2px;cursor:pointer;background:transparent;outline:0;text-transform:capitalize;color:inherit;text-decoration:none;max-width:calc(100% - 34px);overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;-webkit-box-sizing:content-box;box-sizing:content-box}._2BNfs:focus,._2BNfs:hover,.U0pd4{color:#e73232}._1M3kG{display:inline-block;margin-top:10px;font-size:14px}", ""]);

// exports
exports.locals = {
	"root": "_2u9qF",
	"title": "_1MnP2",
	"list": "_1Kp1S",
	"tag": "_2BNfs",
	"active": "U0pd4",
	"clearFilters": "_1M3kG"
};

/***/ }),

/***/ 2796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_desktop_components_AdvertCarCard_AdvertCarCard__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_desktop_components_Carousel_Carousel__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css__ = __webpack_require__(2797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AnotherCars_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





// import AdvertCard from 'desktop/components/AdvertCard/AdvertCard';



var IMAGE_WIDTH = 170;

function AnotherCars(props) {
  var cars = props.cars,
      title = props.title,
      containerClassName = props.containerClassName;

  var imageStyles = { height: '125px' };

  if (!(cars && cars.length)) {
    return null;
  }

  return _jsx('div', {
    className: containerClassName || __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.root
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4_desktop_components_Carousel_Carousel__["a" /* default */], {
    step: 4,
    itemsInRow: 4,
    loop: true,
    classNames: {
      header: __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.header,
      body: __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.carouselBody
    },
    header: _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.title
    }, void 0, title),
    items: cars.map(function (car, idx) {
      return _jsx(__WEBPACK_IMPORTED_MODULE_3_desktop_components_AdvertCarCard_AdvertCarCard__["a" /* default */], {
        index: idx,
        advert: car,
        imageStyle: imageStyles,
        advertClassName: __WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a.advertItem,
        cardType: 'similar',
        width: IMAGE_WIDTH,
        lensEvent: 'similarCarClick'
      }, car.id);
    })
  }));
}

AnotherCars.defaultProps = {
  cars: [],
  containerClassName: null
};


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__AnotherCars_css___default.a)(AnotherCars));

/***/ }),

/***/ 2797:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(2798);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AnotherCars.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./AnotherCars.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 2798:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3Q55Q{position:relative;background-color:#fff;padding:10px 10px 0;min-height:288px;border-bottom:1px solid #d8d8d8;z-index:1;margin:10px 0}._1B4xP{font-size:20px;font-weight:700;color:#000}.WahFN{padding:5px 0 15px 5px}._2Ibj6{padding-bottom:0}", ""]);

// exports
exports.locals = {
	"root": "_3Q55Q",
	"title": "_1B4xP",
	"header": "WahFN",
	"carouselBody": "_2Ibj6"
};

/***/ }),

/***/ 2799:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(1496);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.isEventFromHandle = isEventFromHandle;
exports.isValueOutOfRange = isValueOutOfRange;
exports.isNotTouchEvent = isNotTouchEvent;
exports.getClosestPoint = getClosestPoint;
exports.getPrecision = getPrecision;
exports.getMousePosition = getMousePosition;
exports.getTouchPosition = getTouchPosition;
exports.getHandleCenterPosition = getHandleCenterPosition;
exports.ensureValueInRange = ensureValueInRange;
exports.ensureValuePrecision = ensureValuePrecision;
exports.pauseEvent = pauseEvent;
exports.getKeyboardValueMutator = getKeyboardValueMutator;

var _reactDom = __webpack_require__(38);

var _KeyCode = __webpack_require__(3189);

var _KeyCode2 = _interopRequireDefault(_KeyCode);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function isEventFromHandle(e, handles) {
  return Object.keys(handles).some(function (key) {
    return e.target === (0, _reactDom.findDOMNode)(handles[key]);
  });
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var closestStep = Math.round((val - min) / step) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3['default'])(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = getClosestPoint(val, props);
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function getKeyboardValueMutator(e) {
  switch (e.keyCode) {
    case _KeyCode2['default'].UP:
    case _KeyCode2['default'].RIGHT:
      return function (value, props) {
        return value + props.step;
      };

    case _KeyCode2['default'].DOWN:
    case _KeyCode2['default'].LEFT:
      return function (value, props) {
        return value - props.step;
      };

    case _KeyCode2['default'].END:
      return function (value, props) {
        return props.max;
      };
    case _KeyCode2['default'].HOME:
      return function (value, props) {
        return props.min;
      };
    case _KeyCode2['default'].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };
    case _KeyCode2['default'].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }
}

/***/ }),

/***/ 2812:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(186);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var Track = function Track(props) {
  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style;

  var positonStyle = vertical ? {
    bottom: offset + '%',
    height: length + '%'
  } : {
    left: offset + '%',
    width: length + '%'
  };

  var elStyle = (0, _extends3['default'])({}, style, positonStyle);
  return included ? _react2['default'].createElement('div', { className: className, style: elStyle }) : null;
}; /* eslint-disable react/prop-types */
exports['default'] = Track;
module.exports = exports['default'];

/***/ }),

/***/ 2813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(1485);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(186);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(1390);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(311);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(313);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(314);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(3180);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(315);

var _inherits3 = _interopRequireDefault(_inherits2);

exports['default'] = createSlider;

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2237);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(2814);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _classnames = __webpack_require__(2350);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(318);

var _warning2 = _interopRequireDefault(_warning);

var _Steps = __webpack_require__(3187);

var _Steps2 = _interopRequireDefault(_Steps);

var _Marks = __webpack_require__(3188);

var _Marks2 = _interopRequireDefault(_Marks);

var _Handle = __webpack_require__(2815);

var _Handle2 = _interopRequireDefault(_Handle);

var _utils = __webpack_require__(2799);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    (0, _inherits3['default'])(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      (0, _classCallCheck3['default'])(this, ComponentEnhancer);

      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = utils.getMousePosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.removeDocumentEvents();
        _this.onStart(position);
        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (utils.isNotTouchEvent(e)) return;

        var isVertical = _this.props.vertical;
        var position = utils.getTouchPosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        utils.pauseEvent(e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (utils.isEventFromHandle(e, _this.handlesRefs)) {
          var handlePosition = utils.getHandleCenterPosition(vertical, e.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          utils.pauseEvent(e);
          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd(e);
        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = utils.getMousePosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = utils.getTouchPosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();
        _this.onChange({ value: value });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      if (false) {
        var step = props.step,
            max = props.max,
            min = props.min;

        (0, _warning2['default'])(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      }
      _this.handlesRefs = {};
      return _this;
    }

    (0, _createClass3['default'])(ComponentEnhancer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if ((0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var rect = slider.getBoundingClientRect();

        return this.props.vertical ? rect.top : rect.left;
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = (0, _addEventListener2['default'])(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = (0, _addEventListener2['default'])(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = (0, _addEventListener2['default'])(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = (0, _addEventListener2['default'])(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (!this.props.disabled) {
          this.handlesRefs[0].focus();
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        var _this2 = this;

        if (!this.props.disabled) {
          Object.keys(this.handlesRefs).forEach(function (key) {
            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
              _this2.handlesRefs[key].blur();
            }
          });
        }
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props = this.props,
            vertical = _props.vertical,
            min = _props.min,
            max = _props.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var pixelOffset = position - this.getSliderStart();
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props2 = this.props,
            min = _props2.min,
            max = _props2.max;

        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props3 = this.props,
            prefixCls = _props3.prefixCls,
            className = _props3.className,
            marks = _props3.marks,
            dots = _props3.dots,
            step = _props3.step,
            included = _props3.included,
            disabled = _props3.disabled,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max,
            children = _props3.children,
            maximumTrackStyle = _props3.maximumTrackStyle,
            style = _props3.style,
            railStyle = _props3.railStyle,
            dotStyle = _props3.dotStyle,
            activeDotStyle = _props3.activeDotStyle;

        var _get$call = (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
        return _react2['default'].createElement('div', {
          ref: this.saveSlider,
          className: sliderClassName,
          onTouchStart: disabled ? noop : this.onTouchStart,
          onMouseDown: disabled ? noop : this.onMouseDown,
          onMouseUp: disabled ? noop : this.onMouseUp,
          onKeyDown: disabled ? noop : this.onKeyDown,
          onFocus: disabled ? noop : this.onFocus,
          onBlur: disabled ? noop : this.onBlur,
          style: style
        }, _react2['default'].createElement('div', {
          className: prefixCls + '-rail',
          style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
        }), tracks, _react2['default'].createElement(_Steps2['default'], {
          prefixCls: prefixCls,
          vertical: vertical,
          marks: marks,
          dots: dots,
          step: step,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          dotStyle: dotStyle,
          activeDotStyle: activeDotStyle
        }), handles, _react2['default'].createElement(_Marks2['default'], {
          className: prefixCls + '-mark',
          onClickLabel: disabled ? noop : this.onClickMarkLabel,
          vertical: vertical,
          marks: marks,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min
        }), children);
      }
    }]);
    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
    min: _propTypes2['default'].number,
    max: _propTypes2['default'].number,
    step: _propTypes2['default'].number,
    marks: _propTypes2['default'].object,
    included: _propTypes2['default'].bool,
    className: _propTypes2['default'].string,
    prefixCls: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    children: _propTypes2['default'].any,
    onBeforeChange: _propTypes2['default'].func,
    onChange: _propTypes2['default'].func,
    onAfterChange: _propTypes2['default'].func,
    handle: _propTypes2['default'].func,
    dots: _propTypes2['default'].bool,
    vertical: _propTypes2['default'].bool,
    style: _propTypes2['default'].object,
    minimumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    maximumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    railStyle: _propTypes2['default'].object,
    dotStyle: _propTypes2['default'].object,
    activeDotStyle: _propTypes2['default'].object,
    autoFocus: _propTypes2['default'].bool,
    onFocus: _propTypes2['default'].func,
    onBlur: _propTypes2['default'].func
  }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);

      delete restProps.dragging;
      return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}
module.exports = exports['default'];

/***/ }),

/***/ 2814:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addEventListenerWrap;

var _addDomEventListener = _interopRequireDefault(__webpack_require__(3184));

var _reactDom = _interopRequireDefault(__webpack_require__(38));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
    _reactDom.default.unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener.default)(target, eventType, callback, option);
}

/***/ }),

/***/ 2815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(186);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(1390);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(1485);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(311);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(313);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(314);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(315);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2237);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2350);

var _classnames2 = _interopRequireDefault(_classnames);

var _addEventListener = __webpack_require__(2814);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var Handle = function (_React$Component) {
  (0, _inherits3['default'])(Handle, _React$Component);

  function Handle() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3['default'])(this, Handle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clickFocused: false
    }, _this.setHandleRef = function (node) {
      _this.handle = node;
    }, _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    }, _this.handleBlur = function () {
      _this.setClickFocus(false);
    }, _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
  }

  (0, _createClass3['default'])(Handle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = (0, _addEventListener2['default'])(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: 'setClickFocus',
    value: function setClickFocus(focused) {
      this.setState({ clickFocused: focused });
    }
  }, {
    key: 'clickFocus',
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          tabIndex = _props.tabIndex,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);

      var className = (0, _classnames2['default'])(this.props.className, (0, _defineProperty3['default'])({}, prefixCls + '-handle-click-focused', this.state.clickFocused));

      var postionStyle = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
      var elStyle = (0, _extends3['default'])({}, style, postionStyle);

      return _react2['default'].createElement('div', (0, _extends3['default'])({
        ref: this.setHandleRef,
        tabIndex: disabled ? null : tabIndex || 0
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown

        // aria attribute
        , role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      }));
    }
  }]);
  return Handle;
}(_react2['default'].Component);

exports['default'] = Handle;

Handle.propTypes = {
  prefixCls: _propTypes2['default'].string,
  className: _propTypes2['default'].string,
  vertical: _propTypes2['default'].bool,
  offset: _propTypes2['default'].number,
  style: _propTypes2['default'].object,
  disabled: _propTypes2['default'].bool,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  value: _propTypes2['default'].number,
  tabIndex: _propTypes2['default'].number
};
module.exports = exports['default'];

/***/ }),

/***/ 2816:
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i = 0,
        length = collection.length,
        cont;

    for (i; i < length; i++) {
        cont = fn(collection[i], i);
        if (cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction: isFunction,
    isArray: isArray,
    each: each
};

/***/ }),

/***/ 3168:
/***/ (function(module, exports) {

var HTML_ALPHA = ['apos', 'nbsp', 'iexcl', 'cent', 'pound', 'curren', 'yen', 'brvbar', 'sect', 'uml', 'copy', 'ordf', 'laquo', 'not', 'shy', 'reg', 'macr', 'deg', 'plusmn', 'sup2', 'sup3', 'acute', 'micro', 'para', 'middot', 'cedil', 'sup1', 'ordm', 'raquo', 'frac14', 'frac12', 'frac34', 'iquest', 'Agrave', 'Aacute', 'Acirc', 'Atilde', 'Auml', 'Aring', 'Aelig', 'Ccedil', 'Egrave', 'Eacute', 'Ecirc', 'Euml', 'Igrave', 'Iacute', 'Icirc', 'Iuml', 'ETH', 'Ntilde', 'Ograve', 'Oacute', 'Ocirc', 'Otilde', 'Ouml', 'times', 'Oslash', 'Ugrave', 'Uacute', 'Ucirc', 'Uuml', 'Yacute', 'THORN', 'szlig', 'agrave', 'aacute', 'acirc', 'atilde', 'auml', 'aring', 'aelig', 'ccedil', 'egrave', 'eacute', 'ecirc', 'euml', 'igrave', 'iacute', 'icirc', 'iuml', 'eth', 'ntilde', 'ograve', 'oacute', 'ocirc', 'otilde', 'ouml', 'divide', 'oslash', 'ugrave', 'uacute', 'ucirc', 'uuml', 'yacute', 'thorn', 'yuml', 'quot', 'amp', 'lt', 'gt', 'OElig', 'oelig', 'Scaron', 'scaron', 'Yuml', 'circ', 'tilde', 'ensp', 'emsp', 'thinsp', 'zwnj', 'zwj', 'lrm', 'rlm', 'ndash', 'mdash', 'lsquo', 'rsquo', 'sbquo', 'ldquo', 'rdquo', 'bdquo', 'dagger', 'Dagger', 'permil', 'lsaquo', 'rsaquo', 'euro', 'fnof', 'Alpha', 'Beta', 'Gamma', 'Delta', 'Epsilon', 'Zeta', 'Eta', 'Theta', 'Iota', 'Kappa', 'Lambda', 'Mu', 'Nu', 'Xi', 'Omicron', 'Pi', 'Rho', 'Sigma', 'Tau', 'Upsilon', 'Phi', 'Chi', 'Psi', 'Omega', 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'pi', 'rho', 'sigmaf', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega', 'thetasym', 'upsih', 'piv', 'bull', 'hellip', 'prime', 'Prime', 'oline', 'frasl', 'weierp', 'image', 'real', 'trade', 'alefsym', 'larr', 'uarr', 'rarr', 'darr', 'harr', 'crarr', 'lArr', 'uArr', 'rArr', 'dArr', 'hArr', 'forall', 'part', 'exist', 'empty', 'nabla', 'isin', 'notin', 'ni', 'prod', 'sum', 'minus', 'lowast', 'radic', 'prop', 'infin', 'ang', 'and', 'or', 'cap', 'cup', 'int', 'there4', 'sim', 'cong', 'asymp', 'ne', 'equiv', 'le', 'ge', 'sub', 'sup', 'nsub', 'sube', 'supe', 'oplus', 'otimes', 'perp', 'sdot', 'lceil', 'rceil', 'lfloor', 'rfloor', 'lang', 'rang', 'loz', 'spades', 'clubs', 'hearts', 'diams'];
var HTML_CODES = [39, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 34, 38, 60, 62, 338, 339, 352, 353, 376, 710, 732, 8194, 8195, 8201, 8204, 8205, 8206, 8207, 8211, 8212, 8216, 8217, 8218, 8220, 8221, 8222, 8224, 8225, 8240, 8249, 8250, 8364, 402, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 977, 978, 982, 8226, 8230, 8242, 8243, 8254, 8260, 8472, 8465, 8476, 8482, 8501, 8592, 8593, 8594, 8595, 8596, 8629, 8656, 8657, 8658, 8659, 8660, 8704, 8706, 8707, 8709, 8711, 8712, 8713, 8715, 8719, 8721, 8722, 8727, 8730, 8733, 8734, 8736, 8743, 8744, 8745, 8746, 8747, 8756, 8764, 8773, 8776, 8800, 8801, 8804, 8805, 8834, 8835, 8836, 8838, 8839, 8853, 8855, 8869, 8901, 8968, 8969, 8970, 8971, 9001, 9002, 9674, 9824, 9827, 9829, 9830];

var alphaIndex = {};
var numIndex = {};

var i = 0;
var length = HTML_ALPHA.length;
while (i < length) {
    var a = HTML_ALPHA[i];
    var c = HTML_CODES[i];
    alphaIndex[a] = String.fromCharCode(c);
    numIndex[c] = a;
    i++;
}

/**
 * @constructor
 */
function Html4Entities() {}

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.decode = function (str) {
    if (!str || !str.length) {
        return '';
    }
    return str.replace(/&(#?[\w\d]+);?/g, function (s, entity) {
        var chr;
        if (entity.charAt(0) === "#") {
            var code = entity.charAt(1).toLowerCase() === 'x' ? parseInt(entity.substr(2), 16) : parseInt(entity.substr(1));

            if (!(isNaN(code) || code < -32768 || code > 65535)) {
                chr = String.fromCharCode(code);
            }
        } else {
            chr = alphaIndex[entity];
        }
        return chr || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.decode = function (str) {
    return new Html4Entities().decode(str);
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encode = function (str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var alpha = numIndex[str.charCodeAt(i)];
        result += alpha ? "&" + alpha + ";" : str.charAt(i);
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.encode = function (str) {
    return new Html4Entities().encode(str);
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encodeNonUTF = function (str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var cc = str.charCodeAt(i);
        var alpha = numIndex[cc];
        if (alpha) {
            result += "&" + alpha + ";";
        } else if (cc < 32 || cc > 126) {
            result += "&#" + cc + ";";
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.encodeNonUTF = function (str) {
    return new Html4Entities().encodeNonUTF(str);
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encodeNonASCII = function (str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.encodeNonASCII = function (str) {
    return new Html4Entities().encodeNonASCII(str);
};

module.exports = Html4Entities;

/***/ }),

/***/ 3169:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3170);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ShareButtons.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ShareButtons.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3170:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1cK1d{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}._1SSsM{margin-right:10px;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "_1cK1d",
	"button": "_1SSsM"
};

/***/ }),

/***/ 3171:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3172);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsInfo.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsInfo.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3172:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1DQV0{position:relative;background:#fff;margin-bottom:20px;padding:15px 15px 25px}._1DQV0,._3TGHH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3TGHH{margin-bottom:10px}.nSI2t{font-size:30px;font-weight:400;margin:10px 0}._2lDdp{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._1dITl,._2lDdp{display:-webkit-box;display:-ms-flexbox;display:flex}._1dITl{-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:15px}.eguHy{height:35px;margin-right:10px;border-radius:50%}.Lc_A7{font-size:14px}.U6h0w{font-size:12px;color:#888}.sBbqz{line-height:1.72;font-weight:400}.sBbqz img{width:100%}._2ugf8,.sBbqz img{display:block;height:auto}._2ugf8{max-width:calc(100% + 30px);width:calc(100% + 30px)!important;margin:0 -15px}._2VslU{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 5px}.-xEm1{padding:0;margin:0}._5TSvb .responsive-object{position:relative}._5TSvb .responsive-object iframe{position:absolute;width:100%;height:100%}._5TSvb table{border-collapse:collapse}._5TSvb table td,._5TSvb table th{border:1px solid #000;padding:5px}._5TSvb .block-table{max-width:100%;overflow:auto}@media screen and (max-width:360px){._5TSvb .block-table table{font-size:10px}}@media screen and (max-width:360px){._2VslU{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}@media screen and (max-width:440px){._5TSvb .block-table table{font-size:12px}}@media screen and (max-width:380px){._5TSvb .block-table table{font-size:11px}}@media screen and (max-width:360px){._2VslU{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._5TSvb .block-table table{font-size:10px}}@media screen and (max-width:335px){._5TSvb .block-table table{font-size:9px}}", ""]);

// exports
exports.locals = {
	"root": "_1DQV0",
	"header": "_3TGHH",
	"title": "nSI2t",
	"metaInfo": "_2lDdp",
	"authorCard": "_1dITl",
	"avatar": "eguHy",
	"userName": "Lc_A7",
	"date": "U6h0w",
	"content": "sBbqz",
	"mainImage": "_2ugf8",
	"footer": "_2VslU",
	"tags": "-xEm1",
	"richText": "_5TSvb"
};

/***/ }),

/***/ 3173:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3174);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsPage.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NewsPage.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3174:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2PmNC{margin-bottom:20px}._1fzn2{margin:0 auto}._2ptcg{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._1ziXc{position:relative}._2AppP{width:calc(100% - 300px);padding-right:20px}.Y4Vjl{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.LBEuS{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}", ""]);

// exports
exports.locals = {
	"page": "_2ZiSB page",
	"Juan": "_2PmNC",
	"container": "_1fzn2 container",
	"flexRow": "_2ptcg flexRow",
	"flexCell": "_1ziXc",
	"mainCell": "_2AppP",
	"flexGrow1": "Y4Vjl",
	"sideBar": "LBEuS"
};

/***/ }),

/***/ 3175:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3176);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./RectanglesOptions.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./RectanglesOptions.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3176:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3V7v3{margin-bottom:20px}._1vPmS,._3V7v3{display:-webkit-box;display:-ms-flexbox;display:flex}._1vPmS{min-width:38px;height:38px;border:1px solid rgba(0,0,0,.15);border-radius:2px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._1vPmS:not(:last-child){margin-right:4px}._1X7ut{background-color:#ffc107}.ueLIa{color:rgba(0,0,0,.6)}", ""]);

// exports
exports.locals = {
	"root": "_3V7v3",
	"item": "_1vPmS",
	"selected": "_1X7ut",
	"disabled": "ueLIa"
};

/***/ }),

/***/ 3177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(186);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(311);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(313);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(314);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(315);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2237);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(318);

var _warning2 = _interopRequireDefault(_warning);

var _Track = __webpack_require__(2812);

var _Track2 = _interopRequireDefault(_Track);

var _createSlider = __webpack_require__(2813);

var _createSlider2 = _interopRequireDefault(_createSlider);

var _utils = __webpack_require__(2799);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

/* eslint-disable react/prop-types */
var Slider = function (_React$Component) {
  (0, _inherits3['default'])(Slider, _React$Component);

  function Slider(props) {
    (0, _classCallCheck3['default'])(this, Slider);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function () {
      _this.setState({ dragging: false });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    if (false) {
      (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecate, please use trackStyle instead.');
      (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecate, please use railStyle instead.');
    }
    return _this;
  }

  (0, _createClass3['default'])(Slider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          autoFocus = _props.autoFocus,
          disabled = _props.disabled;

      if (autoFocus && !disabled) {
        this.focus();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;

      var prevValue = this.state.value;
      var value = nextProps.value !== undefined ? nextProps.value : prevValue;
      var nextValue = this.trimAlignValue(value, nextProps);
      if (nextValue === prevValue) return;

      this.setState({ value: nextValue });
      if (utils.isValueOutOfRange(value, nextProps)) {
        this.props.onChange(nextValue);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      }

      var changedValue = state.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.prevMovedHandleIndex = 0;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      utils.pauseEvent(e);
      var oldValue = this.state.value;

      var value = this.calcValueByPos(position);
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var valueMutator = utils.getKeyboardValueMutator(e);

      if (valueMutator) {
        utils.pauseEvent(e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;

        this.onChange({ value: value });
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
      var val = utils.ensureValueInRange(v, mergedProps);
      return utils.ensureValuePrecision(val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          vertical = _props2.vertical,
          included = _props2.included,
          disabled = _props2.disabled,
          minimumTrackStyle = _props2.minimumTrackStyle,
          trackStyle = _props2.trackStyle,
          handleStyle = _props2.handleStyle,
          tabIndex = _props2.tabIndex,
          min = _props2.min,
          max = _props2.max,
          handleGenerator = _props2.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        index: 0,
        tabIndex: tabIndex,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });

      var _trackStyle = trackStyle[0] || trackStyle;
      var track = _react2['default'].createElement(_Track2['default'], {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: 0,
        length: offset,
        style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
      });

      return { tracks: track, handles: handle };
    }
  }]);
  return Slider;
}(_react2['default'].Component);

Slider.propTypes = {
  defaultValue: _propTypes2['default'].number,
  value: _propTypes2['default'].number,
  disabled: _propTypes2['default'].bool,
  autoFocus: _propTypes2['default'].bool,
  tabIndex: _propTypes2['default'].number
};
exports['default'] = (0, _createSlider2['default'])(Slider);
module.exports = exports['default'];

/***/ }),

/***/ 3178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3179);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ 3179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ 3180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(316);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(3181);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),

/***/ 3181:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(3182), __esModule: true };

/***/ }),

/***/ 3182:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3183);
var $Object = __webpack_require__(30).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};

/***/ }),

/***/ 3183:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(89);
var $getOwnPropertyDescriptor = __webpack_require__(353).f;

__webpack_require__(352)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),

/***/ 3184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _EventObject = __webpack_require__(3185);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = function () {
      var useCapture = false;
      if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),

/***/ 3185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _EventBaseObject = __webpack_require__(3186);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(188);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),

/***/ 3186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),

/***/ 3187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(1390);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(186);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2237);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2350);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(318);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat);
  if (dots) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? (0, _extends3['default'])({ bottom: offset }, dotStyle) : (0, _extends3['default'])({ left: offset }, dotStyle);
    if (isActived) {
      style = (0, _extends3['default'])({}, style, activeDotStyle);
    }

    var pointClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-active', isActived), _classNames));

    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
  });

  return _react2['default'].createElement('div', { className: prefixCls + '-step' }, elements);
};

Steps.propTypes = {
  prefixCls: _propTypes2['default'].string,
  activeDotStyle: _propTypes2['default'].object,
  dotStyle: _propTypes2['default'].object,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  upperBound: _propTypes2['default'].number,
  lowerBound: _propTypes2['default'].number,
  included: _propTypes2['default'].bool,
  dots: _propTypes2['default'].bool,
  step: _propTypes2['default'].number,
  marks: _propTypes2['default'].object,
  vertical: _propTypes2['default'].bool
};

exports['default'] = Steps;
module.exports = exports['default'];

/***/ }),

/***/ 3188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(186);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(1390);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2237);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2350);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;

  var marksKeys = Object.keys(marks);
  var marksCount = marksKeys.length;
  var unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
  var markWidth = unit * 0.9;

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = (typeof markPoint === 'undefined' ? 'undefined' : _typeof(markPoint)) === 'object' && !_react2['default'].isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className + '-text', true), (0, _defineProperty3['default'])(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = {
      marginBottom: '-50%',
      bottom: (point - min) / range * 100 + '%'
    };

    var leftStyle = {
      width: markWidth + '%',
      marginLeft: -markWidth / 2 + '%',
      left: (point - min) / range * 100 + '%'
    };

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
    return _react2['default'].createElement('span', {
      className: markClassName,
      style: markStyle,
      key: point,
      onMouseDown: function onMouseDown(e) {
        return onClickLabel(e, point);
      },
      onTouchStart: function onTouchStart(e) {
        return onClickLabel(e, point);
      }
    }, markLabel);
  });

  return _react2['default'].createElement('div', { className: className }, elements);
};

Marks.propTypes = {
  className: _propTypes2['default'].string,
  vertical: _propTypes2['default'].bool,
  marks: _propTypes2['default'].object,
  included: _propTypes2['default'].bool,
  upperBound: _propTypes2['default'].number,
  lowerBound: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  min: _propTypes2['default'].number,
  onClickLabel: _propTypes2['default'].func
};

exports['default'] = Marks;
module.exports = exports['default'];

/***/ }),

/***/ 3189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
var _default = KeyCode;
exports.default = _default;

/***/ }),

/***/ 3190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(1390);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(186);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(1496);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(311);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(313);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(314);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(315);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(11);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2237);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2350);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(3191);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _Track = __webpack_require__(2812);

var _Track2 = _interopRequireDefault(_Track);

var _createSlider = __webpack_require__(2813);

var _createSlider2 = _interopRequireDefault(_createSlider);

var _utils = __webpack_require__(2799);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj['default'] = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var Range = function (_React$Component) {
  (0, _inherits3['default'])(Range, _React$Component);

  function Range(props) {
    (0, _classCallCheck3['default'])(this, Range);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.onEnd = function () {
      _this.setState({
        handle: null
      }, _this.blur);
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(undefined, (0, _toConsumableArray3['default'])(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _this.trimAlignValue(v, i);
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  (0, _createClass3['default'])(Range, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
      if (this.props.min === nextProps.min && this.props.max === nextProps.max && (0, _shallowequal2['default'])(this.props.value, nextProps.value)) {
        return;
      }

      var bounds = this.state.bounds;

      var value = nextProps.value || bounds;
      var nextBounds = value.map(function (v, i) {
        return _this2.trimAlignValue(v, i, nextProps);
      });
      if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
        return v === bounds[i];
      })) return;

      this.setState({ bounds: nextBounds });

      if (bounds.some(function (v) {
        return utils.isValueOutOfRange(v, nextProps);
      })) {
        var newValues = value.map(function (v) {
          return utils.ensureValueInRange(v, nextProps);
        });
        this.props.onChange(newValues);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      } else if (state.handle !== undefined) {
        this.setState({ handle: state.handle });
      }

      var data = (0, _extends3['default'])({}, this.state, state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      var props = this.props;
      var state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);

      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });

      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({ bounds: nextBounds });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      utils.pauseEvent(e);
      var state = this.state;

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;

      this.moveTo(value);
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var valueMutator = utils.getKeyboardValueMutator(e);

      if (valueMutator) {
        utils.pauseEvent(e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;

        var oldValue = bounds[handle];
        var mutatedValue = valueMutator(oldValue, props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: 'getClosestBound',
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;

      var closestBound = 0;
      for (var i = 1; i < bounds.length - 1; ++i) {
        if (value > bounds[i]) {
          closestBound = i;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }
      return closestBound;
    }
  }, {
    key: 'getBoundNeedMoving',
    value: function getBoundNeedMoving(value, closestBound) {
      var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;

      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      var bounds = this.state.bounds;

      return bounds[bounds.length - 1];
    }

    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var _props = this.props,
          marks = _props.marks,
          step = _props.step,
          min = _props.min,
          max = _props.max;

      var cache = this._getPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = (0, _extends3['default'])({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this._getPointsCache = { marks: marks, step: step, points: points };
      }
      return this._getPointsCache.points;
    }
  }, {
    key: 'moveTo',
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
      nextBounds[state.handle] = value;
      var nextHandle = state.handle;
      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        handle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
      }
    }
  }, {
    key: 'pushSurroundingHandles',
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var threshold = this.props.pushable;

      threshold = Number(threshold);

      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: 'pushHandle',
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      // the handle was pushed enough to create the needed `amount` gap
      return true;
    }
  }, {
    key: 'pushHandleOnePoint',
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var threshold = this.props.pushable;

      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      }
      // push the handle
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v, handle) {
      var nextProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
      var valInRange = utils.ensureValueInRange(v, mergedProps);
      var valNotConflict = this.ensureValueNotConflict(handle, valInRange, mergedProps);
      return utils.ensureValuePrecision(valNotConflict, mergedProps);
    }
  }, {
    key: 'ensureValueNotConflict',
    value: function ensureValueNotConflict(handle, val, _ref) {
      var allowCross = _ref.allowCross,
          thershold = _ref.pushable;

      var state = this.state || {};
      var bounds = state.bounds;

      handle = handle === undefined ? state.handle : handle;
      thershold = Number(thershold);
      /* eslint-disable eqeqeq */
      if (!allowCross && handle != null && bounds !== undefined) {
        if (handle > 0 && val <= bounds[handle - 1] + thershold) {
          return bounds[handle - 1] + thershold;
        }
        if (handle < bounds.length - 1 && val >= bounds[handle + 1] - thershold) {
          return bounds[handle + 1] - thershold;
        }
      }
      /* eslint-enable eqeqeq */
      return val;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          vertical = _props2.vertical,
          included = _props2.included,
          disabled = _props2.disabled,
          min = _props2.min,
          max = _props2.max,
          handleGenerator = _props2.handle,
          trackStyle = _props2.trackStyle,
          handleStyle = _props2.handleStyle,
          tabIndex = _props2.tabIndex;

      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });

      var handleClassName = prefixCls + '-handle';
      var handles = bounds.map(function (v, i) {
        var _classNames;

        return handleGenerator({
          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, handleClassName, true), (0, _defineProperty3['default'])(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          offset: offsets[i],
          value: v,
          dragging: handle === i,
          index: i,
          tabIndex: tabIndex[i] || 0,
          min: min,
          max: max,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          }
        });
      });

      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
        return _react2['default'].createElement(_Track2['default'], {
          className: trackClassName,
          vertical: vertical,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });

      return { tracks: tracks, handles: handles };
    }
  }]);
  return Range;
}(_react2['default'].Component); /* eslint-disable react/prop-types */

Range.displayName = 'Range';
Range.propTypes = {
  defaultValue: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  value: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  count: _propTypes2['default'].number,
  pushable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
  allowCross: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  tabIndex: _propTypes2['default'].arrayOf(_propTypes2['default'].number)
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: []
};
exports['default'] = (0, _createSlider2['default'])(Range);
module.exports = exports['default'];

/***/ }),

/***/ 3191:
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || !objA || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
};

/***/ }),

/***/ 3192:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3193);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSlider.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./NumberInputWithSlider.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3193:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._15YKx{font-size:14px}._2KVGP{width:100%;height:42px}._1yPd5{margin:-8px 0 0}", ""]);

// exports
exports.locals = {
	"title": "_15YKx",
	"input": "_2KVGP input",
	"slider": "_1yPd5"
};

/***/ }),

/***/ 3194:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3195);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingModal.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingModal.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3195:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".-Wyv0{font-size:12px;z-index:10;position:relative}.iAO0X{padding:20px 15px}.rorEY{overflow-y:auto;max-height:100vh;margin:0 auto}._2nzt2{position:relative;border-radius:10px;max-width:330px}._2s_UK,.nugq9{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}.nugq9:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"titleLeasingLink": "-Wyv0",
	"rootModalLeasing": "iAO0X",
	"rootModal": "rorEY",
	"modal": "_2nzt2",
	"closeBtnIcon": "_2s_UK",
	"closeBtn": "nugq9"
};

/***/ }),

/***/ 3196:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d2da1909.png";

/***/ }),

/***/ 3197:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3198);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingCalculatorForm.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingCalculatorForm.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3198:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2sURt{width:340px;height:400px;background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.2)),to(rgba(253,191,0,.2))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.2),rgba(253,191,0,.2)),#fff;border-radius:10px;padding:20px 25px}.vql5u{font-size:12px;line-height:14px;color:gray}.IVMAy{font-weight:700;font-size:20px;line-height:24px}", ""]);

// exports
exports.locals = {
	"root": "_2sURt",
	"monthlyTitle": "vql5u",
	"monthlyPrice": "IVMAy"
};

/***/ }),

/***/ 3199:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3200);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingHeader.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingHeader.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3200:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1fEOF{border-radius:15px;background:url(" + __webpack_require__(2238) + ") no-repeat left 240px,-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.4)),to(rgba(253,191,0,.4)));background:url(" + __webpack_require__(2238) + ") no-repeat left 240px,-o-linear-gradient(bottom,rgba(253,191,0,.4),rgba(253,191,0,.4));background:url(" + __webpack_require__(2238) + ") no-repeat left 240px,linear-gradient(0deg,rgba(253,191,0,.4),rgba(253,191,0,.4));min-height:520px;padding:60px 70px;position:relative}._3rsyK{background:url(" + __webpack_require__(2239) + ") no-repeat 100% 100%;position:absolute;top:0;right:0;bottom:0;left:0}._20BIc{font-weight:700;font-size:26px;line-height:31px;margin-bottom:20px}._36Vg1{width:520px;height:57px;font-size:16px;line-height:19px}._1G1fZ{position:absolute;right:100px;top:60px}@media screen and (max-width:768px){._1fEOF{border-radius:0;background:url(" + __webpack_require__(2238) + ") no-repeat left 180px,-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.4)),to(rgba(253,191,0,.4)));background:url(" + __webpack_require__(2238) + ") no-repeat left 180px,-o-linear-gradient(bottom,rgba(253,191,0,.4),rgba(253,191,0,.4));background:url(" + __webpack_require__(2238) + ") no-repeat left 180px,linear-gradient(0deg,rgba(253,191,0,.4),rgba(253,191,0,.4));min-height:752px;padding:30px 13px}._1fEOF:after{background:url(" + __webpack_require__(2239) + ") no-repeat left 240px;position:absolute;top:0;right:0;bottom:0;left:0}._36Vg1{width:auto}._1G1fZ{position:absolute;left:0;right:0;bottom:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:end;-ms-flex-align:end;align-items:end}}", ""]);

// exports
exports.locals = {
	"root": "_1fEOF",
	"bg": "_3rsyK",
	"title": "_20BIc",
	"description": "_36Vg1",
	"calculationForm": "_1G1fZ"
};

/***/ }),

/***/ 3201:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b15d3e3e.png";

/***/ }),

/***/ 3202:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0d3b0cd4.png";

/***/ }),

/***/ 3203:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "791a1220.png";

/***/ }),

/***/ 3204:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9919fcd0.png";

/***/ }),

/***/ 3205:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7094197d.png";

/***/ }),

/***/ 3206:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3207);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingConditions.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingConditions.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3207:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3FZvz{height:330px;background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.3)),to(rgba(253,191,0,.3))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.3),rgba(253,191,0,.3)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.3),rgba(253,191,0,.3)),#fff;border-radius:15px;padding-left:20px;padding-top:40px;position:relative}._32jBg{background:url(" + __webpack_require__(2239) + ") no-repeat 100% 100%;position:absolute;top:0;right:0;bottom:0;left:0}._1n72M{font-weight:600;font-size:20px;line-height:120%;margin-bottom:32px}._3NNXh{position:relative;z-index:1}._2alfg,._3NNXh{display:-webkit-box;display:-ms-flexbox;display:flex}._2alfg{width:240px;height:180px;background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.15)),to(rgba(253,191,0,.15))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.15),rgba(253,191,0,.15)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.15),rgba(253,191,0,.15)),#fff;border-radius:10px;margin-right:10px;padding:20px;text-align:start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.-ss0J{width:70px;height:70px;background:#ffd906;border-radius:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.Ii0zF{width:320px;height:270px;position:absolute;right:0;top:30px}@media screen and (max-width:768px){._3FZvz{height:430px;padding:25px 15px}._1n72M{width:120px}._3NNXh{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._2alfg,._3NNXh{-webkit-box-direction:normal}._2alfg{width:auto;height:90px;margin-bottom:10px;margin-right:0;-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;padding:15px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._1Ksmn{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.-ss0J{width:60px;height:60px;margin-right:15px}.Ii0zF{top:10px}.Ii0zF,.Ii0zF img{width:150px;height:120px}}", ""]);

// exports
exports.locals = {
	"root": "_3FZvz",
	"bg": "_32jBg",
	"title": "_1n72M",
	"items": "_3NNXh",
	"item": "_2alfg",
	"icon": "-ss0J",
	"image": "Ii0zF",
	"text": "_1Ksmn"
};

/***/ }),

/***/ 3208:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3209);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Accordion.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Accordion.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3209:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3LcvH{display:-webkit-box;display:-ms-flexbox;display:flex}.dELCN{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;list-style:none;margin-left:0;padding-left:0}.dELCN:not(:last-child){margin-right:20px}._3T2K9{font-size:14px;padding:15px;background:#fff;margin-bottom:10px;min-height:60px;border-radius:5px}._3T2K9:last-child{border-bottom:1px solid #c4c4c4}._3xHvy{font-style:normal;font-weight:400;font-size:16px;line-height:120%}._1y0Io{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-weight:700;font-size:14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.mMF89{font-size:14px;font-weight:300;line-height:150%}._1r8NR{font-size:14px;line-height:1.45;list-style:initial;padding-left:25px}.Ycho7{display:none}.NuXul{width:28px;height:28px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f5f5f5;color:gray;border-radius:28px;cursor:pointer}._1SQLg:before{content:\"\\2014\";font-size:15px}.Plj5A:before{content:\"+\";font-size:24px;font-weight:100}", ""]);

// exports
exports.locals = {
	"root": "_3LcvH",
	"group": "dELCN",
	"p": "_3T2K9",
	"title": "_3xHvy",
	"groupTitle": "_1y0Io",
	"item": "mMF89",
	"details": "_1r8NR",
	"detailsHidden": "Ycho7",
	"groupToggleBtn": "NuXul",
	"groupToggleOpened": "_1SQLg",
	"groupToggleClosed": "Plj5A"
};

/***/ }),

/***/ 3210:
/***/ (function(module, exports) {

module.exports = [{"title":"Стоит ли брать автомобиль в лизинг от avtobazar.ua?","html":"Покупка авто в лизинг с нашей помощью предоставляет ряд выгод и преимуществ по сравнению с прочими видами займов, поскольку у нас вы: <ul> <li>оформляете сделку за 24 часа;</li> <li>обходитесь без справки о доходах, залогов и поручителей;</li> <li>можете иметь испорченную кредитную историю;</li> <li>выбираете автомашину с гарантией одобрения заявки по ней;</li> <li>приобретаете проверенное авто с полным обслуживанием, страховкой и регистрацией;</li> <li>не должны подтверждать свое финансовое положение;</li> <li>заключаете договор без скрытых комиссий и платежей;</li> <li>имеете право на досрочное погашение;</li> </ul> поиск, подбор, оценку и оформление машин производите на едином ресурсе. Существует одна ситуация, при которой рассматривать лизинг от Avtobazar не имеет смысла – если вы располагаете полной суммой для покупки автомобиля и можете потратить ее безболезненно для собственного бюджета. В остальных случаях «Автобазар» - это реальная возможность быстро и просто получить финансирование на подходящих лично вам условиях.","title_uk":"Чи варто брати автомобіль у лізинг від avtobazar.ua?","html_uk":"Покупка авто в лізинг з нашою допомогою надає низку вигод та переваг у порівнянні з іншими видами позик, оскільки у нас ви: <ul> <li>оформляєте угоду за 24 години;</li> <li>обходьтеся без довідки про доходи, застав та поручителів;</li> <li>можете мати зіпсовану кредитну історію;</li> <li>вибираєте автомашину з гарантією схвалення заявки по ній;</li> <li>придбаєте перевірене авто з повним обслуговуванням , страховкою та реєстрацією;</li> <li>не повинні підтверджувати своє фінансове становище;</li> <li>укладаєте договір без прихованих комісій та платежів;</li> <li>маєте право на дострокове погашення;</li Існує одна ситуація, при якій розглядати лізинг від Avtobazar не має сенсу - якщо ви маєте повну суму для покупки автомобіля і можете витратити її безболісно для власного бюджету. інших випадках «Автобазар» - це реальна можливість швидко та просто отримати фінансування на відповідних вам умовах."},{"title":"Какой автомобиль можно взять в лизинг?","html":"Выбирайте авто для покупки в лизинг по его типу, возрасту, наличию документов и состоянию. При рассмотрении заявок приоритет отдается моделям кат. В: <ul> <li>отечественным и китайским не старше 7 дет;</li> <li>иномаркам – 20-ти лет;</li> <li>легковым коммерческим иномаркам – 15-ти лет.</li> </ul> Автомобиль должен быть растаможен и пребывать в Украине, стоять на учете в МВД, не иметь преград для перерегистрации и сохранять состояние, характерное для своего возраста и пройденного километража.  В случае интереса к транспорту категорий C либо D, машинам старше указанного возраста или других нестандартных ситуаций, каждый запрос рассматривается в индивидуальном порядке.","title_uk":"Який автомобіль можна взяти в лізинг?","html_uk":"Вибирайте авто для покупки в лізинг за його типом, віком, наявністю документів та станом. При розгляді заявок пріоритет надається моделям кат. В: <ul> <li>вітчизняним і китайським не старше 7 дет;</li> <li>іномаркам – 20-ти років;</li> <li>легковим комерційним іномаркам – 15-ти років.</li> </ul> Автомобіль має бути розмитнений і перебувати в Україні, стояти на обліку в МВС, не мати перешкод для перереєстрації та зберігати стан, характерний для свого віку та пройденого кілометражу. У разі інтересу до транспорту категорій C або D, машин старшого за зазначений вік або інших нестандартних ситуацій, кожен запит розглядається в індивідуальному порядку."},{"title":"Кто может взять машину в лизинг? (требования к лизингополучателю)","html":"Приобрести транспортное средство в лизинг может любое физическое или юридическое лицо: <ul> <li>с украинским гражданством</li>; <li>в возрасте от 21 до 65 лет.</li> </ul> Единственным дополнительным условием является необходимость подписывать документы в регионе присутствия представителей компании-лизингодателя.","title_uk":"Хто може взяти машину в лізинг? (вимоги до лізингоодержувача)","html_uk":"Придбати транспортний засіб у лізинг може будь-яка фізична чи юридична особа: <ul> <li>з українським громадянством</li>; <li>у віці від 21 до 65 років.</li> </ul> Єдиною додатковою умовою є необхідність підписувати документи в регіоні присутності представників компанії-лізингодавця."},{"title":"Какие документы нужны для оформления лизинга?","html":"Для подписания лизингового контракта от покупателя требуются: <ul> <li>паспорт гражданина Украины;</li> <li>идентификационный налоговый номер (ИНН).</li> </ul> Продавцу необходимо предоставить техпаспорт автомобиля, одобренного для сделки.","title_uk":"Які документи необхідні для оформлення лізингу?","html_uk":"Для підписання лізингового договору від покупця потрібні: <ul><li>паспорт громадянина України;</li><li>ідентифікаційний податковий номер (ІПН).</li></ul> Продавцю необхідно надати техпаспорт автомобіля, схваленого для угоди."},{"title":"В какой валюте можно платить?","html":"Оплачивать лизинг позволяется сугубо в национальной валюте Украины – гривне.","title_uk":"Якою валютою можна платити?","html_uk":"Оплачувати лізинг дозволяється лише у національній валюті України – гривні."},{"title":"Можно ли погасить лизинг досрочно?","html":"Право погасить лизинг досрочно имеет любой заемщик по истечении одного года с момента подписания договора. Сделать это разрешается в любой момент, оплатив остаток долга за автомобиль и стоимость оплаченных лизингодателем услуг, таких как регистрация авто в сервисном центре МВД, страхование в текущем периоде и т.п.","title_uk":"Чи можна погасити лізинг достроково?","html_uk":"Право погасити лізинг достроково має будь-який позичальник після одного року з підписання договору. Зробити це дозволяється у будь-який момент, сплативши залишок боргу за автомобіль та вартість оплачених лізингодавцем послуг, таких як реєстрація авто у сервісному центрі МВС, страхування у поточному періоді тощо."},{"title":"В чем разница между лизингом и автокредитом?","html":"Отличие финансового лизинга от традиционного автокредита заключается в способе получения транспортного средства, оплате и праве собственности. В случае кредита вы: <ul> <li>получаете от банка средства;</li> <li>самостоятельно заключаете договор с продавцом;</li> <li>занимаетесь проверкой, обслуживанием, постановкой на учет и страхованием авто.</li> </ul> Машина сразу переходит в вашу собственность и все хлопоты по ее эксплуатации ложатся на вас. К тому же, в случае долговых обязательств по другим кредитам, на него может накладываться арест. При оформлении лизинга взаимоотношения с продавцом, полицией и страховыми компаниями берет на себя лизингодатель, тогда как вы: <ul> <li>заключаете только соглашение с лизингодателем;</li> <li>эксплуатируете машину на правах длительной аренды;</li> <li>все платежи осуществляете в счет итоговой стоимости ТС.</li> </ul> До полного выкупа авто принадлежит компании-лизингодателю, не подлежит изъятию сторонними организациями и перерегистрируется на вас после завершения долговых обязательств по договору.","title_uk":"У чому різниця між лізингом та автокредитом?","html_uk":"Відмінність фінансового лізингу від традиційного автокредиту полягає у способі отримання транспортного засобу, оплаті та праві власності. <br/> У разі кредиту ви: <ul> <li>отримуєте від банку кошти;</li> <li>самостійно укладаєте договір із продавцем;</li> <li>займаєтеся перевіркою, обслуговуванням, постановкою на облік та страхуванням авто.</li> </ul> Машина відразу переходить у вашу власність і весь клопіт по її експлуатації лягає на вас. До того ж у разі боргових зобов'язань за іншими кредитами на нього може накладатися арешт. При оформленні лізингу взаємини з продавцем, поліцією та страховими компаніями бере на себе лізингодавець, тоді як ви: <ul><li>укладаєте лише угоду з лізингодавцем;</li><li>експлуатуєте машину на правах тривалої оренди;</li><li>всі платежі здійснюєте у рахунок підсумкової вартості ТЗ.</li> </ul> До повного викупу авто належить компанії-лізингодавцю, не підлягає вилученню сторонніми організаціями та перереєструється на вас після завершення боргових зобов'язань за договором."},{"title":"Кто является собственником авто в лизинге?","html":"С момента подписания и до завершения действия лизингового договора автомобиль остается в собственности компании лизингодателя. Вы эксплуатируете его с первого дня на условиях долгосрочной аренды c зачислением ваших ежемесячных платежей в счет общей суммы соглашения. После выкупа авто переходит в вашу собственность.","title_uk":"Хто є власником авто у лізингу?","html_uk":"З моменту підписання та до завершення дії лізингового договору автомобіль залишається у власності компанії лізингодавця. Ви експлуатуєте його з першого дня на умовах довгострокової оренди із зарахуванням ваших щомісячних платежів у рахунок загальної суми угоди. Після викупу автомобіль переходить у вашу власність."},{"title":"Как продать машину, которая в лизинге?","html":"Для продажи автомобиля при действующем лизинговом соглашении, необходимо получить письменное согласие лизингодателя, дождаться окончания действия договора либо досрочно выполнить обязательства по нему, и распоряжаться авто по собственному усмотрению.","title_uk":"Як продати машину, що є у лізингу?","html_uk":"Для продажу автомобіля за чинною лізинговою угодою, необхідно отримати письмову згоду лізингодавця, дочекатися закінчення дії договору або достроково виконати зобов'язання по ньому, і розпоряджатися авто на власний розсуд."},{"title":"Что делать, если возникла просрочка?","html":"Конечно, нарушение сроков оплаты по договору лучше не допускать, но, если это произошло, рекомендуем: <ul> <li>Оставаться на связи с представителями лизингодателя.</li> <li>Постараться оплатить пеню максимально быстро.</li> </ul> Если ситуация сложная, открыто изложить ее суть лизинговому менеджеру, чтобы совместно найти из нее выход.","title_uk":"Що робити, якщо виникло прострочення?","html_uk":"Звичайно, порушення термінів оплати за договором краще не допускати, але якщо це сталося, рекомендуємо: <ul> <li>Залишатися на зв'язку з представниками лізингодавця.</li> <li>Постаратися сплатити пеню максимально швидко.</li> <li>Якщо ситуація складна, відкрито викласти її суть лізингового менеджера, щоб спільно знайти із неї вихід.</li> </ul>"},{"title":"Могут ли забрать авто, если не платить своевременно?","html":"В соответствии с положениями лизингового соглашения автомобиль действительно может быть отобран у заемщика, но исключительно в случае длительных просрочек. Длительным считается срок более 60 дней, в течение которых лизингополучатель не выполняет собственные обязательства. Если по истечении данного периода человек не платит, не выходит на связь либо не может достичь компромисса с компанией лизингодателем, последняя может изъять авто. В последующем возможно и ее обращение в суд с целью ареста прочего имущества должника. Для избежания этого, рекомендуем оставаться на связи и быть открытым к переговорному процессу.","title_uk":"Чи можуть забрати авто, якщо не платити вчасно?","html_uk":"Відповідно до положень лізингової угоди автомобіль дійсно може бути відібраний у позичальника, але виключно у разі тривалих прострочень. Тривалим вважається термін понад 60 днів, протягом яких лізингоодержувач не виконує своїх зобов'язань. Якщо після цього періоду людина не платить, не виходить на зв'язок або не може досягти компромісу з компанією лізингодавцем, остання може вилучити авто. Надалі можливе і її звернення до суду з метою арешту іншого майна боржника. Для уникнення цього рекомендуємо залишатися на зв'язку та бути відкритим до переговорного процесу."},{"title":"Какой размер штрафа/пени при просрочке платежа?","html":"В случае возникновения просрочки лизингополучатель должен оплатить пеню. Ее размер оговаривается в договоре и составляет двойную учетную ставку НБУ от суммы задолженности. Платежи взимаются за каждый «штрафной» день, а размер ставки НБУ учитывается исходя из ее размера на момент просрочки.","title_uk":"Який розмір штрафу/пені під час прострочення платежу?","html_uk":"У разі виникнення прострочення лізингоодержувач має сплатити пеню. Її розмір обумовлюється у договорі та становить подвійну облікову ставку НБУ від суми заборгованості. Платежі стягуються за кожен «штрафний» день, а розмір ставки НБУ враховується, виходячи з її розміру на момент прострочення."}]

/***/ }),

/***/ 3211:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3212);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingFaq.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingFaq.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3212:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports
exports.locals = {
	"root": "sQSex"
};

/***/ }),

/***/ 3213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slider = _interopRequireDefault(__webpack_require__(3214));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

var _default = _slider["default"];
exports["default"] = _default;

/***/ }),

/***/ 3214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(11));

var _innerSlider = __webpack_require__(3215);

var _json2mq = _interopRequireDefault(__webpack_require__(3222));

var _defaultProps = _interopRequireDefault(__webpack_require__(3224));

var _innerSliderUtils = __webpack_require__(2351);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(3225);

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== "production") {}

        if (settings.slidesToScroll > 1 && "production" !== "production") {}

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return (/*#__PURE__*/_react["default"].createElement("div", {
            className: className
          }, children)
        );
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return (/*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
          style: this.props.style,
          ref: this.innerSliderRefHandler
        }, settings), newChildren)
      );
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;

/***/ }),

/***/ 3215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerSlider = void 0;

var _react = _interopRequireDefault(__webpack_require__(11));

var _initialState = _interopRequireDefault(__webpack_require__(3216));

var _lodash = _interopRequireDefault(__webpack_require__(3217));

var _classnames = _interopRequireDefault(__webpack_require__(2372));

var _innerSliderUtils = __webpack_require__(2351);

var _track = __webpack_require__(3218);

var _dots = __webpack_require__(3219);

var _arrows = __webpack_require__(3220);

var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(3221));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty(_assertThisInitialized(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return (/*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: _this.listRefHandler
        }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends({
          ref: _this.trackRefHandler
        }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "")
      );
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

exports.InnerSlider = InnerSlider;

/***/ }),

/***/ 3216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;

/***/ }),

/***/ 3217:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = debounce;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 3218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;

var _react = _interopRequireDefault(__webpack_require__(11));

var _classnames = _interopRequireDefault(__webpack_require__(2372));

var _innerSliderUtils = __webpack_require__(2351);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread(_objectSpread({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread(_objectSpread({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread(_objectSpread({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  var _super = _createSuper(Track);

  function Track() {
    var _this;

    _classCallCheck(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "node", null);

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return (/*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: this.handleRef,
          className: "slick-track",
          style: this.props.trackStyle
        }, mouseEvents), slides)
      );
    }
  }]);

  return Track;
}(_react["default"].PureComponent);

exports.Track = Track;

/***/ }),

/***/ 3219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dots = void 0;

var _react = _interopRequireDefault(__webpack_require__(11));

var _classnames = _interopRequireDefault(__webpack_require__(2372));

var _innerSliderUtils = __webpack_require__(2351);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  var _super = _createSuper(Dots);

  function Dots() {
    _classCallCheck(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return (/*#__PURE__*/_react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
          className: this.props.dotsClass
        }, mouseEvents))
      );
    }
  }]);

  return Dots;
}(_react["default"].PureComponent);

exports.Dots = Dots;

/***/ }),

/***/ 3220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextArrow = exports.PrevArrow = void 0;

var _react = _interopRequireDefault(__webpack_require__(11));

var _classnames = _interopRequireDefault(__webpack_require__(2372));

var _innerSliderUtils = __webpack_require__(2351);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });keys.push.apply(keys, symbols);
  }return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  var _super = _createSuper(PrevArrow);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.prevArrow, _objectSpread(_objectSpread({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react["default"].PureComponent);

exports.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper(NextArrow);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react["default"].cloneElement(this.props.nextArrow, _objectSpread(_objectSpread({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react["default"].createElement("button", _extends({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react["default"].PureComponent);

exports.NextArrow = NextArrow;

/***/ }),

/***/ 3221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return (/** @class */function () {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function get() {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * @param {*} key
             * @returns {*}
             */
            class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
             * @param {*} key
             * @param {*} value
             * @returns {void}
             */
            class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) {
                    this.__entries__[index][1] = value;
                } else {
                    this.__entries__.push([key, value]);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) {
                    entries.splice(index, 1);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
             * @returns {void}
             */
            class_1.prototype.clear = function () {
                this.__entries__.splice(0);
            };
            /**
             * @param {Function} callback
             * @param {*} [ctx=null]
             * @returns {void}
             */
            class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) {
                    ctx = null;
                }
                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }()
    );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName,
            propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth,
        clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();

var ResizeObserverEntry = /** @class */function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}();

var ResizeObserverSPI = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
}();

/* harmony default export */ __webpack_exports__["default"] = (index);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5)))

/***/ }),

/***/ 3222:
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(3223);

var isDimension = function isDimension(feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function obj2mq(obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length - 1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function json2mq(query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length - 1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 3223:
/***/ (function(module, exports) {

var camel2hyphen = function camel2hyphen(str) {
  return str.replace(/[A-Z]/g, function (match) {
    return '-' + match.toLowerCase();
  }).toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 3224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return (/*#__PURE__*/_react["default"].createElement("ul", {
        style: {
          display: "block"
        }
      }, dots)
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return (/*#__PURE__*/_react["default"].createElement("button", null, i + 1)
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;

/***/ }),

/***/ 3225:
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(3226);
module.exports = new MediaQueryDispatch();

/***/ }),

/***/ 3226:
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(3227);
var Util = __webpack_require__(2816);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch() {
    if (!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor: MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register: function register(q, options, shouldDegrade) {
        var queries = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if (!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if (isFunction(options)) {
            options = { match: options };
        }
        if (!isArray(options)) {
            options = [options];
        }
        each(options, function (handler) {
            if (isFunction(handler)) {
                handler = { match: handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister: function unregister(q, handler) {
        var query = this.queries[q];

        if (query) {
            if (handler) {
                query.removeHandler(handler);
            } else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;

/***/ }),

/***/ 3227:
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(3228);
var each = __webpack_require__(2816).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function (mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor: MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler: function addHandler(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler: function removeHandler(handler) {
        var handlers = this.handlers;
        each(handlers, function (h, i) {
            if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches: function matches() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear: function clear() {
        each(this.handlers, function (handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess: function assess() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function (handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;

/***/ }),

/***/ 3228:
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor: QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup: function setup() {
        if (this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on: function on() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off: function off() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy: function destroy() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals: function equals(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;

/***/ }),

/***/ 3229:
/***/ (function(module, exports) {

module.exports = [{"avatar":"chepura","name":"Чепурная А. П.","text":"Срочно нужна была машина, поэтому решилась на автолизинг, т.к. брать кредиты не люблю. Очень удобно и быстро. Из документов только паспорт и ИНН, никаких справок о доходах. Забрала авто на следующий день. Спасибо avtobazar.ua за большой выбор машин и одобрение в лизинге","rate":5},{"avatar":"otrishko","name":"Отрышко А.А.","text":"С момента оформления лизинга до передачи авто прошло пару часов. Машину выбрал на сайте быстро, ориентируясь на сумму месячного платежа. Без лишних документов и вопросов. Рекомендую","rate":5},{"avatar":"efremova","name":"Ефремова О. И.","text":"Спасибо avtobazar.ua за возможность купить авто своей мечты на таких простых условиях. Лизинг брала впервые. Одобрили запрос сразу, хотя машина не из бюджетных. Оформили все в тот же день. Услуга класс, мой рекомендасьон)","rate":5},{"avatar":"savchenko","name":"Савченко В. С.","text":"У вас просто нет шанса уйти без машины! Выбрал тачку, подал заявку на лизинг. Перезвонили сразу, все рассказали по условиям. Через пару часов встретили у нотариуса, и все оформили. Просто и без проблем. Рекомендую","rate":5},{"avatar":"shilo","name":"Андреев Т. А.","text":"Если у вас нет денег на авто, то лизинг ваш шанс. Берите смело машину в лизинг на avtobazar.ua. Компания уже много лет на рынке. Сам уже и продавал машину и покупал запчасти, а вот сейчас и лизинг взял. Никаких нареканий. Честные ребята и все прозрачно","rate":5},{"avatar":"mihalchenko","name":"Бородько И. В.","text":"Первый раз брала машину под пригон на Автобазар. Процедура не из быстрых, но сэкономить получилось. В этот раз решила взять лизинг на премиальное авто. Одобрение получила без проблем, быстро оформили сделку. Пока без нареканий","rate":5}]

/***/ }),

/***/ 3230:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5da15826.png";

/***/ }),

/***/ 3231:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "95642a18.png";

/***/ }),

/***/ 3232:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c4d93c45.png";

/***/ }),

/***/ 3233:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b18d07f4.png";

/***/ }),

/***/ 3234:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d46ee5cb.png";

/***/ }),

/***/ 3235:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c37042fc.png";

/***/ }),

/***/ 3236:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3237);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingFeedbackCard.css", function() {
        content = require("!!../../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingFeedbackCard.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3237:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, ".JbjXG{width:340px;height:300px;background:#fff;border-radius:5px;padding:15px;-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:30px}._29SwS,.JbjXG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}._29SwS{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;margin-bottom:20px}.YiIiW{width:50px;height:50px;margin-right:10px;border-radius:50px}._3H-Rq{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.nCIpd{font-size:14px;line-height:140%;margin-bottom:20px}._1nDMy{height:0;border-bottom:1px solid #c4c4c4;margin-bottom:15px}", ""]);

// exports
exports.locals = {
	"root": "JbjXG",
	"head": "_29SwS",
	"avatar": "YiIiW",
	"name": "_3H-Rq",
	"text": "nCIpd",
	"divider": "_1nDMy"
};

/***/ }),

/***/ 3238:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3239);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingFeedback.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingFeedback.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3239:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1AzHL .slick-dots li:not(.slick-active){margin-top:3px}._1AzHL .slick-dots li.slick-active{margin:0 6px;border:2px solid #ffc107;border-radius:10px}._1AzHL .slick-dots li button{width:10px;height:10px;border-radius:10px;background:#c4c4c4}._1AzHL .slick-dots li.slick-active button{width:13px;height:13px;border-radius:16px;border-width:3px;background-color:#ffc107;border:3px solid #fff}", ""]);

// exports
exports.locals = {
	"root": "_1AzHL"
};

/***/ }),

/***/ 3240:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dafb25f6.png";

/***/ }),

/***/ 3241:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "26ad857a.png";

/***/ }),

/***/ 3242:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1e847b8d.png";

/***/ }),

/***/ 3243:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3244);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingGuaranty.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingGuaranty.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3244:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2KuOH{height:280px;background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.3)),to(rgba(253,191,0,.3))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.3),rgba(253,191,0,.3)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.3),rgba(253,191,0,.3)),#fff;border-radius:10px;padding:30px;position:relative}._3PtgD{font-weight:600;font-size:20px;line-height:120%;margin-bottom:26px}._3vqFB{height:180px;border-top:1px solid rgba(0,0,0,.2)}._3vqFB,._10GA3{display:-webkit-box;display:-ms-flexbox;display:flex}._10GA3{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._10GA3:not(:last-child){border-right:1px solid rgba(0,0,0,.2)}._2hLHh{width:70px;height:70px;background:#ffd906;border-radius:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:20px}._2UgLA{width:200px}@media screen and (max-width:768px){._2KuOH{height:388px;padding:20px 15px}._3PtgD{margin-bottom:20px}._3vqFB{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}._3vqFB,._10GA3{-webkit-box-direction:normal}._10GA3{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start;margin-top:30px;margin-bottom:0}._10GA3,._10GA3:not(:last-child){border:none}._2hLHh{width:60px;height:60px;margin-right:15px;margin-bottom:0}}", ""]);

// exports
exports.locals = {
	"root": "_2KuOH",
	"title": "_3PtgD",
	"items": "_3vqFB",
	"item": "_10GA3",
	"icon": "_2hLHh",
	"text": "_2UgLA"
};

/***/ }),

/***/ 3245:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d92c901f.png";

/***/ }),

/***/ 3246:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e5fafdc2.png";

/***/ }),

/***/ 3247:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "51e8311e.png";

/***/ }),

/***/ 3248:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3249);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingHowToPayOff.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingHowToPayOff.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3249:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._1W7eC{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._3fh-j{width:340px;height:380px;border-radius:10px;background:#fff;position:relative}._1uqgQ{background:url(" + __webpack_require__(2239) + ") no-repeat 60px bottom;position:absolute;top:0;right:0;bottom:0;left:0}._3fh-j:not(:last-child){margin-right:20px}._3r34q{height:260px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._1lNSN{width:160px;margin-left:30px;margin-top:40px;font-weight:500;font-size:18px;line-height:120%}@media screen and (max-width:768px){._1W7eC{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1uqgQ{background:url(" + __webpack_require__(2239) + ") no-repeat 130px bottom;-webkit-transform:scaleY(-1) scaleX(-1);transform:scaleY(-1) scaleX(-1)}._3fh-j{height:220px;margin-bottom:10px;display:-webkit-box;display:-ms-flexbox;display:flex;width:auto;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}._3fh-j:not(:last-child){margin-right:0}._3r34q{-webkit-box-align:end;-ms-flex-align:end;align-items:end}._3r34q img{height:120px}._1lNSN{width:auto;margin:20px;text-align:center}}", ""]);

// exports
exports.locals = {
	"items": "_1W7eC",
	"item": "_3fh-j",
	"bg": "_1uqgQ",
	"image": "_3r34q",
	"itemTitle": "_1lNSN"
};

/***/ }),

/***/ 3250:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6915864b.png";

/***/ }),

/***/ 3251:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ead8e05f.png";

/***/ }),

/***/ 3252:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f2458a82.png";

/***/ }),

/***/ 3253:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3254);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingPartners.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingPartners.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3254:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3FF0c{-ms-flex-pack:center;-ms-flex-align:center}._3FF0c,._3FF0c>a{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}._3FF0c>a{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;-ms-flex-pack:center;-ms-flex-align:center}@media screen and (max-width:768px){._3FF0c{-ms-flex-wrap:wrap;flex-wrap:wrap}._3FF0c>a>img{width:150px}}", ""]);

// exports
exports.locals = {
	"root": "_3FF0c"
};

/***/ }),

/***/ 3255:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3256);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingCars.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingCars.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3256:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3x2i4{padding:30px;height:300px;background-color:#fff;border-radius:5px}._1xL26{overflow-y:auto;height:100%}@media screen and (max-width:768px){._3x2i4{padding:15px 20px;height:460px}}", ""]);

// exports
exports.locals = {
	"root": "_3x2i4",
	"container": "_1xL26"
};

/***/ }),

/***/ 3257:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d239f156.svg";

/***/ }),

/***/ 3258:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3259);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingWhyAbUa.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingWhyAbUa.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3259:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2Xbgn{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2Aizy,._2Xbgn{display:-webkit-box;display:-ms-flexbox;display:flex}._2Aizy{width:340px;height:90px;padding:20px;background:#fff;border-radius:5px;margin-bottom:20px}._2Aizy:not(:nth-child(3n)){margin-right:20px}._2aEl_{margin-right:20px;width:50px;height:50px;background:#ffd906;border-radius:50px}._1qObY,._2aEl_{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1qObY{font-weight:500;font-size:16px;width:230px}@media screen and (max-width:768px){._2Aizy{width:auto;height:90px;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._2Aizy:not(:nth-child(3n)){margin-right:0}}", ""]);

// exports
exports.locals = {
	"root": "_2Xbgn",
	"item": "_2Aizy",
	"icon": "_2aEl_",
	"text": "_1qObY"
};

/***/ }),

/***/ 3260:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3261);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingSpecialPropositions.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingSpecialPropositions.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3261:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._3jogv,.D_Sjr{position:relative}.D_Sjr{background-color:#ffd906;color:#000;font-weight:600;border:0;padding:8px 7px;border-radius:2px;width:100%;font-size:14px;cursor:pointer;display:block;text-decoration:none;text-align:center;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;-webkit-transition:all .1s ease-out;-o-transition:all .1s ease-out;transition:all .1s ease-out;line-height:1.15}.D_Sjr:hover{background-color:#ffc107;color:#000}", ""]);

// exports
exports.locals = {
	"root": "_3jogv",
	"searchBtn": "D_Sjr"
};

/***/ }),

/***/ 3262:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de3288fe.png";

/***/ }),

/***/ 3263:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3264);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingReliablePartner.css", function() {
        content = require("!!../../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./LeasingReliablePartner.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3264:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2c7GK{height:420px;background:-webkit-gradient(linear,left bottom,left top,from(rgba(253,191,0,.3)),to(rgba(253,191,0,.3))),#fff;background:-o-linear-gradient(bottom,rgba(253,191,0,.3),rgba(253,191,0,.3)),#fff;background:linear-gradient(0deg,rgba(253,191,0,.3),rgba(253,191,0,.3)),#fff;border-radius:10px;padding:30px;position:relative}._1-xuL{background:url(" + __webpack_require__(2239) + ") no-repeat 510px bottom;position:absolute;top:0;right:0;bottom:0;left:0}.hcQqL{width:250px;font-weight:600;font-size:20px;line-height:120%;margin-bottom:32px}._2dQ9x{width:490px}.zXFnA{border-top:1px solid rgba(0,0,0,.2);height:130px;margin-bottom:10px}._3qdJ3,.ez0ba,.zXFnA{display:-webkit-box;display:-ms-flexbox;display:flex}._3qdJ3,.ez0ba{width:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._3qdJ3>b,.ez0ba>b{display:-webkit-box;display:-ms-flexbox;display:flex;font-weight:600;font-size:40px;line-height:120%;text-align:center;color:#ffc107}._3qdJ3>div,.ez0ba>div{font-weight:400;font-size:14px;line-height:120%;text-align:center}.ez0ba{border-left:1px solid rgba(0,0,0,.2)}._1O_5k{position:absolute;right:60px;top:60px}@media screen and (max-width:768px){._2c7GK{height:590px;padding:15px 20px}.hcQqL{margin-bottom:12px}._2dQ9x{width:auto;margin-top:28px}._1O_5k{right:0;left:0;top:0;width:320px;margin:0 auto;position:relative}.zXFnA{height:110px}}", ""]);

// exports
exports.locals = {
	"root": "_2c7GK",
	"bg": "_1-xuL",
	"title": "hcQqL",
	"info": "_2dQ9x",
	"block": "zXFnA",
	"left": "_3qdJ3",
	"right": "ez0ba",
	"image": "_1O_5k"
};

/***/ }),

/***/ 3265:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3266);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TitleDivider.css", function() {
        content = require("!!../../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./TitleDivider.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3266:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2LM5y{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2LM5y:first-child{margin-right:20px}.f6hfQ{margin:0 20px 0 0;font-size:20px}._2UXEW,.f6hfQ{font-weight:600}._2UXEW{margin-right:20px;font-size:36px}._2MW_t{height:0;border:1px solid #c4c4c4;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._3gcMz{margin-right:20px}", ""]);

// exports
exports.locals = {
	"root": "_2LM5y",
	"title": "f6hfQ",
	"h1": "_2UXEW",
	"divider": "_2MW_t",
	"dividerLeft": "_3gcMz"
};

/***/ }),

/***/ 3267:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(3268);
    var insertCss = __webpack_require__(1237);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ArticleLeasing.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./ArticleLeasing.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 3268:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1239)(false);
// imports


// module
exports.push([module.i, "._2pLAZ{width:100%;margin-top:18px;padding:0 13px}.BCXfW{padding:13px}.UFKMN{margin-bottom:100px}", ""]);

// exports
exports.locals = {
	"root": "_2pLAZ",
	"breadcrumbs": "BCXfW",
	"block": "UFKMN"
};

/***/ }),

/***/ 3351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/routes/journal/news-page/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html_entities_lib_html4_entities__ = __webpack_require__(3168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html_entities_lib_html4_entities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html_entities_lib_html4_entities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helpers_adsAndMetrics__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_actions_journal__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_urlBuilder__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_strings__ = __webpack_require__(1463);
var action = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
    var fetch = _ref3.fetch,
        params = _ref3.params,
        query = _ref3.query,
        store = _ref3.store,
        baseUrl = _ref3.baseUrl;

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$shouldFetchRela = _ref4.shouldFetchRelatedAdverts,
        shouldFetchRelatedAdverts = _ref4$shouldFetchRela === undefined ? true : _ref4$shouldFetchRela;

    var id, newsResponse, results, post, relatedAdverts, tag, currentRubric, _store$getState$globa, locale, location, journal, rubrics, joinedTags, targetingArguments, newsListResponse, news, newsData, breadcrumbs, key, title, description, postSeoTitle, postSeoDescription, decodedText;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = params.id;

            if (id) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return', null);

          case 3:
            _context.next = 5;
            return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].JOURNAL.ITEM(id));

          case 5:
            newsResponse = _context.sent;

            if (newsResponse.ok) {
              _context.next = 8;
              break;
            }

            return _context.abrupt('return', null);

          case 8:
            _context.next = 10;
            return newsResponse.json();

          case 10:
            results = _context.sent;
            post = Array.isArray(results) && results[0];

            if (post) {
              _context.next = 14;
              break;
            }

            return _context.abrupt('return', null);

          case 14:
            if (!(shouldFetchRelatedAdverts && post.rubric.slug === TEST_DRIVE_RUBRIC_SLUG)) {
              _context.next = 20;
              break;
            }

            _context.next = 17;
            return fetchRelatedAdverts(fetch, {
              agency: post.agency && post.agency.id,
              make: post.make && post.make.id,
              model: post.model && post.model.id,
              generation: post.generation && post.generation.id,
              year: post.year
            });

          case 17:
            _context.t0 = _context.sent;
            _context.next = 21;
            break;

          case 20:
            _context.t0 = undefined;

          case 21:
            relatedAdverts = _context.t0;
            tag = post.tags.find(function (t) {
              return t.slug === query.tag;
            });
            currentRubric = post.rubric;
            _store$getState$globa = store.getState().globals, locale = _store$getState$globa.locale, location = _store$getState$globa.location, journal = _store$getState$globa.journal;
            rubrics = journal.rubrics;
            joinedTags = [currentRubric].concat(_toConsumableArray(post.tags)).map(function (t) {
              return t.slug;
            }).join(' ');
            targetingArguments = __WEBPACK_IMPORTED_MODULE_3_shared_helpers_adsAndMetrics__["a" /* getAdsContext */]({
              rubric: { slug: joinedTags },
              page: baseUrl.replace(/\//g, ''),
              location: location
            });
            _context.next = 30;
            return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].JOURNAL.LIST({
              tag: tag,
              page: 1,
              perPage: PER_PAGE,
              rubric: ['news'],
              language: locale
            }));

          case 30:
            newsListResponse = _context.sent;
            news = [];

            if (!(newsListResponse.status !== 404)) {
              _context.next = 37;
              break;
            }

            _context.next = 35;
            return newsListResponse.json();

          case 35:
            newsData = _context.sent;

            news = newsData.results;

          case 37:
            store.dispatch(__WEBPACK_IMPORTED_MODULE_4_shared_actions_journal__["b" /* setJournalNews */](news));

            breadcrumbs = [{
              title: currentRubric.title,
              link: __WEBPACK_IMPORTED_MODULE_5__helpers_urlBuilder__["b" /* buildJournalListingUrl */](rubrics, currentRubric)
            }, tag && tag.slug && {
              title: tag.title,
              link: __WEBPACK_IMPORTED_MODULE_5__helpers_urlBuilder__["b" /* buildJournalListingUrl */](rubrics, currentRubric, tag.slug)
            }].filter(function (x) {
              return x;
            });
            key = locale === 'ru' ? '' : '_' + locale;
            title = post['seo_title' + key];
            description = post['search_description' + key];


            if (!title) {
              postSeoTitle = locale === 'ru' ? post.title || post.title_uk : post.title_uk || post.title;

              title = postSeoTitle + ' \u2013 \u0410\u0432\u0442\u043E\u0431\u0430\u0437\u0430\u0440';
            }
            if (!description) {
              postSeoDescription = locale === 'ru' ? post.content || post.content_uk : post.content_uk || post.content;
              decodedText = __WEBPACK_IMPORTED_MODULE_1_html_entities_lib_html4_entities__["decode"](__WEBPACK_IMPORTED_MODULE_6__helpers_strings__["a" /* stripHTML */](postSeoDescription));

              description = decodedText.substr(0, 227).replace('\n', '').trim();
            }

            return _context.abrupt('return', {
              title: title,
              description: description,
              ogImage: post && post.image && post.image.url ? post.image.url : undefined,
              post: post,
              id: id,
              tag: tag,
              targetingArguments: targetingArguments,
              relatedAdverts: relatedAdverts,
              breadcrumbs: breadcrumbs,
              query: query,
              news: news,
              currentRubric: currentRubric
            });

          case 45:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref2.apply(this, arguments);
  };
}();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }









var TEST_DRIVE_RUBRIC_SLUG = 'test-drive';
var PER_PAGE = 10;

var fetchRelatedAdverts = function fetchRelatedAdverts(fetch, _ref) {
  var agency = _ref.agency,
      make = _ref.make,
      model = _ref.model,
      generation = _ref.generation,
      year = _ref.year;
  return fetch(__WEBPACK_IMPORTED_MODULE_2_shared_constants_api__["a" /* default */].ADVERT.ALL('?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify({
    make: make || undefined,
    model: model || undefined,
    generation: generation || undefined,
    year: year || undefined,
    dealer: agency || null, // to only include adverts by the agency that submitted the post
    per_page: 6
  }))).then(function (r) {
    return r.json();
  }).then(function (r) {
    return r.results;
  }).catch(function () {
    return undefined;
  });
};

/* harmony default export */ var news_page_defaultExport = (action);
// CONCATENATED MODULE: ./src/desktop/components/ShareButtons/ShareButtons.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_share__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShareButtons_css__ = __webpack_require__(3169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShareButtons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ShareButtons_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function ShareButtons(props) {
  var link = props.link,
      iconSize = props.iconSize;
  var FacebookShareButton = __WEBPACK_IMPORTED_MODULE_2_react_share__["ShareButtons"].FacebookShareButton,
      TwitterShareButton = __WEBPACK_IMPORTED_MODULE_2_react_share__["ShareButtons"].TwitterShareButton,
      TelegramShareButton = __WEBPACK_IMPORTED_MODULE_2_react_share__["ShareButtons"].TelegramShareButton;


  var FacebookIcon = __WEBPACK_IMPORTED_MODULE_2_react_share__["generateShareIcon"]('facebook');
  var TwitterIcon = __WEBPACK_IMPORTED_MODULE_2_react_share__["generateShareIcon"]('twitter');
  var TelegramIcon = __WEBPACK_IMPORTED_MODULE_2_react_share__["generateShareIcon"]('telegram');

  return _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__ShareButtons_css___default.a.root
  }, void 0, _jsx(FacebookShareButton, {
    className: __WEBPACK_IMPORTED_MODULE_4__ShareButtons_css___default.a.button,
    url: link
  }, void 0, _jsx(FacebookIcon, {
    size: iconSize
  })), _jsx(TwitterShareButton, {
    className: __WEBPACK_IMPORTED_MODULE_4__ShareButtons_css___default.a.button,
    url: link
  }, void 0, _jsx(TwitterIcon, {
    size: iconSize
  })), _jsx(TelegramShareButton, {
    className: __WEBPACK_IMPORTED_MODULE_4__ShareButtons_css___default.a.button,
    url: link
  }, void 0, _jsx(TelegramIcon, {
    size: iconSize
  })));
}

/* harmony default export */ var ShareButtons_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__ShareButtons_css___default.a)(ShareButtons));
// CONCATENATED MODULE: ./src/shared/components/NewsInfo/NewsInfo.js
/* harmony import */ var NewsInfo___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NewsInfo___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NewsInfo___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NewsInfo___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var NewsInfo___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(NewsInfo___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var NewsInfo___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NewsInfo___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NewsInfo___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_users__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_helpers_moment__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_TagList_TagList__ = __webpack_require__(2790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css__ = __webpack_require__(3171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__NewsInfo_css__);
var NewsInfo__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











var isClient = true;

function NewsInfo(props) {
  var post = props.post,
      intl = props.intl;
  var title = post.title,
      title_uk = post.title_uk,
      author = post.author,
      date = post.publication_date,
      content = post.content,
      content_uk = post.content_uk,
      tags = post.tags,
      image = post.image,
      rubric = post.rubric;
  var avatar = author.avatar;

  var authorName = __WEBPACK_IMPORTED_MODULE_4_shared_helpers_users__["c" /* getUserName */](author);
  var formattedDate = __WEBPACK_IMPORTED_MODULE_5_shared_helpers_moment__["b" /* getFullDate */](date);
  var link = isClient ? window.location.href : '';
  var isVideo = rubric.slug === 'video';
  var locale = intl.locale;

  var localizedTitle = locale === 'ru' ? title || title_uk : title_uk || title;
  var localizedContent = locale === 'ru' ? content || content_uk : content_uk || content;

  var imageRe = /(<img [^>]*>)/g;
  localizedContent = localizedContent ? localizedContent.replace(imageRe, '<div data-hyb-ssp-in-image-overlay="5ee9e0174d506e144cfb471c" style="margin: 0 -15px;">\n$1</div>') : '';

  return NewsInfo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.root
  }, void 0, NewsInfo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.header
  }, void 0, NewsInfo__jsx('h1', {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.title
  }, void 0, localizedTitle), NewsInfo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.metaInfo
  }, void 0, NewsInfo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.authorCard
  }, void 0, avatar && NewsInfo__jsx('img', {
    src: avatar,
    alt: authorName,
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.avatar
  }), NewsInfo__jsx('div', {}, void 0, NewsInfo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.userName
  }, void 0, author && author.id && authorName), NewsInfo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.date
  }, void 0, formattedDate))), NewsInfo__jsx(ShareButtons_defaultExport, {
    link: link,
    iconSize: 35
  }))), NewsInfo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.content
  }, void 0, image && image.url && !isVideo && NewsInfo__jsx('img', {
    src: image.url.replace('http:', 'https:'),
    alt: '',
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.mainImage
  }), NewsInfo__jsx('div', {
    dangerouslySetInnerHTML: { __html: localizedContent },
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.richText
  }), NewsInfo__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.footer
  }, void 0, NewsInfo__jsx(ShareButtons_defaultExport, {
    link: link,
    iconSize: 35
  }), tags && tags.length > 0 && NewsInfo__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_TagList_TagList__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a.tags,
    tags: tags,
    currentRubric: rubric
  }))));
}

/* harmony default export */ var NewsInfo_defaultExport = (NewsInfo___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__NewsInfo_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */](NewsInfo)));
// CONCATENATED MODULE: ./src/desktop/routes/journal/news-page/NewsPage.js
/* harmony import */ var NewsPage___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NewsPage___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NewsPage___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_components_BannerAll__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_desktop_components_Breadcrumbs_Breadcrumbs__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_desktop_components_MakesSidebar_MakesSidebar__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_desktop_components_AnotherCars_AnotherCars__ = __webpack_require__(2796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NewsPage_css__ = __webpack_require__(3173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NewsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__NewsPage_css__);
var NewsPage__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();













var NewsPage__ref = NewsPage__jsx(__WEBPACK_IMPORTED_MODULE_5_shared_components_BannerAll__["d" /* DesktopRightSidebar */], {}, void 0, NewsPage__jsx(__WEBPACK_IMPORTED_MODULE_8_desktop_components_MakesSidebar_MakesSidebar__["a" /* default */], {}));

function NewsPage(props) {
  var post = props.post,
      relatedAdverts = props.relatedAdverts,
      intl = props.intl,
      breadcrumbs = props.breadcrumbs;
  var locale = intl.locale;

  var localizedTitle = locale === 'ru' ? post.title || post.title_uk : post.title_uk || post.title;

  return NewsPage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_10__NewsPage_css___default.a.page
  }, void 0, NewsPage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_10__NewsPage_css___default.a.container
  }, void 0, NewsPage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_10__NewsPage_css___default.a.flexRow
  }, void 0, NewsPage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_10__NewsPage_css___default.a.flexCell, __WEBPACK_IMPORTED_MODULE_10__NewsPage_css___default.a.mainCell)
  }, void 0, NewsPage__jsx(__WEBPACK_IMPORTED_MODULE_7_desktop_components_Breadcrumbs_Breadcrumbs__["a" /* default */], {
    current: localizedTitle,
    links: breadcrumbs
  }), NewsPage__jsx(NewsInfo_defaultExport, {
    post: post
  }), relatedAdverts && relatedAdverts.length > 0 && NewsPage__jsx(__WEBPACK_IMPORTED_MODULE_9_desktop_components_AnotherCars_AnotherCars__["a" /* default */], {
    cars: relatedAdverts,
    title: intl.formatMessage({ id: 'Объявления' })
  })), NewsPage__ref)));
}

NewsPage.defaultProps = {
  relatedAdverts: [],
  tag: null
};


/* harmony default export */ var NewsPage_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__NewsPage_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */](NewsPage)));
// CONCATENATED MODULE: ./src/desktop/routes/journal/news-page/index.js
/* harmony import */ var news_page___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var news_page___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(news_page___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_navigation__ = __webpack_require__(1248);
var news_page__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var news_page_action = function () {
  var _ref = news_page__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
    var url = _ref2.url,
        context = _objectWithoutProperties(_ref2, ['url']);

    var store, data, post, title, breadcrumbs, relatedAdverts, targetingArguments, ogImage, description, rubric, showInImage;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = context.store;
            _context.next = 3;
            return news_page_defaultExport(_extends({ url: url }, context));

          case 3:
            data = _context.sent;

            if (data) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('return', null);

          case 6:
            post = data.post, title = data.title, breadcrumbs = data.breadcrumbs, relatedAdverts = data.relatedAdverts, targetingArguments = data.targetingArguments, ogImage = data.ogImage, description = data.description;


            store.dispatch(__WEBPACK_IMPORTED_MODULE_2_shared_actions_globals__["C" /* setTargetingArguments */](targetingArguments));
            rubric = post.rubric;
            showInImage = rubric !== 'aktsii' && rubric !== 'video';
            return _context.abrupt('return', {
              chunks: ['news-page'],
              title: title,
              description: description,
              ogImage: ogImage,
              showInImage: showInImage,
              component: news_page__jsx(__WEBPACK_IMPORTED_MODULE_3__components_Layout__["a" /* default */], {
                navLinks: __WEBPACK_IMPORTED_MODULE_4__constants_navigation__["a" /* default */].JOURNAL,
                currentRoute: url,
                hideLocations: true
              }, void 0, news_page__jsx(NewsPage_defaultExport, {
                route: url,
                post: post,
                breadcrumbs: breadcrumbs,
                relatedAdverts: relatedAdverts
              }))
            });

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function news_page__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








/* harmony default export */ __webpack_exports__["default"] = (news_page_action);

/***/ }),

/***/ 3352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/shared/routes/article/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_api__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_helpers_search__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_helpers_locale__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






// const isMobile = __APP__ === 'mobile';
// const isClient = process.env.BROWSER;

/**
 * Get links for links blocks.
 * @param {Function} fetch
 * @param {Object} q
 * @returns {Promise<Object>}
 */

var fetchDataForLeasingTemplate = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fetch, filter) {
    var result, specialCars;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_1_shared_helpers_search__["a" /* fetchAdvertsWithOmit */](fetch, filter, 8);

          case 2:
            result = _context.sent;
            specialCars = result && result.results || [];
            return _context.abrupt('return', { specialCars: specialCars });

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchDataForLeasingTemplate(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var article_defaultExport = ((function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
    var fetch, store, baseUrl, path, data, otherParams, state, locale, apiURL, filter, leasingResult, lt, spD, lwD, condD, postfix, titles, h1, slug, linksObj, links, categories;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetch = params.fetch, store = params.store, baseUrl = params.baseUrl, path = params.path;
            data = null;
            otherParams = {};
            state = store.getState();
            locale = state.globals.locale;
            _context2.prev = 5;
            apiURL = __WEBPACK_IMPORTED_MODULE_2_shared_helpers_locale__["e" /* removeLocaleFromHref */](('' + baseUrl + path).replace('//', '/'));
            _context2.next = 9;
            return fetch(__WEBPACK_IMPORTED_MODULE_0_shared_constants_api__["a" /* default */].ARTICLES(apiURL)).then(function (r) {
              return r.json();
            });

          case 9:
            data = _context2.sent;

            if (!(data.template.name === 'Leasing')) {
              _context2.next = 16;
              break;
            }

            filter = data.category_avto || '';
            _context2.next = 14;
            return fetchDataForLeasingTemplate(fetch, filter);

          case 14:
            leasingResult = _context2.sent;

            otherParams = _extends({}, otherParams, leasingResult);

          case 16:
            _context2.next = 20;
            break;

          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2['catch'](5);

          case 20:
            lt = data; // .leasingTitles;

            spD = 'Специальные предложения';
            lwD = 'Почему стоит купить авто в лизинг на avtobazar.ua?';
            condD = 'Условия лизинга автомобиля';
            postfix = locale !== 'ru' ? '_' + locale : '';
            titles = {
              specialPropositions: lt && (lt['special_propositions' + postfix] || spD) || spD,
              leasingWhy: lt && (lt['leasing_why' + postfix] || lwD) || lwD,
              // howToPayOff: (lt && (lt[`how_to_pay_off${postfix}`] || condD)) || condD,
              conditions: lt && (lt['how_to_pay_off' + postfix] || condD) || condD // TODO: should be changed to 'conditions' key
            };
            h1 = data['h1_' + locale] || data.h1 || '';
            slug = data.url || '';
            linksObj = slug.replace('leasing', '').split('/').filter(function (s) {
              return !!s;
            });
            links = [['', 'Автобазар', 'avtobazar'], ['/leasing', 'Лизинг авто', 'lising']];
            categories = [];
            // TODO: Fix h1 for use deep links

            linksObj.forEach(function (link) {
              links.push(['/' + link, h1, link]);
              categories.push(link);
            });
            return _context2.abrupt('return', _extends({}, otherParams, {

              breadcrumbsLinks: links,
              slug: slug,
              titles: titles,
              title: data['title_' + locale] || data.title || '',
              description: data['description_' + locale] || data.description || '',
              h1: data['h1_' + locale] || data.h1 || '',
              content: data['content_' + locale] || data.content || '',

              categories: categories,
              advertsFilter: data.category_avto || '',
              searchLink: data.referral_slug || '',
              template: data.template && data.template.name,
              category: data.category && data.category.category_slug,
              canonical: data.canonical

              // filter: null,
              // meta_robots: 0,
              // canonical: null,
              // filter_id: null,
              // filter_redirect: false,
              // redirect: null
            }));

          case 33:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[5, 18]]);
  }));

  return function (_x3) {
    return _ref2.apply(this, arguments);
  };
})());
// CONCATENATED MODULE: ./src/shared/components/UI/RectanglesOptions/RectanglesOptions.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RectanglesOptions_css__ = __webpack_require__(3175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RectanglesOptions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__RectanglesOptions_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var RectanglesOptions = function (_React$Component) {
  _inherits(RectanglesOptions, _React$Component);

  function RectanglesOptions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RectanglesOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RectanglesOptions.__proto__ || Object.getPrototypeOf(RectanglesOptions)).call.apply(_ref, [this].concat(args))), _this), _this.Optoin = function (item) {
      var _cx;

      var _this$props = _this.props,
          disabled = _this$props.disabled,
          selected = _this$props.selected,
          onChange = _this$props.onChange,
          name = _this$props.name,
          postfix = _this$props.postfix;

      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__RectanglesOptions_css___default.a.item, (_cx = {}, _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__RectanglesOptions_css___default.a.selected, selected === item), _defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__RectanglesOptions_css___default.a.disabled, disabled), _cx)),
        onClick: function onClick() {
          return disabled ? null : onChange(name, item);
        }
      }, item, item, postfix);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RectanglesOptions, [{
    key: 'render',
    value: function render() {
      return _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__RectanglesOptions_css___default.a.root
      }, void 0, this.props.options.map(this.Optoin));
    }
  }]);

  return RectanglesOptions;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RectanglesOptions.defaultProps = {
  title: 'term',
  name: 'term',
  postfix: '',
  disabled: false,
  onChange: function onChange() {}
};


/* harmony default export */ var RectanglesOptions_defaultExport = (__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__RectanglesOptions_css___default.a)(RectanglesOptions));
// CONCATENATED MODULE: ./src/shared/components/AntdComponents/Slider/Slider.js
/* harmony import */ var Slider___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Slider___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Slider___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_slider_lib_Slider__ = __webpack_require__(3177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_slider_lib_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rc_slider_lib_Slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_slider_lib_Range__ = __webpack_require__(3190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_slider_lib_Range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rc_slider_lib_Range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_slider_lib_Handle__ = __webpack_require__(2815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_slider_lib_Handle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rc_slider_lib_Handle__);
var Slider__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Slider__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Slider__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Slider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Slider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Slider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/sort-comp */




// import Tooltip from '../tooltip';

// export interface SliderMarks {
//   [key: number]:
//     | React.ReactNode
//     | {
//         style: React.CSSProperties;
//         label: React.ReactNode;
//       };
// }

// export type SliderValue = number | [number, number];

// export type HandleGeneratorFn = (
//   info: {
//     value: number;
//     dragging: boolean;
//     index: number;
//     rest: any[];
//   },
// ) => React.ReactElement<any>;

// export interface SliderProps {
//   prefixCls?: string;
//   tooltipPrefixCls?: string;
//   range?: boolean;
//   min?: number;
//   max?: number;
//   step?: number | null;
//   marks?: SliderMarks;
//   dots?: boolean;
//   value?: SliderValue;
//   defaultValue?: SliderValue;
//   included?: boolean;
//   disabled?: boolean;
//   vertical?: boolean;
//   onChange?: (value: SliderValue) => void;
//   onAfterChange?: (value: SliderValue) => void;
//   tipFormatter?: null | ((value: number) => React.ReactNode);
//   className?: string;
//   id?: string;
//   style?: React.CSSProperties;
//   tooltipVisible?: boolean;
// }

// export interface SliderState {
//   visibles: { [index: number]: boolean };
// }

var Slider = function (_React$Component) {
  Slider__inherits(Slider, _React$Component);

  function Slider(props) {
    Slider__classCallCheck(this, Slider);

    var _this = Slider__possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.toggleTooltipVisible = function (index, visible) {
      _this.setState(function (_ref) {
        var visibles = _ref.visibles;
        return {
          visibles: Slider__extends({}, visibles, Slider__defineProperty({}, index, visible))
        };
      });
    };

    _this.handleWithTooltip = function (_ref2) {
      var value = _ref2.value,
          dragging = _ref2.dragging,
          index = _ref2.index,
          restProps = _objectWithoutProperties(_ref2, ['value', 'dragging', 'index']);

      var _this$props = _this.props,
          tooltipPrefixCls = _this$props.tooltipPrefixCls,
          tipFormatter = _this$props.tipFormatter,
          tooltipVisible = _this$props.tooltipVisible;
      var visibles = _this.state.visibles;

      var isTipFormatter = tipFormatter ? visibles[index] || dragging : false;
      var visible = void 0;
      if (tooltipVisible) {
        visible = tooltipVisible || isTipFormatter;
      } else if (tooltipVisible === undefined) {
        visible = isTipFormatter;
      }
      return (
        // <Tooltip
        //   prefixCls={tooltipPrefixCls}
        //   title={tipFormatter ? tipFormatter(value) : ''}
        //   visible={visible}
        //   placement="top"
        //   transitionName="zoom-down"
        //   key={index}
        // >
        Slider___WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_rc_slider_lib_Handle___default.a, Slider__extends({}, restProps, {
          value: value,
          onMouseEnter: function onMouseEnter() {
            return _this.toggleTooltipVisible(index, true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this.toggleTooltipVisible(index, false);
          }
        }))
        // </Tooltip>

      );
    };

    _this.saveSlider = function (node) {
      _this.rcSlider = node;
    };

    _this.state = {
      visibles: {}
    };
    return _this;
  }

  Slider__createClass(Slider, [{
    key: 'focus',
    value: function focus() {
      this.rcSlider.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.rcSlider.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          range = _props.range,
          restProps = _objectWithoutProperties(_props, ['range']);

      if (range) {
        return Slider___WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_rc_slider_lib_Range___default.a, Slider__extends({}, restProps, { ref: this.saveSlider, handle: this.handleWithTooltip }));
      }
      return Slider___WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_rc_slider_lib_Slider___default.a, Slider__extends({}, restProps, { ref: this.saveSlider, handle: this.handleWithTooltip }));
    }
  }]);

  return Slider;
}(Slider___WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Slider.defaultProps = {
  prefixCls: 'ant-slider',
  tooltipPrefixCls: 'ant-tooltip',
  tipFormatter: function tipFormatter(value) {
    return value.toString();
  }
};
/* harmony default export */ var Slider_defaultExport = (Slider);
// CONCATENATED MODULE: ./src/shared/components/UI/NumberInputWithSlider/NumberInputWithSlider.js
/* harmony import */ var NumberInputWithSlider___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var NumberInputWithSlider___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NumberInputWithSlider___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var NumberInputWithSlider___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var NumberInputWithSlider___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NumberInputWithSlider___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NumberInputWithSlider_css__ = __webpack_require__(3192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NumberInputWithSlider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__NumberInputWithSlider_css__);
var NumberInputWithSlider__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function NumberInputWithSlider__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










function NumberInputWithSlider(props) {
  var name = props.name,
      title = props.title,
      min = props.min,
      max = props.max,
      value = props.value,
      onSliderChange = props.onSliderChange,
      onInputChange = props.onInputChange,
      onInputBlur = props.onInputBlur,
      otherAttrs = NumberInputWithSlider__objectWithoutProperties(props, ['name', 'title', 'min', 'max', 'value', 'onSliderChange', 'onInputChange', 'onInputBlur']);

  return NumberInputWithSlider___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    otherAttrs,
    title && NumberInputWithSlider__jsx('div', {
      className: 'mrb-9 ' + __WEBPACK_IMPORTED_MODULE_6__NumberInputWithSlider_css___default.a.title
    }, void 0, NumberInputWithSlider__jsx(__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
      id: title
    })),
    NumberInputWithSlider__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_NumberInput_NumberInput__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_6__NumberInputWithSlider_css___default.a.input,
      onChange: function onChange(val) {
        return onInputChange(name, val);
      },
      value: value,
      onBlur: function onBlur(val) {
        return onInputBlur(name, Number((val.target.value || '').replace(/\s*/g, '')));
      }
    }),
    NumberInputWithSlider__jsx(Slider_defaultExport, {
      min: min,
      max: max,
      onChange: function onChange(val) {
        return onSliderChange(name, val);
      },
      className: __WEBPACK_IMPORTED_MODULE_6__NumberInputWithSlider_css___default.a.slider,
      value: value,
      trackStyle: { backgroundColor: '#FFC107' },
      handleStyle: {
        borderColor: '#FFC107',
        backgroundColor: '#FFFFFF',
        boxShadow: 'rgb(0 0 0 / 25%) 0px 1px 6px'
      },
      defaultValue: 0
    })
  );
}

NumberInputWithSlider.defaultProps = {
  title: ''
};


/* harmony default export */ var NumberInputWithSlider_defaultExport = (NumberInputWithSlider___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__NumberInputWithSlider_css___default.a)(NumberInputWithSlider));
// CONCATENATED MODULE: ./src/shared/components/LeasingOnlineBanner/LeasingModal/LeasingModal.js
/* harmony import */ var LeasingModal___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingModal___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingModal___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingModal___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingModal___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingModal___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_LeasingOnlineBanner_LeasingOnlineBanner__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingModal_css__ = __webpack_require__(3194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LeasingModal_css__);
var LeasingModal__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function LeasingModal__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









// eslint-disable-next-line css-modules/no-unused-class


function LeasingModal(props) {
  var advert = props.advert,
      show = props.show,
      leasingParams = props.leasingParams,
      partner = props.partner;

  return LeasingModal__jsx(LeasingModal___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, show && leasingParams && LeasingModal__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_ModalContainer_ModalContainer__["a" /* default */], {
    modalCN: __WEBPACK_IMPORTED_MODULE_6__LeasingModal_css___default.a.modal,
    onClose: props.toggleLeasingModal,
    isOpen: props.show
  }, void 0, LeasingModal__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingModal_css___default.a.rootModal
  }, void 0, LeasingModal__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingModal_css___default.a.rootModalLeasing
  }, void 0, LeasingModal__jsx(__WEBPACK_IMPORTED_MODULE_4_shared_components_LeasingOnlineBanner_LeasingOnlineBanner__["a" /* default */], {
    partner: partner,
    advert: advert,
    modalMode: true,
    leasingParams: leasingParams,
    toggleLeasingModal: props.toggleLeasingModal
  }), LeasingModal__jsx('i', {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default.a(LeasingModal__defineProperty({
      'fa fa-times': true
    }, __WEBPACK_IMPORTED_MODULE_6__LeasingModal_css___default.a.closeBtnIcon, true)),
    onClick: props.toggleLeasingModal
  })))));
}

LeasingModal.defaultProps = {
  leasingParams: null,
  partner: ''
};


/* harmony default export */ var LeasingModal_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__LeasingModal_css___default.a)(LeasingModal));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingCalculatorForm/LeasingCalculatorForm.js
/* harmony import */ var LeasingCalculatorForm___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingCalculatorForm___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingCalculatorForm___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var LeasingCalculatorForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingCalculatorForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingCalculatorForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_UI_Button_Button__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_leasing_utils__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_assets_images_articles_leasing_header_car_png__ = __webpack_require__(3196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_assets_images_articles_leasing_header_car_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shared_assets_images_articles_leasing_header_car_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LeasingCalculatorForm_css__ = __webpack_require__(3197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LeasingCalculatorForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__LeasingCalculatorForm_css__);
var LeasingCalculatorForm__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeasingCalculatorForm__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeasingCalculatorForm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingCalculatorForm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingCalculatorForm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















// eslint-disable-next-line css-modules/no-unused-class


var MIN_PRICE = 140000;
var MAX_PRICE = 7000000;

var MIN_PRECENT_PREPAID = 0.2;
var MAX_PRECENT_PREPAID = 0.4;
var DEF_PRECENT_PREPAID = 0.3;

var DEF_PRICE = 500000;

var _ref2 = LeasingCalculatorForm__jsx(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
  id: 'Ежемесячный платеж'
});

var _ref3 = LeasingCalculatorForm__jsx(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
  id: 'мес'
});

var LeasingCalculatorForm_LeasingCalculatorForm = function (_React$Component) {
  LeasingCalculatorForm__inherits(LeasingCalculatorForm, _React$Component);

  function LeasingCalculatorForm() {
    var _ref;

    var _temp, _this, _ret;

    LeasingCalculatorForm__classCallCheck(this, LeasingCalculatorForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LeasingCalculatorForm__possibleConstructorReturn(this, (_ref = LeasingCalculatorForm.__proto__ || Object.getPrototypeOf(LeasingCalculatorForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      priceValue: DEF_PRICE,
      prepaidValue: DEF_PRICE * DEF_PRECENT_PREPAID,
      term: 84,
      prepaidMin: DEF_PRICE * MIN_PRECENT_PREPAID,
      prepaidMax: DEF_PRICE * MAX_PRECENT_PREPAID,
      showModal: false
    }, _this.onPriceInputChange = function (name, value) {
      // console.log('onChangeInput', name, value);
      _this.setState({
        priceValue: value,
        prepaidMin: value * MIN_PRECENT_PREPAID,
        prepaidMax: value * MAX_PRECENT_PREPAID
      });
    }, _this.onPriceSliderChange = function (name, value) {
      // console.log('onChangeSlider', name, value);
      _this.setState({
        priceValue: value,
        prepaidMin: value * MIN_PRECENT_PREPAID,
        prepaidMax: value * MAX_PRECENT_PREPAID
      });
    }, _this.onPrepaidInputChange = function (name, value) {
      // console.log('onChangePrepaidInput', name, value);
      _this.setState({ prepaidValue: value });
    }, _this.onPrepaidSliderChange = function (name, value) {
      // console.log('onChangePrepaidSlider', name, value);
      _this.setState({ prepaidValue: value });
    }, _this.onTermChange = function (name, value) {
      // console.log('onChangePrepaidSlider', name, value);
      _this.setState({ term: value });
    }, _this.onInputBlur = function (name, value) {}, _this.showModal = function () {
      _this.setState({ showModal: true });
    }, _this.closModal = function () {
      _this.setState({ showModal: false });
    }, _temp), LeasingCalculatorForm__possibleConstructorReturn(_this, _ret);
  }

  // onPrepaidChange = value => {

  // };

  LeasingCalculatorForm__createClass(LeasingCalculatorForm, [{
    key: 'render',
    value: function render() {
      // const { t, changeHandler, onSubmitHandler, prepaid, price, terms, term } = this.props;
      // const { errMin, errMax, disabledSubmit } = this.state;
      // const pricePlaceholder = numberWithSpaces(price);
      var YEAR = 2015;
      var _state = this.state,
          priceValue = _state.priceValue,
          prepaidValue = _state.prepaidValue,
          term = _state.term,
          prepaidMin = _state.prepaidMin,
          prepaidMax = _state.prepaidMax;


      var terms = [12, 24, 36, 48, 60, 72, 84];

      var monthlyPriceUah = __WEBPACK_IMPORTED_MODULE_9_shared_helpers_leasing_utils__["b" /* calculateMonthlyPaymentV2 */]({
        year: YEAR,
        term: term,
        price: priceValue,
        prepaid: prepaidValue,
        comission: 5000,
        rate: 45
      });

      var advert = {
        id: 1,
        permalink: '/leasing',
        year: YEAR,
        characteristics: {},
        capacity: 1000,
        photos: [{ image: __WEBPACK_IMPORTED_MODULE_10_shared_assets_images_articles_leasing_header_car_png___default.a }],
        vehreg_info: {},
        price: [{ value: priceValue, exchange_rate: 1, currency: 'uah' }, { value: priceValue, exchange_rate: 1, currency: 'usd' }]
      };

      var leasingParams = {
        term: term,
        monthlyPayment: 1,
        extendedParams: {
          monthlyPaymentUAH: monthlyPriceUah,
          monthlyPaymentUAHFormatted: __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["k" /* numberWithSpaces */](monthlyPriceUah),
          prepaidUAH: prepaidValue,
          priceUAH: priceValue
        }
      };
      return LeasingCalculatorForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__LeasingCalculatorForm_css___default.a.root
      }, void 0, LeasingCalculatorForm__jsx(NumberInputWithSlider_defaultExport, {
        className: 'mrb-18',
        title: '\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0430\u0432\u0442\u043E, \u0433\u0440\u043D',
        name: 'price',
        min: MIN_PRICE,
        max: MAX_PRICE,
        value: priceValue * 1,
        onInputChange: this.onPriceInputChange,
        onSliderChange: this.onPriceSliderChange,
        onInputBlur: this.onInputBlur
      }), LeasingCalculatorForm__jsx(NumberInputWithSlider_defaultExport, {
        className: 'mrb-18',
        title: '\u041F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u0437\u043D\u043E\u0441',
        name: 'prepaid',
        min: prepaidMin,
        max: prepaidMax,
        value: prepaidValue * 1,
        onInputChange: this.onPrepaidInputChange,
        onSliderChange: this.onPrepaidSliderChange,
        onInputBlur: this.onInputBlur
      }), LeasingCalculatorForm__jsx(RectanglesOptions_defaultExport, {
        title: '\u0421\u0440\u043E\u043A \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F, \u043C\u0435\u0441\u044F\u0446\u0435\u0432',
        options: terms,
        selected: term,
        name: 'term',
        onChange: this.onTermChange
      }), LeasingCalculatorForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__LeasingCalculatorForm_css___default.a.monthlyTitle + ' mrb-4'
      }, void 0, _ref2), LeasingCalculatorForm__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_11__LeasingCalculatorForm_css___default.a.monthlyPrice + ' mrb-20'
      }, void 0, __WEBPACK_IMPORTED_MODULE_4_shared_helpers_common__["k" /* numberWithSpaces */](monthlyPriceUah), ' \u20B4/', _ref3), LeasingCalculatorForm__jsx(__WEBPACK_IMPORTED_MODULE_7_shared_components_UI_Button_Button__["a" /* default */], {
        type: 'button',
        text: '\u041E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443',
        onClick: this.showModal
      }), LeasingCalculatorForm__jsx(LeasingModal_defaultExport
      // partner="hapai"
      , {
        toggleLeasingModal: this.closModal,
        show: this.state.showModal,
        leasingParams: leasingParams,
        advert: advert
      }));
    }
  }]);

  return LeasingCalculatorForm;
}(LeasingCalculatorForm___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingCalculatorForm_LeasingCalculatorForm.defaultProps = {};


/* harmony default export */ var LeasingCalculatorForm_defaultExport = (LeasingCalculatorForm___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_11__LeasingCalculatorForm_css___default.a)(__WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](LeasingCalculatorForm_LeasingCalculatorForm)));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingHeader/LeasingHeader.js
/* harmony import */ var LeasingHeader___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingHeader___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingHeader___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var LeasingHeader___WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeasingHeader_css__ = __webpack_require__(3199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeasingHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LeasingHeader_css__);
var LeasingHeader__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var LeasingHeader__ref = LeasingHeader__jsx(LeasingHeader___WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: 'Лизинг авто на avtobazar.ua'
});

var LeasingHeader__ref2 = LeasingHeader__jsx(LeasingHeader___WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedMessage */], {
  id: 'LEASING_HEADER_DESCRPTION'
});

var LeasingHeader__ref3 = LeasingHeader__jsx(LeasingCalculatorForm_defaultExport, {});

function LeasingHeader(props) {
  return LeasingHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingHeader_css___default.a.root
  }, void 0, LeasingHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingHeader_css___default.a.bg
  }), LeasingHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingHeader_css___default.a.title
  }, void 0, LeasingHeader__ref), LeasingHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingHeader_css___default.a.description
  }, void 0, LeasingHeader__ref2), LeasingHeader__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingHeader_css___default.a.calculationForm
  }, void 0, LeasingHeader__ref3));
}

/* harmony default export */ var LeasingHeader_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__LeasingHeader_css___default.a)(LeasingHeader));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingConditions/LeasingConditions.js
/* harmony import */ var LeasingConditions___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingConditions___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingConditions___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingConditions___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingConditions___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingConditions___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LeasingConditions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingConditions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingConditions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var LeasingConditions___WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_car_png__ = __webpack_require__(3201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_car_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_car_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_man_png__ = __webpack_require__(3202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_man_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_man_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_passport_png__ = __webpack_require__(3203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_passport_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_passport_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_articles_leasing_head_with_key_png__ = __webpack_require__(3204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_articles_leasing_head_with_key_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_assets_images_articles_leasing_head_with_key_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_articles_leasing_blured_car_png__ = __webpack_require__(3205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_articles_leasing_blured_car_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_articles_leasing_blured_car_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_helpers_common__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css__ = __webpack_require__(3206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css__);
var LeasingConditions__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeasingConditions__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeasingConditions__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingConditions__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingConditions__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var LeasingConditions_items = [{
  image: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_man_png___default.a,
  text: 'Вам исполнился 21 год'
}, {
  image: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_car_png___default.a,
  text: 'Вы выбрали автомобиль'
}, {
  image: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_passport_png___default.a,
  text: 'У вас есть действительный паспорт'
}];

var LeasingConditions = function (_React$Component) {
  LeasingConditions__inherits(LeasingConditions, _React$Component);

  function LeasingConditions() {
    var _ref;

    var _temp, _this, _ret;

    LeasingConditions__classCallCheck(this, LeasingConditions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LeasingConditions__possibleConstructorReturn(this, (_ref = LeasingConditions.__proto__ || Object.getPrototypeOf(LeasingConditions)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (image, text) {
      var txt = _this.props.t(text);
      return LeasingConditions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default.a.item
      }, txt, LeasingConditions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default.a.icon
      }, void 0, LeasingConditions__jsx('img', {
        alt: txt,
        src: image,
        width: 40,
        height: 40
      })), LeasingConditions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default.a.text
      }, void 0, txt));
    }, _temp), LeasingConditions__possibleConstructorReturn(_this, _ret);
  }

  LeasingConditions__createClass(LeasingConditions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var title = this.props.t(this.props.title);
      return LeasingConditions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default.a.root
      }, void 0, LeasingConditions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default.a.bg
      }), LeasingConditions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default.a.title
      }, void 0, title), LeasingConditions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default.a.items
      }, void 0, LeasingConditions_items.map(function (item) {
        return _this2.renderItem(item.image, item.text);
      })), LeasingConditions__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default.a.image,
        style: __WEBPACK_IMPORTED_MODULE_9_shared_helpers_common__["i" /* imageBgStyle */](__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_articles_leasing_blured_car_png___default.a, 'contain')
      }, void 0, LeasingConditions__jsx('img', {
        alt: title,
        src: __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_articles_leasing_head_with_key_png___default.a,
        width: 320,
        height: 270
      })));
    }
  }]);

  return LeasingConditions;
}(LeasingConditions___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

LeasingConditions.defaultProps = {
  title: 'Условия лизинга автомобиля'
};


/* harmony default export */ var LeasingConditions_defaultExport = (LeasingConditions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_10__LeasingConditions_css___default.a)(LeasingConditions___WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](LeasingConditions)));
// CONCATENATED MODULE: ./src/shared/components/Accordion/Accordion.js
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Accordion___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Accordion___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var Accordion___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Accordion___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Accordion_css__ = __webpack_require__(3208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Accordion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Accordion_css__);
var Accordion__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Accordion__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Accordion__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Accordion__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Accordion__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Accordion__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { FormattedMessage } from 'react-intl';

// import groupBy from 'lodash/groupBy';


var Accordion = function (_React$Component) {
  Accordion__inherits(Accordion, _React$Component);

  function Accordion() {
    var _ref;

    var _temp, _this, _ret;

    Accordion__classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Accordion__possibleConstructorReturn(this, (_ref = Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isShowed: {}
    }, _this.componentWillMount = function () {
      _this.initKeys();
    }, _this.initKeys = function () {
      var isShowed = {};
      _this.props.items.forEach(function (item) {
        isShowed[item.title] = true;
      });
      _this.setState(isShowed);
    }, _this.toggle = function (title) {
      var isShowed = _this.state.isShowed;

      isShowed[title] = !isShowed[title];
      _this.setState(isShowed);
    }, _temp), Accordion__possibleConstructorReturn(_this, _ret);
  }

  Accordion__createClass(Accordion, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          rows = _props.rows;
      var isShowed = this.state.isShowed;

      var rowsList = new Array(rows).fill(0);
      var colCount = Math.ceil(items.length / rows);
      var grouped = [];
      var i = 0;
      rowsList.forEach(function () {
        grouped.push({
          items: items.slice(i, colCount + i),
          key: i
        });
        i += colCount;
      });
      return Accordion__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.root
      }, void 0, grouped.map(function (columns) {
        return Accordion__jsx('ul', {
          className: __WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.group
        }, columns.key, columns.items.map(function (_ref2) {
          var _cx;

          var title = _ref2.title,
              html = _ref2.html;
          return Accordion__jsx('li', {
            className: __WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.p
          }, title, Accordion__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.groupTitle
          }, void 0, Accordion__jsx('span', {
            className: __WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.title
          }, void 0, title), Accordion__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.groupToggleBtn, (_cx = {}, Accordion__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.groupToggleOpened, isShowed[title]), Accordion__defineProperty(_cx, __WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.groupToggleClosed, !isShowed[title]), _cx)),
            onClick: function onClick() {
              return _this2.toggle(title);
            }
          })), Accordion__jsx('div', {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a(__WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.details, Accordion__defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a.detailsHidden, !isShowed[title])),
            dangerouslySetInnerHTML: { __html: html }
          }));
        }));
      }));
    }
  }]);

  return Accordion;
}(Accordion___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Accordion.defaultProps = {
  items: [],
  rows: 1
};


/* harmony default export */ var Accordion_defaultExport = (Accordion___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Accordion_css___default.a)(Accordion));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingFaq/LeasingFaq.js
/* harmony import */ var LeasingFaq___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingFaq___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingFaq___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingFaq___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingFaq___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingFaq___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_data_json_leasingFaq_json__ = __webpack_require__(3210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_data_json_leasingFaq_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_data_json_leasingFaq_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingFaq_css__ = __webpack_require__(3211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeasingFaq_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LeasingFaq_css__);
var LeasingFaq__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();










function LeasingFaq(props) {
  var rows = props.rows,
      locale = props.locale;

  var titleKey = locale === 'ru' ? 'title' : 'title_' + locale;
  var htmltKey = locale === 'ru' ? 'html' : 'html_' + locale;

  var items = __WEBPACK_IMPORTED_MODULE_4_shared_data_json_leasingFaq_json___default.a.map(function (item) {
    return {
      title: item[titleKey],
      html: item[htmltKey]
    };
  });

  return LeasingFaq__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_6__LeasingFaq_css___default.a.root
  }, void 0, LeasingFaq__jsx(Accordion_defaultExport, {
    rows: rows,
    items: items
  }));
}

LeasingFaq.defaultProps = {
  rows: 2
};


var mapStateToProps = function mapStateToProps(_ref) {
  var globals = _ref.globals;
  return {
    locale: globals.locale,
    location: globals.location
  };
};

/* harmony default export */ var LeasingFaq_defaultExport = (__WEBPACK_IMPORTED_MODULE_5_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__LeasingFaq_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapStateToProps)(LeasingFaq)));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingFeedback/LeasingFeedbackCard/LeasingFeedbackCard.js
/* harmony import */ var LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css__ = __webpack_require__(3236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css__);
var LeasingFeedbackCard__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







function LeasingFeedbackCard(props) {
  var avatar = props.avatar,
      name = props.name,
      text = props.text,
      rate = props.rate;

  return LeasingFeedbackCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css___default.a.root
  }, void 0, LeasingFeedbackCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css___default.a.content
  }, void 0, LeasingFeedbackCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css___default.a.head
  }, void 0, LeasingFeedbackCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css___default.a.avatar
  }, void 0, LeasingFeedbackCard__jsx('img', {
    src: avatar,
    width: '50',
    height: '50',
    alt: ''
  })), LeasingFeedbackCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css___default.a.name
  }, void 0, name)), LeasingFeedbackCard__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css___default.a.text
  }, void 0, text)));
}

LeasingFeedbackCard.defaultProps = {};


/* harmony default export */ var LeasingFeedbackCard_defaultExport = (LeasingFeedbackCard___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__LeasingFeedbackCard_css___default.a)(LeasingFeedbackCard));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingFeedback/LeasingFeedback.js
/* harmony import */ var LeasingFeedback___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingFeedback___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingFeedback___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick__ = __webpack_require__(3213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_slick__);
/* harmony import */ var LeasingFeedback___WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(1240);
/* harmony import */ var LeasingFeedback___WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(LeasingFeedback___WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_data_json_leasingFeedbacks_json__ = __webpack_require__(3229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_data_json_leasingFeedbacks_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_data_json_leasingFeedbacks_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_feedback_chepura_png__ = __webpack_require__(3230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_feedback_chepura_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_feedback_chepura_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_feedback_otrishko_png__ = __webpack_require__(3231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_feedback_otrishko_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_assets_images_feedback_otrishko_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_feedback_efremova_png__ = __webpack_require__(3232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_feedback_efremova_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_assets_images_feedback_efremova_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_assets_images_feedback_savchenko_png__ = __webpack_require__(3233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_assets_images_feedback_savchenko_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_assets_images_feedback_savchenko_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_assets_images_feedback_shilo_png__ = __webpack_require__(3234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_assets_images_feedback_shilo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shared_assets_images_feedback_shilo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_assets_images_feedback_mihalchenko_png__ = __webpack_require__(3235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_assets_images_feedback_mihalchenko_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_assets_images_feedback_mihalchenko_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LeasingFeedback_css__ = __webpack_require__(3238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LeasingFeedback_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__LeasingFeedback_css__);
var LeasingFeedback__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



















var isMobile = "desktop" === 'mobile';
var cardsCount = isMobile ? 1 : 3;

var Arrow = function Arrow(_ref) {
  var className = _ref.className,
      myClassName = _ref.myClassName,
      onClick = _ref.onClick;
  return LeasingFeedback__jsx('div', {
    className: LeasingFeedback___WEBPACK_IMPORTED_MODULE_2_classnames___default.a(className, myClassName),
    onClick: onClick
  });
};


var settingsSlider = {
  dots: true,
  infinite: false,
  speed: 2500,
  slidesToShow: cardsCount,
  slidesToScroll: cardsCount,
  arrows: false
};

function LeasingFeedbacks(props) {
  var avLinks = {
    chepura: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_feedback_chepura_png___default.a,
    otrishko: __WEBPACK_IMPORTED_MODULE_7_shared_assets_images_feedback_otrishko_png___default.a,
    efremova: __WEBPACK_IMPORTED_MODULE_8_shared_assets_images_feedback_efremova_png___default.a,
    savchenko: __WEBPACK_IMPORTED_MODULE_9_shared_assets_images_feedback_savchenko_png___default.a,
    shilo: __WEBPACK_IMPORTED_MODULE_10_shared_assets_images_feedback_shilo_png___default.a,
    mihalchenko: __WEBPACK_IMPORTED_MODULE_11_shared_assets_images_feedback_mihalchenko_png___default.a
  };
  return LeasingFeedback__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_13__LeasingFeedback_css___default.a.root + ' ant-carousel'
  }, void 0, LeasingFeedback___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_slick___default.a,
    settingsSlider,
    __WEBPACK_IMPORTED_MODULE_5_shared_data_json_leasingFeedbacks_json___default.a.map(function (item) {
      return LeasingFeedback__jsx(LeasingFeedbackCard_defaultExport, {
        avatar: avLinks[item.avatar] || '',
        name: item.name,
        text: item.text,
        rate: item.rate || 5
      }, item.name);
    })
  ));
}

LeasingFeedbacks.defaultProps = {};


/* harmony default export */ var LeasingFeedback_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_13__LeasingFeedback_css___default.a)(LeasingFeedbacks));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingGuaranty/LeasingGuaranty.js
/* harmony import */ var LeasingGuaranty___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingGuaranty___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingGuaranty___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingGuaranty___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingGuaranty___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingGuaranty___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LeasingGuaranty___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingGuaranty___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingGuaranty___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var LeasingGuaranty___WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_no_credit_card_png__ = __webpack_require__(3240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_no_credit_card_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_no_credit_card_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_security_png__ = __webpack_require__(3241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_security_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_security_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_secure_shield_png__ = __webpack_require__(3242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_secure_shield_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_secure_shield_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css__ = __webpack_require__(3243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css__);
var LeasingGuaranty__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeasingGuaranty__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeasingGuaranty__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingGuaranty__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingGuaranty__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var LeasingGuaranty_items = [{
  image: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_no_credit_card_png___default.a,
  text: 'Без скрытых платежей и дополнительных комиссий'
}, {
  image: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_security_png___default.a,
  text: 'Несем ответственность за сохранность Ваших данных'
}, {
  image: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_secure_shield_png___default.a,
  text: 'Соблюдаем законы о защите Ваших прав пользователя'
}];

var LeasingGuaranty = function (_React$Component) {
  LeasingGuaranty__inherits(LeasingGuaranty, _React$Component);

  function LeasingGuaranty() {
    var _ref;

    var _temp, _this, _ret;

    LeasingGuaranty__classCallCheck(this, LeasingGuaranty);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LeasingGuaranty__possibleConstructorReturn(this, (_ref = LeasingGuaranty.__proto__ || Object.getPrototypeOf(LeasingGuaranty)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (image, text) {
      return LeasingGuaranty__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css___default.a.item
      }, text, LeasingGuaranty__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css___default.a.icon
      }, void 0, LeasingGuaranty__jsx('img', {
        alt: _this.props.t(text),
        src: image,
        width: 40,
        height: 40
      })), LeasingGuaranty__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css___default.a.text
      }, void 0, _this.props.t(text)));
    }, _temp), LeasingGuaranty__possibleConstructorReturn(_this, _ret);
  }

  LeasingGuaranty__createClass(LeasingGuaranty, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return LeasingGuaranty__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css___default.a.root
      }, void 0, LeasingGuaranty__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css___default.a.title
      }, void 0, this.props.t('Ответственность и гарантия безопасности')), LeasingGuaranty__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css___default.a.items
      }, void 0, LeasingGuaranty_items.map(function (item) {
        return _this2.renderItem(item.image, item.text);
      })));
    }
  }]);

  return LeasingGuaranty;
}(LeasingGuaranty___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var LeasingGuaranty_defaultExport = (LeasingGuaranty___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__LeasingGuaranty_css___default.a)(LeasingGuaranty___WEBPACK_IMPORTED_MODULE_3_shared_hocs_withTranslate__["a" /* withTranslate */](LeasingGuaranty)));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingHowToPayOff/LeasingHowToPayOff.js
/* harmony import */ var LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_credit_card_png__ = __webpack_require__(3245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_credit_card_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_credit_card_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_saving_money_png__ = __webpack_require__(3246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_saving_money_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_saving_money_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_atm_png__ = __webpack_require__(3247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_atm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_atm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LeasingHowToPayOff_css__ = __webpack_require__(3248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LeasingHowToPayOff_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LeasingHowToPayOff_css__);
var LeasingHowToPayOff__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var LeasingHowToPayOff__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LeasingHowToPayOff__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingHowToPayOff__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingHowToPayOff__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var LeasingHowToPayOff_items = [{
  image: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_credit_card_png___default.a,
  text: 'Картой, онлайн в личном кабинете'
}, {
  image: __WEBPACK_IMPORTED_MODULE_5_shared_assets_images_articles_leasing_saving_money_png___default.a,
  text: 'В отделении банка-партнера'
}, {
  image: __WEBPACK_IMPORTED_MODULE_6_shared_assets_images_articles_leasing_atm_png___default.a,
  text: 'Через платежные терминалы'
}];

var LeasingHowToPayOff = function (_React$Component) {
  LeasingHowToPayOff__inherits(LeasingHowToPayOff, _React$Component);

  function LeasingHowToPayOff() {
    var _ref;

    var _temp, _this, _ret;

    LeasingHowToPayOff__classCallCheck(this, LeasingHowToPayOff);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LeasingHowToPayOff__possibleConstructorReturn(this, (_ref = LeasingHowToPayOff.__proto__ || Object.getPrototypeOf(LeasingHowToPayOff)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (image, text) {
      var txt = _this.props.t(text);
      return LeasingHowToPayOff__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingHowToPayOff_css___default.a.item
      }, txt, LeasingHowToPayOff__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingHowToPayOff_css___default.a.bg
      }), LeasingHowToPayOff__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingHowToPayOff_css___default.a.itemTitle
      }, void 0, txt), LeasingHowToPayOff__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingHowToPayOff_css___default.a.image
      }, void 0, LeasingHowToPayOff__jsx('img', {
        alt: txt,
        src: image
      })));
    }, _temp), LeasingHowToPayOff__possibleConstructorReturn(_this, _ret);
  }

  LeasingHowToPayOff__createClass(LeasingHowToPayOff, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return LeasingHowToPayOff__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_7__LeasingHowToPayOff_css___default.a.items
      }, void 0, LeasingHowToPayOff_items.map(function (item) {
        return _this2.renderItem(item.image, item.text);
      }));
    }
  }]);

  return LeasingHowToPayOff;
}(LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var LeasingHowToPayOff_defaultExport = (LeasingHowToPayOff___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__LeasingHowToPayOff_css___default.a)(__WEBPACK_IMPORTED_MODULE_2_shared_hocs_withTranslate__["a" /* withTranslate */](LeasingHowToPayOff)));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingPartners/LeasingPartners.js
/* harmony import */ var LeasingPartners___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingPartners___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingPartners___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingPartners___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingPartners___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingPartners___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_articles_leasing_partner_myavto_png__ = __webpack_require__(3250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_articles_leasing_partner_myavto_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_assets_images_articles_leasing_partner_myavto_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_articles_leasing_partner_mycredit_png__ = __webpack_require__(3251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_articles_leasing_partner_mycredit_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_assets_images_articles_leasing_partner_mycredit_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_partner_otpbank_png__ = __webpack_require__(3252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_partner_otpbank_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_partner_otpbank_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingPartners_css__ = __webpack_require__(3253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LeasingPartners_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LeasingPartners_css__);
var LeasingPartners__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



// import Link from 'shared/components/Link/Link';







var LeasingPartners__ref = LeasingPartners__jsx('a', {
  href: null
}, void 0, LeasingPartners__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_articles_leasing_partner_mycredit_png___default.a,
  alt: ''
}));

var LeasingPartners__ref2 = LeasingPartners__jsx('a', {
  href: null
}, void 0, LeasingPartners__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_4_shared_assets_images_articles_leasing_partner_otpbank_png___default.a,
  alt: ''
}));

var LeasingPartners__ref3 = LeasingPartners__jsx('a', {
  target: '_blank',
  href: 'https://myavto.com.ua/'
}, void 0, LeasingPartners__jsx('img', {
  src: __WEBPACK_IMPORTED_MODULE_2_shared_assets_images_articles_leasing_partner_myavto_png___default.a,
  alt: 'https://myavto.com.ua/'
}));

function LeasingPartners(props) {
  return LeasingPartners__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LeasingPartners_css___default.a.root
  }, void 0, LeasingPartners__ref, LeasingPartners__ref2, LeasingPartners__ref3);
}

LeasingPartners.defaultProps = {};


/* harmony default export */ var LeasingPartners_defaultExport = (LeasingPartners___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LeasingPartners_css___default.a)(LeasingPartners));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingCars/LeasingCars.js
/* harmony import */ var LeasingCars___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingCars___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingCars___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingCars___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingCars___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingCars___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LeasingCars___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingCars___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingCars___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeasingCars_css__ = __webpack_require__(3255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LeasingCars_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LeasingCars_css__);
var LeasingCars__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();


// import cx from 'classnames';





function LeasingCars(props) {
  var content = props.content;

  return LeasingCars__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__LeasingCars_css___default.a.root
  }, void 0, LeasingCars__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__LeasingCars_css___default.a.container,
    dangerouslySetInnerHTML: { __html: content }
  }));
}

LeasingCars.defaultProps = {};


/* harmony default export */ var LeasingCars_defaultExport = (LeasingCars___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__LeasingCars_css___default.a)(LeasingCars));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingWhyAbUa/LeasingWhyAbUa.js
/* harmony import */ var LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_icons_sprites_articleLeasing_svg__ = __webpack_require__(3257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_icons_sprites_articleLeasing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_assets_icons_sprites_articleLeasing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeasingWhyAbUa_css__ = __webpack_require__(3258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeasingWhyAbUa_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LeasingWhyAbUa_css__);
var LeasingWhyAbUa__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var LeasingWhyAbUa__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function LeasingWhyAbUa__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LeasingWhyAbUa__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LeasingWhyAbUa__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Icon = function Icon(params) {
  return LeasingWhyAbUa__jsx('svg', {
    width: '24',
    height: '24'
  }, void 0, LeasingWhyAbUa__jsx('use', {
    xlinkHref: __WEBPACK_IMPORTED_MODULE_3_shared_assets_icons_sprites_articleLeasing_svg___default.a + '#' + params.name
  }));
};

var LeasingWhyAbUa_items = [{
  icon: 'car',
  text: 'Авто любого года выпуска и модели'
}, {
  icon: 'savemoney',
  text: 'Любая сумма финансирования'
}, {
  icon: 'buiseness',
  text: 'Без поручителей и без справки о доходах'
}, {
  icon: 'time',
  text: 'Автолизинг за 24 часа'
}, {
  icon: 'shield',
  text: 'Страховка и автогражданка оплачивается лизинговой компанией'
}, {
  icon: 'math',
  text: 'Отсутстве комиссий и скрытых платежей'
}];

var LeasingWhyAbUa = function (_React$Component) {
  LeasingWhyAbUa__inherits(LeasingWhyAbUa, _React$Component);

  function LeasingWhyAbUa() {
    var _ref;

    var _temp, _this, _ret;

    LeasingWhyAbUa__classCallCheck(this, LeasingWhyAbUa);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LeasingWhyAbUa__possibleConstructorReturn(this, (_ref = LeasingWhyAbUa.__proto__ || Object.getPrototypeOf(LeasingWhyAbUa)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (icon, text) {
      return LeasingWhyAbUa__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__LeasingWhyAbUa_css___default.a.item
      }, text, LeasingWhyAbUa__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__LeasingWhyAbUa_css___default.a.icon
      }, void 0, LeasingWhyAbUa__jsx(Icon, {
        name: icon
      })), LeasingWhyAbUa__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__LeasingWhyAbUa_css___default.a.text
      }, void 0, LeasingWhyAbUa__jsx(LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
        id: text
      })));
    }, _temp), LeasingWhyAbUa__possibleConstructorReturn(_this, _ret);
  }

  LeasingWhyAbUa__createClass(LeasingWhyAbUa, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return LeasingWhyAbUa__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_4__LeasingWhyAbUa_css___default.a.root
      }, void 0, LeasingWhyAbUa_items.map(function (item) {
        return _this2.renderItem(item.icon, item.text);
      }));
    }
  }]);

  return LeasingWhyAbUa;
}(LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var LeasingWhyAbUa_defaultExport = (LeasingWhyAbUa___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__LeasingWhyAbUa_css___default.a)(LeasingWhyAbUa));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingSpecialPropositions/LeasingSpecialPropositions.js
/* harmony import */ var LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_desktop_components_InlineAdvertsBlock_InlineAdvertsBlock__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_hocs_withFetch__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LeasingSpecialPropositions_css__ = __webpack_require__(3260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LeasingSpecialPropositions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LeasingSpecialPropositions_css__);
var LeasingSpecialPropositions__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();


// import cx from 'classnames';



// import { fetchVipCars } from 'shared/helpers/search';

// import Button from 'shared/components/UI/Button/Button';






var LeasingSpecialPropositions__ref = LeasingSpecialPropositions__jsx(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], {
  id: 'Показать все'
});

function SpecialPropositions(props) {
  return LeasingSpecialPropositions__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_7__LeasingSpecialPropositions_css___default.a.root
  }, void 0, LeasingSpecialPropositions__jsx('div', {}, void 0, LeasingSpecialPropositions__jsx(__WEBPACK_IMPORTED_MODULE_3_desktop_components_InlineAdvertsBlock_InlineAdvertsBlock__["a" /* default */], {
    items: props.specialCars,
    rows: 2,
    itemsInLine: 4
  }), LeasingSpecialPropositions__jsx(__WEBPACK_IMPORTED_MODULE_6_shared_components_Link_Link__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_7__LeasingSpecialPropositions_css___default.a.searchBtn,
    to: props.searchLink
  }, void 0, LeasingSpecialPropositions__ref)));
}

SpecialPropositions.defaultProps = {
  searchLink: '/avto/'
};


/* harmony default export */ var LeasingSpecialPropositions_defaultExport = (LeasingSpecialPropositions___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_7__LeasingSpecialPropositions_css___default.a)(__WEBPACK_IMPORTED_MODULE_4_shared_hocs_withFetch__["a" /* withFetch */](SpecialPropositions)));
// CONCATENATED MODULE: ./src/shared/components/Article/Leasing/LeasingReliablePartner/LeasingReliablePartner.js
/* harmony import */ var LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(474);
/* harmony import */ var LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_articles_leasing_reliable_car_png__ = __webpack_require__(3262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_articles_leasing_reliable_car_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_assets_images_articles_leasing_reliable_car_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css__ = __webpack_require__(3263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css__);
var LeasingReliablePartner__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var LeasingReliablePartner__ref = LeasingReliablePartner__jsx(LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
  id: 'avtobazar.ua – надежный финансовый партнер'
});

var LeasingReliablePartner__ref2 = LeasingReliablePartner__jsx('div', {}, void 0, LeasingReliablePartner__jsx(LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
  id: 'Лет на рынке'
}));

var LeasingReliablePartner__ref3 = LeasingReliablePartner__jsx('div', {}, void 0, LeasingReliablePartner__jsx(LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
  id: 'Автомобилей на сайте'
}));

var _ref4 = LeasingReliablePartner__jsx('div', {}, void 0, LeasingReliablePartner__jsx(LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
  id: 'Корпоративных партнеров'
}));

var _ref5 = LeasingReliablePartner__jsx('div', {}, void 0, LeasingReliablePartner__jsx(LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], {
  id: 'Сотрудников компании'
}));

function LeasingReliablePartner(props) {
  var year = 14;
  var cars = 6450;
  var partners = 100;
  var employees = 60;

  return LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.root
  }, void 0, LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.bg
  }), LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.title
  }, void 0, LeasingReliablePartner__ref), LeasingReliablePartner__jsx('img', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.image,
    src: __WEBPACK_IMPORTED_MODULE_3_shared_assets_images_articles_leasing_reliable_car_png___default.a,
    alt: ''
  }), LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.info
  }, void 0, LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.block
  }, void 0, LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.left
  }, void 0, LeasingReliablePartner__jsx('b', {}, void 0, year), LeasingReliablePartner__ref2), LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.right
  }, void 0, LeasingReliablePartner__jsx('b', {}, void 0, cars, '\u207A'), LeasingReliablePartner__ref3)), LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.block
  }, void 0, LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.left
  }, void 0, LeasingReliablePartner__jsx('b', {}, void 0, partners, '\u207A'), _ref4), LeasingReliablePartner__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a.right
  }, void 0, LeasingReliablePartner__jsx('b', {}, void 0, employees), _ref5))));
}

/* harmony default export */ var LeasingReliablePartner_defaultExport = (LeasingReliablePartner___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__LeasingReliablePartner_css___default.a)(LeasingReliablePartner));
// CONCATENATED MODULE: ./src/shared/components/Article/TitleDivider/TitleDivider.js
/* harmony import */ var TitleDivider___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var TitleDivider___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(TitleDivider___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_hocs_withTranslate__ = __webpack_require__(1242);
/* harmony import */ var TitleDivider___WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(131);
/* harmony import */ var TitleDivider___WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(TitleDivider___WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var TitleDivider___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var TitleDivider___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(TitleDivider___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TitleDivider_css__ = __webpack_require__(3265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TitleDivider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TitleDivider_css__);
var TitleDivider__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








function TitleDivider(props) {
  var t = props.t,
      divider = props.divider,
      position = props.position,
      className = props.className,
      h1 = props.h1;

  var title = t(props.title);
  return TitleDivider__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__TitleDivider_css___default.a.root + ' ' + className
  }, void 0, divider && position !== 'left' && TitleDivider__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__TitleDivider_css___default.a.divider + ' ' + __WEBPACK_IMPORTED_MODULE_4__TitleDivider_css___default.a.dividerLeft
  }), h1 && TitleDivider__jsx('h1', {
    className: __WEBPACK_IMPORTED_MODULE_4__TitleDivider_css___default.a.h1
  }, void 0, title), !h1 && TitleDivider__jsx('p', {
    className: __WEBPACK_IMPORTED_MODULE_4__TitleDivider_css___default.a.title
  }, void 0, title), divider && position !== 'right' && TitleDivider__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_4__TitleDivider_css___default.a.divider
  }));
}

TitleDivider.defaultProps = {
  position: 'left',
  className: 'mrb-30',
  divider: true,
  h1: false
};


/* harmony default export */ var TitleDivider_defaultExport = (TitleDivider___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__TitleDivider_css___default.a)(__WEBPACK_IMPORTED_MODULE_1_shared_hocs_withTranslate__["a" /* withTranslate */](TitleDivider)));
// CONCATENATED MODULE: ./src/desktop/routes/articles/ArticleLeasing.js
/* harmony import */ var ArticleLeasing___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var ArticleLeasing___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ArticleLeasing___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ArticleLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(131);
/* harmony import */ var ArticleLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ArticleLeasing___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var ArticleLeasing___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(1238);
/* harmony import */ var ArticleLeasing___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ArticleLeasing___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_BreadcrumbsLinks_BreadcrumbsLinks__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css__ = __webpack_require__(3267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css__);
var ArticleLeasing__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();


// import cx from 'classnames';


// import Breadcrumbs from 'desktop/components/Breadcrumbs/Breadcrumbs';



// import LeasingBannerInfo from 'shared/components/Article/Leasing/LeasingBannerInfo/LeasingBannerInfo';





// import LeasingMedia from 'shared/components/Article/Leasing/LeasingMedia/LeasingMedia';


// import LeasingQuestions from 'shared/components/Article/Leasing/LeasingQuestions/LeasingQuestions';







// TODO: Move to shared component ArticleLeasing.

var ArticleLeasing__ref = ArticleLeasing__jsx(LeasingHeader_defaultExport, {});

var ArticleLeasing__ref2 = ArticleLeasing__jsx(LeasingWhyAbUa_defaultExport, {});

var ArticleLeasing__ref3 = ArticleLeasing__jsx(TitleDivider_defaultExport, {
  title: '\u041A\u0430\u043A \u043F\u043E\u0433\u0430\u0441\u0438\u0442\u044C \u0430\u0432\u0442\u043E \u043B\u0438\u0437\u0438\u043D\u0433?'
});

var ArticleLeasing__ref4 = ArticleLeasing__jsx(LeasingHowToPayOff_defaultExport, {});

var ArticleLeasing__ref5 = ArticleLeasing__jsx(LeasingReliablePartner_defaultExport, {});

var _ref6 = ArticleLeasing__jsx(TitleDivider_defaultExport, {
  title: '\u041E\u0442\u0437\u044B\u0432\u044B'
});

var _ref7 = ArticleLeasing__jsx(LeasingFeedback_defaultExport, {});

var _ref8 = ArticleLeasing__jsx(LeasingGuaranty_defaultExport, {});

var _ref9 = ArticleLeasing__jsx(TitleDivider_defaultExport, {
  position: 'center',
  title: '\u041D\u0430\u0448\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u044B'
});

var _ref10 = ArticleLeasing__jsx(LeasingPartners_defaultExport, {});

var _ref11 = ArticleLeasing__jsx(ArticleLeasing___WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, ArticleLeasing__jsx(TitleDivider_defaultExport, {
  title: '\u0427\u0430\u0441\u0442\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B'
}), ArticleLeasing__jsx(LeasingFaq_defaultExport, {}));

function ArticleLeasing(props) {
  var specialCars = props.specialCars,
      searchLink = props.searchLink,
      content = props.content,
      h1 = props.h1,
      breadcrumbsLinks = props.breadcrumbsLinks,
      categories = props.categories,
      titles = props.titles;
  var specialPropositions = titles.specialPropositions,
      leasingWhy = titles.leasingWhy,
      conditions = titles.conditions;


  return ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.root
  }, void 0, ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.breadcrumbs
  }, void 0, ArticleLeasing__jsx(__WEBPACK_IMPORTED_MODULE_3_shared_components_BreadcrumbsLinks_BreadcrumbsLinks__["a" /* default */], {
    links: breadcrumbsLinks
  })), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, ArticleLeasing__ref), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, ArticleLeasing__jsx(TitleDivider_defaultExport, {
    title: specialPropositions
  }), ArticleLeasing__jsx(LeasingSpecialPropositions_defaultExport, {
    specialCars: specialCars,
    searchLink: searchLink
  })), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, ArticleLeasing__jsx(TitleDivider_defaultExport, {
    divider: false,
    title: leasingWhy
  }), ArticleLeasing__ref2), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, ArticleLeasing__jsx(LeasingConditions_defaultExport, {
    title: conditions
  })), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, ArticleLeasing__ref3, ArticleLeasing__ref4), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, ArticleLeasing__ref5), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, _ref6, _ref7), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, _ref8), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, _ref9, _ref10), ArticleLeasing__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a.block
  }, void 0, ArticleLeasing__jsx(TitleDivider_defaultExport, {
    title: h1,
    h1: true
  }), ArticleLeasing__jsx(LeasingCars_defaultExport, {
    content: content
  })), categories.length === 0 && _ref11);
}

ArticleLeasing.defaultProps = {
  searchLink: '',
  specialCars: [],
  breadcrumbsLinks: [],
  categories: [],
  titles: {}
};


/* harmony default export */ var ArticleLeasing_defaultExport = (ArticleLeasing___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_16__ArticleLeasing_css___default.a)(ArticleLeasing));
// CONCATENATED MODULE: ./src/desktop/routes/articles/index.js
/* harmony import */ var articles___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var articles___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(articles___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_desktop_components_Layout__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_desktop_constants_navigation__ = __webpack_require__(1248);
var articles__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var action = function () {
  var _ref = articles__asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    var baseUrl, path, url, pageParams, slug, title, description, template, otherParams;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            baseUrl = params.baseUrl, path = params.path;
            url = ('' + baseUrl + path).replace('//', '/');
            _context.next = 4;
            return article_defaultExport(params);

          case 4:
            pageParams = _context.sent;
            slug = pageParams.slug, title = pageParams.title, description = pageParams.description, template = pageParams.template, otherParams = articles__objectWithoutProperties(pageParams, ['slug', 'title', 'description', 'template']);

            if (slug) {
              _context.next = 8;
              break;
            }

            return _context.abrupt('return', null);

          case 8:
            return _context.abrupt('return', {
              chunks: ['articles'],
              title: title,
              description: description,
              shouldSetNoIndex: false,
              shouldSetIndex: true,
              component: articles__jsx(__WEBPACK_IMPORTED_MODULE_2_desktop_components_Layout__["a" /* default */], {
                navLinks: __WEBPACK_IMPORTED_MODULE_3_desktop_constants_navigation__["a" /* default */].JOURNAL,
                currentRoute: url,
                footer: 'leasing'
              }, void 0, articles_renderArticleByTemplate(template, otherParams))
            });

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function action(_x) {
    return _ref.apply(this, arguments);
  };
}();

function articles__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function articles__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }









var articles_renderArticleByTemplate = function renderArticleByTemplate(template, params) {
  return (
    // if (template === 'Leasing')
    //  return <ArticleLeasing specialCars={specialCars} content={content} h1={h1} />
    // else return <ArticleLeasing specialCars={specialCars} content={content} h1={h1} />
    articles__jsx(ArticleLeasing_defaultExport, {
      content: params.content,
      h1: params.h1,
      specialCars: params.specialCars,
      breadcrumbsLinks: params.breadcrumbsLinks,
      advertsFilter: params.advertsFilter,
      searchLink: params.searchLink,
      categories: params.categories,
      titles: params.titles
    })
  );
};

/* harmony default export */ __webpack_exports__["default"] = (action);

/***/ })

});


// WEBPACK FOOTER //
// 21-news-page-4fe6e8e2.chunk.js